(function () {
	'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	var jquery = {exports: {}};

	/*!
	 * jQuery JavaScript Library v3.6.4
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2023-03-08T15:28Z
	 */

	(function (module) {
		( function( global, factory ) {

			{

				// For CommonJS and CommonJS-like environments where a proper `window`
				// is present, execute the factory and get jQuery.
				// For environments that do not have a `window` with a `document`
				// (such as Node.js), expose a factory as module.exports.
				// This accentuates the need for the creation of a real `window`.
				// e.g. var jQuery = require("jquery")(window);
				// See ticket trac-14549 for more info.
				module.exports = global.document ?
					factory( global, true ) :
					function( w ) {
						if ( !w.document ) {
							throw new Error( "jQuery requires a window with a document" );
						}
						return factory( w );
					};
			}

		// Pass this if window is not defined yet
		} )( typeof window !== "undefined" ? window : commonjsGlobal, function( window, noGlobal ) {

		var arr = [];

		var getProto = Object.getPrototypeOf;

		var slice = arr.slice;

		var flat = arr.flat ? function( array ) {
			return arr.flat.call( array );
		} : function( array ) {
			return arr.concat.apply( [], array );
		};


		var push = arr.push;

		var indexOf = arr.indexOf;

		var class2type = {};

		var toString = class2type.toString;

		var hasOwn = class2type.hasOwnProperty;

		var fnToString = hasOwn.toString;

		var ObjectFunctionString = fnToString.call( Object );

		var support = {};

		var isFunction = function isFunction( obj ) {

				// Support: Chrome <=57, Firefox <=52
				// In some browsers, typeof returns "function" for HTML <object> elements
				// (i.e., `typeof document.createElement( "object" ) === "function"`).
				// We don't want to classify *any* DOM node as a function.
				// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
				// Plus for old WebKit, typeof returns "function" for HTML collections
				// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
				return typeof obj === "function" && typeof obj.nodeType !== "number" &&
					typeof obj.item !== "function";
			};


		var isWindow = function isWindow( obj ) {
				return obj != null && obj === obj.window;
			};


		var document = window.document;



			var preservedScriptAttributes = {
				type: true,
				src: true,
				nonce: true,
				noModule: true
			};

			function DOMEval( code, node, doc ) {
				doc = doc || document;

				var i, val,
					script = doc.createElement( "script" );

				script.text = code;
				if ( node ) {
					for ( i in preservedScriptAttributes ) {

						// Support: Firefox 64+, Edge 18+
						// Some browsers don't support the "nonce" property on scripts.
						// On the other hand, just using `getAttribute` is not enough as
						// the `nonce` attribute is reset to an empty string whenever it
						// becomes browsing-context connected.
						// See https://github.com/whatwg/html/issues/2369
						// See https://html.spec.whatwg.org/#nonce-attributes
						// The `node.getAttribute` check was added for the sake of
						// `jQuery.globalEval` so that it can fake a nonce-containing node
						// via an object.
						val = node[ i ] || node.getAttribute && node.getAttribute( i );
						if ( val ) {
							script.setAttribute( i, val );
						}
					}
				}
				doc.head.appendChild( script ).parentNode.removeChild( script );
			}


		function toType( obj ) {
			if ( obj == null ) {
				return obj + "";
			}

			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		}
		/* global Symbol */
		// Defining this global in .eslintrc.json would create a danger of using the global
		// unguarded in another place, it seems safer to define global only for this module



		var
			version = "3.6.4",

			// Define a local copy of jQuery
			jQuery = function( selector, context ) {

				// The jQuery object is actually just the init constructor 'enhanced'
				// Need init if jQuery is called (just allow error to be thrown if not included)
				return new jQuery.fn.init( selector, context );
			};

		jQuery.fn = jQuery.prototype = {

			// The current version of jQuery being used
			jquery: version,

			constructor: jQuery,

			// The default length of a jQuery object is 0
			length: 0,

			toArray: function() {
				return slice.call( this );
			},

			// Get the Nth element in the matched element set OR
			// Get the whole matched element set as a clean array
			get: function( num ) {

				// Return all the elements in a clean array
				if ( num == null ) {
					return slice.call( this );
				}

				// Return just the one element from the set
				return num < 0 ? this[ num + this.length ] : this[ num ];
			},

			// Take an array of elements and push it onto the stack
			// (returning the new matched element set)
			pushStack: function( elems ) {

				// Build a new jQuery matched element set
				var ret = jQuery.merge( this.constructor(), elems );

				// Add the old object onto the stack (as a reference)
				ret.prevObject = this;

				// Return the newly-formed element set
				return ret;
			},

			// Execute a callback for every element in the matched set.
			each: function( callback ) {
				return jQuery.each( this, callback );
			},

			map: function( callback ) {
				return this.pushStack( jQuery.map( this, function( elem, i ) {
					return callback.call( elem, i, elem );
				} ) );
			},

			slice: function() {
				return this.pushStack( slice.apply( this, arguments ) );
			},

			first: function() {
				return this.eq( 0 );
			},

			last: function() {
				return this.eq( -1 );
			},

			even: function() {
				return this.pushStack( jQuery.grep( this, function( _elem, i ) {
					return ( i + 1 ) % 2;
				} ) );
			},

			odd: function() {
				return this.pushStack( jQuery.grep( this, function( _elem, i ) {
					return i % 2;
				} ) );
			},

			eq: function( i ) {
				var len = this.length,
					j = +i + ( i < 0 ? len : 0 );
				return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
			},

			end: function() {
				return this.prevObject || this.constructor();
			},

			// For internal use only.
			// Behaves like an Array's method, not like a jQuery method.
			push: push,
			sort: arr.sort,
			splice: arr.splice
		};

		jQuery.extend = jQuery.fn.extend = function() {
			var options, name, src, copy, copyIsArray, clone,
				target = arguments[ 0 ] || {},
				i = 1,
				length = arguments.length,
				deep = false;

			// Handle a deep copy situation
			if ( typeof target === "boolean" ) {
				deep = target;

				// Skip the boolean and the target
				target = arguments[ i ] || {};
				i++;
			}

			// Handle case when target is a string or something (possible in deep copy)
			if ( typeof target !== "object" && !isFunction( target ) ) {
				target = {};
			}

			// Extend jQuery itself if only one argument is passed
			if ( i === length ) {
				target = this;
				i--;
			}

			for ( ; i < length; i++ ) {

				// Only deal with non-null/undefined values
				if ( ( options = arguments[ i ] ) != null ) {

					// Extend the base object
					for ( name in options ) {
						copy = options[ name ];

						// Prevent Object.prototype pollution
						// Prevent never-ending loop
						if ( name === "__proto__" || target === copy ) {
							continue;
						}

						// Recurse if we're merging plain objects or arrays
						if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
							( copyIsArray = Array.isArray( copy ) ) ) ) {
							src = target[ name ];

							// Ensure proper type for the source value
							if ( copyIsArray && !Array.isArray( src ) ) {
								clone = [];
							} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
								clone = {};
							} else {
								clone = src;
							}
							copyIsArray = false;

							// Never move original objects, clone them
							target[ name ] = jQuery.extend( deep, clone, copy );

						// Don't bring in undefined values
						} else if ( copy !== undefined ) {
							target[ name ] = copy;
						}
					}
				}
			}

			// Return the modified object
			return target;
		};

		jQuery.extend( {

			// Unique for each copy of jQuery on the page
			expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

			// Assume jQuery is ready without the ready module
			isReady: true,

			error: function( msg ) {
				throw new Error( msg );
			},

			noop: function() {},

			isPlainObject: function( obj ) {
				var proto, Ctor;

				// Detect obvious negatives
				// Use toString instead of jQuery.type to catch host objects
				if ( !obj || toString.call( obj ) !== "[object Object]" ) {
					return false;
				}

				proto = getProto( obj );

				// Objects with no prototype (e.g., `Object.create( null )`) are plain
				if ( !proto ) {
					return true;
				}

				// Objects with prototype are plain iff they were constructed by a global Object function
				Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
				return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
			},

			isEmptyObject: function( obj ) {
				var name;

				for ( name in obj ) {
					return false;
				}
				return true;
			},

			// Evaluates a script in a provided context; falls back to the global one
			// if not specified.
			globalEval: function( code, options, doc ) {
				DOMEval( code, { nonce: options && options.nonce }, doc );
			},

			each: function( obj, callback ) {
				var length, i = 0;

				if ( isArrayLike( obj ) ) {
					length = obj.length;
					for ( ; i < length; i++ ) {
						if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
							break;
						}
					}
				}

				return obj;
			},

			// results is for internal usage only
			makeArray: function( arr, results ) {
				var ret = results || [];

				if ( arr != null ) {
					if ( isArrayLike( Object( arr ) ) ) {
						jQuery.merge( ret,
							typeof arr === "string" ?
								[ arr ] : arr
						);
					} else {
						push.call( ret, arr );
					}
				}

				return ret;
			},

			inArray: function( elem, arr, i ) {
				return arr == null ? -1 : indexOf.call( arr, elem, i );
			},

			// Support: Android <=4.0 only, PhantomJS 1 only
			// push.apply(_, arraylike) throws on ancient WebKit
			merge: function( first, second ) {
				var len = +second.length,
					j = 0,
					i = first.length;

				for ( ; j < len; j++ ) {
					first[ i++ ] = second[ j ];
				}

				first.length = i;

				return first;
			},

			grep: function( elems, callback, invert ) {
				var callbackInverse,
					matches = [],
					i = 0,
					length = elems.length,
					callbackExpect = !invert;

				// Go through the array, only saving the items
				// that pass the validator function
				for ( ; i < length; i++ ) {
					callbackInverse = !callback( elems[ i ], i );
					if ( callbackInverse !== callbackExpect ) {
						matches.push( elems[ i ] );
					}
				}

				return matches;
			},

			// arg is for internal usage only
			map: function( elems, callback, arg ) {
				var length, value,
					i = 0,
					ret = [];

				// Go through the array, translating each of the items to their new values
				if ( isArrayLike( elems ) ) {
					length = elems.length;
					for ( ; i < length; i++ ) {
						value = callback( elems[ i ], i, arg );

						if ( value != null ) {
							ret.push( value );
						}
					}

				// Go through every key on the object,
				} else {
					for ( i in elems ) {
						value = callback( elems[ i ], i, arg );

						if ( value != null ) {
							ret.push( value );
						}
					}
				}

				// Flatten any nested arrays
				return flat( ret );
			},

			// A global GUID counter for objects
			guid: 1,

			// jQuery.support is not used in Core but other projects attach their
			// properties to it so it needs to exist.
			support: support
		} );

		if ( typeof Symbol === "function" ) {
			jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
		}

		// Populate the class2type map
		jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
			function( _i, name ) {
				class2type[ "[object " + name + "]" ] = name.toLowerCase();
			} );

		function isArrayLike( obj ) {

			// Support: real iOS 8.2 only (not reproducible in simulator)
			// `in` check used to prevent JIT error (gh-2145)
			// hasOwn isn't used here due to false negatives
			// regarding Nodelist length in IE
			var length = !!obj && "length" in obj && obj.length,
				type = toType( obj );

			if ( isFunction( obj ) || isWindow( obj ) ) {
				return false;
			}

			return type === "array" || length === 0 ||
				typeof length === "number" && length > 0 && ( length - 1 ) in obj;
		}
		var Sizzle =
		/*!
		 * Sizzle CSS Selector Engine v2.3.10
		 * https://sizzlejs.com/
		 *
		 * Copyright JS Foundation and other contributors
		 * Released under the MIT license
		 * https://js.foundation/
		 *
		 * Date: 2023-02-14
		 */
		( function( window ) {
		var i,
			support,
			Expr,
			getText,
			isXML,
			tokenize,
			compile,
			select,
			outermostContext,
			sortInput,
			hasDuplicate,

			// Local document vars
			setDocument,
			document,
			docElem,
			documentIsHTML,
			rbuggyQSA,
			rbuggyMatches,
			matches,
			contains,

			// Instance-specific data
			expando = "sizzle" + 1 * new Date(),
			preferredDoc = window.document,
			dirruns = 0,
			done = 0,
			classCache = createCache(),
			tokenCache = createCache(),
			compilerCache = createCache(),
			nonnativeSelectorCache = createCache(),
			sortOrder = function( a, b ) {
				if ( a === b ) {
					hasDuplicate = true;
				}
				return 0;
			},

			// Instance methods
			hasOwn = ( {} ).hasOwnProperty,
			arr = [],
			pop = arr.pop,
			pushNative = arr.push,
			push = arr.push,
			slice = arr.slice,

			// Use a stripped-down indexOf as it's faster than native
			// https://jsperf.com/thor-indexof-vs-for/5
			indexOf = function( list, elem ) {
				var i = 0,
					len = list.length;
				for ( ; i < len; i++ ) {
					if ( list[ i ] === elem ) {
						return i;
					}
				}
				return -1;
			},

			booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
				"ismap|loop|multiple|open|readonly|required|scoped",

			// Regular expressions

			// http://www.w3.org/TR/css3-selectors/#whitespace
			whitespace = "[\\x20\\t\\r\\n\\f]",

			// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
			identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
				"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

			// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
			attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

				// Operator (capture 2)
				"*([*^$|!~]?=)" + whitespace +

				// "Attribute values must be CSS identifiers [capture 5]
				// or strings [capture 3 or capture 4]"
				"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
				whitespace + "*\\]",

			pseudos = ":(" + identifier + ")(?:\\((" +

				// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
				// 1. quoted (capture 3; capture 4 or capture 5)
				"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

				// 2. simple (capture 6)
				"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

				// 3. anything else (capture 2)
				".*" +
				")\\)|)",

			// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
			rwhitespace = new RegExp( whitespace + "+", "g" ),
			rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
				whitespace + "+$", "g" ),

			rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
			rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
				"*" ),
			rdescend = new RegExp( whitespace + "|>" ),

			rpseudo = new RegExp( pseudos ),
			ridentifier = new RegExp( "^" + identifier + "$" ),

			matchExpr = {
				"ID": new RegExp( "^#(" + identifier + ")" ),
				"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
				"TAG": new RegExp( "^(" + identifier + "|[*])" ),
				"ATTR": new RegExp( "^" + attributes ),
				"PSEUDO": new RegExp( "^" + pseudos ),
				"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
					whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
					whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
				"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

				// For use in libraries implementing .is()
				// We use this for POS matching in `select`
				"needsContext": new RegExp( "^" + whitespace +
					"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
					"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
			},

			rhtml = /HTML$/i,
			rinputs = /^(?:input|select|textarea|button)$/i,
			rheader = /^h\d$/i,

			rnative = /^[^{]+\{\s*\[native \w/,

			// Easily-parseable/retrievable ID or TAG or CLASS selectors
			rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

			rsibling = /[+~]/,

			// CSS escapes
			// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
			runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
			funescape = function( escape, nonHex ) {
				var high = "0x" + escape.slice( 1 ) - 0x10000;

				return nonHex ?

					// Strip the backslash prefix from a non-hex escape sequence
					nonHex :

					// Replace a hexadecimal escape sequence with the encoded Unicode code point
					// Support: IE <=11+
					// For values outside the Basic Multilingual Plane (BMP), manually construct a
					// surrogate pair
					high < 0 ?
						String.fromCharCode( high + 0x10000 ) :
						String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
			},

			// CSS string/identifier serialization
			// https://drafts.csswg.org/cssom/#common-serializing-idioms
			rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
			fcssescape = function( ch, asCodePoint ) {
				if ( asCodePoint ) {

					// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
					if ( ch === "\0" ) {
						return "\uFFFD";
					}

					// Control characters and (dependent upon position) numbers get escaped as code points
					return ch.slice( 0, -1 ) + "\\" +
						ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
				}

				// Other potentially-special ASCII characters get backslash-escaped
				return "\\" + ch;
			},

			// Used for iframes
			// See setDocument()
			// Removing the function wrapper causes a "Permission Denied"
			// error in IE
			unloadHandler = function() {
				setDocument();
			},

			inDisabledFieldset = addCombinator(
				function( elem ) {
					return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
				},
				{ dir: "parentNode", next: "legend" }
			);

		// Optimize for push.apply( _, NodeList )
		try {
			push.apply(
				( arr = slice.call( preferredDoc.childNodes ) ),
				preferredDoc.childNodes
			);

			// Support: Android<4.0
			// Detect silently failing push.apply
			// eslint-disable-next-line no-unused-expressions
			arr[ preferredDoc.childNodes.length ].nodeType;
		} catch ( e ) {
			push = { apply: arr.length ?

				// Leverage slice if possible
				function( target, els ) {
					pushNative.apply( target, slice.call( els ) );
				} :

				// Support: IE<9
				// Otherwise append directly
				function( target, els ) {
					var j = target.length,
						i = 0;

					// Can't trust NodeList.length
					while ( ( target[ j++ ] = els[ i++ ] ) ) {}
					target.length = j - 1;
				}
			};
		}

		function Sizzle( selector, context, results, seed ) {
			var m, i, elem, nid, match, groups, newSelector,
				newContext = context && context.ownerDocument,

				// nodeType defaults to 9, since context defaults to document
				nodeType = context ? context.nodeType : 9;

			results = results || [];

			// Return early from calls with invalid selector or context
			if ( typeof selector !== "string" || !selector ||
				nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

				return results;
			}

			// Try to shortcut find operations (as opposed to filters) in HTML documents
			if ( !seed ) {
				setDocument( context );
				context = context || document;

				if ( documentIsHTML ) {

					// If the selector is sufficiently simple, try using a "get*By*" DOM method
					// (excepting DocumentFragment context, where the methods don't exist)
					if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

						// ID selector
						if ( ( m = match[ 1 ] ) ) {

							// Document context
							if ( nodeType === 9 ) {
								if ( ( elem = context.getElementById( m ) ) ) {

									// Support: IE, Opera, Webkit
									// TODO: identify versions
									// getElementById can match elements by name instead of ID
									if ( elem.id === m ) {
										results.push( elem );
										return results;
									}
								} else {
									return results;
								}

							// Element context
							} else {

								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( newContext && ( elem = newContext.getElementById( m ) ) &&
									contains( context, elem ) &&
									elem.id === m ) {

									results.push( elem );
									return results;
								}
							}

						// Type selector
						} else if ( match[ 2 ] ) {
							push.apply( results, context.getElementsByTagName( selector ) );
							return results;

						// Class selector
						} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
							context.getElementsByClassName ) {

							push.apply( results, context.getElementsByClassName( m ) );
							return results;
						}
					}

					// Take advantage of querySelectorAll
					if ( support.qsa &&
						!nonnativeSelectorCache[ selector + " " ] &&
						( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

						// Support: IE 8 only
						// Exclude object elements
						( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

						newSelector = selector;
						newContext = context;

						// qSA considers elements outside a scoping root when evaluating child or
						// descendant combinators, which is not what we want.
						// In such cases, we work around the behavior by prefixing every selector in the
						// list with an ID selector referencing the scope context.
						// The technique has to be used as well when a leading combinator is used
						// as such selectors are not recognized by querySelectorAll.
						// Thanks to Andrew Dupont for this technique.
						if ( nodeType === 1 &&
							( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

							// Expand context for sibling selectors
							newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
								context;

							// We can use :scope instead of the ID hack if the browser
							// supports it & if we're not changing the context.
							if ( newContext !== context || !support.scope ) {

								// Capture the context ID, setting it first if necessary
								if ( ( nid = context.getAttribute( "id" ) ) ) {
									nid = nid.replace( rcssescape, fcssescape );
								} else {
									context.setAttribute( "id", ( nid = expando ) );
								}
							}

							// Prefix every selector in the list
							groups = tokenize( selector );
							i = groups.length;
							while ( i-- ) {
								groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
									toSelector( groups[ i ] );
							}
							newSelector = groups.join( "," );
						}

						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
							nonnativeSelectorCache( selector, true );
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}

			// All others
			return select( selector.replace( rtrim, "$1" ), context, results, seed );
		}

		/**
		 * Create key-value caches of limited size
		 * @returns {function(string, object)} Returns the Object data after storing it on itself with
		 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
		 *	deleting the oldest entry
		 */
		function createCache() {
			var keys = [];

			function cache( key, value ) {

				// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
				if ( keys.push( key + " " ) > Expr.cacheLength ) {

					// Only keep the most recent entries
					delete cache[ keys.shift() ];
				}
				return ( cache[ key + " " ] = value );
			}
			return cache;
		}

		/**
		 * Mark a function for special use by Sizzle
		 * @param {Function} fn The function to mark
		 */
		function markFunction( fn ) {
			fn[ expando ] = true;
			return fn;
		}

		/**
		 * Support testing using an element
		 * @param {Function} fn Passed the created element and returns a boolean result
		 */
		function assert( fn ) {
			var el = document.createElement( "fieldset" );

			try {
				return !!fn( el );
			} catch ( e ) {
				return false;
			} finally {

				// Remove from its parent by default
				if ( el.parentNode ) {
					el.parentNode.removeChild( el );
				}

				// release memory in IE
				el = null;
			}
		}

		/**
		 * Adds the same handler for all of the specified attrs
		 * @param {String} attrs Pipe-separated list of attributes
		 * @param {Function} handler The method that will be applied
		 */
		function addHandle( attrs, handler ) {
			var arr = attrs.split( "|" ),
				i = arr.length;

			while ( i-- ) {
				Expr.attrHandle[ arr[ i ] ] = handler;
			}
		}

		/**
		 * Checks document order of two siblings
		 * @param {Element} a
		 * @param {Element} b
		 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
		 */
		function siblingCheck( a, b ) {
			var cur = b && a,
				diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
					a.sourceIndex - b.sourceIndex;

			// Use IE sourceIndex if available on both nodes
			if ( diff ) {
				return diff;
			}

			// Check if b follows a
			if ( cur ) {
				while ( ( cur = cur.nextSibling ) ) {
					if ( cur === b ) {
						return -1;
					}
				}
			}

			return a ? 1 : -1;
		}

		/**
		 * Returns a function to use in pseudos for input types
		 * @param {String} type
		 */
		function createInputPseudo( type ) {
			return function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === type;
			};
		}

		/**
		 * Returns a function to use in pseudos for buttons
		 * @param {String} type
		 */
		function createButtonPseudo( type ) {
			return function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return ( name === "input" || name === "button" ) && elem.type === type;
			};
		}

		/**
		 * Returns a function to use in pseudos for :enabled/:disabled
		 * @param {Boolean} disabled true for :disabled; false for :enabled
		 */
		function createDisabledPseudo( disabled ) {

			// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
			return function( elem ) {

				// Only certain elements can match :enabled or :disabled
				// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
				// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
				if ( "form" in elem ) {

					// Check for inherited disabledness on relevant non-disabled elements:
					// * listed form-associated elements in a disabled fieldset
					//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
					//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
					// * option elements in a disabled optgroup
					//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
					// All such elements have a "form" property.
					if ( elem.parentNode && elem.disabled === false ) {

						// Option elements defer to a parent optgroup if present
						if ( "label" in elem ) {
							if ( "label" in elem.parentNode ) {
								return elem.parentNode.disabled === disabled;
							} else {
								return elem.disabled === disabled;
							}
						}

						// Support: IE 6 - 11
						// Use the isDisabled shortcut property to check for disabled fieldset ancestors
						return elem.isDisabled === disabled ||

							// Where there is no isDisabled, check manually
							/* jshint -W018 */
							elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
					}

					return elem.disabled === disabled;

				// Try to winnow out elements that can't be disabled before trusting the disabled property.
				// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
				// even exist on them, let alone have a boolean value.
				} else if ( "label" in elem ) {
					return elem.disabled === disabled;
				}

				// Remaining elements are neither :enabled nor :disabled
				return false;
			};
		}

		/**
		 * Returns a function to use in pseudos for positionals
		 * @param {Function} fn
		 */
		function createPositionalPseudo( fn ) {
			return markFunction( function( argument ) {
				argument = +argument;
				return markFunction( function( seed, matches ) {
					var j,
						matchIndexes = fn( [], seed.length, argument ),
						i = matchIndexes.length;

					// Match elements found at the specified indexes
					while ( i-- ) {
						if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
							seed[ j ] = !( matches[ j ] = seed[ j ] );
						}
					}
				} );
			} );
		}

		/**
		 * Checks a node for validity as a Sizzle context
		 * @param {Element|Object=} context
		 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
		 */
		function testContext( context ) {
			return context && typeof context.getElementsByTagName !== "undefined" && context;
		}

		// Expose support vars for convenience
		support = Sizzle.support = {};

		/**
		 * Detects XML nodes
		 * @param {Element|Object} elem An element or a document
		 * @returns {Boolean} True iff elem is a non-HTML XML node
		 */
		isXML = Sizzle.isXML = function( elem ) {
			var namespace = elem && elem.namespaceURI,
				docElem = elem && ( elem.ownerDocument || elem ).documentElement;

			// Support: IE <=8
			// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
			// https://bugs.jquery.com/ticket/4833
			return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
		};

		/**
		 * Sets document-related variables once based on the current document
		 * @param {Element|Object} [doc] An element or document object to use to set the document
		 * @returns {Object} Returns the current document
		 */
		setDocument = Sizzle.setDocument = function( node ) {
			var hasCompare, subWindow,
				doc = node ? node.ownerDocument || node : preferredDoc;

			// Return early if doc is invalid or already selected
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
				return document;
			}

			// Update global variables
			document = doc;
			docElem = document.documentElement;
			documentIsHTML = !isXML( document );

			// Support: IE 9 - 11+, Edge 12 - 18+
			// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( preferredDoc != document &&
				( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

				// Support: IE 11, Edge
				if ( subWindow.addEventListener ) {
					subWindow.addEventListener( "unload", unloadHandler, false );

				// Support: IE 9 - 10 only
				} else if ( subWindow.attachEvent ) {
					subWindow.attachEvent( "onunload", unloadHandler );
				}
			}

			// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
			// Safari 4 - 5 only, Opera <=11.6 - 12.x only
			// IE/Edge & older browsers don't support the :scope pseudo-class.
			// Support: Safari 6.0 only
			// Safari 6.0 supports :scope but it's an alias of :root there.
			support.scope = assert( function( el ) {
				docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
				return typeof el.querySelectorAll !== "undefined" &&
					!el.querySelectorAll( ":scope fieldset div" ).length;
			} );

			// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
			// Make sure the the `:has()` argument is parsed unforgivingly.
			// We include `*` in the test to detect buggy implementations that are
			// _selectively_ forgiving (specifically when the list includes at least
			// one valid selector).
			// Note that we treat complete lack of support for `:has()` as if it were
			// spec-compliant support, which is fine because use of `:has()` in such
			// environments will fail in the qSA path and fall back to jQuery traversal
			// anyway.
			support.cssHas = assert( function() {
				try {
					document.querySelector( ":has(*,:jqfake)" );
					return false;
				} catch ( e ) {
					return true;
				}
			} );

			/* Attributes
			---------------------------------------------------------------------- */

			// Support: IE<8
			// Verify that getAttribute really returns attributes and not properties
			// (excepting IE8 booleans)
			support.attributes = assert( function( el ) {
				el.className = "i";
				return !el.getAttribute( "className" );
			} );

			/* getElement(s)By*
			---------------------------------------------------------------------- */

			// Check if getElementsByTagName("*") returns only elements
			support.getElementsByTagName = assert( function( el ) {
				el.appendChild( document.createComment( "" ) );
				return !el.getElementsByTagName( "*" ).length;
			} );

			// Support: IE<9
			support.getElementsByClassName = rnative.test( document.getElementsByClassName );

			// Support: IE<10
			// Check if getElementById returns elements by name
			// The broken getElementById methods don't pick up programmatically-set names,
			// so use a roundabout getElementsByName test
			support.getById = assert( function( el ) {
				docElem.appendChild( el ).id = expando;
				return !document.getElementsByName || !document.getElementsByName( expando ).length;
			} );

			// ID filter and find
			if ( support.getById ) {
				Expr.filter[ "ID" ] = function( id ) {
					var attrId = id.replace( runescape, funescape );
					return function( elem ) {
						return elem.getAttribute( "id" ) === attrId;
					};
				};
				Expr.find[ "ID" ] = function( id, context ) {
					if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
						var elem = context.getElementById( id );
						return elem ? [ elem ] : [];
					}
				};
			} else {
				Expr.filter[ "ID" ] =  function( id ) {
					var attrId = id.replace( runescape, funescape );
					return function( elem ) {
						var node = typeof elem.getAttributeNode !== "undefined" &&
							elem.getAttributeNode( "id" );
						return node && node.value === attrId;
					};
				};

				// Support: IE 6 - 7 only
				// getElementById is not reliable as a find shortcut
				Expr.find[ "ID" ] = function( id, context ) {
					if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
						var node, i, elems,
							elem = context.getElementById( id );

						if ( elem ) {

							// Verify the id attribute
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}

							// Fall back on getElementsByName
							elems = context.getElementsByName( id );
							i = 0;
							while ( ( elem = elems[ i++ ] ) ) {
								node = elem.getAttributeNode( "id" );
								if ( node && node.value === id ) {
									return [ elem ];
								}
							}
						}

						return [];
					}
				};
			}

			// Tag
			Expr.find[ "TAG" ] = support.getElementsByTagName ?
				function( tag, context ) {
					if ( typeof context.getElementsByTagName !== "undefined" ) {
						return context.getElementsByTagName( tag );

					// DocumentFragment nodes don't have gEBTN
					} else if ( support.qsa ) {
						return context.querySelectorAll( tag );
					}
				} :

				function( tag, context ) {
					var elem,
						tmp = [],
						i = 0,

						// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
						results = context.getElementsByTagName( tag );

					// Filter out possible comments
					if ( tag === "*" ) {
						while ( ( elem = results[ i++ ] ) ) {
							if ( elem.nodeType === 1 ) {
								tmp.push( elem );
							}
						}

						return tmp;
					}
					return results;
				};

			// Class
			Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
				if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
					return context.getElementsByClassName( className );
				}
			};

			/* QSA/matchesSelector
			---------------------------------------------------------------------- */

			// QSA and matchesSelector support

			// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
			rbuggyMatches = [];

			// qSa(:focus) reports false when true (Chrome 21)
			// We allow this because of a bug in IE8/9 that throws an error
			// whenever `document.activeElement` is accessed on an iframe
			// So, we allow :focus to pass through QSA all the time to avoid the IE error
			// See https://bugs.jquery.com/ticket/13378
			rbuggyQSA = [];

			if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

				// Build QSA regex
				// Regex strategy adopted from Diego Perini
				assert( function( el ) {

					var input;

					// Select is set to empty string on purpose
					// This is to test IE's treatment of not explicitly
					// setting a boolean content attribute,
					// since its presence should be enough
					// https://bugs.jquery.com/ticket/12359
					docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
						"<select id='" + expando + "-\r\\' msallowcapture=''>" +
						"<option selected=''></option></select>";

					// Support: IE8, Opera 11-12.16
					// Nothing should be selected when empty strings follow ^= or $= or *=
					// The test attribute must be unknown in Opera but "safe" for WinRT
					// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
					if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
						rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
					}

					// Support: IE8
					// Boolean attributes and "value" are not treated correctly
					if ( !el.querySelectorAll( "[selected]" ).length ) {
						rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
					}

					// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
					if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
						rbuggyQSA.push( "~=" );
					}

					// Support: IE 11+, Edge 15 - 18+
					// IE 11/Edge don't find elements on a `[name='']` query in some cases.
					// Adding a temporary attribute to the document before the selection works
					// around the issue.
					// Interestingly, IE 10 & older don't seem to have the issue.
					input = document.createElement( "input" );
					input.setAttribute( "name", "" );
					el.appendChild( input );
					if ( !el.querySelectorAll( "[name='']" ).length ) {
						rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
							whitespace + "*(?:''|\"\")" );
					}

					// Webkit/Opera - :checked should return selected option elements
					// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
					// IE8 throws error here and will not see later tests
					if ( !el.querySelectorAll( ":checked" ).length ) {
						rbuggyQSA.push( ":checked" );
					}

					// Support: Safari 8+, iOS 8+
					// https://bugs.webkit.org/show_bug.cgi?id=136851
					// In-page `selector#id sibling-combinator selector` fails
					if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
						rbuggyQSA.push( ".#.+[+~]" );
					}

					// Support: Firefox <=3.6 - 5 only
					// Old Firefox doesn't throw on a badly-escaped identifier.
					el.querySelectorAll( "\\\f" );
					rbuggyQSA.push( "[\\r\\n\\f]" );
				} );

				assert( function( el ) {
					el.innerHTML = "<a href='' disabled='disabled'></a>" +
						"<select disabled='disabled'><option/></select>";

					// Support: Windows 8 Native Apps
					// The type and name attributes are restricted during .innerHTML assignment
					var input = document.createElement( "input" );
					input.setAttribute( "type", "hidden" );
					el.appendChild( input ).setAttribute( "name", "D" );

					// Support: IE8
					// Enforce case-sensitivity of name attribute
					if ( el.querySelectorAll( "[name=d]" ).length ) {
						rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
					}

					// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
					// IE8 throws error here and will not see later tests
					if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
						rbuggyQSA.push( ":enabled", ":disabled" );
					}

					// Support: IE9-11+
					// IE's :disabled selector does not pick up the children of disabled fieldsets
					docElem.appendChild( el ).disabled = true;
					if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
						rbuggyQSA.push( ":enabled", ":disabled" );
					}

					// Support: Opera 10 - 11 only
					// Opera 10-11 does not throw on post-comma invalid pseudos
					el.querySelectorAll( "*,:x" );
					rbuggyQSA.push( ",.*:" );
				} );
			}

			if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
				docElem.webkitMatchesSelector ||
				docElem.mozMatchesSelector ||
				docElem.oMatchesSelector ||
				docElem.msMatchesSelector ) ) ) ) {

				assert( function( el ) {

					// Check to see if it's possible to do matchesSelector
					// on a disconnected node (IE 9)
					support.disconnectedMatch = matches.call( el, "*" );

					// This should fail with an exception
					// Gecko does not error, returns false instead
					matches.call( el, "[s!='']:x" );
					rbuggyMatches.push( "!=", pseudos );
				} );
			}

			if ( !support.cssHas ) {

				// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
				// Our regular `try-catch` mechanism fails to detect natively-unsupported
				// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
				// in browsers that parse the `:has()` argument as a forgiving selector list.
				// https://drafts.csswg.org/selectors/#relational now requires the argument
				// to be parsed unforgivingly, but browsers have not yet fully adjusted.
				rbuggyQSA.push( ":has" );
			}

			rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
			rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

			/* Contains
			---------------------------------------------------------------------- */
			hasCompare = rnative.test( docElem.compareDocumentPosition );

			// Element contains another
			// Purposefully self-exclusive
			// As in, an element does not contain itself
			contains = hasCompare || rnative.test( docElem.contains ) ?
				function( a, b ) {

					// Support: IE <9 only
					// IE doesn't have `contains` on `document` so we need to check for
					// `documentElement` presence.
					// We need to fall back to `a` when `documentElement` is missing
					// as `ownerDocument` of elements within `<template/>` may have
					// a null one - a default behavior of all modern browsers.
					var adown = a.nodeType === 9 && a.documentElement || a,
						bup = b && b.parentNode;
					return a === bup || !!( bup && bup.nodeType === 1 && (
						adown.contains ?
							adown.contains( bup ) :
							a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
					) );
				} :
				function( a, b ) {
					if ( b ) {
						while ( ( b = b.parentNode ) ) {
							if ( b === a ) {
								return true;
							}
						}
					}
					return false;
				};

			/* Sorting
			---------------------------------------------------------------------- */

			// Document order sorting
			sortOrder = hasCompare ?
			function( a, b ) {

				// Flag for duplicate removal
				if ( a === b ) {
					hasDuplicate = true;
					return 0;
				}

				// Sort on method existence if only one input has compareDocumentPosition
				var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
				if ( compare ) {
					return compare;
				}

				// Calculate position if both inputs belong to the same document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
					a.compareDocumentPosition( b ) :

					// Otherwise we know they are disconnected
					1;

				// Disconnected nodes
				if ( compare & 1 ||
					( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

					// Choose the first element that is related to our preferred document
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( a == document || a.ownerDocument == preferredDoc &&
						contains( preferredDoc, a ) ) {
						return -1;
					}

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( b == document || b.ownerDocument == preferredDoc &&
						contains( preferredDoc, b ) ) {
						return 1;
					}

					// Maintain original order
					return sortInput ?
						( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
						0;
				}

				return compare & 4 ? -1 : 1;
			} :
			function( a, b ) {

				// Exit early if the nodes are identical
				if ( a === b ) {
					hasDuplicate = true;
					return 0;
				}

				var cur,
					i = 0,
					aup = a.parentNode,
					bup = b.parentNode,
					ap = [ a ],
					bp = [ b ];

				// Parentless nodes are either documents or disconnected
				if ( !aup || !bup ) {

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					/* eslint-disable eqeqeq */
					return a == document ? -1 :
						b == document ? 1 :
						/* eslint-enable eqeqeq */
						aup ? -1 :
						bup ? 1 :
						sortInput ?
						( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
						0;

				// If the nodes are siblings, we can do a quick check
				} else if ( aup === bup ) {
					return siblingCheck( a, b );
				}

				// Otherwise we need full lists of their ancestors for comparison
				cur = a;
				while ( ( cur = cur.parentNode ) ) {
					ap.unshift( cur );
				}
				cur = b;
				while ( ( cur = cur.parentNode ) ) {
					bp.unshift( cur );
				}

				// Walk down the tree looking for a discrepancy
				while ( ap[ i ] === bp[ i ] ) {
					i++;
				}

				return i ?

					// Do a sibling check if the nodes have a common ancestor
					siblingCheck( ap[ i ], bp[ i ] ) :

					// Otherwise nodes in our document sort first
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					/* eslint-disable eqeqeq */
					ap[ i ] == preferredDoc ? -1 :
					bp[ i ] == preferredDoc ? 1 :
					/* eslint-enable eqeqeq */
					0;
			};

			return document;
		};

		Sizzle.matches = function( expr, elements ) {
			return Sizzle( expr, null, null, elements );
		};

		Sizzle.matchesSelector = function( elem, expr ) {
			setDocument( elem );

			if ( support.matchesSelector && documentIsHTML &&
				!nonnativeSelectorCache[ expr + " " ] &&
				( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
				( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

				try {
					var ret = matches.call( elem, expr );

					// IE 9's matchesSelector returns false on disconnected nodes
					if ( ret || support.disconnectedMatch ||

						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
						return ret;
					}
				} catch ( e ) {
					nonnativeSelectorCache( expr, true );
				}
			}

			return Sizzle( expr, document, null, [ elem ] ).length > 0;
		};

		Sizzle.contains = function( context, elem ) {

			// Set document vars if needed
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( ( context.ownerDocument || context ) != document ) {
				setDocument( context );
			}
			return contains( context, elem );
		};

		Sizzle.attr = function( elem, name ) {

			// Set document vars if needed
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( ( elem.ownerDocument || elem ) != document ) {
				setDocument( elem );
			}

			var fn = Expr.attrHandle[ name.toLowerCase() ],

				// Don't get fooled by Object.prototype properties (jQuery #13807)
				val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
					fn( elem, name, !documentIsHTML ) :
					undefined;

			return val !== undefined ?
				val :
				support.attributes || !documentIsHTML ?
					elem.getAttribute( name ) :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
		};

		Sizzle.escape = function( sel ) {
			return ( sel + "" ).replace( rcssescape, fcssescape );
		};

		Sizzle.error = function( msg ) {
			throw new Error( "Syntax error, unrecognized expression: " + msg );
		};

		/**
		 * Document sorting and removing duplicates
		 * @param {ArrayLike} results
		 */
		Sizzle.uniqueSort = function( results ) {
			var elem,
				duplicates = [],
				j = 0,
				i = 0;

			// Unless we *know* we can detect duplicates, assume their presence
			hasDuplicate = !support.detectDuplicates;
			sortInput = !support.sortStable && results.slice( 0 );
			results.sort( sortOrder );

			if ( hasDuplicate ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem === results[ i ] ) {
						j = duplicates.push( i );
					}
				}
				while ( j-- ) {
					results.splice( duplicates[ j ], 1 );
				}
			}

			// Clear input after sorting to release objects
			// See https://github.com/jquery/sizzle/pull/225
			sortInput = null;

			return results;
		};

		/**
		 * Utility function for retrieving the text value of an array of DOM nodes
		 * @param {Array|Element} elem
		 */
		getText = Sizzle.getText = function( elem ) {
			var node,
				ret = "",
				i = 0,
				nodeType = elem.nodeType;

			if ( !nodeType ) {

				// If no nodeType, this is expected to be an array
				while ( ( node = elem[ i++ ] ) ) {

					// Do not traverse comment nodes
					ret += getText( node );
				}
			} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

				// Use textContent for elements
				// innerText usage removed for consistency of new lines (jQuery #11153)
				if ( typeof elem.textContent === "string" ) {
					return elem.textContent;
				} else {

					// Traverse its children
					for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
						ret += getText( elem );
					}
				}
			} else if ( nodeType === 3 || nodeType === 4 ) {
				return elem.nodeValue;
			}

			// Do not include comment or processing instruction nodes

			return ret;
		};

		Expr = Sizzle.selectors = {

			// Can be adjusted by the user
			cacheLength: 50,

			createPseudo: markFunction,

			match: matchExpr,

			attrHandle: {},

			find: {},

			relative: {
				">": { dir: "parentNode", first: true },
				" ": { dir: "parentNode" },
				"+": { dir: "previousSibling", first: true },
				"~": { dir: "previousSibling" }
			},

			preFilter: {
				"ATTR": function( match ) {
					match[ 1 ] = match[ 1 ].replace( runescape, funescape );

					// Move the given value to match[3] whether quoted or unquoted
					match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
						match[ 5 ] || "" ).replace( runescape, funescape );

					if ( match[ 2 ] === "~=" ) {
						match[ 3 ] = " " + match[ 3 ] + " ";
					}

					return match.slice( 0, 4 );
				},

				"CHILD": function( match ) {

					/* matches from matchExpr["CHILD"]
						1 type (only|nth|...)
						2 what (child|of-type)
						3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
						4 xn-component of xn+y argument ([+-]?\d*n|)
						5 sign of xn-component
						6 x of xn-component
						7 sign of y-component
						8 y of y-component
					*/
					match[ 1 ] = match[ 1 ].toLowerCase();

					if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

						// nth-* requires argument
						if ( !match[ 3 ] ) {
							Sizzle.error( match[ 0 ] );
						}

						// numeric x and y parameters for Expr.filter.CHILD
						// remember that false/true cast respectively to 0/1
						match[ 4 ] = +( match[ 4 ] ?
							match[ 5 ] + ( match[ 6 ] || 1 ) :
							2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
						match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

						// other types prohibit arguments
					} else if ( match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}

					return match;
				},

				"PSEUDO": function( match ) {
					var excess,
						unquoted = !match[ 6 ] && match[ 2 ];

					if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
						return null;
					}

					// Accept quoted arguments as-is
					if ( match[ 3 ] ) {
						match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

					// Strip excess characters from unquoted arguments
					} else if ( unquoted && rpseudo.test( unquoted ) &&

						// Get excess from tokenize (recursively)
						( excess = tokenize( unquoted, true ) ) &&

						// advance to the next closing parenthesis
						( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

						// excess is a negative index
						match[ 0 ] = match[ 0 ].slice( 0, excess );
						match[ 2 ] = unquoted.slice( 0, excess );
					}

					// Return only captures needed by the pseudo filter method (type and argument)
					return match.slice( 0, 3 );
				}
			},

			filter: {

				"TAG": function( nodeNameSelector ) {
					var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
					return nodeNameSelector === "*" ?
						function() {
							return true;
						} :
						function( elem ) {
							return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
						};
				},

				"CLASS": function( className ) {
					var pattern = classCache[ className + " " ];

					return pattern ||
						( pattern = new RegExp( "(^|" + whitespace +
							")" + className + "(" + whitespace + "|$)" ) ) && classCache(
								className, function( elem ) {
									return pattern.test(
										typeof elem.className === "string" && elem.className ||
										typeof elem.getAttribute !== "undefined" &&
											elem.getAttribute( "class" ) ||
										""
									);
						} );
				},

				"ATTR": function( name, operator, check ) {
					return function( elem ) {
						var result = Sizzle.attr( elem, name );

						if ( result == null ) {
							return operator === "!=";
						}
						if ( !operator ) {
							return true;
						}

						result += "";

						/* eslint-disable max-len */

						return operator === "=" ? result === check :
							operator === "!=" ? result !== check :
							operator === "^=" ? check && result.indexOf( check ) === 0 :
							operator === "*=" ? check && result.indexOf( check ) > -1 :
							operator === "$=" ? check && result.slice( -check.length ) === check :
							operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
							operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
							false;
						/* eslint-enable max-len */

					};
				},

				"CHILD": function( type, what, _argument, first, last ) {
					var simple = type.slice( 0, 3 ) !== "nth",
						forward = type.slice( -4 ) !== "last",
						ofType = what === "of-type";

					return first === 1 && last === 0 ?

						// Shortcut for :nth-*(n)
						function( elem ) {
							return !!elem.parentNode;
						} :

						function( elem, _context, xml ) {
							var cache, uniqueCache, outerCache, node, nodeIndex, start,
								dir = simple !== forward ? "nextSibling" : "previousSibling",
								parent = elem.parentNode,
								name = ofType && elem.nodeName.toLowerCase(),
								useCache = !xml && !ofType,
								diff = false;

							if ( parent ) {

								// :(first|last|only)-(child|of-type)
								if ( simple ) {
									while ( dir ) {
										node = elem;
										while ( ( node = node[ dir ] ) ) {
											if ( ofType ?
												node.nodeName.toLowerCase() === name :
												node.nodeType === 1 ) {

												return false;
											}
										}

										// Reverse direction for :only-* (if we haven't yet done so)
										start = dir = type === "only" && !start && "nextSibling";
									}
									return true;
								}

								start = [ forward ? parent.firstChild : parent.lastChild ];

								// non-xml :nth-child(...) stores cache data on `parent`
								if ( forward && useCache ) {

									// Seek `elem` from a previously-cached index

									// ...in a gzip-friendly way
									node = parent;
									outerCache = node[ expando ] || ( node[ expando ] = {} );

									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );

									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex && cache[ 2 ];
									node = nodeIndex && parent.childNodes[ nodeIndex ];

									while ( ( node = ++nodeIndex && node && node[ dir ] ||

										// Fallback to seeking `elem` from the start
										( diff = nodeIndex = 0 ) || start.pop() ) ) {

										// When found, cache indexes on `parent` and break
										if ( node.nodeType === 1 && ++diff && node === elem ) {
											uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
											break;
										}
									}

								} else {

									// Use previously-cached element index if available
									if ( useCache ) {

										// ...in a gzip-friendly way
										node = elem;
										outerCache = node[ expando ] || ( node[ expando ] = {} );

										// Support: IE <9 only
										// Defend against cloned attroperties (jQuery gh-1709)
										uniqueCache = outerCache[ node.uniqueID ] ||
											( outerCache[ node.uniqueID ] = {} );

										cache = uniqueCache[ type ] || [];
										nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
										diff = nodeIndex;
									}

									// xml :nth-child(...)
									// or :nth-last-child(...) or :nth(-last)?-of-type(...)
									if ( diff === false ) {

										// Use the same loop as above to seek `elem` from the start
										while ( ( node = ++nodeIndex && node && node[ dir ] ||
											( diff = nodeIndex = 0 ) || start.pop() ) ) {

											if ( ( ofType ?
												node.nodeName.toLowerCase() === name :
												node.nodeType === 1 ) &&
												++diff ) {

												// Cache the index of each encountered element
												if ( useCache ) {
													outerCache = node[ expando ] ||
														( node[ expando ] = {} );

													// Support: IE <9 only
													// Defend against cloned attroperties (jQuery gh-1709)
													uniqueCache = outerCache[ node.uniqueID ] ||
														( outerCache[ node.uniqueID ] = {} );

													uniqueCache[ type ] = [ dirruns, diff ];
												}

												if ( node === elem ) {
													break;
												}
											}
										}
									}
								}

								// Incorporate the offset, then check against cycle size
								diff -= last;
								return diff === first || ( diff % first === 0 && diff / first >= 0 );
							}
						};
				},

				"PSEUDO": function( pseudo, argument ) {

					// pseudo-class names are case-insensitive
					// http://www.w3.org/TR/selectors/#pseudo-classes
					// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
					// Remember that setFilters inherits from pseudos
					var args,
						fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
							Sizzle.error( "unsupported pseudo: " + pseudo );

					// The user may use createPseudo to indicate that
					// arguments are needed to create the filter function
					// just as Sizzle does
					if ( fn[ expando ] ) {
						return fn( argument );
					}

					// But maintain support for old signatures
					if ( fn.length > 1 ) {
						args = [ pseudo, pseudo, "", argument ];
						return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
							markFunction( function( seed, matches ) {
								var idx,
									matched = fn( seed, argument ),
									i = matched.length;
								while ( i-- ) {
									idx = indexOf( seed, matched[ i ] );
									seed[ idx ] = !( matches[ idx ] = matched[ i ] );
								}
							} ) :
							function( elem ) {
								return fn( elem, 0, args );
							};
					}

					return fn;
				}
			},

			pseudos: {

				// Potentially complex pseudos
				"not": markFunction( function( selector ) {

					// Trim the selector passed to compile
					// to avoid treating leading and trailing
					// spaces as combinators
					var input = [],
						results = [],
						matcher = compile( selector.replace( rtrim, "$1" ) );

					return matcher[ expando ] ?
						markFunction( function( seed, matches, _context, xml ) {
							var elem,
								unmatched = matcher( seed, null, xml, [] ),
								i = seed.length;

							// Match elements unmatched by `matcher`
							while ( i-- ) {
								if ( ( elem = unmatched[ i ] ) ) {
									seed[ i ] = !( matches[ i ] = elem );
								}
							}
						} ) :
						function( elem, _context, xml ) {
							input[ 0 ] = elem;
							matcher( input, null, xml, results );

							// Don't keep the element (issue #299)
							input[ 0 ] = null;
							return !results.pop();
						};
				} ),

				"has": markFunction( function( selector ) {
					return function( elem ) {
						return Sizzle( selector, elem ).length > 0;
					};
				} ),

				"contains": markFunction( function( text ) {
					text = text.replace( runescape, funescape );
					return function( elem ) {
						return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
					};
				} ),

				// "Whether an element is represented by a :lang() selector
				// is based solely on the element's language value
				// being equal to the identifier C,
				// or beginning with the identifier C immediately followed by "-".
				// The matching of C against the element's language value is performed case-insensitively.
				// The identifier C does not have to be a valid language name."
				// http://www.w3.org/TR/selectors/#lang-pseudo
				"lang": markFunction( function( lang ) {

					// lang value must be a valid identifier
					if ( !ridentifier.test( lang || "" ) ) {
						Sizzle.error( "unsupported lang: " + lang );
					}
					lang = lang.replace( runescape, funescape ).toLowerCase();
					return function( elem ) {
						var elemLang;
						do {
							if ( ( elemLang = documentIsHTML ?
								elem.lang :
								elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

								elemLang = elemLang.toLowerCase();
								return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
							}
						} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
						return false;
					};
				} ),

				// Miscellaneous
				"target": function( elem ) {
					var hash = window.location && window.location.hash;
					return hash && hash.slice( 1 ) === elem.id;
				},

				"root": function( elem ) {
					return elem === docElem;
				},

				"focus": function( elem ) {
					return elem === document.activeElement &&
						( !document.hasFocus || document.hasFocus() ) &&
						!!( elem.type || elem.href || ~elem.tabIndex );
				},

				// Boolean properties
				"enabled": createDisabledPseudo( false ),
				"disabled": createDisabledPseudo( true ),

				"checked": function( elem ) {

					// In CSS3, :checked should return both checked and selected elements
					// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
					var nodeName = elem.nodeName.toLowerCase();
					return ( nodeName === "input" && !!elem.checked ) ||
						( nodeName === "option" && !!elem.selected );
				},

				"selected": function( elem ) {

					// Accessing this property makes selected-by-default
					// options in Safari work properly
					if ( elem.parentNode ) {
						// eslint-disable-next-line no-unused-expressions
						elem.parentNode.selectedIndex;
					}

					return elem.selected === true;
				},

				// Contents
				"empty": function( elem ) {

					// http://www.w3.org/TR/selectors/#empty-pseudo
					// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
					//   but not by others (comment: 8; processing instruction: 7; etc.)
					// nodeType < 6 works because attributes (2) do not appear as children
					for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
						if ( elem.nodeType < 6 ) {
							return false;
						}
					}
					return true;
				},

				"parent": function( elem ) {
					return !Expr.pseudos[ "empty" ]( elem );
				},

				// Element/input types
				"header": function( elem ) {
					return rheader.test( elem.nodeName );
				},

				"input": function( elem ) {
					return rinputs.test( elem.nodeName );
				},

				"button": function( elem ) {
					var name = elem.nodeName.toLowerCase();
					return name === "input" && elem.type === "button" || name === "button";
				},

				"text": function( elem ) {
					var attr;
					return elem.nodeName.toLowerCase() === "input" &&
						elem.type === "text" &&

						// Support: IE <10 only
						// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
						( ( attr = elem.getAttribute( "type" ) ) == null ||
							attr.toLowerCase() === "text" );
				},

				// Position-in-collection
				"first": createPositionalPseudo( function() {
					return [ 0 ];
				} ),

				"last": createPositionalPseudo( function( _matchIndexes, length ) {
					return [ length - 1 ];
				} ),

				"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
					return [ argument < 0 ? argument + length : argument ];
				} ),

				"even": createPositionalPseudo( function( matchIndexes, length ) {
					var i = 0;
					for ( ; i < length; i += 2 ) {
						matchIndexes.push( i );
					}
					return matchIndexes;
				} ),

				"odd": createPositionalPseudo( function( matchIndexes, length ) {
					var i = 1;
					for ( ; i < length; i += 2 ) {
						matchIndexes.push( i );
					}
					return matchIndexes;
				} ),

				"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
					var i = argument < 0 ?
						argument + length :
						argument > length ?
							length :
							argument;
					for ( ; --i >= 0; ) {
						matchIndexes.push( i );
					}
					return matchIndexes;
				} ),

				"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
					var i = argument < 0 ? argument + length : argument;
					for ( ; ++i < length; ) {
						matchIndexes.push( i );
					}
					return matchIndexes;
				} )
			}
		};

		Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

		// Add button/input type pseudos
		for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
			Expr.pseudos[ i ] = createInputPseudo( i );
		}
		for ( i in { submit: true, reset: true } ) {
			Expr.pseudos[ i ] = createButtonPseudo( i );
		}

		// Easy API for creating new setFilters
		function setFilters() {}
		setFilters.prototype = Expr.filters = Expr.pseudos;
		Expr.setFilters = new setFilters();

		tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
			var matched, match, tokens, type,
				soFar, groups, preFilters,
				cached = tokenCache[ selector + " " ];

			if ( cached ) {
				return parseOnly ? 0 : cached.slice( 0 );
			}

			soFar = selector;
			groups = [];
			preFilters = Expr.preFilter;

			while ( soFar ) {

				// Comma and first run
				if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
					if ( match ) {

						// Don't consume trailing commas as valid
						soFar = soFar.slice( match[ 0 ].length ) || soFar;
					}
					groups.push( ( tokens = [] ) );
				}

				matched = false;

				// Combinators
				if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,

						// Cast descendant combinators to space
						type: match[ 0 ].replace( rtrim, " " )
					} );
					soFar = soFar.slice( matched.length );
				}

				// Filters
				for ( type in Expr.filter ) {
					if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
						( match = preFilters[ type ]( match ) ) ) ) {
						matched = match.shift();
						tokens.push( {
							value: matched,
							type: type,
							matches: match
						} );
						soFar = soFar.slice( matched.length );
					}
				}

				if ( !matched ) {
					break;
				}
			}

			// Return the length of the invalid excess
			// if we're just parsing
			// Otherwise, throw an error or return tokens
			return parseOnly ?
				soFar.length :
				soFar ?
					Sizzle.error( selector ) :

					// Cache the tokens
					tokenCache( selector, groups ).slice( 0 );
		};

		function toSelector( tokens ) {
			var i = 0,
				len = tokens.length,
				selector = "";
			for ( ; i < len; i++ ) {
				selector += tokens[ i ].value;
			}
			return selector;
		}

		function addCombinator( matcher, combinator, base ) {
			var dir = combinator.dir,
				skip = combinator.next,
				key = skip || dir,
				checkNonElements = base && key === "parentNode",
				doneName = done++;

			return combinator.first ?

				// Check against closest ancestor/preceding element
				function( elem, context, xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							return matcher( elem, context, xml );
						}
					}
					return false;
				} :

				// Check against all ancestor/preceding elements
				function( elem, context, xml ) {
					var oldCache, uniqueCache, outerCache,
						newCache = [ dirruns, doneName ];

					// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
					if ( xml ) {
						while ( ( elem = elem[ dir ] ) ) {
							if ( elem.nodeType === 1 || checkNonElements ) {
								if ( matcher( elem, context, xml ) ) {
									return true;
								}
							}
						}
					} else {
						while ( ( elem = elem[ dir ] ) ) {
							if ( elem.nodeType === 1 || checkNonElements ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ elem.uniqueID ] ||
									( outerCache[ elem.uniqueID ] = {} );

								if ( skip && skip === elem.nodeName.toLowerCase() ) {
									elem = elem[ dir ] || elem;
								} else if ( ( oldCache = uniqueCache[ key ] ) &&
									oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

									// Assign to newCache so results back-propagate to previous elements
									return ( newCache[ 2 ] = oldCache[ 2 ] );
								} else {

									// Reuse newcache so results back-propagate to previous elements
									uniqueCache[ key ] = newCache;

									// A match means we're done; a fail means we have to keep checking
									if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
										return true;
									}
								}
							}
						}
					}
					return false;
				};
		}

		function elementMatcher( matchers ) {
			return matchers.length > 1 ?
				function( elem, context, xml ) {
					var i = matchers.length;
					while ( i-- ) {
						if ( !matchers[ i ]( elem, context, xml ) ) {
							return false;
						}
					}
					return true;
				} :
				matchers[ 0 ];
		}

		function multipleContexts( selector, contexts, results ) {
			var i = 0,
				len = contexts.length;
			for ( ; i < len; i++ ) {
				Sizzle( selector, contexts[ i ], results );
			}
			return results;
		}

		function condense( unmatched, map, filter, context, xml ) {
			var elem,
				newUnmatched = [],
				i = 0,
				len = unmatched.length,
				mapped = map != null;

			for ( ; i < len; i++ ) {
				if ( ( elem = unmatched[ i ] ) ) {
					if ( !filter || filter( elem, context, xml ) ) {
						newUnmatched.push( elem );
						if ( mapped ) {
							map.push( i );
						}
					}
				}
			}

			return newUnmatched;
		}

		function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
			if ( postFilter && !postFilter[ expando ] ) {
				postFilter = setMatcher( postFilter );
			}
			if ( postFinder && !postFinder[ expando ] ) {
				postFinder = setMatcher( postFinder, postSelector );
			}
			return markFunction( function( seed, results, context, xml ) {
				var temp, i, elem,
					preMap = [],
					postMap = [],
					preexisting = results.length,

					// Get initial elements from seed or context
					elems = seed || multipleContexts(
						selector || "*",
						context.nodeType ? [ context ] : context,
						[]
					),

					// Prefilter to get matcher input, preserving a map for seed-results synchronization
					matcherIn = preFilter && ( seed || !selector ) ?
						condense( elems, preMap, preFilter, context, xml ) :
						elems,

					matcherOut = matcher ?

						// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
						postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

							// ...intermediate processing is necessary
							[] :

							// ...otherwise use results directly
							results :
						matcherIn;

				// Find primary matches
				if ( matcher ) {
					matcher( matcherIn, matcherOut, context, xml );
				}

				// Apply postFilter
				if ( postFilter ) {
					temp = condense( matcherOut, postMap );
					postFilter( temp, [], context, xml );

					// Un-match failing elements by moving them back to matcherIn
					i = temp.length;
					while ( i-- ) {
						if ( ( elem = temp[ i ] ) ) {
							matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
						}
					}
				}

				if ( seed ) {
					if ( postFinder || preFilter ) {
						if ( postFinder ) {

							// Get the final matcherOut by condensing this intermediate into postFinder contexts
							temp = [];
							i = matcherOut.length;
							while ( i-- ) {
								if ( ( elem = matcherOut[ i ] ) ) {

									// Restore matcherIn since elem is not yet a final match
									temp.push( ( matcherIn[ i ] = elem ) );
								}
							}
							postFinder( null, ( matcherOut = [] ), temp, xml );
						}

						// Move matched elements from seed to results to keep them synchronized
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) &&
								( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

								seed[ temp ] = !( results[ temp ] = elem );
							}
						}
					}

				// Add elements to results, through postFinder if defined
				} else {
					matcherOut = condense(
						matcherOut === results ?
							matcherOut.splice( preexisting, matcherOut.length ) :
							matcherOut
					);
					if ( postFinder ) {
						postFinder( null, results, matcherOut, xml );
					} else {
						push.apply( results, matcherOut );
					}
				}
			} );
		}

		function matcherFromTokens( tokens ) {
			var checkContext, matcher, j,
				len = tokens.length,
				leadingRelative = Expr.relative[ tokens[ 0 ].type ],
				implicitRelative = leadingRelative || Expr.relative[ " " ],
				i = leadingRelative ? 1 : 0,

				// The foundational matcher ensures that elements are reachable from top-level context(s)
				matchContext = addCombinator( function( elem ) {
					return elem === checkContext;
				}, implicitRelative, true ),
				matchAnyContext = addCombinator( function( elem ) {
					return indexOf( checkContext, elem ) > -1;
				}, implicitRelative, true ),
				matchers = [ function( elem, context, xml ) {
					var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
						( checkContext = context ).nodeType ?
							matchContext( elem, context, xml ) :
							matchAnyContext( elem, context, xml ) );

					// Avoid hanging onto element (issue #299)
					checkContext = null;
					return ret;
				} ];

			for ( ; i < len; i++ ) {
				if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
					matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
				} else {
					matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

					// Return special upon seeing a positional matcher
					if ( matcher[ expando ] ) {

						// Find the next relative operator (if any) for proper handling
						j = ++i;
						for ( ; j < len; j++ ) {
							if ( Expr.relative[ tokens[ j ].type ] ) {
								break;
							}
						}
						return setMatcher(
							i > 1 && elementMatcher( matchers ),
							i > 1 && toSelector(

							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens
								.slice( 0, i - 1 )
								.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
							).replace( rtrim, "$1" ),
							matcher,
							i < j && matcherFromTokens( tokens.slice( i, j ) ),
							j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
							j < len && toSelector( tokens )
						);
					}
					matchers.push( matcher );
				}
			}

			return elementMatcher( matchers );
		}

		function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
			var bySet = setMatchers.length > 0,
				byElement = elementMatchers.length > 0,
				superMatcher = function( seed, context, xml, results, outermost ) {
					var elem, j, matcher,
						matchedCount = 0,
						i = "0",
						unmatched = seed && [],
						setMatched = [],
						contextBackup = outermostContext,

						// We must always have either seed elements or outermost context
						elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

						// Use integer dirruns iff this is the outermost matcher
						dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
						len = elems.length;

					if ( outermost ) {

						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						outermostContext = context == document || context || outermost;
					}

					// Add elements passing elementMatchers directly to results
					// Support: IE<9, Safari
					// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
					for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
						if ( byElement && elem ) {
							j = 0;

							// Support: IE 11+, Edge 17 - 18+
							// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
							// two documents; shallow comparisons work.
							// eslint-disable-next-line eqeqeq
							if ( !context && elem.ownerDocument != document ) {
								setDocument( elem );
								xml = !documentIsHTML;
							}
							while ( ( matcher = elementMatchers[ j++ ] ) ) {
								if ( matcher( elem, context || document, xml ) ) {
									results.push( elem );
									break;
								}
							}
							if ( outermost ) {
								dirruns = dirrunsUnique;
							}
						}

						// Track unmatched elements for set filters
						if ( bySet ) {

							// They will have gone through all possible matchers
							if ( ( elem = !matcher && elem ) ) {
								matchedCount--;
							}

							// Lengthen the array for every element, matched or not
							if ( seed ) {
								unmatched.push( elem );
							}
						}
					}

					// `i` is now the count of elements visited above, and adding it to `matchedCount`
					// makes the latter nonnegative.
					matchedCount += i;

					// Apply set filters to unmatched elements
					// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
					// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
					// no element matchers and no seed.
					// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
					// case, which will result in a "00" `matchedCount` that differs from `i` but is also
					// numerically zero.
					if ( bySet && i !== matchedCount ) {
						j = 0;
						while ( ( matcher = setMatchers[ j++ ] ) ) {
							matcher( unmatched, setMatched, context, xml );
						}

						if ( seed ) {

							// Reintegrate element matches to eliminate the need for sorting
							if ( matchedCount > 0 ) {
								while ( i-- ) {
									if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
										setMatched[ i ] = pop.call( results );
									}
								}
							}

							// Discard index placeholder values to get only actual matches
							setMatched = condense( setMatched );
						}

						// Add matches to results
						push.apply( results, setMatched );

						// Seedless set matches succeeding multiple successful matchers stipulate sorting
						if ( outermost && !seed && setMatched.length > 0 &&
							( matchedCount + setMatchers.length ) > 1 ) {

							Sizzle.uniqueSort( results );
						}
					}

					// Override manipulation of globals by nested matchers
					if ( outermost ) {
						dirruns = dirrunsUnique;
						outermostContext = contextBackup;
					}

					return unmatched;
				};

			return bySet ?
				markFunction( superMatcher ) :
				superMatcher;
		}

		compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
			var i,
				setMatchers = [],
				elementMatchers = [],
				cached = compilerCache[ selector + " " ];

			if ( !cached ) {

				// Generate a function of recursive functions that can be used to check each element
				if ( !match ) {
					match = tokenize( selector );
				}
				i = match.length;
				while ( i-- ) {
					cached = matcherFromTokens( match[ i ] );
					if ( cached[ expando ] ) {
						setMatchers.push( cached );
					} else {
						elementMatchers.push( cached );
					}
				}

				// Cache the compiled function
				cached = compilerCache(
					selector,
					matcherFromGroupMatchers( elementMatchers, setMatchers )
				);

				// Save selector and tokenization
				cached.selector = selector;
			}
			return cached;
		};

		/**
		 * A low-level selection function that works with Sizzle's compiled
		 *  selector functions
		 * @param {String|Function} selector A selector or a pre-compiled
		 *  selector function built with Sizzle.compile
		 * @param {Element} context
		 * @param {Array} [results]
		 * @param {Array} [seed] A set of elements to match against
		 */
		select = Sizzle.select = function( selector, context, results, seed ) {
			var i, tokens, token, type, find,
				compiled = typeof selector === "function" && selector,
				match = !seed && tokenize( ( selector = compiled.selector || selector ) );

			results = results || [];

			// Try to minimize operations if there is only one selector in the list and no seed
			// (the latter of which guarantees us context)
			if ( match.length === 1 ) {

				// Reduce context if the leading compound selector is an ID
				tokens = match[ 0 ] = match[ 0 ].slice( 0 );
				if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

					context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
						.replace( runescape, funescape ), context ) || [] )[ 0 ];
					if ( !context ) {
						return results;

					// Precompiled matchers will still verify ancestry, so step up a level
					} else if ( compiled ) {
						context = context.parentNode;
					}

					selector = selector.slice( tokens.shift().value.length );
				}

				// Fetch a seed set for right-to-left matching
				i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
				while ( i-- ) {
					token = tokens[ i ];

					// Abort if we hit a combinator
					if ( Expr.relative[ ( type = token.type ) ] ) {
						break;
					}
					if ( ( find = Expr.find[ type ] ) ) {

						// Search, expanding context for leading sibling combinators
						if ( ( seed = find(
							token.matches[ 0 ].replace( runescape, funescape ),
							rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
								context
						) ) ) {

							// If seed is empty or no tokens remain, we can return early
							tokens.splice( i, 1 );
							selector = seed.length && toSelector( tokens );
							if ( !selector ) {
								push.apply( results, seed );
								return results;
							}

							break;
						}
					}
				}
			}

			// Compile and execute a filtering function if one is not provided
			// Provide `match` to avoid retokenization if we modified the selector above
			( compiled || compile( selector, match ) )(
				seed,
				context,
				!documentIsHTML,
				results,
				!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
			);
			return results;
		};

		// One-time assignments

		// Sort stability
		support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

		// Support: Chrome 14-35+
		// Always assume duplicates if they aren't passed to the comparison function
		support.detectDuplicates = !!hasDuplicate;

		// Initialize against the default document
		setDocument();

		// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
		// Detached nodes confoundingly follow *each other*
		support.sortDetached = assert( function( el ) {

			// Should return 1, but returns 4 (following)
			return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
		} );

		// Support: IE<8
		// Prevent attribute/property "interpolation"
		// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
		if ( !assert( function( el ) {
			el.innerHTML = "<a href='#'></a>";
			return el.firstChild.getAttribute( "href" ) === "#";
		} ) ) {
			addHandle( "type|href|height|width", function( elem, name, isXML ) {
				if ( !isXML ) {
					return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
				}
			} );
		}

		// Support: IE<9
		// Use defaultValue in place of getAttribute("value")
		if ( !support.attributes || !assert( function( el ) {
			el.innerHTML = "<input/>";
			el.firstChild.setAttribute( "value", "" );
			return el.firstChild.getAttribute( "value" ) === "";
		} ) ) {
			addHandle( "value", function( elem, _name, isXML ) {
				if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
					return elem.defaultValue;
				}
			} );
		}

		// Support: IE<9
		// Use getAttributeNode to fetch booleans when getAttribute lies
		if ( !assert( function( el ) {
			return el.getAttribute( "disabled" ) == null;
		} ) ) {
			addHandle( booleans, function( elem, name, isXML ) {
				var val;
				if ( !isXML ) {
					return elem[ name ] === true ? name.toLowerCase() :
						( val = elem.getAttributeNode( name ) ) && val.specified ?
							val.value :
							null;
				}
			} );
		}

		return Sizzle;

		} )( window );



		jQuery.find = Sizzle;
		jQuery.expr = Sizzle.selectors;

		// Deprecated
		jQuery.expr[ ":" ] = jQuery.expr.pseudos;
		jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
		jQuery.text = Sizzle.getText;
		jQuery.isXMLDoc = Sizzle.isXML;
		jQuery.contains = Sizzle.contains;
		jQuery.escapeSelector = Sizzle.escape;




		var dir = function( elem, dir, until ) {
			var matched = [],
				truncate = until !== undefined;

			while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
				if ( elem.nodeType === 1 ) {
					if ( truncate && jQuery( elem ).is( until ) ) {
						break;
					}
					matched.push( elem );
				}
			}
			return matched;
		};


		var siblings = function( n, elem ) {
			var matched = [];

			for ( ; n; n = n.nextSibling ) {
				if ( n.nodeType === 1 && n !== elem ) {
					matched.push( n );
				}
			}

			return matched;
		};


		var rneedsContext = jQuery.expr.match.needsContext;



		function nodeName( elem, name ) {

			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

		}
		var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



		// Implement the identical functionality for filter and not
		function winnow( elements, qualifier, not ) {
			if ( isFunction( qualifier ) ) {
				return jQuery.grep( elements, function( elem, i ) {
					return !!qualifier.call( elem, i, elem ) !== not;
				} );
			}

			// Single element
			if ( qualifier.nodeType ) {
				return jQuery.grep( elements, function( elem ) {
					return ( elem === qualifier ) !== not;
				} );
			}

			// Arraylike of elements (jQuery, arguments, Array)
			if ( typeof qualifier !== "string" ) {
				return jQuery.grep( elements, function( elem ) {
					return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
				} );
			}

			// Filtered directly for both simple and complex selectors
			return jQuery.filter( qualifier, elements, not );
		}

		jQuery.filter = function( expr, elems, not ) {
			var elem = elems[ 0 ];

			if ( not ) {
				expr = ":not(" + expr + ")";
			}

			if ( elems.length === 1 && elem.nodeType === 1 ) {
				return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
			}

			return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
		};

		jQuery.fn.extend( {
			find: function( selector ) {
				var i, ret,
					len = this.length,
					self = this;

				if ( typeof selector !== "string" ) {
					return this.pushStack( jQuery( selector ).filter( function() {
						for ( i = 0; i < len; i++ ) {
							if ( jQuery.contains( self[ i ], this ) ) {
								return true;
							}
						}
					} ) );
				}

				ret = this.pushStack( [] );

				for ( i = 0; i < len; i++ ) {
					jQuery.find( selector, self[ i ], ret );
				}

				return len > 1 ? jQuery.uniqueSort( ret ) : ret;
			},
			filter: function( selector ) {
				return this.pushStack( winnow( this, selector || [], false ) );
			},
			not: function( selector ) {
				return this.pushStack( winnow( this, selector || [], true ) );
			},
			is: function( selector ) {
				return !!winnow(
					this,

					// If this is a positional/relative selector, check membership in the returned set
					// so $("p:first").is("p:last") won't return true for a doc with two "p".
					typeof selector === "string" && rneedsContext.test( selector ) ?
						jQuery( selector ) :
						selector || [],
					false
				).length;
			}
		} );


		// Initialize a jQuery object


		// A central reference to the root jQuery(document)
		var rootjQuery,

			// A simple way to check for HTML strings
			// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
			// Strict HTML recognition (trac-11290: must start with <)
			// Shortcut simple #id case for speed
			rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

			init = jQuery.fn.init = function( selector, context, root ) {
				var match, elem;

				// HANDLE: $(""), $(null), $(undefined), $(false)
				if ( !selector ) {
					return this;
				}

				// Method init() accepts an alternate rootjQuery
				// so migrate can support jQuery.sub (gh-2101)
				root = root || rootjQuery;

				// Handle HTML strings
				if ( typeof selector === "string" ) {
					if ( selector[ 0 ] === "<" &&
						selector[ selector.length - 1 ] === ">" &&
						selector.length >= 3 ) {

						// Assume that strings that start and end with <> are HTML and skip the regex check
						match = [ null, selector, null ];

					} else {
						match = rquickExpr.exec( selector );
					}

					// Match html or make sure no context is specified for #id
					if ( match && ( match[ 1 ] || !context ) ) {

						// HANDLE: $(html) -> $(array)
						if ( match[ 1 ] ) {
							context = context instanceof jQuery ? context[ 0 ] : context;

							// Option to run scripts is true for back-compat
							// Intentionally let the error be thrown if parseHTML is not present
							jQuery.merge( this, jQuery.parseHTML(
								match[ 1 ],
								context && context.nodeType ? context.ownerDocument || context : document,
								true
							) );

							// HANDLE: $(html, props)
							if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
								for ( match in context ) {

									// Properties of context are called as methods if possible
									if ( isFunction( this[ match ] ) ) {
										this[ match ]( context[ match ] );

									// ...and otherwise set as attributes
									} else {
										this.attr( match, context[ match ] );
									}
								}
							}

							return this;

						// HANDLE: $(#id)
						} else {
							elem = document.getElementById( match[ 2 ] );

							if ( elem ) {

								// Inject the element directly into the jQuery object
								this[ 0 ] = elem;
								this.length = 1;
							}
							return this;
						}

					// HANDLE: $(expr, $(...))
					} else if ( !context || context.jquery ) {
						return ( context || root ).find( selector );

					// HANDLE: $(expr, context)
					// (which is just equivalent to: $(context).find(expr)
					} else {
						return this.constructor( context ).find( selector );
					}

				// HANDLE: $(DOMElement)
				} else if ( selector.nodeType ) {
					this[ 0 ] = selector;
					this.length = 1;
					return this;

				// HANDLE: $(function)
				// Shortcut for document ready
				} else if ( isFunction( selector ) ) {
					return root.ready !== undefined ?
						root.ready( selector ) :

						// Execute immediately if ready is not present
						selector( jQuery );
				}

				return jQuery.makeArray( selector, this );
			};

		// Give the init function the jQuery prototype for later instantiation
		init.prototype = jQuery.fn;

		// Initialize central reference
		rootjQuery = jQuery( document );


		var rparentsprev = /^(?:parents|prev(?:Until|All))/,

			// Methods guaranteed to produce a unique set when starting from a unique set
			guaranteedUnique = {
				children: true,
				contents: true,
				next: true,
				prev: true
			};

		jQuery.fn.extend( {
			has: function( target ) {
				var targets = jQuery( target, this ),
					l = targets.length;

				return this.filter( function() {
					var i = 0;
					for ( ; i < l; i++ ) {
						if ( jQuery.contains( this, targets[ i ] ) ) {
							return true;
						}
					}
				} );
			},

			closest: function( selectors, context ) {
				var cur,
					i = 0,
					l = this.length,
					matched = [],
					targets = typeof selectors !== "string" && jQuery( selectors );

				// Positional selectors never match, since there's no _selection_ context
				if ( !rneedsContext.test( selectors ) ) {
					for ( ; i < l; i++ ) {
						for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

							// Always skip document fragments
							if ( cur.nodeType < 11 && ( targets ?
								targets.index( cur ) > -1 :

								// Don't pass non-elements to Sizzle
								cur.nodeType === 1 &&
									jQuery.find.matchesSelector( cur, selectors ) ) ) {

								matched.push( cur );
								break;
							}
						}
					}
				}

				return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
			},

			// Determine the position of an element within the set
			index: function( elem ) {

				// No argument, return index in parent
				if ( !elem ) {
					return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
				}

				// Index in selector
				if ( typeof elem === "string" ) {
					return indexOf.call( jQuery( elem ), this[ 0 ] );
				}

				// Locate the position of the desired element
				return indexOf.call( this,

					// If it receives a jQuery object, the first element is used
					elem.jquery ? elem[ 0 ] : elem
				);
			},

			add: function( selector, context ) {
				return this.pushStack(
					jQuery.uniqueSort(
						jQuery.merge( this.get(), jQuery( selector, context ) )
					)
				);
			},

			addBack: function( selector ) {
				return this.add( selector == null ?
					this.prevObject : this.prevObject.filter( selector )
				);
			}
		} );

		function sibling( cur, dir ) {
			while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
			return cur;
		}

		jQuery.each( {
			parent: function( elem ) {
				var parent = elem.parentNode;
				return parent && parent.nodeType !== 11 ? parent : null;
			},
			parents: function( elem ) {
				return dir( elem, "parentNode" );
			},
			parentsUntil: function( elem, _i, until ) {
				return dir( elem, "parentNode", until );
			},
			next: function( elem ) {
				return sibling( elem, "nextSibling" );
			},
			prev: function( elem ) {
				return sibling( elem, "previousSibling" );
			},
			nextAll: function( elem ) {
				return dir( elem, "nextSibling" );
			},
			prevAll: function( elem ) {
				return dir( elem, "previousSibling" );
			},
			nextUntil: function( elem, _i, until ) {
				return dir( elem, "nextSibling", until );
			},
			prevUntil: function( elem, _i, until ) {
				return dir( elem, "previousSibling", until );
			},
			siblings: function( elem ) {
				return siblings( ( elem.parentNode || {} ).firstChild, elem );
			},
			children: function( elem ) {
				return siblings( elem.firstChild );
			},
			contents: function( elem ) {
				if ( elem.contentDocument != null &&

					// Support: IE 11+
					// <object> elements with no `data` attribute has an object
					// `contentDocument` with a `null` prototype.
					getProto( elem.contentDocument ) ) {

					return elem.contentDocument;
				}

				// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
				// Treat the template element as a regular one in browsers that
				// don't support it.
				if ( nodeName( elem, "template" ) ) {
					elem = elem.content || elem;
				}

				return jQuery.merge( [], elem.childNodes );
			}
		}, function( name, fn ) {
			jQuery.fn[ name ] = function( until, selector ) {
				var matched = jQuery.map( this, fn, until );

				if ( name.slice( -5 ) !== "Until" ) {
					selector = until;
				}

				if ( selector && typeof selector === "string" ) {
					matched = jQuery.filter( selector, matched );
				}

				if ( this.length > 1 ) {

					// Remove duplicates
					if ( !guaranteedUnique[ name ] ) {
						jQuery.uniqueSort( matched );
					}

					// Reverse order for parents* and prev-derivatives
					if ( rparentsprev.test( name ) ) {
						matched.reverse();
					}
				}

				return this.pushStack( matched );
			};
		} );
		var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



		// Convert String-formatted options into Object-formatted ones
		function createOptions( options ) {
			var object = {};
			jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
				object[ flag ] = true;
			} );
			return object;
		}

		/*
		 * Create a callback list using the following parameters:
		 *
		 *	options: an optional list of space-separated options that will change how
		 *			the callback list behaves or a more traditional option object
		 *
		 * By default a callback list will act like an event callback list and can be
		 * "fired" multiple times.
		 *
		 * Possible options:
		 *
		 *	once:			will ensure the callback list can only be fired once (like a Deferred)
		 *
		 *	memory:			will keep track of previous values and will call any callback added
		 *					after the list has been fired right away with the latest "memorized"
		 *					values (like a Deferred)
		 *
		 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
		 *
		 *	stopOnFalse:	interrupt callings when a callback returns false
		 *
		 */
		jQuery.Callbacks = function( options ) {

			// Convert options from String-formatted to Object-formatted if needed
			// (we check in cache first)
			options = typeof options === "string" ?
				createOptions( options ) :
				jQuery.extend( {}, options );

			var // Flag to know if list is currently firing
				firing,

				// Last fire value for non-forgettable lists
				memory,

				// Flag to know if list was already fired
				fired,

				// Flag to prevent firing
				locked,

				// Actual callback list
				list = [],

				// Queue of execution data for repeatable lists
				queue = [],

				// Index of currently firing callback (modified by add/remove as needed)
				firingIndex = -1,

				// Fire callbacks
				fire = function() {

					// Enforce single-firing
					locked = locked || options.once;

					// Execute callbacks for all pending executions,
					// respecting firingIndex overrides and runtime changes
					fired = firing = true;
					for ( ; queue.length; firingIndex = -1 ) {
						memory = queue.shift();
						while ( ++firingIndex < list.length ) {

							// Run callback and check for early termination
							if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
								options.stopOnFalse ) {

								// Jump to end and forget the data so .add doesn't re-fire
								firingIndex = list.length;
								memory = false;
							}
						}
					}

					// Forget the data if we're done with it
					if ( !options.memory ) {
						memory = false;
					}

					firing = false;

					// Clean up if we're done firing for good
					if ( locked ) {

						// Keep an empty list if we have data for future add calls
						if ( memory ) {
							list = [];

						// Otherwise, this object is spent
						} else {
							list = "";
						}
					}
				},

				// Actual Callbacks object
				self = {

					// Add a callback or a collection of callbacks to the list
					add: function() {
						if ( list ) {

							// If we have memory from a past run, we should fire after adding
							if ( memory && !firing ) {
								firingIndex = list.length - 1;
								queue.push( memory );
							}

							( function add( args ) {
								jQuery.each( args, function( _, arg ) {
									if ( isFunction( arg ) ) {
										if ( !options.unique || !self.has( arg ) ) {
											list.push( arg );
										}
									} else if ( arg && arg.length && toType( arg ) !== "string" ) {

										// Inspect recursively
										add( arg );
									}
								} );
							} )( arguments );

							if ( memory && !firing ) {
								fire();
							}
						}
						return this;
					},

					// Remove a callback from the list
					remove: function() {
						jQuery.each( arguments, function( _, arg ) {
							var index;
							while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
								list.splice( index, 1 );

								// Handle firing indexes
								if ( index <= firingIndex ) {
									firingIndex--;
								}
							}
						} );
						return this;
					},

					// Check if a given callback is in the list.
					// If no argument is given, return whether or not list has callbacks attached.
					has: function( fn ) {
						return fn ?
							jQuery.inArray( fn, list ) > -1 :
							list.length > 0;
					},

					// Remove all callbacks from the list
					empty: function() {
						if ( list ) {
							list = [];
						}
						return this;
					},

					// Disable .fire and .add
					// Abort any current/pending executions
					// Clear all callbacks and values
					disable: function() {
						locked = queue = [];
						list = memory = "";
						return this;
					},
					disabled: function() {
						return !list;
					},

					// Disable .fire
					// Also disable .add unless we have memory (since it would have no effect)
					// Abort any pending executions
					lock: function() {
						locked = queue = [];
						if ( !memory && !firing ) {
							list = memory = "";
						}
						return this;
					},
					locked: function() {
						return !!locked;
					},

					// Call all callbacks with the given context and arguments
					fireWith: function( context, args ) {
						if ( !locked ) {
							args = args || [];
							args = [ context, args.slice ? args.slice() : args ];
							queue.push( args );
							if ( !firing ) {
								fire();
							}
						}
						return this;
					},

					// Call all the callbacks with the given arguments
					fire: function() {
						self.fireWith( this, arguments );
						return this;
					},

					// To know if the callbacks have already been called at least once
					fired: function() {
						return !!fired;
					}
				};

			return self;
		};


		function Identity( v ) {
			return v;
		}
		function Thrower( ex ) {
			throw ex;
		}

		function adoptValue( value, resolve, reject, noValue ) {
			var method;

			try {

				// Check for promise aspect first to privilege synchronous behavior
				if ( value && isFunction( ( method = value.promise ) ) ) {
					method.call( value ).done( resolve ).fail( reject );

				// Other thenables
				} else if ( value && isFunction( ( method = value.then ) ) ) {
					method.call( value, resolve, reject );

				// Other non-thenables
				} else {

					// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
					// * false: [ value ].slice( 0 ) => resolve( value )
					// * true: [ value ].slice( 1 ) => resolve()
					resolve.apply( undefined, [ value ].slice( noValue ) );
				}

			// For Promises/A+, convert exceptions into rejections
			// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
			// Deferred#then to conditionally suppress rejection.
			} catch ( value ) {

				// Support: Android 4.0 only
				// Strict mode functions invoked without .call/.apply get global-object context
				reject.apply( undefined, [ value ] );
			}
		}

		jQuery.extend( {

			Deferred: function( func ) {
				var tuples = [

						// action, add listener, callbacks,
						// ... .then handlers, argument index, [final state]
						[ "notify", "progress", jQuery.Callbacks( "memory" ),
							jQuery.Callbacks( "memory" ), 2 ],
						[ "resolve", "done", jQuery.Callbacks( "once memory" ),
							jQuery.Callbacks( "once memory" ), 0, "resolved" ],
						[ "reject", "fail", jQuery.Callbacks( "once memory" ),
							jQuery.Callbacks( "once memory" ), 1, "rejected" ]
					],
					state = "pending",
					promise = {
						state: function() {
							return state;
						},
						always: function() {
							deferred.done( arguments ).fail( arguments );
							return this;
						},
						"catch": function( fn ) {
							return promise.then( null, fn );
						},

						// Keep pipe for back-compat
						pipe: function( /* fnDone, fnFail, fnProgress */ ) {
							var fns = arguments;

							return jQuery.Deferred( function( newDefer ) {
								jQuery.each( tuples, function( _i, tuple ) {

									// Map tuples (progress, done, fail) to arguments (done, fail, progress)
									var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

									// deferred.progress(function() { bind to newDefer or newDefer.notify })
									// deferred.done(function() { bind to newDefer or newDefer.resolve })
									// deferred.fail(function() { bind to newDefer or newDefer.reject })
									deferred[ tuple[ 1 ] ]( function() {
										var returned = fn && fn.apply( this, arguments );
										if ( returned && isFunction( returned.promise ) ) {
											returned.promise()
												.progress( newDefer.notify )
												.done( newDefer.resolve )
												.fail( newDefer.reject );
										} else {
											newDefer[ tuple[ 0 ] + "With" ](
												this,
												fn ? [ returned ] : arguments
											);
										}
									} );
								} );
								fns = null;
							} ).promise();
						},
						then: function( onFulfilled, onRejected, onProgress ) {
							var maxDepth = 0;
							function resolve( depth, deferred, handler, special ) {
								return function() {
									var that = this,
										args = arguments,
										mightThrow = function() {
											var returned, then;

											// Support: Promises/A+ section 2.3.3.3.3
											// https://promisesaplus.com/#point-59
											// Ignore double-resolution attempts
											if ( depth < maxDepth ) {
												return;
											}

											returned = handler.apply( that, args );

											// Support: Promises/A+ section 2.3.1
											// https://promisesaplus.com/#point-48
											if ( returned === deferred.promise() ) {
												throw new TypeError( "Thenable self-resolution" );
											}

											// Support: Promises/A+ sections 2.3.3.1, 3.5
											// https://promisesaplus.com/#point-54
											// https://promisesaplus.com/#point-75
											// Retrieve `then` only once
											then = returned &&

												// Support: Promises/A+ section 2.3.4
												// https://promisesaplus.com/#point-64
												// Only check objects and functions for thenability
												( typeof returned === "object" ||
													typeof returned === "function" ) &&
												returned.then;

											// Handle a returned thenable
											if ( isFunction( then ) ) {

												// Special processors (notify) just wait for resolution
												if ( special ) {
													then.call(
														returned,
														resolve( maxDepth, deferred, Identity, special ),
														resolve( maxDepth, deferred, Thrower, special )
													);

												// Normal processors (resolve) also hook into progress
												} else {

													// ...and disregard older resolution values
													maxDepth++;

													then.call(
														returned,
														resolve( maxDepth, deferred, Identity, special ),
														resolve( maxDepth, deferred, Thrower, special ),
														resolve( maxDepth, deferred, Identity,
															deferred.notifyWith )
													);
												}

											// Handle all other returned values
											} else {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Identity ) {
													that = undefined;
													args = [ returned ];
												}

												// Process the value(s)
												// Default process is resolve
												( special || deferred.resolveWith )( that, args );
											}
										},

										// Only normal processors (resolve) catch and reject exceptions
										process = special ?
											mightThrow :
											function() {
												try {
													mightThrow();
												} catch ( e ) {

													if ( jQuery.Deferred.exceptionHook ) {
														jQuery.Deferred.exceptionHook( e,
															process.stackTrace );
													}

													// Support: Promises/A+ section 2.3.3.3.4.1
													// https://promisesaplus.com/#point-61
													// Ignore post-resolution exceptions
													if ( depth + 1 >= maxDepth ) {

														// Only substitute handlers pass on context
														// and multiple values (non-spec behavior)
														if ( handler !== Thrower ) {
															that = undefined;
															args = [ e ];
														}

														deferred.rejectWith( that, args );
													}
												}
											};

									// Support: Promises/A+ section 2.3.3.3.1
									// https://promisesaplus.com/#point-57
									// Re-resolve promises immediately to dodge false rejection from
									// subsequent errors
									if ( depth ) {
										process();
									} else {

										// Call an optional hook to record the stack, in case of exception
										// since it's otherwise lost when execution goes async
										if ( jQuery.Deferred.getStackHook ) {
											process.stackTrace = jQuery.Deferred.getStackHook();
										}
										window.setTimeout( process );
									}
								};
							}

							return jQuery.Deferred( function( newDefer ) {

								// progress_handlers.add( ... )
								tuples[ 0 ][ 3 ].add(
									resolve(
										0,
										newDefer,
										isFunction( onProgress ) ?
											onProgress :
											Identity,
										newDefer.notifyWith
									)
								);

								// fulfilled_handlers.add( ... )
								tuples[ 1 ][ 3 ].add(
									resolve(
										0,
										newDefer,
										isFunction( onFulfilled ) ?
											onFulfilled :
											Identity
									)
								);

								// rejected_handlers.add( ... )
								tuples[ 2 ][ 3 ].add(
									resolve(
										0,
										newDefer,
										isFunction( onRejected ) ?
											onRejected :
											Thrower
									)
								);
							} ).promise();
						},

						// Get a promise for this deferred
						// If obj is provided, the promise aspect is added to the object
						promise: function( obj ) {
							return obj != null ? jQuery.extend( obj, promise ) : promise;
						}
					},
					deferred = {};

				// Add list-specific methods
				jQuery.each( tuples, function( i, tuple ) {
					var list = tuple[ 2 ],
						stateString = tuple[ 5 ];

					// promise.progress = list.add
					// promise.done = list.add
					// promise.fail = list.add
					promise[ tuple[ 1 ] ] = list.add;

					// Handle state
					if ( stateString ) {
						list.add(
							function() {

								// state = "resolved" (i.e., fulfilled)
								// state = "rejected"
								state = stateString;
							},

							// rejected_callbacks.disable
							// fulfilled_callbacks.disable
							tuples[ 3 - i ][ 2 ].disable,

							// rejected_handlers.disable
							// fulfilled_handlers.disable
							tuples[ 3 - i ][ 3 ].disable,

							// progress_callbacks.lock
							tuples[ 0 ][ 2 ].lock,

							// progress_handlers.lock
							tuples[ 0 ][ 3 ].lock
						);
					}

					// progress_handlers.fire
					// fulfilled_handlers.fire
					// rejected_handlers.fire
					list.add( tuple[ 3 ].fire );

					// deferred.notify = function() { deferred.notifyWith(...) }
					// deferred.resolve = function() { deferred.resolveWith(...) }
					// deferred.reject = function() { deferred.rejectWith(...) }
					deferred[ tuple[ 0 ] ] = function() {
						deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
						return this;
					};

					// deferred.notifyWith = list.fireWith
					// deferred.resolveWith = list.fireWith
					// deferred.rejectWith = list.fireWith
					deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
				} );

				// Make the deferred a promise
				promise.promise( deferred );

				// Call given func if any
				if ( func ) {
					func.call( deferred, deferred );
				}

				// All done!
				return deferred;
			},

			// Deferred helper
			when: function( singleValue ) {
				var

					// count of uncompleted subordinates
					remaining = arguments.length,

					// count of unprocessed arguments
					i = remaining,

					// subordinate fulfillment data
					resolveContexts = Array( i ),
					resolveValues = slice.call( arguments ),

					// the primary Deferred
					primary = jQuery.Deferred(),

					// subordinate callback factory
					updateFunc = function( i ) {
						return function( value ) {
							resolveContexts[ i ] = this;
							resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
							if ( !( --remaining ) ) {
								primary.resolveWith( resolveContexts, resolveValues );
							}
						};
					};

				// Single- and empty arguments are adopted like Promise.resolve
				if ( remaining <= 1 ) {
					adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
						!remaining );

					// Use .then() to unwrap secondary thenables (cf. gh-3000)
					if ( primary.state() === "pending" ||
						isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

						return primary.then();
					}
				}

				// Multiple arguments are aggregated like Promise.all array elements
				while ( i-- ) {
					adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
				}

				return primary.promise();
			}
		} );


		// These usually indicate a programmer mistake during development,
		// warn about them ASAP rather than swallowing them by default.
		var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

		jQuery.Deferred.exceptionHook = function( error, stack ) {

			// Support: IE 8 - 9 only
			// Console exists when dev tools are open, which can happen at any time
			if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
				window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
			}
		};




		jQuery.readyException = function( error ) {
			window.setTimeout( function() {
				throw error;
			} );
		};




		// The deferred used on DOM ready
		var readyList = jQuery.Deferred();

		jQuery.fn.ready = function( fn ) {

			readyList
				.then( fn )

				// Wrap jQuery.readyException in a function so that the lookup
				// happens at the time of error handling instead of callback
				// registration.
				.catch( function( error ) {
					jQuery.readyException( error );
				} );

			return this;
		};

		jQuery.extend( {

			// Is the DOM ready to be used? Set to true once it occurs.
			isReady: false,

			// A counter to track how many items to wait for before
			// the ready event fires. See trac-6781
			readyWait: 1,

			// Handle when the DOM is ready
			ready: function( wait ) {

				// Abort if there are pending holds or we're already ready
				if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
					return;
				}

				// Remember that the DOM is ready
				jQuery.isReady = true;

				// If a normal DOM Ready event fired, decrement, and wait if need be
				if ( wait !== true && --jQuery.readyWait > 0 ) {
					return;
				}

				// If there are functions bound, to execute
				readyList.resolveWith( document, [ jQuery ] );
			}
		} );

		jQuery.ready.then = readyList.then;

		// The ready event handler and self cleanup method
		function completed() {
			document.removeEventListener( "DOMContentLoaded", completed );
			window.removeEventListener( "load", completed );
			jQuery.ready();
		}

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE <=9 - 10 only
		// Older IE sometimes signals "interactive" too soon
		if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed );
		}




		// Multifunctional method to get and set values of a collection
		// The value/s can optionally be executed if it's a function
		var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
			var i = 0,
				len = elems.length,
				bulk = key == null;

			// Sets many values
			if ( toType( key ) === "object" ) {
				chainable = true;
				for ( i in key ) {
					access( elems, fn, i, key[ i ], true, emptyGet, raw );
				}

			// Sets one value
			} else if ( value !== undefined ) {
				chainable = true;

				if ( !isFunction( value ) ) {
					raw = true;
				}

				if ( bulk ) {

					// Bulk operations run against the entire set
					if ( raw ) {
						fn.call( elems, value );
						fn = null;

					// ...except when executing function values
					} else {
						bulk = fn;
						fn = function( elem, _key, value ) {
							return bulk.call( jQuery( elem ), value );
						};
					}
				}

				if ( fn ) {
					for ( ; i < len; i++ ) {
						fn(
							elems[ i ], key, raw ?
								value :
								value.call( elems[ i ], i, fn( elems[ i ], key ) )
						);
					}
				}
			}

			if ( chainable ) {
				return elems;
			}

			// Gets
			if ( bulk ) {
				return fn.call( elems );
			}

			return len ? fn( elems[ 0 ], key ) : emptyGet;
		};


		// Matches dashed string for camelizing
		var rmsPrefix = /^-ms-/,
			rdashAlpha = /-([a-z])/g;

		// Used by camelCase as callback to replace()
		function fcamelCase( _all, letter ) {
			return letter.toUpperCase();
		}

		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 15
		// Microsoft forgot to hump their vendor prefix (trac-9572)
		function camelCase( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		}
		var acceptData = function( owner ) {

			// Accepts only:
			//  - Node
			//    - Node.ELEMENT_NODE
			//    - Node.DOCUMENT_NODE
			//  - Object
			//    - Any
			return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
		};




		function Data() {
			this.expando = jQuery.expando + Data.uid++;
		}

		Data.uid = 1;

		Data.prototype = {

			cache: function( owner ) {

				// Check if the owner object already has a cache
				var value = owner[ this.expando ];

				// If not, create one
				if ( !value ) {
					value = {};

					// We can accept data for non-element nodes in modern browsers,
					// but we should not, see trac-8335.
					// Always return an empty object.
					if ( acceptData( owner ) ) {

						// If it is a node unlikely to be stringify-ed or looped over
						// use plain assignment
						if ( owner.nodeType ) {
							owner[ this.expando ] = value;

						// Otherwise secure it in a non-enumerable property
						// configurable must be true to allow the property to be
						// deleted when data is removed
						} else {
							Object.defineProperty( owner, this.expando, {
								value: value,
								configurable: true
							} );
						}
					}
				}

				return value;
			},
			set: function( owner, data, value ) {
				var prop,
					cache = this.cache( owner );

				// Handle: [ owner, key, value ] args
				// Always use camelCase key (gh-2257)
				if ( typeof data === "string" ) {
					cache[ camelCase( data ) ] = value;

				// Handle: [ owner, { properties } ] args
				} else {

					// Copy the properties one-by-one to the cache object
					for ( prop in data ) {
						cache[ camelCase( prop ) ] = data[ prop ];
					}
				}
				return cache;
			},
			get: function( owner, key ) {
				return key === undefined ?
					this.cache( owner ) :

					// Always use camelCase key (gh-2257)
					owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
			},
			access: function( owner, key, value ) {

				// In cases where either:
				//
				//   1. No key was specified
				//   2. A string key was specified, but no value provided
				//
				// Take the "read" path and allow the get method to determine
				// which value to return, respectively either:
				//
				//   1. The entire cache object
				//   2. The data stored at the key
				//
				if ( key === undefined ||
						( ( key && typeof key === "string" ) && value === undefined ) ) {

					return this.get( owner, key );
				}

				// When the key is not a string, or both a key and value
				// are specified, set or extend (existing objects) with either:
				//
				//   1. An object of properties
				//   2. A key and value
				//
				this.set( owner, key, value );

				// Since the "set" path can have two possible entry points
				// return the expected data based on which path was taken[*]
				return value !== undefined ? value : key;
			},
			remove: function( owner, key ) {
				var i,
					cache = owner[ this.expando ];

				if ( cache === undefined ) {
					return;
				}

				if ( key !== undefined ) {

					// Support array or space separated string of keys
					if ( Array.isArray( key ) ) {

						// If key is an array of keys...
						// We always set camelCase keys, so remove that.
						key = key.map( camelCase );
					} else {
						key = camelCase( key );

						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						key = key in cache ?
							[ key ] :
							( key.match( rnothtmlwhite ) || [] );
					}

					i = key.length;

					while ( i-- ) {
						delete cache[ key[ i ] ];
					}
				}

				// Remove the expando if there's no more data
				if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

					// Support: Chrome <=35 - 45
					// Webkit & Blink performance suffers when deleting properties
					// from DOM nodes, so set to undefined instead
					// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
					if ( owner.nodeType ) {
						owner[ this.expando ] = undefined;
					} else {
						delete owner[ this.expando ];
					}
				}
			},
			hasData: function( owner ) {
				var cache = owner[ this.expando ];
				return cache !== undefined && !jQuery.isEmptyObject( cache );
			}
		};
		var dataPriv = new Data();

		var dataUser = new Data();



		//	Implementation Summary
		//
		//	1. Enforce API surface and semantic compatibility with 1.9.x branch
		//	2. Improve the module's maintainability by reducing the storage
		//		paths to a single mechanism.
		//	3. Use the same single mechanism to support "private" and "user" data.
		//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
		//	5. Avoid exposing implementation details on user objects (eg. expando properties)
		//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

		var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
			rmultiDash = /[A-Z]/g;

		function getData( data ) {
			if ( data === "true" ) {
				return true;
			}

			if ( data === "false" ) {
				return false;
			}

			if ( data === "null" ) {
				return null;
			}

			// Only convert to a number if it doesn't change the string
			if ( data === +data + "" ) {
				return +data;
			}

			if ( rbrace.test( data ) ) {
				return JSON.parse( data );
			}

			return data;
		}

		function dataAttr( elem, key, data ) {
			var name;

			// If nothing was found internally, try to fetch any
			// data from the HTML5 data-* attribute
			if ( data === undefined && elem.nodeType === 1 ) {
				name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
				data = elem.getAttribute( name );

				if ( typeof data === "string" ) {
					try {
						data = getData( data );
					} catch ( e ) {}

					// Make sure we set the data so it isn't changed later
					dataUser.set( elem, key, data );
				} else {
					data = undefined;
				}
			}
			return data;
		}

		jQuery.extend( {
			hasData: function( elem ) {
				return dataUser.hasData( elem ) || dataPriv.hasData( elem );
			},

			data: function( elem, name, data ) {
				return dataUser.access( elem, name, data );
			},

			removeData: function( elem, name ) {
				dataUser.remove( elem, name );
			},

			// TODO: Now that all calls to _data and _removeData have been replaced
			// with direct calls to dataPriv methods, these can be deprecated.
			_data: function( elem, name, data ) {
				return dataPriv.access( elem, name, data );
			},

			_removeData: function( elem, name ) {
				dataPriv.remove( elem, name );
			}
		} );

		jQuery.fn.extend( {
			data: function( key, value ) {
				var i, name, data,
					elem = this[ 0 ],
					attrs = elem && elem.attributes;

				// Gets all values
				if ( key === undefined ) {
					if ( this.length ) {
						data = dataUser.get( elem );

						if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
							i = attrs.length;
							while ( i-- ) {

								// Support: IE 11 only
								// The attrs elements can be null (trac-14894)
								if ( attrs[ i ] ) {
									name = attrs[ i ].name;
									if ( name.indexOf( "data-" ) === 0 ) {
										name = camelCase( name.slice( 5 ) );
										dataAttr( elem, name, data[ name ] );
									}
								}
							}
							dataPriv.set( elem, "hasDataAttrs", true );
						}
					}

					return data;
				}

				// Sets multiple values
				if ( typeof key === "object" ) {
					return this.each( function() {
						dataUser.set( this, key );
					} );
				}

				return access( this, function( value ) {
					var data;

					// The calling jQuery object (element matches) is not empty
					// (and therefore has an element appears at this[ 0 ]) and the
					// `value` parameter was not undefined. An empty jQuery object
					// will result in `undefined` for elem = this[ 0 ] which will
					// throw an exception if an attempt to read a data cache is made.
					if ( elem && value === undefined ) {

						// Attempt to get data from the cache
						// The key will always be camelCased in Data
						data = dataUser.get( elem, key );
						if ( data !== undefined ) {
							return data;
						}

						// Attempt to "discover" the data in
						// HTML5 custom data-* attrs
						data = dataAttr( elem, key );
						if ( data !== undefined ) {
							return data;
						}

						// We tried really hard, but the data doesn't exist.
						return;
					}

					// Set the data...
					this.each( function() {

						// We always store the camelCased key
						dataUser.set( this, key, value );
					} );
				}, null, value, arguments.length > 1, null, true );
			},

			removeData: function( key ) {
				return this.each( function() {
					dataUser.remove( this, key );
				} );
			}
		} );


		jQuery.extend( {
			queue: function( elem, type, data ) {
				var queue;

				if ( elem ) {
					type = ( type || "fx" ) + "queue";
					queue = dataPriv.get( elem, type );

					// Speed up dequeue by getting out quickly if this is just a lookup
					if ( data ) {
						if ( !queue || Array.isArray( data ) ) {
							queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
						} else {
							queue.push( data );
						}
					}
					return queue || [];
				}
			},

			dequeue: function( elem, type ) {
				type = type || "fx";

				var queue = jQuery.queue( elem, type ),
					startLength = queue.length,
					fn = queue.shift(),
					hooks = jQuery._queueHooks( elem, type ),
					next = function() {
						jQuery.dequeue( elem, type );
					};

				// If the fx queue is dequeued, always remove the progress sentinel
				if ( fn === "inprogress" ) {
					fn = queue.shift();
					startLength--;
				}

				if ( fn ) {

					// Add a progress sentinel to prevent the fx queue from being
					// automatically dequeued
					if ( type === "fx" ) {
						queue.unshift( "inprogress" );
					}

					// Clear up the last queue stop function
					delete hooks.stop;
					fn.call( elem, next, hooks );
				}

				if ( !startLength && hooks ) {
					hooks.empty.fire();
				}
			},

			// Not public - generate a queueHooks object, or return the current one
			_queueHooks: function( elem, type ) {
				var key = type + "queueHooks";
				return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
					empty: jQuery.Callbacks( "once memory" ).add( function() {
						dataPriv.remove( elem, [ type + "queue", key ] );
					} )
				} );
			}
		} );

		jQuery.fn.extend( {
			queue: function( type, data ) {
				var setter = 2;

				if ( typeof type !== "string" ) {
					data = type;
					type = "fx";
					setter--;
				}

				if ( arguments.length < setter ) {
					return jQuery.queue( this[ 0 ], type );
				}

				return data === undefined ?
					this :
					this.each( function() {
						var queue = jQuery.queue( this, type, data );

						// Ensure a hooks for this queue
						jQuery._queueHooks( this, type );

						if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
							jQuery.dequeue( this, type );
						}
					} );
			},
			dequeue: function( type ) {
				return this.each( function() {
					jQuery.dequeue( this, type );
				} );
			},
			clearQueue: function( type ) {
				return this.queue( type || "fx", [] );
			},

			// Get a promise resolved when queues of a certain type
			// are emptied (fx is the type by default)
			promise: function( type, obj ) {
				var tmp,
					count = 1,
					defer = jQuery.Deferred(),
					elements = this,
					i = this.length,
					resolve = function() {
						if ( !( --count ) ) {
							defer.resolveWith( elements, [ elements ] );
						}
					};

				if ( typeof type !== "string" ) {
					obj = type;
					type = undefined;
				}
				type = type || "fx";

				while ( i-- ) {
					tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
					if ( tmp && tmp.empty ) {
						count++;
						tmp.empty.add( resolve );
					}
				}
				resolve();
				return defer.promise( obj );
			}
		} );
		var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

		var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


		var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

		var documentElement = document.documentElement;



			var isAttached = function( elem ) {
					return jQuery.contains( elem.ownerDocument, elem );
				},
				composed = { composed: true };

			// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
			// Check attachment across shadow DOM boundaries when possible (gh-3504)
			// Support: iOS 10.0-10.2 only
			// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
			// leading to errors. We need to check for `getRootNode`.
			if ( documentElement.getRootNode ) {
				isAttached = function( elem ) {
					return jQuery.contains( elem.ownerDocument, elem ) ||
						elem.getRootNode( composed ) === elem.ownerDocument;
				};
			}
		var isHiddenWithinTree = function( elem, el ) {

				// isHiddenWithinTree might be called from jQuery#filter function;
				// in that case, element will be second argument
				elem = el || elem;

				// Inline style trumps all
				return elem.style.display === "none" ||
					elem.style.display === "" &&

					// Otherwise, check computed style
					// Support: Firefox <=43 - 45
					// Disconnected elements can have computed display: none, so first confirm that elem is
					// in the document.
					isAttached( elem ) &&

					jQuery.css( elem, "display" ) === "none";
			};



		function adjustCSS( elem, prop, valueParts, tween ) {
			var adjusted, scale,
				maxIterations = 20,
				currentValue = tween ?
					function() {
						return tween.cur();
					} :
					function() {
						return jQuery.css( elem, prop, "" );
					},
				initial = currentValue(),
				unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

				// Starting value computation is required for potential unit mismatches
				initialInUnit = elem.nodeType &&
					( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
					rcssNum.exec( jQuery.css( elem, prop ) );

			if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

				// Support: Firefox <=54
				// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
				initial = initial / 2;

				// Trust units reported by jQuery.css
				unit = unit || initialInUnit[ 3 ];

				// Iteratively approximate from a nonzero starting point
				initialInUnit = +initial || 1;

				while ( maxIterations-- ) {

					// Evaluate and update our best guess (doubling guesses that zero out).
					// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
					jQuery.style( elem, prop, initialInUnit + unit );
					if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
						maxIterations = 0;
					}
					initialInUnit = initialInUnit / scale;

				}

				initialInUnit = initialInUnit * 2;
				jQuery.style( elem, prop, initialInUnit + unit );

				// Make sure we update the tween properties later on
				valueParts = valueParts || [];
			}

			if ( valueParts ) {
				initialInUnit = +initialInUnit || +initial || 0;

				// Apply relative offset (+=/-=) if specified
				adjusted = valueParts[ 1 ] ?
					initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
					+valueParts[ 2 ];
				if ( tween ) {
					tween.unit = unit;
					tween.start = initialInUnit;
					tween.end = adjusted;
				}
			}
			return adjusted;
		}


		var defaultDisplayMap = {};

		function getDefaultDisplay( elem ) {
			var temp,
				doc = elem.ownerDocument,
				nodeName = elem.nodeName,
				display = defaultDisplayMap[ nodeName ];

			if ( display ) {
				return display;
			}

			temp = doc.body.appendChild( doc.createElement( nodeName ) );
			display = jQuery.css( temp, "display" );

			temp.parentNode.removeChild( temp );

			if ( display === "none" ) {
				display = "block";
			}
			defaultDisplayMap[ nodeName ] = display;

			return display;
		}

		function showHide( elements, show ) {
			var display, elem,
				values = [],
				index = 0,
				length = elements.length;

			// Determine new display value for elements that need to change
			for ( ; index < length; index++ ) {
				elem = elements[ index ];
				if ( !elem.style ) {
					continue;
				}

				display = elem.style.display;
				if ( show ) {

					// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
					// check is required in this first loop unless we have a nonempty display value (either
					// inline or about-to-be-restored)
					if ( display === "none" ) {
						values[ index ] = dataPriv.get( elem, "display" ) || null;
						if ( !values[ index ] ) {
							elem.style.display = "";
						}
					}
					if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
						values[ index ] = getDefaultDisplay( elem );
					}
				} else {
					if ( display !== "none" ) {
						values[ index ] = "none";

						// Remember what we're overwriting
						dataPriv.set( elem, "display", display );
					}
				}
			}

			// Set the display of the elements in a second loop to avoid constant reflow
			for ( index = 0; index < length; index++ ) {
				if ( values[ index ] != null ) {
					elements[ index ].style.display = values[ index ];
				}
			}

			return elements;
		}

		jQuery.fn.extend( {
			show: function() {
				return showHide( this, true );
			},
			hide: function() {
				return showHide( this );
			},
			toggle: function( state ) {
				if ( typeof state === "boolean" ) {
					return state ? this.show() : this.hide();
				}

				return this.each( function() {
					if ( isHiddenWithinTree( this ) ) {
						jQuery( this ).show();
					} else {
						jQuery( this ).hide();
					}
				} );
			}
		} );
		var rcheckableType = ( /^(?:checkbox|radio)$/i );

		var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

		var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



		( function() {
			var fragment = document.createDocumentFragment(),
				div = fragment.appendChild( document.createElement( "div" ) ),
				input = document.createElement( "input" );

			// Support: Android 4.0 - 4.3 only
			// Check state lost if the name is set (trac-11217)
			// Support: Windows Web Apps (WWA)
			// `name` and `type` must use .setAttribute for WWA (trac-14901)
			input.setAttribute( "type", "radio" );
			input.setAttribute( "checked", "checked" );
			input.setAttribute( "name", "t" );

			div.appendChild( input );

			// Support: Android <=4.1 only
			// Older WebKit doesn't clone checked state correctly in fragments
			support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

			// Support: IE <=11 only
			// Make sure textarea (and checkbox) defaultValue is properly cloned
			div.innerHTML = "<textarea>x</textarea>";
			support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

			// Support: IE <=9 only
			// IE <=9 replaces <option> tags with their contents when inserted outside of
			// the select element.
			div.innerHTML = "<option></option>";
			support.option = !!div.lastChild;
		} )();


		// We have to close these tags to support XHTML (trac-13200)
		var wrapMap = {

			// XHTML parsers do not magically insert elements in the
			// same way that tag soup parsers do. So we cannot shorten
			// this by omitting <tbody> or other required elements.
			thead: [ 1, "<table>", "</table>" ],
			col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
			tr: [ 2, "<table><tbody>", "</tbody></table>" ],
			td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

			_default: [ 0, "", "" ]
		};

		wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
		wrapMap.th = wrapMap.td;

		// Support: IE <=9 only
		if ( !support.option ) {
			wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
		}


		function getAll( context, tag ) {

			// Support: IE <=9 - 11 only
			// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
			var ret;

			if ( typeof context.getElementsByTagName !== "undefined" ) {
				ret = context.getElementsByTagName( tag || "*" );

			} else if ( typeof context.querySelectorAll !== "undefined" ) {
				ret = context.querySelectorAll( tag || "*" );

			} else {
				ret = [];
			}

			if ( tag === undefined || tag && nodeName( context, tag ) ) {
				return jQuery.merge( [ context ], ret );
			}

			return ret;
		}


		// Mark scripts as having already been evaluated
		function setGlobalEval( elems, refElements ) {
			var i = 0,
				l = elems.length;

			for ( ; i < l; i++ ) {
				dataPriv.set(
					elems[ i ],
					"globalEval",
					!refElements || dataPriv.get( refElements[ i ], "globalEval" )
				);
			}
		}


		var rhtml = /<|&#?\w+;/;

		function buildFragment( elems, context, scripts, selection, ignored ) {
			var elem, tmp, tag, wrap, attached, j,
				fragment = context.createDocumentFragment(),
				nodes = [],
				i = 0,
				l = elems.length;

			for ( ; i < l; i++ ) {
				elem = elems[ i ];

				if ( elem || elem === 0 ) {

					// Add nodes directly
					if ( toType( elem ) === "object" ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

					// Convert non-html into a text node
					} else if ( !rhtml.test( elem ) ) {
						nodes.push( context.createTextNode( elem ) );

					// Convert html into DOM nodes
					} else {
						tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

						// Deserialize a standard representation
						tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
						wrap = wrapMap[ tag ] || wrapMap._default;
						tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

						// Descend through wrappers to the right content
						j = wrap[ 0 ];
						while ( j-- ) {
							tmp = tmp.lastChild;
						}

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( nodes, tmp.childNodes );

						// Remember the top-level container
						tmp = fragment.firstChild;

						// Ensure the created nodes are orphaned (trac-12392)
						tmp.textContent = "";
					}
				}
			}

			// Remove wrapper from fragment
			fragment.textContent = "";

			i = 0;
			while ( ( elem = nodes[ i++ ] ) ) {

				// Skip elements already in the context collection (trac-4087)
				if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
					if ( ignored ) {
						ignored.push( elem );
					}
					continue;
				}

				attached = isAttached( elem );

				// Append to fragment
				tmp = getAll( fragment.appendChild( elem ), "script" );

				// Preserve script evaluation history
				if ( attached ) {
					setGlobalEval( tmp );
				}

				// Capture executables
				if ( scripts ) {
					j = 0;
					while ( ( elem = tmp[ j++ ] ) ) {
						if ( rscriptType.test( elem.type || "" ) ) {
							scripts.push( elem );
						}
					}
				}
			}

			return fragment;
		}


		var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

		function returnTrue() {
			return true;
		}

		function returnFalse() {
			return false;
		}

		// Support: IE <=9 - 11+
		// focus() and blur() are asynchronous, except when they are no-op.
		// So expect focus to be synchronous when the element is already active,
		// and blur to be synchronous when the element is not already active.
		// (focus and blur are always synchronous in other supported browsers,
		// this just defines when we can count on it).
		function expectSync( elem, type ) {
			return ( elem === safeActiveElement() ) === ( type === "focus" );
		}

		// Support: IE <=9 only
		// Accessing document.activeElement can throw unexpectedly
		// https://bugs.jquery.com/ticket/13393
		function safeActiveElement() {
			try {
				return document.activeElement;
			} catch ( err ) { }
		}

		function on( elem, types, selector, data, fn, one ) {
			var origFn, type;

			// Types can be a map of types/handlers
			if ( typeof types === "object" ) {

				// ( types-Object, selector, data )
				if ( typeof selector !== "string" ) {

					// ( types-Object, data )
					data = data || selector;
					selector = undefined;
				}
				for ( type in types ) {
					on( elem, type, selector, data, types[ type ], one );
				}
				return elem;
			}

			if ( data == null && fn == null ) {

				// ( types, fn )
				fn = selector;
				data = selector = undefined;
			} else if ( fn == null ) {
				if ( typeof selector === "string" ) {

					// ( types, selector, fn )
					fn = data;
					data = undefined;
				} else {

					// ( types, data, fn )
					fn = data;
					data = selector;
					selector = undefined;
				}
			}
			if ( fn === false ) {
				fn = returnFalse;
			} else if ( !fn ) {
				return elem;
			}

			if ( one === 1 ) {
				origFn = fn;
				fn = function( event ) {

					// Can use an empty set, since event contains the info
					jQuery().off( event );
					return origFn.apply( this, arguments );
				};

				// Use same guid so caller can remove using origFn
				fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
			}
			return elem.each( function() {
				jQuery.event.add( this, types, fn, data, selector );
			} );
		}

		/*
		 * Helper functions for managing events -- not part of the public interface.
		 * Props to Dean Edwards' addEvent library for many of the ideas.
		 */
		jQuery.event = {

			global: {},

			add: function( elem, types, handler, data, selector ) {

				var handleObjIn, eventHandle, tmp,
					events, t, handleObj,
					special, handlers, type, namespaces, origType,
					elemData = dataPriv.get( elem );

				// Only attach events to objects that accept data
				if ( !acceptData( elem ) ) {
					return;
				}

				// Caller can pass in an object of custom data in lieu of the handler
				if ( handler.handler ) {
					handleObjIn = handler;
					handler = handleObjIn.handler;
					selector = handleObjIn.selector;
				}

				// Ensure that invalid selectors throw exceptions at attach time
				// Evaluate against documentElement in case elem is a non-element node (e.g., document)
				if ( selector ) {
					jQuery.find.matchesSelector( documentElement, selector );
				}

				// Make sure that the handler has a unique ID, used to find/remove it later
				if ( !handler.guid ) {
					handler.guid = jQuery.guid++;
				}

				// Init the element's event structure and main handler, if this is the first
				if ( !( events = elemData.events ) ) {
					events = elemData.events = Object.create( null );
				}
				if ( !( eventHandle = elemData.handle ) ) {
					eventHandle = elemData.handle = function( e ) {

						// Discard the second event of a jQuery.event.trigger() and
						// when an event is called after a page has unloaded
						return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
							jQuery.event.dispatch.apply( elem, arguments ) : undefined;
					};
				}

				// Handle multiple events separated by a space
				types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
				t = types.length;
				while ( t-- ) {
					tmp = rtypenamespace.exec( types[ t ] ) || [];
					type = origType = tmp[ 1 ];
					namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

					// There *must* be a type, no attaching namespace-only handlers
					if ( !type ) {
						continue;
					}

					// If event changes its type, use the special event handlers for the changed type
					special = jQuery.event.special[ type ] || {};

					// If selector defined, determine special event api type, otherwise given type
					type = ( selector ? special.delegateType : special.bindType ) || type;

					// Update special based on newly reset type
					special = jQuery.event.special[ type ] || {};

					// handleObj is passed to all event handlers
					handleObj = jQuery.extend( {
						type: type,
						origType: origType,
						data: data,
						handler: handler,
						guid: handler.guid,
						selector: selector,
						needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
						namespace: namespaces.join( "." )
					}, handleObjIn );

					// Init the event handler queue if we're the first
					if ( !( handlers = events[ type ] ) ) {
						handlers = events[ type ] = [];
						handlers.delegateCount = 0;

						// Only use addEventListener if the special events handler returns false
						if ( !special.setup ||
							special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

							if ( elem.addEventListener ) {
								elem.addEventListener( type, eventHandle );
							}
						}
					}

					if ( special.add ) {
						special.add.call( elem, handleObj );

						if ( !handleObj.handler.guid ) {
							handleObj.handler.guid = handler.guid;
						}
					}

					// Add to the element's handler list, delegates in front
					if ( selector ) {
						handlers.splice( handlers.delegateCount++, 0, handleObj );
					} else {
						handlers.push( handleObj );
					}

					// Keep track of which events have ever been used, for event optimization
					jQuery.event.global[ type ] = true;
				}

			},

			// Detach an event or set of events from an element
			remove: function( elem, types, handler, selector, mappedTypes ) {

				var j, origCount, tmp,
					events, t, handleObj,
					special, handlers, type, namespaces, origType,
					elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

				if ( !elemData || !( events = elemData.events ) ) {
					return;
				}

				// Once for each type.namespace in types; type may be omitted
				types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
				t = types.length;
				while ( t-- ) {
					tmp = rtypenamespace.exec( types[ t ] ) || [];
					type = origType = tmp[ 1 ];
					namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

					// Unbind all events (on this namespace, if provided) for the element
					if ( !type ) {
						for ( type in events ) {
							jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
						}
						continue;
					}

					special = jQuery.event.special[ type ] || {};
					type = ( selector ? special.delegateType : special.bindType ) || type;
					handlers = events[ type ] || [];
					tmp = tmp[ 2 ] &&
						new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

					// Remove matching events
					origCount = j = handlers.length;
					while ( j-- ) {
						handleObj = handlers[ j ];

						if ( ( mappedTypes || origType === handleObj.origType ) &&
							( !handler || handler.guid === handleObj.guid ) &&
							( !tmp || tmp.test( handleObj.namespace ) ) &&
							( !selector || selector === handleObj.selector ||
								selector === "**" && handleObj.selector ) ) {
							handlers.splice( j, 1 );

							if ( handleObj.selector ) {
								handlers.delegateCount--;
							}
							if ( special.remove ) {
								special.remove.call( elem, handleObj );
							}
						}
					}

					// Remove generic event handler if we removed something and no more handlers exist
					// (avoids potential for endless recursion during removal of special event handlers)
					if ( origCount && !handlers.length ) {
						if ( !special.teardown ||
							special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

							jQuery.removeEvent( elem, type, elemData.handle );
						}

						delete events[ type ];
					}
				}

				// Remove data and the expando if it's no longer used
				if ( jQuery.isEmptyObject( events ) ) {
					dataPriv.remove( elem, "handle events" );
				}
			},

			dispatch: function( nativeEvent ) {

				var i, j, ret, matched, handleObj, handlerQueue,
					args = new Array( arguments.length ),

					// Make a writable jQuery.Event from the native event object
					event = jQuery.event.fix( nativeEvent ),

					handlers = (
						dataPriv.get( this, "events" ) || Object.create( null )
					)[ event.type ] || [],
					special = jQuery.event.special[ event.type ] || {};

				// Use the fix-ed jQuery.Event rather than the (read-only) native event
				args[ 0 ] = event;

				for ( i = 1; i < arguments.length; i++ ) {
					args[ i ] = arguments[ i ];
				}

				event.delegateTarget = this;

				// Call the preDispatch hook for the mapped type, and let it bail if desired
				if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
					return;
				}

				// Determine handlers
				handlerQueue = jQuery.event.handlers.call( this, event, handlers );

				// Run delegates first; they may want to stop propagation beneath us
				i = 0;
				while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
					event.currentTarget = matched.elem;

					j = 0;
					while ( ( handleObj = matched.handlers[ j++ ] ) &&
						!event.isImmediatePropagationStopped() ) {

						// If the event is namespaced, then each handler is only invoked if it is
						// specially universal or its namespaces are a superset of the event's.
						if ( !event.rnamespace || handleObj.namespace === false ||
							event.rnamespace.test( handleObj.namespace ) ) {

							event.handleObj = handleObj;
							event.data = handleObj.data;

							ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
								handleObj.handler ).apply( matched.elem, args );

							if ( ret !== undefined ) {
								if ( ( event.result = ret ) === false ) {
									event.preventDefault();
									event.stopPropagation();
								}
							}
						}
					}
				}

				// Call the postDispatch hook for the mapped type
				if ( special.postDispatch ) {
					special.postDispatch.call( this, event );
				}

				return event.result;
			},

			handlers: function( event, handlers ) {
				var i, handleObj, sel, matchedHandlers, matchedSelectors,
					handlerQueue = [],
					delegateCount = handlers.delegateCount,
					cur = event.target;

				// Find delegate handlers
				if ( delegateCount &&

					// Support: IE <=9
					// Black-hole SVG <use> instance trees (trac-13180)
					cur.nodeType &&

					// Support: Firefox <=42
					// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
					// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
					// Support: IE 11 only
					// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
					!( event.type === "click" && event.button >= 1 ) ) {

					for ( ; cur !== this; cur = cur.parentNode || this ) {

						// Don't check non-elements (trac-13208)
						// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
						if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
							matchedHandlers = [];
							matchedSelectors = {};
							for ( i = 0; i < delegateCount; i++ ) {
								handleObj = handlers[ i ];

								// Don't conflict with Object.prototype properties (trac-13203)
								sel = handleObj.selector + " ";

								if ( matchedSelectors[ sel ] === undefined ) {
									matchedSelectors[ sel ] = handleObj.needsContext ?
										jQuery( sel, this ).index( cur ) > -1 :
										jQuery.find( sel, this, null, [ cur ] ).length;
								}
								if ( matchedSelectors[ sel ] ) {
									matchedHandlers.push( handleObj );
								}
							}
							if ( matchedHandlers.length ) {
								handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
							}
						}
					}
				}

				// Add the remaining (directly-bound) handlers
				cur = this;
				if ( delegateCount < handlers.length ) {
					handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
				}

				return handlerQueue;
			},

			addProp: function( name, hook ) {
				Object.defineProperty( jQuery.Event.prototype, name, {
					enumerable: true,
					configurable: true,

					get: isFunction( hook ) ?
						function() {
							if ( this.originalEvent ) {
								return hook( this.originalEvent );
							}
						} :
						function() {
							if ( this.originalEvent ) {
								return this.originalEvent[ name ];
							}
						},

					set: function( value ) {
						Object.defineProperty( this, name, {
							enumerable: true,
							configurable: true,
							writable: true,
							value: value
						} );
					}
				} );
			},

			fix: function( originalEvent ) {
				return originalEvent[ jQuery.expando ] ?
					originalEvent :
					new jQuery.Event( originalEvent );
			},

			special: {
				load: {

					// Prevent triggered image.load events from bubbling to window.load
					noBubble: true
				},
				click: {

					// Utilize native event to ensure correct state for checkable inputs
					setup: function( data ) {

						// For mutual compressibility with _default, replace `this` access with a local var.
						// `|| data` is dead code meant only to preserve the variable through minification.
						var el = this || data;

						// Claim the first handler
						if ( rcheckableType.test( el.type ) &&
							el.click && nodeName( el, "input" ) ) {

							// dataPriv.set( el, "click", ... )
							leverageNative( el, "click", returnTrue );
						}

						// Return false to allow normal processing in the caller
						return false;
					},
					trigger: function( data ) {

						// For mutual compressibility with _default, replace `this` access with a local var.
						// `|| data` is dead code meant only to preserve the variable through minification.
						var el = this || data;

						// Force setup before triggering a click
						if ( rcheckableType.test( el.type ) &&
							el.click && nodeName( el, "input" ) ) {

							leverageNative( el, "click" );
						}

						// Return non-false to allow normal event-path propagation
						return true;
					},

					// For cross-browser consistency, suppress native .click() on links
					// Also prevent it if we're currently inside a leveraged native-event stack
					_default: function( event ) {
						var target = event.target;
						return rcheckableType.test( target.type ) &&
							target.click && nodeName( target, "input" ) &&
							dataPriv.get( target, "click" ) ||
							nodeName( target, "a" );
					}
				},

				beforeunload: {
					postDispatch: function( event ) {

						// Support: Firefox 20+
						// Firefox doesn't alert if the returnValue field is not set.
						if ( event.result !== undefined && event.originalEvent ) {
							event.originalEvent.returnValue = event.result;
						}
					}
				}
			}
		};

		// Ensure the presence of an event listener that handles manually-triggered
		// synthetic events by interrupting progress until reinvoked in response to
		// *native* events that it fires directly, ensuring that state changes have
		// already occurred before other listeners are invoked.
		function leverageNative( el, type, expectSync ) {

			// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
			if ( !expectSync ) {
				if ( dataPriv.get( el, type ) === undefined ) {
					jQuery.event.add( el, type, returnTrue );
				}
				return;
			}

			// Register the controller as a special universal handler for all event namespaces
			dataPriv.set( el, type, false );
			jQuery.event.add( el, type, {
				namespace: false,
				handler: function( event ) {
					var notAsync, result,
						saved = dataPriv.get( this, type );

					if ( ( event.isTrigger & 1 ) && this[ type ] ) {

						// Interrupt processing of the outer synthetic .trigger()ed event
						// Saved data should be false in such cases, but might be a leftover capture object
						// from an async native handler (gh-4350)
						if ( !saved.length ) {

							// Store arguments for use when handling the inner native event
							// There will always be at least one argument (an event object), so this array
							// will not be confused with a leftover capture object.
							saved = slice.call( arguments );
							dataPriv.set( this, type, saved );

							// Trigger the native event and capture its result
							// Support: IE <=9 - 11+
							// focus() and blur() are asynchronous
							notAsync = expectSync( this, type );
							this[ type ]();
							result = dataPriv.get( this, type );
							if ( saved !== result || notAsync ) {
								dataPriv.set( this, type, false );
							} else {
								result = {};
							}
							if ( saved !== result ) {

								// Cancel the outer synthetic event
								event.stopImmediatePropagation();
								event.preventDefault();

								// Support: Chrome 86+
								// In Chrome, if an element having a focusout handler is blurred by
								// clicking outside of it, it invokes the handler synchronously. If
								// that handler calls `.remove()` on the element, the data is cleared,
								// leaving `result` undefined. We need to guard against this.
								return result && result.value;
							}

						// If this is an inner synthetic event for an event with a bubbling surrogate
						// (focus or blur), assume that the surrogate already propagated from triggering the
						// native event and prevent that from happening again here.
						// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
						// bubbling surrogate propagates *after* the non-bubbling base), but that seems
						// less bad than duplication.
						} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
							event.stopPropagation();
						}

					// If this is a native event triggered above, everything is now in order
					// Fire an inner synthetic event with the original arguments
					} else if ( saved.length ) {

						// ...and capture the result
						dataPriv.set( this, type, {
							value: jQuery.event.trigger(

								// Support: IE <=9 - 11+
								// Extend with the prototype to reset the above stopImmediatePropagation()
								jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
								saved.slice( 1 ),
								this
							)
						} );

						// Abort handling of the native event
						event.stopImmediatePropagation();
					}
				}
			} );
		}

		jQuery.removeEvent = function( elem, type, handle ) {

			// This "if" is needed for plain objects
			if ( elem.removeEventListener ) {
				elem.removeEventListener( type, handle );
			}
		};

		jQuery.Event = function( src, props ) {

			// Allow instantiation without the 'new' keyword
			if ( !( this instanceof jQuery.Event ) ) {
				return new jQuery.Event( src, props );
			}

			// Event object
			if ( src && src.type ) {
				this.originalEvent = src;
				this.type = src.type;

				// Events bubbling up the document may have been marked as prevented
				// by a handler lower down the tree; reflect the correct value.
				this.isDefaultPrevented = src.defaultPrevented ||
						src.defaultPrevented === undefined &&

						// Support: Android <=2.3 only
						src.returnValue === false ?
					returnTrue :
					returnFalse;

				// Create target properties
				// Support: Safari <=6 - 7 only
				// Target should not be a text node (trac-504, trac-13143)
				this.target = ( src.target && src.target.nodeType === 3 ) ?
					src.target.parentNode :
					src.target;

				this.currentTarget = src.currentTarget;
				this.relatedTarget = src.relatedTarget;

			// Event type
			} else {
				this.type = src;
			}

			// Put explicitly provided properties onto the event object
			if ( props ) {
				jQuery.extend( this, props );
			}

			// Create a timestamp if incoming event doesn't have one
			this.timeStamp = src && src.timeStamp || Date.now();

			// Mark it as fixed
			this[ jQuery.expando ] = true;
		};

		// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
		// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
		jQuery.Event.prototype = {
			constructor: jQuery.Event,
			isDefaultPrevented: returnFalse,
			isPropagationStopped: returnFalse,
			isImmediatePropagationStopped: returnFalse,
			isSimulated: false,

			preventDefault: function() {
				var e = this.originalEvent;

				this.isDefaultPrevented = returnTrue;

				if ( e && !this.isSimulated ) {
					e.preventDefault();
				}
			},
			stopPropagation: function() {
				var e = this.originalEvent;

				this.isPropagationStopped = returnTrue;

				if ( e && !this.isSimulated ) {
					e.stopPropagation();
				}
			},
			stopImmediatePropagation: function() {
				var e = this.originalEvent;

				this.isImmediatePropagationStopped = returnTrue;

				if ( e && !this.isSimulated ) {
					e.stopImmediatePropagation();
				}

				this.stopPropagation();
			}
		};

		// Includes all common event props including KeyEvent and MouseEvent specific props
		jQuery.each( {
			altKey: true,
			bubbles: true,
			cancelable: true,
			changedTouches: true,
			ctrlKey: true,
			detail: true,
			eventPhase: true,
			metaKey: true,
			pageX: true,
			pageY: true,
			shiftKey: true,
			view: true,
			"char": true,
			code: true,
			charCode: true,
			key: true,
			keyCode: true,
			button: true,
			buttons: true,
			clientX: true,
			clientY: true,
			offsetX: true,
			offsetY: true,
			pointerId: true,
			pointerType: true,
			screenX: true,
			screenY: true,
			targetTouches: true,
			toElement: true,
			touches: true,
			which: true
		}, jQuery.event.addProp );

		jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
			jQuery.event.special[ type ] = {

				// Utilize native event if possible so blur/focus sequence is correct
				setup: function() {

					// Claim the first handler
					// dataPriv.set( this, "focus", ... )
					// dataPriv.set( this, "blur", ... )
					leverageNative( this, type, expectSync );

					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function() {

					// Force setup before trigger
					leverageNative( this, type );

					// Return non-false to allow normal event-path propagation
					return true;
				},

				// Suppress native focus or blur if we're currently inside
				// a leveraged native-event stack
				_default: function( event ) {
					return dataPriv.get( event.target, type );
				},

				delegateType: delegateType
			};
		} );

		// Create mouseenter/leave events using mouseover/out and event-time checks
		// so that event delegation works in jQuery.
		// Do the same for pointerenter/pointerleave and pointerover/pointerout
		//
		// Support: Safari 7 only
		// Safari sends mouseenter too often; see:
		// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
		// for the description of the bug (it existed in older Chrome versions as well).
		jQuery.each( {
			mouseenter: "mouseover",
			mouseleave: "mouseout",
			pointerenter: "pointerover",
			pointerleave: "pointerout"
		}, function( orig, fix ) {
			jQuery.event.special[ orig ] = {
				delegateType: fix,
				bindType: fix,

				handle: function( event ) {
					var ret,
						target = this,
						related = event.relatedTarget,
						handleObj = event.handleObj;

					// For mouseenter/leave call the handler if related is outside the target.
					// NB: No relatedTarget if the mouse left/entered the browser window
					if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
						event.type = handleObj.origType;
						ret = handleObj.handler.apply( this, arguments );
						event.type = fix;
					}
					return ret;
				}
			};
		} );

		jQuery.fn.extend( {

			on: function( types, selector, data, fn ) {
				return on( this, types, selector, data, fn );
			},
			one: function( types, selector, data, fn ) {
				return on( this, types, selector, data, fn, 1 );
			},
			off: function( types, selector, fn ) {
				var handleObj, type;
				if ( types && types.preventDefault && types.handleObj ) {

					// ( event )  dispatched jQuery.Event
					handleObj = types.handleObj;
					jQuery( types.delegateTarget ).off(
						handleObj.namespace ?
							handleObj.origType + "." + handleObj.namespace :
							handleObj.origType,
						handleObj.selector,
						handleObj.handler
					);
					return this;
				}
				if ( typeof types === "object" ) {

					// ( types-object [, selector] )
					for ( type in types ) {
						this.off( type, selector, types[ type ] );
					}
					return this;
				}
				if ( selector === false || typeof selector === "function" ) {

					// ( types [, fn] )
					fn = selector;
					selector = undefined;
				}
				if ( fn === false ) {
					fn = returnFalse;
				}
				return this.each( function() {
					jQuery.event.remove( this, types, fn, selector );
				} );
			}
		} );


		var

			// Support: IE <=10 - 11, Edge 12 - 13 only
			// In IE/Edge using regex groups here causes severe slowdowns.
			// See https://connect.microsoft.com/IE/feedback/details/1736512/
			rnoInnerhtml = /<script|<style|<link/i,

			// checked="checked" or checked
			rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

			rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

		// Prefer a tbody over its parent table for containing new rows
		function manipulationTarget( elem, content ) {
			if ( nodeName( elem, "table" ) &&
				nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

				return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
			}

			return elem;
		}

		// Replace/restore the type attribute of script elements for safe DOM manipulation
		function disableScript( elem ) {
			elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
			return elem;
		}
		function restoreScript( elem ) {
			if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
				elem.type = elem.type.slice( 5 );
			} else {
				elem.removeAttribute( "type" );
			}

			return elem;
		}

		function cloneCopyEvent( src, dest ) {
			var i, l, type, pdataOld, udataOld, udataCur, events;

			if ( dest.nodeType !== 1 ) {
				return;
			}

			// 1. Copy private data: events, handlers, etc.
			if ( dataPriv.hasData( src ) ) {
				pdataOld = dataPriv.get( src );
				events = pdataOld.events;

				if ( events ) {
					dataPriv.remove( dest, "handle events" );

					for ( type in events ) {
						for ( i = 0, l = events[ type ].length; i < l; i++ ) {
							jQuery.event.add( dest, type, events[ type ][ i ] );
						}
					}
				}
			}

			// 2. Copy user data
			if ( dataUser.hasData( src ) ) {
				udataOld = dataUser.access( src );
				udataCur = jQuery.extend( {}, udataOld );

				dataUser.set( dest, udataCur );
			}
		}

		// Fix IE bugs, see support tests
		function fixInput( src, dest ) {
			var nodeName = dest.nodeName.toLowerCase();

			// Fails to persist the checked state of a cloned checkbox or radio button.
			if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
				dest.checked = src.checked;

			// Fails to return the selected option to the default selected state when cloning options
			} else if ( nodeName === "input" || nodeName === "textarea" ) {
				dest.defaultValue = src.defaultValue;
			}
		}

		function domManip( collection, args, callback, ignored ) {

			// Flatten any nested arrays
			args = flat( args );

			var fragment, first, scripts, hasScripts, node, doc,
				i = 0,
				l = collection.length,
				iNoClone = l - 1,
				value = args[ 0 ],
				valueIsFunction = isFunction( value );

			// We can't cloneNode fragments that contain checked, in WebKit
			if ( valueIsFunction ||
					( l > 1 && typeof value === "string" &&
						!support.checkClone && rchecked.test( value ) ) ) {
				return collection.each( function( index ) {
					var self = collection.eq( index );
					if ( valueIsFunction ) {
						args[ 0 ] = value.call( this, index, self.html() );
					}
					domManip( self, args, callback, ignored );
				} );
			}

			if ( l ) {
				fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
				first = fragment.firstChild;

				if ( fragment.childNodes.length === 1 ) {
					fragment = first;
				}

				// Require either new content or an interest in ignored elements to invoke the callback
				if ( first || ignored ) {
					scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
					hasScripts = scripts.length;

					// Use the original fragment for the last item
					// instead of the first because it can end up
					// being emptied incorrectly in certain situations (trac-8070).
					for ( ; i < l; i++ ) {
						node = fragment;

						if ( i !== iNoClone ) {
							node = jQuery.clone( node, true, true );

							// Keep references to cloned scripts for later restoration
							if ( hasScripts ) {

								// Support: Android <=4.0 only, PhantomJS 1 only
								// push.apply(_, arraylike) throws on ancient WebKit
								jQuery.merge( scripts, getAll( node, "script" ) );
							}
						}

						callback.call( collection[ i ], node, i );
					}

					if ( hasScripts ) {
						doc = scripts[ scripts.length - 1 ].ownerDocument;

						// Reenable scripts
						jQuery.map( scripts, restoreScript );

						// Evaluate executable scripts on first document insertion
						for ( i = 0; i < hasScripts; i++ ) {
							node = scripts[ i ];
							if ( rscriptType.test( node.type || "" ) &&
								!dataPriv.access( node, "globalEval" ) &&
								jQuery.contains( doc, node ) ) {

								if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

									// Optional AJAX dependency, but won't run scripts if not present
									if ( jQuery._evalUrl && !node.noModule ) {
										jQuery._evalUrl( node.src, {
											nonce: node.nonce || node.getAttribute( "nonce" )
										}, doc );
									}
								} else {

									// Unwrap a CDATA section containing script contents. This shouldn't be
									// needed as in XML documents they're already not visible when
									// inspecting element contents and in HTML documents they have no
									// meaning but we're preserving that logic for backwards compatibility.
									// This will be removed completely in 4.0. See gh-4904.
									DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
								}
							}
						}
					}
				}
			}

			return collection;
		}

		function remove( elem, selector, keepData ) {
			var node,
				nodes = selector ? jQuery.filter( selector, elem ) : elem,
				i = 0;

			for ( ; ( node = nodes[ i ] ) != null; i++ ) {
				if ( !keepData && node.nodeType === 1 ) {
					jQuery.cleanData( getAll( node ) );
				}

				if ( node.parentNode ) {
					if ( keepData && isAttached( node ) ) {
						setGlobalEval( getAll( node, "script" ) );
					}
					node.parentNode.removeChild( node );
				}
			}

			return elem;
		}

		jQuery.extend( {
			htmlPrefilter: function( html ) {
				return html;
			},

			clone: function( elem, dataAndEvents, deepDataAndEvents ) {
				var i, l, srcElements, destElements,
					clone = elem.cloneNode( true ),
					inPage = isAttached( elem );

				// Fix IE cloning issues
				if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
						!jQuery.isXMLDoc( elem ) ) {

					// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
					destElements = getAll( clone );
					srcElements = getAll( elem );

					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						fixInput( srcElements[ i ], destElements[ i ] );
					}
				}

				// Copy the events from the original to the clone
				if ( dataAndEvents ) {
					if ( deepDataAndEvents ) {
						srcElements = srcElements || getAll( elem );
						destElements = destElements || getAll( clone );

						for ( i = 0, l = srcElements.length; i < l; i++ ) {
							cloneCopyEvent( srcElements[ i ], destElements[ i ] );
						}
					} else {
						cloneCopyEvent( elem, clone );
					}
				}

				// Preserve script evaluation history
				destElements = getAll( clone, "script" );
				if ( destElements.length > 0 ) {
					setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
				}

				// Return the cloned set
				return clone;
			},

			cleanData: function( elems ) {
				var data, elem, type,
					special = jQuery.event.special,
					i = 0;

				for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
					if ( acceptData( elem ) ) {
						if ( ( data = elem[ dataPriv.expando ] ) ) {
							if ( data.events ) {
								for ( type in data.events ) {
									if ( special[ type ] ) {
										jQuery.event.remove( elem, type );

									// This is a shortcut to avoid jQuery.event.remove's overhead
									} else {
										jQuery.removeEvent( elem, type, data.handle );
									}
								}
							}

							// Support: Chrome <=35 - 45+
							// Assign undefined instead of using delete, see Data#remove
							elem[ dataPriv.expando ] = undefined;
						}
						if ( elem[ dataUser.expando ] ) {

							// Support: Chrome <=35 - 45+
							// Assign undefined instead of using delete, see Data#remove
							elem[ dataUser.expando ] = undefined;
						}
					}
				}
			}
		} );

		jQuery.fn.extend( {
			detach: function( selector ) {
				return remove( this, selector, true );
			},

			remove: function( selector ) {
				return remove( this, selector );
			},

			text: function( value ) {
				return access( this, function( value ) {
					return value === undefined ?
						jQuery.text( this ) :
						this.empty().each( function() {
							if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
								this.textContent = value;
							}
						} );
				}, null, value, arguments.length );
			},

			append: function() {
				return domManip( this, arguments, function( elem ) {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						var target = manipulationTarget( this, elem );
						target.appendChild( elem );
					}
				} );
			},

			prepend: function() {
				return domManip( this, arguments, function( elem ) {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						var target = manipulationTarget( this, elem );
						target.insertBefore( elem, target.firstChild );
					}
				} );
			},

			before: function() {
				return domManip( this, arguments, function( elem ) {
					if ( this.parentNode ) {
						this.parentNode.insertBefore( elem, this );
					}
				} );
			},

			after: function() {
				return domManip( this, arguments, function( elem ) {
					if ( this.parentNode ) {
						this.parentNode.insertBefore( elem, this.nextSibling );
					}
				} );
			},

			empty: function() {
				var elem,
					i = 0;

				for ( ; ( elem = this[ i ] ) != null; i++ ) {
					if ( elem.nodeType === 1 ) {

						// Prevent memory leaks
						jQuery.cleanData( getAll( elem, false ) );

						// Remove any remaining nodes
						elem.textContent = "";
					}
				}

				return this;
			},

			clone: function( dataAndEvents, deepDataAndEvents ) {
				dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
				deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

				return this.map( function() {
					return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
				} );
			},

			html: function( value ) {
				return access( this, function( value ) {
					var elem = this[ 0 ] || {},
						i = 0,
						l = this.length;

					if ( value === undefined && elem.nodeType === 1 ) {
						return elem.innerHTML;
					}

					// See if we can take a shortcut and just use innerHTML
					if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
						!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

						value = jQuery.htmlPrefilter( value );

						try {
							for ( ; i < l; i++ ) {
								elem = this[ i ] || {};

								// Remove element nodes and prevent memory leaks
								if ( elem.nodeType === 1 ) {
									jQuery.cleanData( getAll( elem, false ) );
									elem.innerHTML = value;
								}
							}

							elem = 0;

						// If using innerHTML throws an exception, use the fallback method
						} catch ( e ) {}
					}

					if ( elem ) {
						this.empty().append( value );
					}
				}, null, value, arguments.length );
			},

			replaceWith: function() {
				var ignored = [];

				// Make the changes, replacing each non-ignored context element with the new content
				return domManip( this, arguments, function( elem ) {
					var parent = this.parentNode;

					if ( jQuery.inArray( this, ignored ) < 0 ) {
						jQuery.cleanData( getAll( this ) );
						if ( parent ) {
							parent.replaceChild( elem, this );
						}
					}

				// Force callback invocation
				}, ignored );
			}
		} );

		jQuery.each( {
			appendTo: "append",
			prependTo: "prepend",
			insertBefore: "before",
			insertAfter: "after",
			replaceAll: "replaceWith"
		}, function( name, original ) {
			jQuery.fn[ name ] = function( selector ) {
				var elems,
					ret = [],
					insert = jQuery( selector ),
					last = insert.length - 1,
					i = 0;

				for ( ; i <= last; i++ ) {
					elems = i === last ? this : this.clone( true );
					jQuery( insert[ i ] )[ original ]( elems );

					// Support: Android <=4.0 only, PhantomJS 1 only
					// .get() because push.apply(_, arraylike) throws on ancient WebKit
					push.apply( ret, elems.get() );
				}

				return this.pushStack( ret );
			};
		} );
		var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

		var rcustomProp = /^--/;


		var getStyles = function( elem ) {

				// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
				// IE throws on elements created in popups
				// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
				var view = elem.ownerDocument.defaultView;

				if ( !view || !view.opener ) {
					view = window;
				}

				return view.getComputedStyle( elem );
			};

		var swap = function( elem, options, callback ) {
			var ret, name,
				old = {};

			// Remember the old values, and insert the new ones
			for ( name in options ) {
				old[ name ] = elem.style[ name ];
				elem.style[ name ] = options[ name ];
			}

			ret = callback.call( elem );

			// Revert the old values
			for ( name in options ) {
				elem.style[ name ] = old[ name ];
			}

			return ret;
		};


		var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );

		var whitespace = "[\\x20\\t\\r\\n\\f]";


		var rtrimCSS = new RegExp(
			"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
			"g"
		);




		( function() {

			// Executing both pixelPosition & boxSizingReliable tests require only one layout
			// so they're executed at the same time to save the second computation.
			function computeStyleTests() {

				// This is a singleton, we need to execute it only once
				if ( !div ) {
					return;
				}

				container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
					"margin-top:1px;padding:0;border:0";
				div.style.cssText =
					"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
					"margin:auto;border:1px;padding:1px;" +
					"width:60%;top:1%";
				documentElement.appendChild( container ).appendChild( div );

				var divStyle = window.getComputedStyle( div );
				pixelPositionVal = divStyle.top !== "1%";

				// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
				reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

				// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
				// Some styles come back with percentage values, even though they shouldn't
				div.style.right = "60%";
				pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

				// Support: IE 9 - 11 only
				// Detect misreporting of content dimensions for box-sizing:border-box elements
				boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

				// Support: IE 9 only
				// Detect overflow:scroll screwiness (gh-3699)
				// Support: Chrome <=64
				// Don't get tricked when zoom affects offsetWidth (gh-4029)
				div.style.position = "absolute";
				scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

				documentElement.removeChild( container );

				// Nullify the div so it wouldn't be stored in the memory and
				// it will also be a sign that checks already performed
				div = null;
			}

			function roundPixelMeasures( measure ) {
				return Math.round( parseFloat( measure ) );
			}

			var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
				reliableTrDimensionsVal, reliableMarginLeftVal,
				container = document.createElement( "div" ),
				div = document.createElement( "div" );

			// Finish early in limited (non-browser) environments
			if ( !div.style ) {
				return;
			}

			// Support: IE <=9 - 11 only
			// Style of cloned element affects source element cloned (trac-8908)
			div.style.backgroundClip = "content-box";
			div.cloneNode( true ).style.backgroundClip = "";
			support.clearCloneStyle = div.style.backgroundClip === "content-box";

			jQuery.extend( support, {
				boxSizingReliable: function() {
					computeStyleTests();
					return boxSizingReliableVal;
				},
				pixelBoxStyles: function() {
					computeStyleTests();
					return pixelBoxStylesVal;
				},
				pixelPosition: function() {
					computeStyleTests();
					return pixelPositionVal;
				},
				reliableMarginLeft: function() {
					computeStyleTests();
					return reliableMarginLeftVal;
				},
				scrollboxSize: function() {
					computeStyleTests();
					return scrollboxSizeVal;
				},

				// Support: IE 9 - 11+, Edge 15 - 18+
				// IE/Edge misreport `getComputedStyle` of table rows with width/height
				// set in CSS while `offset*` properties report correct values.
				// Behavior in IE 9 is more subtle than in newer versions & it passes
				// some versions of this test; make sure not to make it pass there!
				//
				// Support: Firefox 70+
				// Only Firefox includes border widths
				// in computed dimensions. (gh-4529)
				reliableTrDimensions: function() {
					var table, tr, trChild, trStyle;
					if ( reliableTrDimensionsVal == null ) {
						table = document.createElement( "table" );
						tr = document.createElement( "tr" );
						trChild = document.createElement( "div" );

						table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
						tr.style.cssText = "border:1px solid";

						// Support: Chrome 86+
						// Height set through cssText does not get applied.
						// Computed height then comes back as 0.
						tr.style.height = "1px";
						trChild.style.height = "9px";

						// Support: Android 8 Chrome 86+
						// In our bodyBackground.html iframe,
						// display for all div elements is set to "inline",
						// which causes a problem only in Android 8 Chrome 86.
						// Ensuring the div is display: block
						// gets around this issue.
						trChild.style.display = "block";

						documentElement
							.appendChild( table )
							.appendChild( tr )
							.appendChild( trChild );

						trStyle = window.getComputedStyle( tr );
						reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
							parseInt( trStyle.borderTopWidth, 10 ) +
							parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

						documentElement.removeChild( table );
					}
					return reliableTrDimensionsVal;
				}
			} );
		} )();


		function curCSS( elem, name, computed ) {
			var width, minWidth, maxWidth, ret,
				isCustomProp = rcustomProp.test( name ),

				// Support: Firefox 51+
				// Retrieving style before computed somehow
				// fixes an issue with getting wrong values
				// on detached elements
				style = elem.style;

			computed = computed || getStyles( elem );

			// getPropertyValue is needed for:
			//   .css('filter') (IE 9 only, trac-12537)
			//   .css('--customProperty) (gh-3144)
			if ( computed ) {

				// Support: IE <=9 - 11+
				// IE only supports `"float"` in `getPropertyValue`; in computed styles
				// it's only available as `"cssFloat"`. We no longer modify properties
				// sent to `.css()` apart from camelCasing, so we need to check both.
				// Normally, this would create difference in behavior: if
				// `getPropertyValue` returns an empty string, the value returned
				// by `.css()` would be `undefined`. This is usually the case for
				// disconnected elements. However, in IE even disconnected elements
				// with no styles return `"none"` for `getPropertyValue( "float" )`
				ret = computed.getPropertyValue( name ) || computed[ name ];

				if ( isCustomProp && ret ) {

					// Support: Firefox 105+, Chrome <=105+
					// Spec requires trimming whitespace for custom properties (gh-4926).
					// Firefox only trims leading whitespace. Chrome just collapses
					// both leading & trailing whitespace to a single space.
					//
					// Fall back to `undefined` if empty string returned.
					// This collapses a missing definition with property defined
					// and set to an empty string but there's no standard API
					// allowing us to differentiate them without a performance penalty
					// and returning `undefined` aligns with older jQuery.
					//
					// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
					// as whitespace while CSS does not, but this is not a problem
					// because CSS preprocessing replaces them with U+000A LINE FEED
					// (which *is* CSS whitespace)
					// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
					ret = ret.replace( rtrimCSS, "$1" ) || undefined;
				}

				if ( ret === "" && !isAttached( elem ) ) {
					ret = jQuery.style( elem, name );
				}

				// A tribute to the "awesome hack by Dean Edwards"
				// Android Browser returns percentage for some values,
				// but width seems to be reliably pixels.
				// This is against the CSSOM draft spec:
				// https://drafts.csswg.org/cssom/#resolved-values
				if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

					// Remember the original values
					width = style.width;
					minWidth = style.minWidth;
					maxWidth = style.maxWidth;

					// Put in the new values to get a computed value out
					style.minWidth = style.maxWidth = style.width = ret;
					ret = computed.width;

					// Revert the changed values
					style.width = width;
					style.minWidth = minWidth;
					style.maxWidth = maxWidth;
				}
			}

			return ret !== undefined ?

				// Support: IE <=9 - 11 only
				// IE returns zIndex value as an integer.
				ret + "" :
				ret;
		}


		function addGetHookIf( conditionFn, hookFn ) {

			// Define the hook, we'll check on the first run if it's really needed.
			return {
				get: function() {
					if ( conditionFn() ) {

						// Hook not needed (or it's not possible to use it due
						// to missing dependency), remove it.
						delete this.get;
						return;
					}

					// Hook needed; redefine it so that the support test is not executed again.
					return ( this.get = hookFn ).apply( this, arguments );
				}
			};
		}


		var cssPrefixes = [ "Webkit", "Moz", "ms" ],
			emptyStyle = document.createElement( "div" ).style,
			vendorProps = {};

		// Return a vendor-prefixed property or undefined
		function vendorPropName( name ) {

			// Check for vendor prefixed names
			var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
				i = cssPrefixes.length;

			while ( i-- ) {
				name = cssPrefixes[ i ] + capName;
				if ( name in emptyStyle ) {
					return name;
				}
			}
		}

		// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
		function finalPropName( name ) {
			var final = jQuery.cssProps[ name ] || vendorProps[ name ];

			if ( final ) {
				return final;
			}
			if ( name in emptyStyle ) {
				return name;
			}
			return vendorProps[ name ] = vendorPropName( name ) || name;
		}


		var

			// Swappable if display is none or starts with table
			// except "table", "table-cell", or "table-caption"
			// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
			rdisplayswap = /^(none|table(?!-c[ea]).+)/,
			cssShow = { position: "absolute", visibility: "hidden", display: "block" },
			cssNormalTransform = {
				letterSpacing: "0",
				fontWeight: "400"
			};

		function setPositiveNumber( _elem, value, subtract ) {

			// Any relative (+/-) values have already been
			// normalized at this point
			var matches = rcssNum.exec( value );
			return matches ?

				// Guard against undefined "subtract", e.g., when used as in cssHooks
				Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
				value;
		}

		function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
			var i = dimension === "width" ? 1 : 0,
				extra = 0,
				delta = 0;

			// Adjustment may not be necessary
			if ( box === ( isBorderBox ? "border" : "content" ) ) {
				return 0;
			}

			for ( ; i < 4; i += 2 ) {

				// Both box models exclude margin
				if ( box === "margin" ) {
					delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
				}

				// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
				if ( !isBorderBox ) {

					// Add padding
					delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

					// For "border" or "margin", add border
					if ( box !== "padding" ) {
						delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

					// But still keep track of it otherwise
					} else {
						extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
					}

				// If we get here with a border-box (content + padding + border), we're seeking "content" or
				// "padding" or "margin"
				} else {

					// For "content", subtract padding
					if ( box === "content" ) {
						delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
					}

					// For "content" or "padding", subtract border
					if ( box !== "margin" ) {
						delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
					}
				}
			}

			// Account for positive content-box scroll gutter when requested by providing computedVal
			if ( !isBorderBox && computedVal >= 0 ) {

				// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
				// Assuming integer scroll gutter, subtract the rest and round down
				delta += Math.max( 0, Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					computedVal -
					delta -
					extra -
					0.5

				// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
				// Use an explicit zero to avoid NaN (gh-3964)
				) ) || 0;
			}

			return delta;
		}

		function getWidthOrHeight( elem, dimension, extra ) {

			// Start with computed style
			var styles = getStyles( elem ),

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
				// Fake content-box until we know it's needed to know the true value.
				boxSizingNeeded = !support.boxSizingReliable() || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				valueIsBorderBox = isBorderBox,

				val = curCSS( elem, dimension, styles ),
				offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

			// Support: Firefox <=54
			// Return a confounding non-pixel value or feign ignorance, as appropriate.
			if ( rnumnonpx.test( val ) ) {
				if ( !extra ) {
					return val;
				}
				val = "auto";
			}


			// Support: IE 9 - 11 only
			// Use offsetWidth/offsetHeight for when box sizing is unreliable.
			// In those cases, the computed value can be trusted to be border-box.
			if ( ( !support.boxSizingReliable() && isBorderBox ||

				// Support: IE 10 - 11+, Edge 15 - 18+
				// IE/Edge misreport `getComputedStyle` of table rows with width/height
				// set in CSS while `offset*` properties report correct values.
				// Interestingly, in some cases IE 9 doesn't suffer from this issue.
				!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

				// Fall back to offsetWidth/offsetHeight when value is "auto"
				// This happens for inline elements with no explicit setting (gh-3571)
				val === "auto" ||

				// Support: Android <=4.1 - 4.3 only
				// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
				!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

				// Make sure the element is visible & connected
				elem.getClientRects().length ) {

				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

				// Where available, offsetWidth/offsetHeight approximate border box dimensions.
				// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
				// retrieved value as a content box dimension.
				valueIsBorderBox = offsetProp in elem;
				if ( valueIsBorderBox ) {
					val = elem[ offsetProp ];
				}
			}

			// Normalize "" and auto
			val = parseFloat( val ) || 0;

			// Adjust for the element's box model
			return ( val +
				boxModelAdjustment(
					elem,
					dimension,
					extra || ( isBorderBox ? "border" : "content" ),
					valueIsBorderBox,
					styles,

					// Provide the current computed size to request scroll gutter calculation (gh-3589)
					val
				)
			) + "px";
		}

		jQuery.extend( {

			// Add in style property hooks for overriding the default
			// behavior of getting and setting a style property
			cssHooks: {
				opacity: {
					get: function( elem, computed ) {
						if ( computed ) {

							// We should always get a number back from opacity
							var ret = curCSS( elem, "opacity" );
							return ret === "" ? "1" : ret;
						}
					}
				}
			},

			// Don't automatically add "px" to these possibly-unitless properties
			cssNumber: {
				"animationIterationCount": true,
				"columnCount": true,
				"fillOpacity": true,
				"flexGrow": true,
				"flexShrink": true,
				"fontWeight": true,
				"gridArea": true,
				"gridColumn": true,
				"gridColumnEnd": true,
				"gridColumnStart": true,
				"gridRow": true,
				"gridRowEnd": true,
				"gridRowStart": true,
				"lineHeight": true,
				"opacity": true,
				"order": true,
				"orphans": true,
				"widows": true,
				"zIndex": true,
				"zoom": true
			},

			// Add in properties whose names you wish to fix before
			// setting or getting the value
			cssProps: {},

			// Get and set the style property on a DOM Node
			style: function( elem, name, value, extra ) {

				// Don't set styles on text and comment nodes
				if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
					return;
				}

				// Make sure that we're working with the right name
				var ret, type, hooks,
					origName = camelCase( name ),
					isCustomProp = rcustomProp.test( name ),
					style = elem.style;

				// Make sure that we're working with the right name. We don't
				// want to query the value if it is a CSS custom property
				// since they are user-defined.
				if ( !isCustomProp ) {
					name = finalPropName( origName );
				}

				// Gets hook for the prefixed version, then unprefixed version
				hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

				// Check if we're setting a value
				if ( value !== undefined ) {
					type = typeof value;

					// Convert "+=" or "-=" to relative numbers (trac-7345)
					if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
						value = adjustCSS( elem, name, ret );

						// Fixes bug trac-9237
						type = "number";
					}

					// Make sure that null and NaN values aren't set (trac-7116)
					if ( value == null || value !== value ) {
						return;
					}

					// If a number was passed in, add the unit (except for certain CSS properties)
					// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
					// "px" to a few hardcoded values.
					if ( type === "number" && !isCustomProp ) {
						value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
					}

					// background-* props affect original clone's values
					if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
						style[ name ] = "inherit";
					}

					// If a hook was provided, use that value, otherwise just set the specified value
					if ( !hooks || !( "set" in hooks ) ||
						( value = hooks.set( elem, value, extra ) ) !== undefined ) {

						if ( isCustomProp ) {
							style.setProperty( name, value );
						} else {
							style[ name ] = value;
						}
					}

				} else {

					// If a hook was provided get the non-computed value from there
					if ( hooks && "get" in hooks &&
						( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

						return ret;
					}

					// Otherwise just get the value from the style object
					return style[ name ];
				}
			},

			css: function( elem, name, extra, styles ) {
				var val, num, hooks,
					origName = camelCase( name ),
					isCustomProp = rcustomProp.test( name );

				// Make sure that we're working with the right name. We don't
				// want to modify the value if it is a CSS custom property
				// since they are user-defined.
				if ( !isCustomProp ) {
					name = finalPropName( origName );
				}

				// Try prefixed name followed by the unprefixed name
				hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

				// If a hook was provided get the computed value from there
				if ( hooks && "get" in hooks ) {
					val = hooks.get( elem, true, extra );
				}

				// Otherwise, if a way to get the computed value exists, use that
				if ( val === undefined ) {
					val = curCSS( elem, name, styles );
				}

				// Convert "normal" to computed value
				if ( val === "normal" && name in cssNormalTransform ) {
					val = cssNormalTransform[ name ];
				}

				// Make numeric if forced or a qualifier was provided and val looks numeric
				if ( extra === "" || extra ) {
					num = parseFloat( val );
					return extra === true || isFinite( num ) ? num || 0 : val;
				}

				return val;
			}
		} );

		jQuery.each( [ "height", "width" ], function( _i, dimension ) {
			jQuery.cssHooks[ dimension ] = {
				get: function( elem, computed, extra ) {
					if ( computed ) {

						// Certain elements can have dimension info if we invisibly show them
						// but it must have a current display style that would benefit
						return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

							// Support: Safari 8+
							// Table columns in Safari have non-zero offsetWidth & zero
							// getBoundingClientRect().width unless display is changed.
							// Support: IE <=11 only
							// Running getBoundingClientRect on a disconnected node
							// in IE throws an error.
							( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
					}
				},

				set: function( elem, value, extra ) {
					var matches,
						styles = getStyles( elem ),

						// Only read styles.position if the test has a chance to fail
						// to avoid forcing a reflow.
						scrollboxSizeBuggy = !support.scrollboxSize() &&
							styles.position === "absolute",

						// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
						boxSizingNeeded = scrollboxSizeBuggy || extra,
						isBorderBox = boxSizingNeeded &&
							jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						subtract = extra ?
							boxModelAdjustment(
								elem,
								dimension,
								extra,
								isBorderBox,
								styles
							) :
							0;

					// Account for unreliable border-box dimensions by comparing offset* to computed and
					// faking a content-box to get border and padding (gh-3699)
					if ( isBorderBox && scrollboxSizeBuggy ) {
						subtract -= Math.ceil(
							elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
							parseFloat( styles[ dimension ] ) -
							boxModelAdjustment( elem, dimension, "border", false, styles ) -
							0.5
						);
					}

					// Convert to pixels if value adjustment is needed
					if ( subtract && ( matches = rcssNum.exec( value ) ) &&
						( matches[ 3 ] || "px" ) !== "px" ) {

						elem.style[ dimension ] = value;
						value = jQuery.css( elem, dimension );
					}

					return setPositiveNumber( elem, value, subtract );
				}
			};
		} );

		jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
			function( elem, computed ) {
				if ( computed ) {
					return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
						elem.getBoundingClientRect().left -
							swap( elem, { marginLeft: 0 }, function() {
								return elem.getBoundingClientRect().left;
							} )
					) + "px";
				}
			}
		);

		// These hooks are used by animate to expand properties
		jQuery.each( {
			margin: "",
			padding: "",
			border: "Width"
		}, function( prefix, suffix ) {
			jQuery.cssHooks[ prefix + suffix ] = {
				expand: function( value ) {
					var i = 0,
						expanded = {},

						// Assumes a single number if not a string
						parts = typeof value === "string" ? value.split( " " ) : [ value ];

					for ( ; i < 4; i++ ) {
						expanded[ prefix + cssExpand[ i ] + suffix ] =
							parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
					}

					return expanded;
				}
			};

			if ( prefix !== "margin" ) {
				jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
			}
		} );

		jQuery.fn.extend( {
			css: function( name, value ) {
				return access( this, function( elem, name, value ) {
					var styles, len,
						map = {},
						i = 0;

					if ( Array.isArray( name ) ) {
						styles = getStyles( elem );
						len = name.length;

						for ( ; i < len; i++ ) {
							map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
						}

						return map;
					}

					return value !== undefined ?
						jQuery.style( elem, name, value ) :
						jQuery.css( elem, name );
				}, name, value, arguments.length > 1 );
			}
		} );


		function Tween( elem, options, prop, end, easing ) {
			return new Tween.prototype.init( elem, options, prop, end, easing );
		}
		jQuery.Tween = Tween;

		Tween.prototype = {
			constructor: Tween,
			init: function( elem, options, prop, end, easing, unit ) {
				this.elem = elem;
				this.prop = prop;
				this.easing = easing || jQuery.easing._default;
				this.options = options;
				this.start = this.now = this.cur();
				this.end = end;
				this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
			},
			cur: function() {
				var hooks = Tween.propHooks[ this.prop ];

				return hooks && hooks.get ?
					hooks.get( this ) :
					Tween.propHooks._default.get( this );
			},
			run: function( percent ) {
				var eased,
					hooks = Tween.propHooks[ this.prop ];

				if ( this.options.duration ) {
					this.pos = eased = jQuery.easing[ this.easing ](
						percent, this.options.duration * percent, 0, 1, this.options.duration
					);
				} else {
					this.pos = eased = percent;
				}
				this.now = ( this.end - this.start ) * eased + this.start;

				if ( this.options.step ) {
					this.options.step.call( this.elem, this.now, this );
				}

				if ( hooks && hooks.set ) {
					hooks.set( this );
				} else {
					Tween.propHooks._default.set( this );
				}
				return this;
			}
		};

		Tween.prototype.init.prototype = Tween.prototype;

		Tween.propHooks = {
			_default: {
				get: function( tween ) {
					var result;

					// Use a property on the element directly when it is not a DOM element,
					// or when there is no matching style property that exists.
					if ( tween.elem.nodeType !== 1 ||
						tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
						return tween.elem[ tween.prop ];
					}

					// Passing an empty string as a 3rd parameter to .css will automatically
					// attempt a parseFloat and fallback to a string if the parse fails.
					// Simple values such as "10px" are parsed to Float;
					// complex values such as "rotate(1rad)" are returned as-is.
					result = jQuery.css( tween.elem, tween.prop, "" );

					// Empty strings, null, undefined and "auto" are converted to 0.
					return !result || result === "auto" ? 0 : result;
				},
				set: function( tween ) {

					// Use step hook for back compat.
					// Use cssHook if its there.
					// Use .style if available and use plain properties where available.
					if ( jQuery.fx.step[ tween.prop ] ) {
						jQuery.fx.step[ tween.prop ]( tween );
					} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
							tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
						jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
					} else {
						tween.elem[ tween.prop ] = tween.now;
					}
				}
			}
		};

		// Support: IE <=9 only
		// Panic based approach to setting things on disconnected nodes
		Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
			set: function( tween ) {
				if ( tween.elem.nodeType && tween.elem.parentNode ) {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		};

		jQuery.easing = {
			linear: function( p ) {
				return p;
			},
			swing: function( p ) {
				return 0.5 - Math.cos( p * Math.PI ) / 2;
			},
			_default: "swing"
		};

		jQuery.fx = Tween.prototype.init;

		// Back compat <1.8 extension point
		jQuery.fx.step = {};




		var
			fxNow, inProgress,
			rfxtypes = /^(?:toggle|show|hide)$/,
			rrun = /queueHooks$/;

		function schedule() {
			if ( inProgress ) {
				if ( document.hidden === false && window.requestAnimationFrame ) {
					window.requestAnimationFrame( schedule );
				} else {
					window.setTimeout( schedule, jQuery.fx.interval );
				}

				jQuery.fx.tick();
			}
		}

		// Animations created synchronously will run synchronously
		function createFxNow() {
			window.setTimeout( function() {
				fxNow = undefined;
			} );
			return ( fxNow = Date.now() );
		}

		// Generate parameters to create a standard animation
		function genFx( type, includeWidth ) {
			var which,
				i = 0,
				attrs = { height: type };

			// If we include width, step value is 1 to do all cssExpand values,
			// otherwise step value is 2 to skip over Left and Right
			includeWidth = includeWidth ? 1 : 0;
			for ( ; i < 4; i += 2 - includeWidth ) {
				which = cssExpand[ i ];
				attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
			}

			if ( includeWidth ) {
				attrs.opacity = attrs.width = type;
			}

			return attrs;
		}

		function createTween( value, prop, animation ) {
			var tween,
				collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
				index = 0,
				length = collection.length;
			for ( ; index < length; index++ ) {
				if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

					// We're done with this property
					return tween;
				}
			}
		}

		function defaultPrefilter( elem, props, opts ) {
			var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
				isBox = "width" in props || "height" in props,
				anim = this,
				orig = {},
				style = elem.style,
				hidden = elem.nodeType && isHiddenWithinTree( elem ),
				dataShow = dataPriv.get( elem, "fxshow" );

			// Queue-skipping animations hijack the fx hooks
			if ( !opts.queue ) {
				hooks = jQuery._queueHooks( elem, "fx" );
				if ( hooks.unqueued == null ) {
					hooks.unqueued = 0;
					oldfire = hooks.empty.fire;
					hooks.empty.fire = function() {
						if ( !hooks.unqueued ) {
							oldfire();
						}
					};
				}
				hooks.unqueued++;

				anim.always( function() {

					// Ensure the complete handler is called before this completes
					anim.always( function() {
						hooks.unqueued--;
						if ( !jQuery.queue( elem, "fx" ).length ) {
							hooks.empty.fire();
						}
					} );
				} );
			}

			// Detect show/hide animations
			for ( prop in props ) {
				value = props[ prop ];
				if ( rfxtypes.test( value ) ) {
					delete props[ prop ];
					toggle = toggle || value === "toggle";
					if ( value === ( hidden ? "hide" : "show" ) ) {

						// Pretend to be hidden if this is a "show" and
						// there is still data from a stopped show/hide
						if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
							hidden = true;

						// Ignore all other no-op show/hide data
						} else {
							continue;
						}
					}
					orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
				}
			}

			// Bail out if this is a no-op like .hide().hide()
			propTween = !jQuery.isEmptyObject( props );
			if ( !propTween && jQuery.isEmptyObject( orig ) ) {
				return;
			}

			// Restrict "overflow" and "display" styles during box animations
			if ( isBox && elem.nodeType === 1 ) {

				// Support: IE <=9 - 11, Edge 12 - 15
				// Record all 3 overflow attributes because IE does not infer the shorthand
				// from identically-valued overflowX and overflowY and Edge just mirrors
				// the overflowX value there.
				opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

				// Identify a display type, preferring old show/hide data over the CSS cascade
				restoreDisplay = dataShow && dataShow.display;
				if ( restoreDisplay == null ) {
					restoreDisplay = dataPriv.get( elem, "display" );
				}
				display = jQuery.css( elem, "display" );
				if ( display === "none" ) {
					if ( restoreDisplay ) {
						display = restoreDisplay;
					} else {

						// Get nonempty value(s) by temporarily forcing visibility
						showHide( [ elem ], true );
						restoreDisplay = elem.style.display || restoreDisplay;
						display = jQuery.css( elem, "display" );
						showHide( [ elem ] );
					}
				}

				// Animate inline elements as inline-block
				if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
					if ( jQuery.css( elem, "float" ) === "none" ) {

						// Restore the original display value at the end of pure show/hide animations
						if ( !propTween ) {
							anim.done( function() {
								style.display = restoreDisplay;
							} );
							if ( restoreDisplay == null ) {
								display = style.display;
								restoreDisplay = display === "none" ? "" : display;
							}
						}
						style.display = "inline-block";
					}
				}
			}

			if ( opts.overflow ) {
				style.overflow = "hidden";
				anim.always( function() {
					style.overflow = opts.overflow[ 0 ];
					style.overflowX = opts.overflow[ 1 ];
					style.overflowY = opts.overflow[ 2 ];
				} );
			}

			// Implement show/hide animations
			propTween = false;
			for ( prop in orig ) {

				// General show/hide setup for this element animation
				if ( !propTween ) {
					if ( dataShow ) {
						if ( "hidden" in dataShow ) {
							hidden = dataShow.hidden;
						}
					} else {
						dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
					}

					// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
					if ( toggle ) {
						dataShow.hidden = !hidden;
					}

					// Show elements before animating them
					if ( hidden ) {
						showHide( [ elem ], true );
					}

					/* eslint-disable no-loop-func */

					anim.done( function() {

						/* eslint-enable no-loop-func */

						// The final step of a "hide" animation is actually hiding the element
						if ( !hidden ) {
							showHide( [ elem ] );
						}
						dataPriv.remove( elem, "fxshow" );
						for ( prop in orig ) {
							jQuery.style( elem, prop, orig[ prop ] );
						}
					} );
				}

				// Per-property setup
				propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = propTween.start;
					if ( hidden ) {
						propTween.end = propTween.start;
						propTween.start = 0;
					}
				}
			}
		}

		function propFilter( props, specialEasing ) {
			var index, name, easing, value, hooks;

			// camelCase, specialEasing and expand cssHook pass
			for ( index in props ) {
				name = camelCase( index );
				easing = specialEasing[ name ];
				value = props[ index ];
				if ( Array.isArray( value ) ) {
					easing = value[ 1 ];
					value = props[ index ] = value[ 0 ];
				}

				if ( index !== name ) {
					props[ name ] = value;
					delete props[ index ];
				}

				hooks = jQuery.cssHooks[ name ];
				if ( hooks && "expand" in hooks ) {
					value = hooks.expand( value );
					delete props[ name ];

					// Not quite $.extend, this won't overwrite existing keys.
					// Reusing 'index' because we have the correct "name"
					for ( index in value ) {
						if ( !( index in props ) ) {
							props[ index ] = value[ index ];
							specialEasing[ index ] = easing;
						}
					}
				} else {
					specialEasing[ name ] = easing;
				}
			}
		}

		function Animation( elem, properties, options ) {
			var result,
				stopped,
				index = 0,
				length = Animation.prefilters.length,
				deferred = jQuery.Deferred().always( function() {

					// Don't match elem in the :animated selector
					delete tick.elem;
				} ),
				tick = function() {
					if ( stopped ) {
						return false;
					}
					var currentTime = fxNow || createFxNow(),
						remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

						// Support: Android 2.3 only
						// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
						temp = remaining / animation.duration || 0,
						percent = 1 - temp,
						index = 0,
						length = animation.tweens.length;

					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( percent );
					}

					deferred.notifyWith( elem, [ animation, percent, remaining ] );

					// If there's more to do, yield
					if ( percent < 1 && length ) {
						return remaining;
					}

					// If this was an empty animation, synthesize a final progress notification
					if ( !length ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
					}

					// Resolve the animation and report its conclusion
					deferred.resolveWith( elem, [ animation ] );
					return false;
				},
				animation = deferred.promise( {
					elem: elem,
					props: jQuery.extend( {}, properties ),
					opts: jQuery.extend( true, {
						specialEasing: {},
						easing: jQuery.easing._default
					}, options ),
					originalProperties: properties,
					originalOptions: options,
					startTime: fxNow || createFxNow(),
					duration: options.duration,
					tweens: [],
					createTween: function( prop, end ) {
						var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
						animation.tweens.push( tween );
						return tween;
					},
					stop: function( gotoEnd ) {
						var index = 0,

							// If we are going to the end, we want to run all the tweens
							// otherwise we skip this part
							length = gotoEnd ? animation.tweens.length : 0;
						if ( stopped ) {
							return this;
						}
						stopped = true;
						for ( ; index < length; index++ ) {
							animation.tweens[ index ].run( 1 );
						}

						// Resolve when we played the last frame; otherwise, reject
						if ( gotoEnd ) {
							deferred.notifyWith( elem, [ animation, 1, 0 ] );
							deferred.resolveWith( elem, [ animation, gotoEnd ] );
						} else {
							deferred.rejectWith( elem, [ animation, gotoEnd ] );
						}
						return this;
					}
				} ),
				props = animation.props;

			propFilter( props, animation.opts.specialEasing );

			for ( ; index < length; index++ ) {
				result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
				if ( result ) {
					if ( isFunction( result.stop ) ) {
						jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
							result.stop.bind( result );
					}
					return result;
				}
			}

			jQuery.map( props, createTween, animation );

			if ( isFunction( animation.opts.start ) ) {
				animation.opts.start.call( elem, animation );
			}

			// Attach callbacks from options
			animation
				.progress( animation.opts.progress )
				.done( animation.opts.done, animation.opts.complete )
				.fail( animation.opts.fail )
				.always( animation.opts.always );

			jQuery.fx.timer(
				jQuery.extend( tick, {
					elem: elem,
					anim: animation,
					queue: animation.opts.queue
				} )
			);

			return animation;
		}

		jQuery.Animation = jQuery.extend( Animation, {

			tweeners: {
				"*": [ function( prop, value ) {
					var tween = this.createTween( prop, value );
					adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
					return tween;
				} ]
			},

			tweener: function( props, callback ) {
				if ( isFunction( props ) ) {
					callback = props;
					props = [ "*" ];
				} else {
					props = props.match( rnothtmlwhite );
				}

				var prop,
					index = 0,
					length = props.length;

				for ( ; index < length; index++ ) {
					prop = props[ index ];
					Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
					Animation.tweeners[ prop ].unshift( callback );
				}
			},

			prefilters: [ defaultPrefilter ],

			prefilter: function( callback, prepend ) {
				if ( prepend ) {
					Animation.prefilters.unshift( callback );
				} else {
					Animation.prefilters.push( callback );
				}
			}
		} );

		jQuery.speed = function( speed, easing, fn ) {
			var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
				complete: fn || !fn && easing ||
					isFunction( speed ) && speed,
				duration: speed,
				easing: fn && easing || easing && !isFunction( easing ) && easing
			};

			// Go to the end state if fx are off
			if ( jQuery.fx.off ) {
				opt.duration = 0;

			} else {
				if ( typeof opt.duration !== "number" ) {
					if ( opt.duration in jQuery.fx.speeds ) {
						opt.duration = jQuery.fx.speeds[ opt.duration ];

					} else {
						opt.duration = jQuery.fx.speeds._default;
					}
				}
			}

			// Normalize opt.queue - true/undefined/null -> "fx"
			if ( opt.queue == null || opt.queue === true ) {
				opt.queue = "fx";
			}

			// Queueing
			opt.old = opt.complete;

			opt.complete = function() {
				if ( isFunction( opt.old ) ) {
					opt.old.call( this );
				}

				if ( opt.queue ) {
					jQuery.dequeue( this, opt.queue );
				}
			};

			return opt;
		};

		jQuery.fn.extend( {
			fadeTo: function( speed, to, easing, callback ) {

				// Show any hidden elements after setting opacity to 0
				return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

					// Animate to the value specified
					.end().animate( { opacity: to }, speed, easing, callback );
			},
			animate: function( prop, speed, easing, callback ) {
				var empty = jQuery.isEmptyObject( prop ),
					optall = jQuery.speed( speed, easing, callback ),
					doAnimation = function() {

						// Operate on a copy of prop so per-property easing won't be lost
						var anim = Animation( this, jQuery.extend( {}, prop ), optall );

						// Empty animations, or finishing resolves immediately
						if ( empty || dataPriv.get( this, "finish" ) ) {
							anim.stop( true );
						}
					};

				doAnimation.finish = doAnimation;

				return empty || optall.queue === false ?
					this.each( doAnimation ) :
					this.queue( optall.queue, doAnimation );
			},
			stop: function( type, clearQueue, gotoEnd ) {
				var stopQueue = function( hooks ) {
					var stop = hooks.stop;
					delete hooks.stop;
					stop( gotoEnd );
				};

				if ( typeof type !== "string" ) {
					gotoEnd = clearQueue;
					clearQueue = type;
					type = undefined;
				}
				if ( clearQueue ) {
					this.queue( type || "fx", [] );
				}

				return this.each( function() {
					var dequeue = true,
						index = type != null && type + "queueHooks",
						timers = jQuery.timers,
						data = dataPriv.get( this );

					if ( index ) {
						if ( data[ index ] && data[ index ].stop ) {
							stopQueue( data[ index ] );
						}
					} else {
						for ( index in data ) {
							if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
								stopQueue( data[ index ] );
							}
						}
					}

					for ( index = timers.length; index--; ) {
						if ( timers[ index ].elem === this &&
							( type == null || timers[ index ].queue === type ) ) {

							timers[ index ].anim.stop( gotoEnd );
							dequeue = false;
							timers.splice( index, 1 );
						}
					}

					// Start the next in the queue if the last step wasn't forced.
					// Timers currently will call their complete callbacks, which
					// will dequeue but only if they were gotoEnd.
					if ( dequeue || !gotoEnd ) {
						jQuery.dequeue( this, type );
					}
				} );
			},
			finish: function( type ) {
				if ( type !== false ) {
					type = type || "fx";
				}
				return this.each( function() {
					var index,
						data = dataPriv.get( this ),
						queue = data[ type + "queue" ],
						hooks = data[ type + "queueHooks" ],
						timers = jQuery.timers,
						length = queue ? queue.length : 0;

					// Enable finishing flag on private data
					data.finish = true;

					// Empty the queue first
					jQuery.queue( this, type, [] );

					if ( hooks && hooks.stop ) {
						hooks.stop.call( this, true );
					}

					// Look for any active animations, and finish them
					for ( index = timers.length; index--; ) {
						if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
							timers[ index ].anim.stop( true );
							timers.splice( index, 1 );
						}
					}

					// Look for any animations in the old queue and finish them
					for ( index = 0; index < length; index++ ) {
						if ( queue[ index ] && queue[ index ].finish ) {
							queue[ index ].finish.call( this );
						}
					}

					// Turn off finishing flag
					delete data.finish;
				} );
			}
		} );

		jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
			var cssFn = jQuery.fn[ name ];
			jQuery.fn[ name ] = function( speed, easing, callback ) {
				return speed == null || typeof speed === "boolean" ?
					cssFn.apply( this, arguments ) :
					this.animate( genFx( name, true ), speed, easing, callback );
			};
		} );

		// Generate shortcuts for custom animations
		jQuery.each( {
			slideDown: genFx( "show" ),
			slideUp: genFx( "hide" ),
			slideToggle: genFx( "toggle" ),
			fadeIn: { opacity: "show" },
			fadeOut: { opacity: "hide" },
			fadeToggle: { opacity: "toggle" }
		}, function( name, props ) {
			jQuery.fn[ name ] = function( speed, easing, callback ) {
				return this.animate( props, speed, easing, callback );
			};
		} );

		jQuery.timers = [];
		jQuery.fx.tick = function() {
			var timer,
				i = 0,
				timers = jQuery.timers;

			fxNow = Date.now();

			for ( ; i < timers.length; i++ ) {
				timer = timers[ i ];

				// Run the timer and safely remove it when done (allowing for external removal)
				if ( !timer() && timers[ i ] === timer ) {
					timers.splice( i--, 1 );
				}
			}

			if ( !timers.length ) {
				jQuery.fx.stop();
			}
			fxNow = undefined;
		};

		jQuery.fx.timer = function( timer ) {
			jQuery.timers.push( timer );
			jQuery.fx.start();
		};

		jQuery.fx.interval = 13;
		jQuery.fx.start = function() {
			if ( inProgress ) {
				return;
			}

			inProgress = true;
			schedule();
		};

		jQuery.fx.stop = function() {
			inProgress = null;
		};

		jQuery.fx.speeds = {
			slow: 600,
			fast: 200,

			// Default speed
			_default: 400
		};


		// Based off of the plugin by Clint Helfers, with permission.
		jQuery.fn.delay = function( time, type ) {
			time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
			type = type || "fx";

			return this.queue( type, function( next, hooks ) {
				var timeout = window.setTimeout( next, time );
				hooks.stop = function() {
					window.clearTimeout( timeout );
				};
			} );
		};


		( function() {
			var input = document.createElement( "input" ),
				select = document.createElement( "select" ),
				opt = select.appendChild( document.createElement( "option" ) );

			input.type = "checkbox";

			// Support: Android <=4.3 only
			// Default value for a checkbox should be "on"
			support.checkOn = input.value !== "";

			// Support: IE <=11 only
			// Must access selectedIndex to make default options select
			support.optSelected = opt.selected;

			// Support: IE <=11 only
			// An input loses its value after becoming a radio
			input = document.createElement( "input" );
			input.value = "t";
			input.type = "radio";
			support.radioValue = input.value === "t";
		} )();


		var boolHook,
			attrHandle = jQuery.expr.attrHandle;

		jQuery.fn.extend( {
			attr: function( name, value ) {
				return access( this, jQuery.attr, name, value, arguments.length > 1 );
			},

			removeAttr: function( name ) {
				return this.each( function() {
					jQuery.removeAttr( this, name );
				} );
			}
		} );

		jQuery.extend( {
			attr: function( elem, name, value ) {
				var ret, hooks,
					nType = elem.nodeType;

				// Don't get/set attributes on text, comment and attribute nodes
				if ( nType === 3 || nType === 8 || nType === 2 ) {
					return;
				}

				// Fallback to prop when attributes are not supported
				if ( typeof elem.getAttribute === "undefined" ) {
					return jQuery.prop( elem, name, value );
				}

				// Attribute hooks are determined by the lowercase version
				// Grab necessary hook if one is defined
				if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
					hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
						( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
				}

				if ( value !== undefined ) {
					if ( value === null ) {
						jQuery.removeAttr( elem, name );
						return;
					}

					if ( hooks && "set" in hooks &&
						( ret = hooks.set( elem, value, name ) ) !== undefined ) {
						return ret;
					}

					elem.setAttribute( name, value + "" );
					return value;
				}

				if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
					return ret;
				}

				ret = jQuery.find.attr( elem, name );

				// Non-existent attributes return null, we normalize to undefined
				return ret == null ? undefined : ret;
			},

			attrHooks: {
				type: {
					set: function( elem, value ) {
						if ( !support.radioValue && value === "radio" &&
							nodeName( elem, "input" ) ) {
							var val = elem.value;
							elem.setAttribute( "type", value );
							if ( val ) {
								elem.value = val;
							}
							return value;
						}
					}
				}
			},

			removeAttr: function( elem, value ) {
				var name,
					i = 0,

					// Attribute names can contain non-HTML whitespace characters
					// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
					attrNames = value && value.match( rnothtmlwhite );

				if ( attrNames && elem.nodeType === 1 ) {
					while ( ( name = attrNames[ i++ ] ) ) {
						elem.removeAttribute( name );
					}
				}
			}
		} );

		// Hooks for boolean attributes
		boolHook = {
			set: function( elem, value, name ) {
				if ( value === false ) {

					// Remove boolean attributes when set to false
					jQuery.removeAttr( elem, name );
				} else {
					elem.setAttribute( name, name );
				}
				return name;
			}
		};

		jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
			var getter = attrHandle[ name ] || jQuery.find.attr;

			attrHandle[ name ] = function( elem, name, isXML ) {
				var ret, handle,
					lowercaseName = name.toLowerCase();

				if ( !isXML ) {

					// Avoid an infinite loop by temporarily removing this function from the getter
					handle = attrHandle[ lowercaseName ];
					attrHandle[ lowercaseName ] = ret;
					ret = getter( elem, name, isXML ) != null ?
						lowercaseName :
						null;
					attrHandle[ lowercaseName ] = handle;
				}
				return ret;
			};
		} );




		var rfocusable = /^(?:input|select|textarea|button)$/i,
			rclickable = /^(?:a|area)$/i;

		jQuery.fn.extend( {
			prop: function( name, value ) {
				return access( this, jQuery.prop, name, value, arguments.length > 1 );
			},

			removeProp: function( name ) {
				return this.each( function() {
					delete this[ jQuery.propFix[ name ] || name ];
				} );
			}
		} );

		jQuery.extend( {
			prop: function( elem, name, value ) {
				var ret, hooks,
					nType = elem.nodeType;

				// Don't get/set properties on text, comment and attribute nodes
				if ( nType === 3 || nType === 8 || nType === 2 ) {
					return;
				}

				if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

					// Fix name and attach hooks
					name = jQuery.propFix[ name ] || name;
					hooks = jQuery.propHooks[ name ];
				}

				if ( value !== undefined ) {
					if ( hooks && "set" in hooks &&
						( ret = hooks.set( elem, value, name ) ) !== undefined ) {
						return ret;
					}

					return ( elem[ name ] = value );
				}

				if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
					return ret;
				}

				return elem[ name ];
			},

			propHooks: {
				tabIndex: {
					get: function( elem ) {

						// Support: IE <=9 - 11 only
						// elem.tabIndex doesn't always return the
						// correct value when it hasn't been explicitly set
						// Use proper attribute retrieval (trac-12072)
						var tabindex = jQuery.find.attr( elem, "tabindex" );

						if ( tabindex ) {
							return parseInt( tabindex, 10 );
						}

						if (
							rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) &&
							elem.href
						) {
							return 0;
						}

						return -1;
					}
				}
			},

			propFix: {
				"for": "htmlFor",
				"class": "className"
			}
		} );

		// Support: IE <=11 only
		// Accessing the selectedIndex property
		// forces the browser to respect setting selected
		// on the option
		// The getter ensures a default option is selected
		// when in an optgroup
		// eslint rule "no-unused-expressions" is disabled for this code
		// since it considers such accessions noop
		if ( !support.optSelected ) {
			jQuery.propHooks.selected = {
				get: function( elem ) {

					/* eslint no-unused-expressions: "off" */

					var parent = elem.parentNode;
					if ( parent && parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
					return null;
				},
				set: function( elem ) {

					/* eslint no-unused-expressions: "off" */

					var parent = elem.parentNode;
					if ( parent ) {
						parent.selectedIndex;

						if ( parent.parentNode ) {
							parent.parentNode.selectedIndex;
						}
					}
				}
			};
		}

		jQuery.each( [
			"tabIndex",
			"readOnly",
			"maxLength",
			"cellSpacing",
			"cellPadding",
			"rowSpan",
			"colSpan",
			"useMap",
			"frameBorder",
			"contentEditable"
		], function() {
			jQuery.propFix[ this.toLowerCase() ] = this;
		} );




			// Strip and collapse whitespace according to HTML spec
			// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
			function stripAndCollapse( value ) {
				var tokens = value.match( rnothtmlwhite ) || [];
				return tokens.join( " " );
			}


		function getClass( elem ) {
			return elem.getAttribute && elem.getAttribute( "class" ) || "";
		}

		function classesToArray( value ) {
			if ( Array.isArray( value ) ) {
				return value;
			}
			if ( typeof value === "string" ) {
				return value.match( rnothtmlwhite ) || [];
			}
			return [];
		}

		jQuery.fn.extend( {
			addClass: function( value ) {
				var classNames, cur, curValue, className, i, finalValue;

				if ( isFunction( value ) ) {
					return this.each( function( j ) {
						jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
					} );
				}

				classNames = classesToArray( value );

				if ( classNames.length ) {
					return this.each( function() {
						curValue = getClass( this );
						cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

						if ( cur ) {
							for ( i = 0; i < classNames.length; i++ ) {
								className = classNames[ i ];
								if ( cur.indexOf( " " + className + " " ) < 0 ) {
									cur += className + " ";
								}
							}

							// Only assign if different to avoid unneeded rendering.
							finalValue = stripAndCollapse( cur );
							if ( curValue !== finalValue ) {
								this.setAttribute( "class", finalValue );
							}
						}
					} );
				}

				return this;
			},

			removeClass: function( value ) {
				var classNames, cur, curValue, className, i, finalValue;

				if ( isFunction( value ) ) {
					return this.each( function( j ) {
						jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
					} );
				}

				if ( !arguments.length ) {
					return this.attr( "class", "" );
				}

				classNames = classesToArray( value );

				if ( classNames.length ) {
					return this.each( function() {
						curValue = getClass( this );

						// This expression is here for better compressibility (see addClass)
						cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

						if ( cur ) {
							for ( i = 0; i < classNames.length; i++ ) {
								className = classNames[ i ];

								// Remove *all* instances
								while ( cur.indexOf( " " + className + " " ) > -1 ) {
									cur = cur.replace( " " + className + " ", " " );
								}
							}

							// Only assign if different to avoid unneeded rendering.
							finalValue = stripAndCollapse( cur );
							if ( curValue !== finalValue ) {
								this.setAttribute( "class", finalValue );
							}
						}
					} );
				}

				return this;
			},

			toggleClass: function( value, stateVal ) {
				var classNames, className, i, self,
					type = typeof value,
					isValidValue = type === "string" || Array.isArray( value );

				if ( isFunction( value ) ) {
					return this.each( function( i ) {
						jQuery( this ).toggleClass(
							value.call( this, i, getClass( this ), stateVal ),
							stateVal
						);
					} );
				}

				if ( typeof stateVal === "boolean" && isValidValue ) {
					return stateVal ? this.addClass( value ) : this.removeClass( value );
				}

				classNames = classesToArray( value );

				return this.each( function() {
					if ( isValidValue ) {

						// Toggle individual class names
						self = jQuery( this );

						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];

							// Check each className given, space separated list
							if ( self.hasClass( className ) ) {
								self.removeClass( className );
							} else {
								self.addClass( className );
							}
						}

					// Toggle whole class name
					} else if ( value === undefined || type === "boolean" ) {
						className = getClass( this );
						if ( className ) {

							// Store className if set
							dataPriv.set( this, "__className__", className );
						}

						// If the element has a class name or if we're passed `false`,
						// then remove the whole classname (if there was one, the above saved it).
						// Otherwise bring back whatever was previously saved (if anything),
						// falling back to the empty string if nothing was stored.
						if ( this.setAttribute ) {
							this.setAttribute( "class",
								className || value === false ?
									"" :
									dataPriv.get( this, "__className__" ) || ""
							);
						}
					}
				} );
			},

			hasClass: function( selector ) {
				var className, elem,
					i = 0;

				className = " " + selector + " ";
				while ( ( elem = this[ i++ ] ) ) {
					if ( elem.nodeType === 1 &&
						( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
					}
				}

				return false;
			}
		} );




		var rreturn = /\r/g;

		jQuery.fn.extend( {
			val: function( value ) {
				var hooks, ret, valueIsFunction,
					elem = this[ 0 ];

				if ( !arguments.length ) {
					if ( elem ) {
						hooks = jQuery.valHooks[ elem.type ] ||
							jQuery.valHooks[ elem.nodeName.toLowerCase() ];

						if ( hooks &&
							"get" in hooks &&
							( ret = hooks.get( elem, "value" ) ) !== undefined
						) {
							return ret;
						}

						ret = elem.value;

						// Handle most common string cases
						if ( typeof ret === "string" ) {
							return ret.replace( rreturn, "" );
						}

						// Handle cases where value is null/undef or number
						return ret == null ? "" : ret;
					}

					return;
				}

				valueIsFunction = isFunction( value );

				return this.each( function( i ) {
					var val;

					if ( this.nodeType !== 1 ) {
						return;
					}

					if ( valueIsFunction ) {
						val = value.call( this, i, jQuery( this ).val() );
					} else {
						val = value;
					}

					// Treat null/undefined as ""; convert numbers to string
					if ( val == null ) {
						val = "";

					} else if ( typeof val === "number" ) {
						val += "";

					} else if ( Array.isArray( val ) ) {
						val = jQuery.map( val, function( value ) {
							return value == null ? "" : value + "";
						} );
					}

					hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

					// If set returns undefined, fall back to normal setting
					if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
						this.value = val;
					}
				} );
			}
		} );

		jQuery.extend( {
			valHooks: {
				option: {
					get: function( elem ) {

						var val = jQuery.find.attr( elem, "value" );
						return val != null ?
							val :

							// Support: IE <=10 - 11 only
							// option.text throws exceptions (trac-14686, trac-14858)
							// Strip and collapse whitespace
							// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
							stripAndCollapse( jQuery.text( elem ) );
					}
				},
				select: {
					get: function( elem ) {
						var value, option, i,
							options = elem.options,
							index = elem.selectedIndex,
							one = elem.type === "select-one",
							values = one ? null : [],
							max = one ? index + 1 : options.length;

						if ( index < 0 ) {
							i = max;

						} else {
							i = one ? index : 0;
						}

						// Loop through all the selected options
						for ( ; i < max; i++ ) {
							option = options[ i ];

							// Support: IE <=9 only
							// IE8-9 doesn't update selected after form reset (trac-2551)
							if ( ( option.selected || i === index ) &&

									// Don't return options that are disabled or in a disabled optgroup
									!option.disabled &&
									( !option.parentNode.disabled ||
										!nodeName( option.parentNode, "optgroup" ) ) ) {

								// Get the specific value for the option
								value = jQuery( option ).val();

								// We don't need an array for one selects
								if ( one ) {
									return value;
								}

								// Multi-Selects return an array
								values.push( value );
							}
						}

						return values;
					},

					set: function( elem, value ) {
						var optionSet, option,
							options = elem.options,
							values = jQuery.makeArray( value ),
							i = options.length;

						while ( i-- ) {
							option = options[ i ];

							/* eslint-disable no-cond-assign */

							if ( option.selected =
								jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
							) {
								optionSet = true;
							}

							/* eslint-enable no-cond-assign */
						}

						// Force browsers to behave consistently when non-matching value is set
						if ( !optionSet ) {
							elem.selectedIndex = -1;
						}
						return values;
					}
				}
			}
		} );

		// Radios and checkboxes getter/setter
		jQuery.each( [ "radio", "checkbox" ], function() {
			jQuery.valHooks[ this ] = {
				set: function( elem, value ) {
					if ( Array.isArray( value ) ) {
						return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
					}
				}
			};
			if ( !support.checkOn ) {
				jQuery.valHooks[ this ].get = function( elem ) {
					return elem.getAttribute( "value" ) === null ? "on" : elem.value;
				};
			}
		} );




		// Return jQuery for attributes-only inclusion


		support.focusin = "onfocusin" in window;


		var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
			stopPropagationCallback = function( e ) {
				e.stopPropagation();
			};

		jQuery.extend( jQuery.event, {

			trigger: function( event, data, elem, onlyHandlers ) {

				var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
					eventPath = [ elem || document ],
					type = hasOwn.call( event, "type" ) ? event.type : event,
					namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

				cur = lastElement = tmp = elem = elem || document;

				// Don't do events on text and comment nodes
				if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
					return;
				}

				// focus/blur morphs to focusin/out; ensure we're not firing them right now
				if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
					return;
				}

				if ( type.indexOf( "." ) > -1 ) {

					// Namespaced trigger; create a regexp to match event type in handle()
					namespaces = type.split( "." );
					type = namespaces.shift();
					namespaces.sort();
				}
				ontype = type.indexOf( ":" ) < 0 && "on" + type;

				// Caller can pass in a jQuery.Event object, Object, or just an event type string
				event = event[ jQuery.expando ] ?
					event :
					new jQuery.Event( type, typeof event === "object" && event );

				// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
				event.isTrigger = onlyHandlers ? 2 : 3;
				event.namespace = namespaces.join( "." );
				event.rnamespace = event.namespace ?
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
					null;

				// Clean up the event in case it is being reused
				event.result = undefined;
				if ( !event.target ) {
					event.target = elem;
				}

				// Clone any incoming data and prepend the event, creating the handler arg list
				data = data == null ?
					[ event ] :
					jQuery.makeArray( data, [ event ] );

				// Allow special events to draw outside the lines
				special = jQuery.event.special[ type ] || {};
				if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
					return;
				}

				// Determine event propagation path in advance, per W3C events spec (trac-9951)
				// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
				if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

					bubbleType = special.delegateType || type;
					if ( !rfocusMorph.test( bubbleType + type ) ) {
						cur = cur.parentNode;
					}
					for ( ; cur; cur = cur.parentNode ) {
						eventPath.push( cur );
						tmp = cur;
					}

					// Only add window if we got to document (e.g., not plain obj or detached DOM)
					if ( tmp === ( elem.ownerDocument || document ) ) {
						eventPath.push( tmp.defaultView || tmp.parentWindow || window );
					}
				}

				// Fire handlers on the event path
				i = 0;
				while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
					lastElement = cur;
					event.type = i > 1 ?
						bubbleType :
						special.bindType || type;

					// jQuery handler
					handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
						dataPriv.get( cur, "handle" );
					if ( handle ) {
						handle.apply( cur, data );
					}

					// Native handler
					handle = ontype && cur[ ontype ];
					if ( handle && handle.apply && acceptData( cur ) ) {
						event.result = handle.apply( cur, data );
						if ( event.result === false ) {
							event.preventDefault();
						}
					}
				}
				event.type = type;

				// If nobody prevented the default action, do it now
				if ( !onlyHandlers && !event.isDefaultPrevented() ) {

					if ( ( !special._default ||
						special._default.apply( eventPath.pop(), data ) === false ) &&
						acceptData( elem ) ) {

						// Call a native DOM method on the target with the same name as the event.
						// Don't do default actions on window, that's where global variables be (trac-6170)
						if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

							// Don't re-trigger an onFOO event when we call its FOO() method
							tmp = elem[ ontype ];

							if ( tmp ) {
								elem[ ontype ] = null;
							}

							// Prevent re-triggering of the same event, since we already bubbled it above
							jQuery.event.triggered = type;

							if ( event.isPropagationStopped() ) {
								lastElement.addEventListener( type, stopPropagationCallback );
							}

							elem[ type ]();

							if ( event.isPropagationStopped() ) {
								lastElement.removeEventListener( type, stopPropagationCallback );
							}

							jQuery.event.triggered = undefined;

							if ( tmp ) {
								elem[ ontype ] = tmp;
							}
						}
					}
				}

				return event.result;
			},

			// Piggyback on a donor event to simulate a different one
			// Used only for `focus(in | out)` events
			simulate: function( type, elem, event ) {
				var e = jQuery.extend(
					new jQuery.Event(),
					event,
					{
						type: type,
						isSimulated: true
					}
				);

				jQuery.event.trigger( e, null, elem );
			}

		} );

		jQuery.fn.extend( {

			trigger: function( type, data ) {
				return this.each( function() {
					jQuery.event.trigger( type, data, this );
				} );
			},
			triggerHandler: function( type, data ) {
				var elem = this[ 0 ];
				if ( elem ) {
					return jQuery.event.trigger( type, data, elem, true );
				}
			}
		} );


		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		if ( !support.focusin ) {
			jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

				// Attach a single capturing handler on the document while someone wants focusin/focusout
				var handler = function( event ) {
					jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
				};

				jQuery.event.special[ fix ] = {
					setup: function() {

						// Handle: regular nodes (via `this.ownerDocument`), window
						// (via `this.document`) & document (via `this`).
						var doc = this.ownerDocument || this.document || this,
							attaches = dataPriv.access( doc, fix );

						if ( !attaches ) {
							doc.addEventListener( orig, handler, true );
						}
						dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
					},
					teardown: function() {
						var doc = this.ownerDocument || this.document || this,
							attaches = dataPriv.access( doc, fix ) - 1;

						if ( !attaches ) {
							doc.removeEventListener( orig, handler, true );
							dataPriv.remove( doc, fix );

						} else {
							dataPriv.access( doc, fix, attaches );
						}
					}
				};
			} );
		}
		var location = window.location;

		var nonce = { guid: Date.now() };

		var rquery = ( /\?/ );



		// Cross-browser xml parsing
		jQuery.parseXML = function( data ) {
			var xml, parserErrorElem;
			if ( !data || typeof data !== "string" ) {
				return null;
			}

			// Support: IE 9 - 11 only
			// IE throws on parseFromString with invalid input.
			try {
				xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
			} catch ( e ) {}

			parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
			if ( !xml || parserErrorElem ) {
				jQuery.error( "Invalid XML: " + (
					parserErrorElem ?
						jQuery.map( parserErrorElem.childNodes, function( el ) {
							return el.textContent;
						} ).join( "\n" ) :
						data
				) );
			}
			return xml;
		};


		var
			rbracket = /\[\]$/,
			rCRLF = /\r?\n/g,
			rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
			rsubmittable = /^(?:input|select|textarea|keygen)/i;

		function buildParams( prefix, obj, traditional, add ) {
			var name;

			if ( Array.isArray( obj ) ) {

				// Serialize array item.
				jQuery.each( obj, function( i, v ) {
					if ( traditional || rbracket.test( prefix ) ) {

						// Treat each array item as a scalar.
						add( prefix, v );

					} else {

						// Item is non-scalar (array or object), encode its numeric index.
						buildParams(
							prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
							v,
							traditional,
							add
						);
					}
				} );

			} else if ( !traditional && toType( obj ) === "object" ) {

				// Serialize object item.
				for ( name in obj ) {
					buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
				}

			} else {

				// Serialize scalar item.
				add( prefix, obj );
			}
		}

		// Serialize an array of form elements or a set of
		// key/values into a query string
		jQuery.param = function( a, traditional ) {
			var prefix,
				s = [],
				add = function( key, valueOrFunction ) {

					// If value is a function, invoke it and use its return value
					var value = isFunction( valueOrFunction ) ?
						valueOrFunction() :
						valueOrFunction;

					s[ s.length ] = encodeURIComponent( key ) + "=" +
						encodeURIComponent( value == null ? "" : value );
				};

			if ( a == null ) {
				return "";
			}

			// If an array was passed in, assume that it is an array of form elements.
			if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

				// Serialize the form elements
				jQuery.each( a, function() {
					add( this.name, this.value );
				} );

			} else {

				// If traditional, encode the "old" way (the way 1.3.2 or older
				// did it), otherwise encode params recursively.
				for ( prefix in a ) {
					buildParams( prefix, a[ prefix ], traditional, add );
				}
			}

			// Return the resulting serialization
			return s.join( "&" );
		};

		jQuery.fn.extend( {
			serialize: function() {
				return jQuery.param( this.serializeArray() );
			},
			serializeArray: function() {
				return this.map( function() {

					// Can add propHook for "elements" to filter or add form elements
					var elements = jQuery.prop( this, "elements" );
					return elements ? jQuery.makeArray( elements ) : this;
				} ).filter( function() {
					var type = this.type;

					// Use .is( ":disabled" ) so that fieldset[disabled] works
					return this.name && !jQuery( this ).is( ":disabled" ) &&
						rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
						( this.checked || !rcheckableType.test( type ) );
				} ).map( function( _i, elem ) {
					var val = jQuery( this ).val();

					if ( val == null ) {
						return null;
					}

					if ( Array.isArray( val ) ) {
						return jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} );
					}

					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} ).get();
			}
		} );


		var
			r20 = /%20/g,
			rhash = /#.*$/,
			rantiCache = /([?&])_=[^&]*/,
			rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

			// trac-7653, trac-8125, trac-8152: local protocol detection
			rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
			rnoContent = /^(?:GET|HEAD)$/,
			rprotocol = /^\/\//,

			/* Prefilters
			 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
			 * 2) These are called:
			 *    - BEFORE asking for a transport
			 *    - AFTER param serialization (s.data is a string if s.processData is true)
			 * 3) key is the dataType
			 * 4) the catchall symbol "*" can be used
			 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
			 */
			prefilters = {},

			/* Transports bindings
			 * 1) key is the dataType
			 * 2) the catchall symbol "*" can be used
			 * 3) selection will start with transport dataType and THEN go to "*" if needed
			 */
			transports = {},

			// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
			allTypes = "*/".concat( "*" ),

			// Anchor tag for parsing the document origin
			originAnchor = document.createElement( "a" );

		originAnchor.href = location.href;

		// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
		function addToPrefiltersOrTransports( structure ) {

			// dataTypeExpression is optional and defaults to "*"
			return function( dataTypeExpression, func ) {

				if ( typeof dataTypeExpression !== "string" ) {
					func = dataTypeExpression;
					dataTypeExpression = "*";
				}

				var dataType,
					i = 0,
					dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

				if ( isFunction( func ) ) {

					// For each dataType in the dataTypeExpression
					while ( ( dataType = dataTypes[ i++ ] ) ) {

						// Prepend if requested
						if ( dataType[ 0 ] === "+" ) {
							dataType = dataType.slice( 1 ) || "*";
							( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

						// Otherwise append
						} else {
							( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
						}
					}
				}
			};
		}

		// Base inspection function for prefilters and transports
		function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

			var inspected = {},
				seekingTransport = ( structure === transports );

			function inspect( dataType ) {
				var selected;
				inspected[ dataType ] = true;
				jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
					var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
					if ( typeof dataTypeOrTransport === "string" &&
						!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

						options.dataTypes.unshift( dataTypeOrTransport );
						inspect( dataTypeOrTransport );
						return false;
					} else if ( seekingTransport ) {
						return !( selected = dataTypeOrTransport );
					}
				} );
				return selected;
			}

			return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
		}

		// A special extend for ajax options
		// that takes "flat" options (not to be deep extended)
		// Fixes trac-9887
		function ajaxExtend( target, src ) {
			var key, deep,
				flatOptions = jQuery.ajaxSettings.flatOptions || {};

			for ( key in src ) {
				if ( src[ key ] !== undefined ) {
					( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
				}
			}
			if ( deep ) {
				jQuery.extend( true, target, deep );
			}

			return target;
		}

		/* Handles responses to an ajax request:
		 * - finds the right dataType (mediates between content-type and expected dataType)
		 * - returns the corresponding response
		 */
		function ajaxHandleResponses( s, jqXHR, responses ) {

			var ct, type, finalDataType, firstDataType,
				contents = s.contents,
				dataTypes = s.dataTypes;

			// Remove auto dataType and get content-type in the process
			while ( dataTypes[ 0 ] === "*" ) {
				dataTypes.shift();
				if ( ct === undefined ) {
					ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
				}
			}

			// Check if we're dealing with a known content-type
			if ( ct ) {
				for ( type in contents ) {
					if ( contents[ type ] && contents[ type ].test( ct ) ) {
						dataTypes.unshift( type );
						break;
					}
				}
			}

			// Check to see if we have a response for the expected dataType
			if ( dataTypes[ 0 ] in responses ) {
				finalDataType = dataTypes[ 0 ];
			} else {

				// Try convertible dataTypes
				for ( type in responses ) {
					if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
						finalDataType = type;
						break;
					}
					if ( !firstDataType ) {
						firstDataType = type;
					}
				}

				// Or just use first one
				finalDataType = finalDataType || firstDataType;
			}

			// If we found a dataType
			// We add the dataType to the list if needed
			// and return the corresponding response
			if ( finalDataType ) {
				if ( finalDataType !== dataTypes[ 0 ] ) {
					dataTypes.unshift( finalDataType );
				}
				return responses[ finalDataType ];
			}
		}

		/* Chain conversions given the request and the original response
		 * Also sets the responseXXX fields on the jqXHR instance
		 */
		function ajaxConvert( s, response, jqXHR, isSuccess ) {
			var conv2, current, conv, tmp, prev,
				converters = {},

				// Work with a copy of dataTypes in case we need to modify it for conversion
				dataTypes = s.dataTypes.slice();

			// Create converters map with lowercased keys
			if ( dataTypes[ 1 ] ) {
				for ( conv in s.converters ) {
					converters[ conv.toLowerCase() ] = s.converters[ conv ];
				}
			}

			current = dataTypes.shift();

			// Convert to each sequential dataType
			while ( current ) {

				if ( s.responseFields[ current ] ) {
					jqXHR[ s.responseFields[ current ] ] = response;
				}

				// Apply the dataFilter if provided
				if ( !prev && isSuccess && s.dataFilter ) {
					response = s.dataFilter( response, s.dataType );
				}

				prev = current;
				current = dataTypes.shift();

				if ( current ) {

					// There's only work to do if current dataType is non-auto
					if ( current === "*" ) {

						current = prev;

					// Convert response if prev dataType is non-auto and differs from current
					} else if ( prev !== "*" && prev !== current ) {

						// Seek a direct converter
						conv = converters[ prev + " " + current ] || converters[ "* " + current ];

						// If none found, seek a pair
						if ( !conv ) {
							for ( conv2 in converters ) {

								// If conv2 outputs current
								tmp = conv2.split( " " );
								if ( tmp[ 1 ] === current ) {

									// If prev can be converted to accepted input
									conv = converters[ prev + " " + tmp[ 0 ] ] ||
										converters[ "* " + tmp[ 0 ] ];
									if ( conv ) {

										// Condense equivalence converters
										if ( conv === true ) {
											conv = converters[ conv2 ];

										// Otherwise, insert the intermediate dataType
										} else if ( converters[ conv2 ] !== true ) {
											current = tmp[ 0 ];
											dataTypes.unshift( tmp[ 1 ] );
										}
										break;
									}
								}
							}
						}

						// Apply converter (if not an equivalence)
						if ( conv !== true ) {

							// Unless errors are allowed to bubble, catch and return them
							if ( conv && s.throws ) {
								response = conv( response );
							} else {
								try {
									response = conv( response );
								} catch ( e ) {
									return {
										state: "parsererror",
										error: conv ? e : "No conversion from " + prev + " to " + current
									};
								}
							}
						}
					}
				}
			}

			return { state: "success", data: response };
		}

		jQuery.extend( {

			// Counter for holding the number of active queries
			active: 0,

			// Last-Modified header cache for next request
			lastModified: {},
			etag: {},

			ajaxSettings: {
				url: location.href,
				type: "GET",
				isLocal: rlocalProtocol.test( location.protocol ),
				global: true,
				processData: true,
				async: true,
				contentType: "application/x-www-form-urlencoded; charset=UTF-8",

				/*
				timeout: 0,
				data: null,
				dataType: null,
				username: null,
				password: null,
				cache: null,
				throws: false,
				traditional: false,
				headers: {},
				*/

				accepts: {
					"*": allTypes,
					text: "text/plain",
					html: "text/html",
					xml: "application/xml, text/xml",
					json: "application/json, text/javascript"
				},

				contents: {
					xml: /\bxml\b/,
					html: /\bhtml/,
					json: /\bjson\b/
				},

				responseFields: {
					xml: "responseXML",
					text: "responseText",
					json: "responseJSON"
				},

				// Data converters
				// Keys separate source (or catchall "*") and destination types with a single space
				converters: {

					// Convert anything to text
					"* text": String,

					// Text to html (true = no transformation)
					"text html": true,

					// Evaluate text as a json expression
					"text json": JSON.parse,

					// Parse text as xml
					"text xml": jQuery.parseXML
				},

				// For options that shouldn't be deep extended:
				// you can add your own custom options here if
				// and when you create one that shouldn't be
				// deep extended (see ajaxExtend)
				flatOptions: {
					url: true,
					context: true
				}
			},

			// Creates a full fledged settings object into target
			// with both ajaxSettings and settings fields.
			// If target is omitted, writes into ajaxSettings.
			ajaxSetup: function( target, settings ) {
				return settings ?

					// Building a settings object
					ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

					// Extending ajaxSettings
					ajaxExtend( jQuery.ajaxSettings, target );
			},

			ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
			ajaxTransport: addToPrefiltersOrTransports( transports ),

			// Main method
			ajax: function( url, options ) {

				// If url is an object, simulate pre-1.5 signature
				if ( typeof url === "object" ) {
					options = url;
					url = undefined;
				}

				// Force options to be an object
				options = options || {};

				var transport,

					// URL without anti-cache param
					cacheURL,

					// Response headers
					responseHeadersString,
					responseHeaders,

					// timeout handle
					timeoutTimer,

					// Url cleanup var
					urlAnchor,

					// Request state (becomes false upon send and true upon completion)
					completed,

					// To know if global events are to be dispatched
					fireGlobals,

					// Loop variable
					i,

					// uncached part of the url
					uncached,

					// Create the final options object
					s = jQuery.ajaxSetup( {}, options ),

					// Callbacks context
					callbackContext = s.context || s,

					// Context for global events is callbackContext if it is a DOM node or jQuery collection
					globalEventContext = s.context &&
						( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,

					// Deferreds
					deferred = jQuery.Deferred(),
					completeDeferred = jQuery.Callbacks( "once memory" ),

					// Status-dependent callbacks
					statusCode = s.statusCode || {},

					// Headers (they are sent all at once)
					requestHeaders = {},
					requestHeadersNames = {},

					// Default abort message
					strAbort = "canceled",

					// Fake xhr
					jqXHR = {
						readyState: 0,

						// Builds headers hashtable if needed
						getResponseHeader: function( key ) {
							var match;
							if ( completed ) {
								if ( !responseHeaders ) {
									responseHeaders = {};
									while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
										responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
											( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
												.concat( match[ 2 ] );
									}
								}
								match = responseHeaders[ key.toLowerCase() + " " ];
							}
							return match == null ? null : match.join( ", " );
						},

						// Raw string
						getAllResponseHeaders: function() {
							return completed ? responseHeadersString : null;
						},

						// Caches the header
						setRequestHeader: function( name, value ) {
							if ( completed == null ) {
								name = requestHeadersNames[ name.toLowerCase() ] =
									requestHeadersNames[ name.toLowerCase() ] || name;
								requestHeaders[ name ] = value;
							}
							return this;
						},

						// Overrides response content-type header
						overrideMimeType: function( type ) {
							if ( completed == null ) {
								s.mimeType = type;
							}
							return this;
						},

						// Status-dependent callbacks
						statusCode: function( map ) {
							var code;
							if ( map ) {
								if ( completed ) {

									// Execute the appropriate callbacks
									jqXHR.always( map[ jqXHR.status ] );
								} else {

									// Lazy-add the new callbacks in a way that preserves old ones
									for ( code in map ) {
										statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
									}
								}
							}
							return this;
						},

						// Cancel the request
						abort: function( statusText ) {
							var finalText = statusText || strAbort;
							if ( transport ) {
								transport.abort( finalText );
							}
							done( 0, finalText );
							return this;
						}
					};

				// Attach deferreds
				deferred.promise( jqXHR );

				// Add protocol if not provided (prefilters might expect it)
				// Handle falsy url in the settings object (trac-10093: consistency with old signature)
				// We also use the url parameter if available
				s.url = ( ( url || s.url || location.href ) + "" )
					.replace( rprotocol, location.protocol + "//" );

				// Alias method option to type as per ticket trac-12004
				s.type = options.method || options.type || s.method || s.type;

				// Extract dataTypes list
				s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

				// A cross-domain request is in order when the origin doesn't match the current origin.
				if ( s.crossDomain == null ) {
					urlAnchor = document.createElement( "a" );

					// Support: IE <=8 - 11, Edge 12 - 15
					// IE throws exception on accessing the href property if url is malformed,
					// e.g. http://example.com:80x/
					try {
						urlAnchor.href = s.url;

						// Support: IE <=8 - 11 only
						// Anchor's host property isn't correctly set when s.url is relative
						urlAnchor.href = urlAnchor.href;
						s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
							urlAnchor.protocol + "//" + urlAnchor.host;
					} catch ( e ) {

						// If there is an error parsing the URL, assume it is crossDomain,
						// it can be rejected by the transport if it is invalid
						s.crossDomain = true;
					}
				}

				// Convert data if not already a string
				if ( s.data && s.processData && typeof s.data !== "string" ) {
					s.data = jQuery.param( s.data, s.traditional );
				}

				// Apply prefilters
				inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

				// If request was aborted inside a prefilter, stop there
				if ( completed ) {
					return jqXHR;
				}

				// We can fire global events as of now if asked to
				// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
				fireGlobals = jQuery.event && s.global;

				// Watch for a new set of requests
				if ( fireGlobals && jQuery.active++ === 0 ) {
					jQuery.event.trigger( "ajaxStart" );
				}

				// Uppercase the type
				s.type = s.type.toUpperCase();

				// Determine if request has content
				s.hasContent = !rnoContent.test( s.type );

				// Save the URL in case we're toying with the If-Modified-Since
				// and/or If-None-Match header later on
				// Remove hash to simplify url manipulation
				cacheURL = s.url.replace( rhash, "" );

				// More options handling for requests with no content
				if ( !s.hasContent ) {

					// Remember the hash so we can put it back
					uncached = s.url.slice( cacheURL.length );

					// If data is available and should be processed, append data to url
					if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
						cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

						// trac-9682: remove data so that it's not used in an eventual retry
						delete s.data;
					}

					// Add or update anti-cache param if needed
					if ( s.cache === false ) {
						cacheURL = cacheURL.replace( rantiCache, "$1" );
						uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
							uncached;
					}

					// Put hash and anti-cache on the URL that will be requested (gh-1732)
					s.url = cacheURL + uncached;

				// Change '%20' to '+' if this is encoded form body content (gh-2658)
				} else if ( s.data && s.processData &&
					( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
					s.data = s.data.replace( r20, "+" );
				}

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					if ( jQuery.lastModified[ cacheURL ] ) {
						jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
					}
					if ( jQuery.etag[ cacheURL ] ) {
						jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
					}
				}

				// Set the correct header, if data is being sent
				if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
					jqXHR.setRequestHeader( "Content-Type", s.contentType );
				}

				// Set the Accepts header for the server, depending on the dataType
				jqXHR.setRequestHeader(
					"Accept",
					s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
						s.accepts[ s.dataTypes[ 0 ] ] +
							( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
						s.accepts[ "*" ]
				);

				// Check for headers option
				for ( i in s.headers ) {
					jqXHR.setRequestHeader( i, s.headers[ i ] );
				}

				// Allow custom headers/mimetypes and early abort
				if ( s.beforeSend &&
					( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

					// Abort if not done already and return
					return jqXHR.abort();
				}

				// Aborting is no longer a cancellation
				strAbort = "abort";

				// Install callbacks on deferreds
				completeDeferred.add( s.complete );
				jqXHR.done( s.success );
				jqXHR.fail( s.error );

				// Get transport
				transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

				// If no transport, we auto-abort
				if ( !transport ) {
					done( -1, "No Transport" );
				} else {
					jqXHR.readyState = 1;

					// Send global event
					if ( fireGlobals ) {
						globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
					}

					// If request was aborted inside ajaxSend, stop there
					if ( completed ) {
						return jqXHR;
					}

					// Timeout
					if ( s.async && s.timeout > 0 ) {
						timeoutTimer = window.setTimeout( function() {
							jqXHR.abort( "timeout" );
						}, s.timeout );
					}

					try {
						completed = false;
						transport.send( requestHeaders, done );
					} catch ( e ) {

						// Rethrow post-completion exceptions
						if ( completed ) {
							throw e;
						}

						// Propagate others as results
						done( -1, e );
					}
				}

				// Callback for when everything is done
				function done( status, nativeStatusText, responses, headers ) {
					var isSuccess, success, error, response, modified,
						statusText = nativeStatusText;

					// Ignore repeat invocations
					if ( completed ) {
						return;
					}

					completed = true;

					// Clear timeout if it exists
					if ( timeoutTimer ) {
						window.clearTimeout( timeoutTimer );
					}

					// Dereference transport for early garbage collection
					// (no matter how long the jqXHR object will be used)
					transport = undefined;

					// Cache response headers
					responseHeadersString = headers || "";

					// Set readyState
					jqXHR.readyState = status > 0 ? 4 : 0;

					// Determine if successful
					isSuccess = status >= 200 && status < 300 || status === 304;

					// Get response data
					if ( responses ) {
						response = ajaxHandleResponses( s, jqXHR, responses );
					}

					// Use a noop converter for missing script but not if jsonp
					if ( !isSuccess &&
						jQuery.inArray( "script", s.dataTypes ) > -1 &&
						jQuery.inArray( "json", s.dataTypes ) < 0 ) {
						s.converters[ "text script" ] = function() {};
					}

					// Convert no matter what (that way responseXXX fields are always set)
					response = ajaxConvert( s, response, jqXHR, isSuccess );

					// If successful, handle type chaining
					if ( isSuccess ) {

						// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
						if ( s.ifModified ) {
							modified = jqXHR.getResponseHeader( "Last-Modified" );
							if ( modified ) {
								jQuery.lastModified[ cacheURL ] = modified;
							}
							modified = jqXHR.getResponseHeader( "etag" );
							if ( modified ) {
								jQuery.etag[ cacheURL ] = modified;
							}
						}

						// if no content
						if ( status === 204 || s.type === "HEAD" ) {
							statusText = "nocontent";

						// if not modified
						} else if ( status === 304 ) {
							statusText = "notmodified";

						// If we have data, let's convert it
						} else {
							statusText = response.state;
							success = response.data;
							error = response.error;
							isSuccess = !error;
						}
					} else {

						// Extract error from statusText and normalize for non-aborts
						error = statusText;
						if ( status || !statusText ) {
							statusText = "error";
							if ( status < 0 ) {
								status = 0;
							}
						}
					}

					// Set data for the fake xhr object
					jqXHR.status = status;
					jqXHR.statusText = ( nativeStatusText || statusText ) + "";

					// Success/Error
					if ( isSuccess ) {
						deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
					} else {
						deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
					}

					// Status-dependent callbacks
					jqXHR.statusCode( statusCode );
					statusCode = undefined;

					if ( fireGlobals ) {
						globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
							[ jqXHR, s, isSuccess ? success : error ] );
					}

					// Complete
					completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

					if ( fireGlobals ) {
						globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

						// Handle the global AJAX counter
						if ( !( --jQuery.active ) ) {
							jQuery.event.trigger( "ajaxStop" );
						}
					}
				}

				return jqXHR;
			},

			getJSON: function( url, data, callback ) {
				return jQuery.get( url, data, callback, "json" );
			},

			getScript: function( url, callback ) {
				return jQuery.get( url, undefined, callback, "script" );
			}
		} );

		jQuery.each( [ "get", "post" ], function( _i, method ) {
			jQuery[ method ] = function( url, data, callback, type ) {

				// Shift arguments if data argument was omitted
				if ( isFunction( data ) ) {
					type = type || callback;
					callback = data;
					data = undefined;
				}

				// The url can be an options object (which then must have .url)
				return jQuery.ajax( jQuery.extend( {
					url: url,
					type: method,
					dataType: type,
					data: data,
					success: callback
				}, jQuery.isPlainObject( url ) && url ) );
			};
		} );

		jQuery.ajaxPrefilter( function( s ) {
			var i;
			for ( i in s.headers ) {
				if ( i.toLowerCase() === "content-type" ) {
					s.contentType = s.headers[ i ] || "";
				}
			}
		} );


		jQuery._evalUrl = function( url, options, doc ) {
			return jQuery.ajax( {
				url: url,

				// Make this explicit, since user can override this through ajaxSetup (trac-11264)
				type: "GET",
				dataType: "script",
				cache: true,
				async: false,
				global: false,

				// Only evaluate the response if it is successful (gh-4126)
				// dataFilter is not invoked for failure responses, so using it instead
				// of the default converter is kludgy but it works.
				converters: {
					"text script": function() {}
				},
				dataFilter: function( response ) {
					jQuery.globalEval( response, options, doc );
				}
			} );
		};


		jQuery.fn.extend( {
			wrapAll: function( html ) {
				var wrap;

				if ( this[ 0 ] ) {
					if ( isFunction( html ) ) {
						html = html.call( this[ 0 ] );
					}

					// The elements to wrap the target around
					wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

					if ( this[ 0 ].parentNode ) {
						wrap.insertBefore( this[ 0 ] );
					}

					wrap.map( function() {
						var elem = this;

						while ( elem.firstElementChild ) {
							elem = elem.firstElementChild;
						}

						return elem;
					} ).append( this );
				}

				return this;
			},

			wrapInner: function( html ) {
				if ( isFunction( html ) ) {
					return this.each( function( i ) {
						jQuery( this ).wrapInner( html.call( this, i ) );
					} );
				}

				return this.each( function() {
					var self = jQuery( this ),
						contents = self.contents();

					if ( contents.length ) {
						contents.wrapAll( html );

					} else {
						self.append( html );
					}
				} );
			},

			wrap: function( html ) {
				var htmlIsFunction = isFunction( html );

				return this.each( function( i ) {
					jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
				} );
			},

			unwrap: function( selector ) {
				this.parent( selector ).not( "body" ).each( function() {
					jQuery( this ).replaceWith( this.childNodes );
				} );
				return this;
			}
		} );


		jQuery.expr.pseudos.hidden = function( elem ) {
			return !jQuery.expr.pseudos.visible( elem );
		};
		jQuery.expr.pseudos.visible = function( elem ) {
			return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
		};




		jQuery.ajaxSettings.xhr = function() {
			try {
				return new window.XMLHttpRequest();
			} catch ( e ) {}
		};

		var xhrSuccessStatus = {

				// File protocol always yields status code 0, assume 200
				0: 200,

				// Support: IE <=9 only
				// trac-1450: sometimes IE returns 1223 when it should be 204
				1223: 204
			},
			xhrSupported = jQuery.ajaxSettings.xhr();

		support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
		support.ajax = xhrSupported = !!xhrSupported;

		jQuery.ajaxTransport( function( options ) {
			var callback, errorCallback;

			// Cross domain only allowed if supported through XMLHttpRequest
			if ( support.cors || xhrSupported && !options.crossDomain ) {
				return {
					send: function( headers, complete ) {
						var i,
							xhr = options.xhr();

						xhr.open(
							options.type,
							options.url,
							options.async,
							options.username,
							options.password
						);

						// Apply custom fields if provided
						if ( options.xhrFields ) {
							for ( i in options.xhrFields ) {
								xhr[ i ] = options.xhrFields[ i ];
							}
						}

						// Override mime type if needed
						if ( options.mimeType && xhr.overrideMimeType ) {
							xhr.overrideMimeType( options.mimeType );
						}

						// X-Requested-With header
						// For cross-domain requests, seeing as conditions for a preflight are
						// akin to a jigsaw puzzle, we simply never set it to be sure.
						// (it can always be set on a per-request basis or even using ajaxSetup)
						// For same-domain requests, won't change header if already provided.
						if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
							headers[ "X-Requested-With" ] = "XMLHttpRequest";
						}

						// Set headers
						for ( i in headers ) {
							xhr.setRequestHeader( i, headers[ i ] );
						}

						// Callback
						callback = function( type ) {
							return function() {
								if ( callback ) {
									callback = errorCallback = xhr.onload =
										xhr.onerror = xhr.onabort = xhr.ontimeout =
											xhr.onreadystatechange = null;

									if ( type === "abort" ) {
										xhr.abort();
									} else if ( type === "error" ) {

										// Support: IE <=9 only
										// On a manual native abort, IE9 throws
										// errors on any property access that is not readyState
										if ( typeof xhr.status !== "number" ) {
											complete( 0, "error" );
										} else {
											complete(

												// File: protocol always yields status 0; see trac-8605, trac-14207
												xhr.status,
												xhr.statusText
											);
										}
									} else {
										complete(
											xhrSuccessStatus[ xhr.status ] || xhr.status,
											xhr.statusText,

											// Support: IE <=9 only
											// IE9 has no XHR2 but throws on binary (trac-11426)
											// For XHR2 non-text, let the caller handle it (gh-2498)
											( xhr.responseType || "text" ) !== "text"  ||
											typeof xhr.responseText !== "string" ?
												{ binary: xhr.response } :
												{ text: xhr.responseText },
											xhr.getAllResponseHeaders()
										);
									}
								}
							};
						};

						// Listen to events
						xhr.onload = callback();
						errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

						// Support: IE 9 only
						// Use onreadystatechange to replace onabort
						// to handle uncaught aborts
						if ( xhr.onabort !== undefined ) {
							xhr.onabort = errorCallback;
						} else {
							xhr.onreadystatechange = function() {

								// Check readyState before timeout as it changes
								if ( xhr.readyState === 4 ) {

									// Allow onerror to be called first,
									// but that will not handle a native abort
									// Also, save errorCallback to a variable
									// as xhr.onerror cannot be accessed
									window.setTimeout( function() {
										if ( callback ) {
											errorCallback();
										}
									} );
								}
							};
						}

						// Create the abort callback
						callback = callback( "abort" );

						try {

							// Do send the request (this may raise an exception)
							xhr.send( options.hasContent && options.data || null );
						} catch ( e ) {

							// trac-14683: Only rethrow if this hasn't been notified as an error yet
							if ( callback ) {
								throw e;
							}
						}
					},

					abort: function() {
						if ( callback ) {
							callback();
						}
					}
				};
			}
		} );




		// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
		jQuery.ajaxPrefilter( function( s ) {
			if ( s.crossDomain ) {
				s.contents.script = false;
			}
		} );

		// Install script dataType
		jQuery.ajaxSetup( {
			accepts: {
				script: "text/javascript, application/javascript, " +
					"application/ecmascript, application/x-ecmascript"
			},
			contents: {
				script: /\b(?:java|ecma)script\b/
			},
			converters: {
				"text script": function( text ) {
					jQuery.globalEval( text );
					return text;
				}
			}
		} );

		// Handle cache's special case and crossDomain
		jQuery.ajaxPrefilter( "script", function( s ) {
			if ( s.cache === undefined ) {
				s.cache = false;
			}
			if ( s.crossDomain ) {
				s.type = "GET";
			}
		} );

		// Bind script tag hack transport
		jQuery.ajaxTransport( "script", function( s ) {

			// This transport only deals with cross domain or forced-by-attrs requests
			if ( s.crossDomain || s.scriptAttrs ) {
				var script, callback;
				return {
					send: function( _, complete ) {
						script = jQuery( "<script>" )
							.attr( s.scriptAttrs || {} )
							.prop( { charset: s.scriptCharset, src: s.url } )
							.on( "load error", callback = function( evt ) {
								script.remove();
								callback = null;
								if ( evt ) {
									complete( evt.type === "error" ? 404 : 200, evt.type );
								}
							} );

						// Use native DOM manipulation to avoid our domManip AJAX trickery
						document.head.appendChild( script[ 0 ] );
					},
					abort: function() {
						if ( callback ) {
							callback();
						}
					}
				};
			}
		} );




		var oldCallbacks = [],
			rjsonp = /(=)\?(?=&|$)|\?\?/;

		// Default jsonp settings
		jQuery.ajaxSetup( {
			jsonp: "callback",
			jsonpCallback: function() {
				var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
				this[ callback ] = true;
				return callback;
			}
		} );

		// Detect, normalize options and install callbacks for jsonp requests
		jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

			var callbackName, overwritten, responseContainer,
				jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
					"url" :
					typeof s.data === "string" &&
						( s.contentType || "" )
							.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
						rjsonp.test( s.data ) && "data"
				);

			// Handle iff the expected data type is "jsonp" or we have a parameter to set
			if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

				// Get callback name, remembering preexisting value associated with it
				callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
					s.jsonpCallback() :
					s.jsonpCallback;

				// Insert callback into url or form data
				if ( jsonProp ) {
					s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
				} else if ( s.jsonp !== false ) {
					s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
				}

				// Use data converter to retrieve json after script execution
				s.converters[ "script json" ] = function() {
					if ( !responseContainer ) {
						jQuery.error( callbackName + " was not called" );
					}
					return responseContainer[ 0 ];
				};

				// Force json dataType
				s.dataTypes[ 0 ] = "json";

				// Install callback
				overwritten = window[ callbackName ];
				window[ callbackName ] = function() {
					responseContainer = arguments;
				};

				// Clean-up function (fires after converters)
				jqXHR.always( function() {

					// If previous value didn't exist - remove it
					if ( overwritten === undefined ) {
						jQuery( window ).removeProp( callbackName );

					// Otherwise restore preexisting value
					} else {
						window[ callbackName ] = overwritten;
					}

					// Save back as free
					if ( s[ callbackName ] ) {

						// Make sure that re-using the options doesn't screw things around
						s.jsonpCallback = originalSettings.jsonpCallback;

						// Save the callback name for future use
						oldCallbacks.push( callbackName );
					}

					// Call if it was a function and we have a response
					if ( responseContainer && isFunction( overwritten ) ) {
						overwritten( responseContainer[ 0 ] );
					}

					responseContainer = overwritten = undefined;
				} );

				// Delegate to script
				return "script";
			}
		} );




		// Support: Safari 8 only
		// In Safari 8 documents created via document.implementation.createHTMLDocument
		// collapse sibling forms: the second one becomes a child of the first one.
		// Because of that, this security measure has to be disabled in Safari 8.
		// https://bugs.webkit.org/show_bug.cgi?id=137337
		support.createHTMLDocument = ( function() {
			var body = document.implementation.createHTMLDocument( "" ).body;
			body.innerHTML = "<form></form><form></form>";
			return body.childNodes.length === 2;
		} )();


		// Argument "data" should be string of html
		// context (optional): If specified, the fragment will be created in this context,
		// defaults to document
		// keepScripts (optional): If true, will include scripts passed in the html string
		jQuery.parseHTML = function( data, context, keepScripts ) {
			if ( typeof data !== "string" ) {
				return [];
			}
			if ( typeof context === "boolean" ) {
				keepScripts = context;
				context = false;
			}

			var base, parsed, scripts;

			if ( !context ) {

				// Stop scripts or inline event handlers from being executed immediately
				// by using document.implementation
				if ( support.createHTMLDocument ) {
					context = document.implementation.createHTMLDocument( "" );

					// Set the base href for the created document
					// so any parsed elements with URLs
					// are based on the document's URL (gh-2965)
					base = context.createElement( "base" );
					base.href = document.location.href;
					context.head.appendChild( base );
				} else {
					context = document;
				}
			}

			parsed = rsingleTag.exec( data );
			scripts = !keepScripts && [];

			// Single tag
			if ( parsed ) {
				return [ context.createElement( parsed[ 1 ] ) ];
			}

			parsed = buildFragment( [ data ], context, scripts );

			if ( scripts && scripts.length ) {
				jQuery( scripts ).remove();
			}

			return jQuery.merge( [], parsed.childNodes );
		};


		/**
		 * Load a url into a page
		 */
		jQuery.fn.load = function( url, params, callback ) {
			var selector, type, response,
				self = this,
				off = url.indexOf( " " );

			if ( off > -1 ) {
				selector = stripAndCollapse( url.slice( off ) );
				url = url.slice( 0, off );
			}

			// If it's a function
			if ( isFunction( params ) ) {

				// We assume that it's the callback
				callback = params;
				params = undefined;

			// Otherwise, build a param string
			} else if ( params && typeof params === "object" ) {
				type = "POST";
			}

			// If we have elements to modify, make the request
			if ( self.length > 0 ) {
				jQuery.ajax( {
					url: url,

					// If "type" variable is undefined, then "GET" method will be used.
					// Make value of this field explicit since
					// user can override it through ajaxSetup method
					type: type || "GET",
					dataType: "html",
					data: params
				} ).done( function( responseText ) {

					// Save response for use in complete callback
					response = arguments;

					self.html( selector ?

						// If a selector was specified, locate the right elements in a dummy div
						// Exclude scripts to avoid IE 'Permission Denied' errors
						jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

						// Otherwise use the full result
						responseText );

				// If the request succeeds, this function gets "data", "status", "jqXHR"
				// but they are ignored because response was set above.
				// If it fails, this function gets "jqXHR", "status", "error"
				} ).always( callback && function( jqXHR, status ) {
					self.each( function() {
						callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
					} );
				} );
			}

			return this;
		};




		jQuery.expr.pseudos.animated = function( elem ) {
			return jQuery.grep( jQuery.timers, function( fn ) {
				return elem === fn.elem;
			} ).length;
		};




		jQuery.offset = {
			setOffset: function( elem, options, i ) {
				var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
					position = jQuery.css( elem, "position" ),
					curElem = jQuery( elem ),
					props = {};

				// Set position first, in-case top/left are set even on static elem
				if ( position === "static" ) {
					elem.style.position = "relative";
				}

				curOffset = curElem.offset();
				curCSSTop = jQuery.css( elem, "top" );
				curCSSLeft = jQuery.css( elem, "left" );
				calculatePosition = ( position === "absolute" || position === "fixed" ) &&
					( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

				// Need to be able to calculate position if either
				// top or left is auto and position is either absolute or fixed
				if ( calculatePosition ) {
					curPosition = curElem.position();
					curTop = curPosition.top;
					curLeft = curPosition.left;

				} else {
					curTop = parseFloat( curCSSTop ) || 0;
					curLeft = parseFloat( curCSSLeft ) || 0;
				}

				if ( isFunction( options ) ) {

					// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
					options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
				}

				if ( options.top != null ) {
					props.top = ( options.top - curOffset.top ) + curTop;
				}
				if ( options.left != null ) {
					props.left = ( options.left - curOffset.left ) + curLeft;
				}

				if ( "using" in options ) {
					options.using.call( elem, props );

				} else {
					curElem.css( props );
				}
			}
		};

		jQuery.fn.extend( {

			// offset() relates an element's border box to the document origin
			offset: function( options ) {

				// Preserve chaining for setter
				if ( arguments.length ) {
					return options === undefined ?
						this :
						this.each( function( i ) {
							jQuery.offset.setOffset( this, options, i );
						} );
				}

				var rect, win,
					elem = this[ 0 ];

				if ( !elem ) {
					return;
				}

				// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
				// Support: IE <=11 only
				// Running getBoundingClientRect on a
				// disconnected node in IE throws an error
				if ( !elem.getClientRects().length ) {
					return { top: 0, left: 0 };
				}

				// Get document-relative position by adding viewport scroll to viewport-relative gBCR
				rect = elem.getBoundingClientRect();
				win = elem.ownerDocument.defaultView;
				return {
					top: rect.top + win.pageYOffset,
					left: rect.left + win.pageXOffset
				};
			},

			// position() relates an element's margin box to its offset parent's padding box
			// This corresponds to the behavior of CSS absolute positioning
			position: function() {
				if ( !this[ 0 ] ) {
					return;
				}

				var offsetParent, offset, doc,
					elem = this[ 0 ],
					parentOffset = { top: 0, left: 0 };

				// position:fixed elements are offset from the viewport, which itself always has zero offset
				if ( jQuery.css( elem, "position" ) === "fixed" ) {

					// Assume position:fixed implies availability of getBoundingClientRect
					offset = elem.getBoundingClientRect();

				} else {
					offset = this.offset();

					// Account for the *real* offset parent, which can be the document or its root element
					// when a statically positioned element is identified
					doc = elem.ownerDocument;
					offsetParent = elem.offsetParent || doc.documentElement;
					while ( offsetParent &&
						( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
						jQuery.css( offsetParent, "position" ) === "static" ) {

						offsetParent = offsetParent.parentNode;
					}
					if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

						// Incorporate borders into its offset, since they are outside its content origin
						parentOffset = jQuery( offsetParent ).offset();
						parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
						parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
					}
				}

				// Subtract parent offsets and element margins
				return {
					top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
					left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
				};
			},

			// This method will return documentElement in the following cases:
			// 1) For the element inside the iframe without offsetParent, this method will return
			//    documentElement of the parent window
			// 2) For the hidden or detached element
			// 3) For body or html element, i.e. in case of the html node - it will return itself
			//
			// but those exceptions were never presented as a real life use-cases
			// and might be considered as more preferable results.
			//
			// This logic, however, is not guaranteed and can change at any point in the future
			offsetParent: function() {
				return this.map( function() {
					var offsetParent = this.offsetParent;

					while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
						offsetParent = offsetParent.offsetParent;
					}

					return offsetParent || documentElement;
				} );
			}
		} );

		// Create scrollLeft and scrollTop methods
		jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
			var top = "pageYOffset" === prop;

			jQuery.fn[ method ] = function( val ) {
				return access( this, function( elem, method, val ) {

					// Coalesce documents and windows
					var win;
					if ( isWindow( elem ) ) {
						win = elem;
					} else if ( elem.nodeType === 9 ) {
						win = elem.defaultView;
					}

					if ( val === undefined ) {
						return win ? win[ prop ] : elem[ method ];
					}

					if ( win ) {
						win.scrollTo(
							!top ? val : win.pageXOffset,
							top ? val : win.pageYOffset
						);

					} else {
						elem[ method ] = val;
					}
				}, method, val, arguments.length );
			};
		} );

		// Support: Safari <=7 - 9.1, Chrome <=37 - 49
		// Add the top/left cssHooks using jQuery.fn.position
		// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
		// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
		// getComputedStyle returns percent when specified for top/left/bottom/right;
		// rather than make the css module depend on the offset module, just check for it here
		jQuery.each( [ "top", "left" ], function( _i, prop ) {
			jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
				function( elem, computed ) {
					if ( computed ) {
						computed = curCSS( elem, prop );

						// If curCSS returns percentage, fallback to offset
						return rnumnonpx.test( computed ) ?
							jQuery( elem ).position()[ prop ] + "px" :
							computed;
					}
				}
			);
		} );


		// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
		jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
			jQuery.each( {
				padding: "inner" + name,
				content: type,
				"": "outer" + name
			}, function( defaultExtra, funcName ) {

				// Margin is only for outerHeight, outerWidth
				jQuery.fn[ funcName ] = function( margin, value ) {
					var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
						extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

					return access( this, function( elem, type, value ) {
						var doc;

						if ( isWindow( elem ) ) {

							// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
							return funcName.indexOf( "outer" ) === 0 ?
								elem[ "inner" + name ] :
								elem.document.documentElement[ "client" + name ];
						}

						// Get document width or height
						if ( elem.nodeType === 9 ) {
							doc = elem.documentElement;

							// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
							// whichever is greatest
							return Math.max(
								elem.body[ "scroll" + name ], doc[ "scroll" + name ],
								elem.body[ "offset" + name ], doc[ "offset" + name ],
								doc[ "client" + name ]
							);
						}

						return value === undefined ?

							// Get width or height on the element, requesting but not forcing parseFloat
							jQuery.css( elem, type, extra ) :

							// Set width or height on the element
							jQuery.style( elem, type, value, extra );
					}, type, chainable ? margin : undefined, chainable );
				};
			} );
		} );


		jQuery.each( [
			"ajaxStart",
			"ajaxStop",
			"ajaxComplete",
			"ajaxError",
			"ajaxSuccess",
			"ajaxSend"
		], function( _i, type ) {
			jQuery.fn[ type ] = function( fn ) {
				return this.on( type, fn );
			};
		} );




		jQuery.fn.extend( {

			bind: function( types, data, fn ) {
				return this.on( types, null, data, fn );
			},
			unbind: function( types, fn ) {
				return this.off( types, null, fn );
			},

			delegate: function( selector, types, data, fn ) {
				return this.on( types, selector, data, fn );
			},
			undelegate: function( selector, types, fn ) {

				// ( namespace ) or ( selector, types [, fn] )
				return arguments.length === 1 ?
					this.off( selector, "**" ) :
					this.off( types, selector || "**", fn );
			},

			hover: function( fnOver, fnOut ) {
				return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
			}
		} );

		jQuery.each(
			( "blur focus focusin focusout resize scroll click dblclick " +
			"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
			"change select submit keydown keypress keyup contextmenu" ).split( " " ),
			function( _i, name ) {

				// Handle event binding
				jQuery.fn[ name ] = function( data, fn ) {
					return arguments.length > 0 ?
						this.on( name, null, data, fn ) :
						this.trigger( name );
				};
			}
		);




		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		// Require that the "whitespace run" starts from a non-whitespace
		// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
		var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

		// Bind a function to a context, optionally partially applying any
		// arguments.
		// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
		// However, it is not slated for removal any time soon
		jQuery.proxy = function( fn, context ) {
			var tmp, args, proxy;

			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}

			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !isFunction( fn ) ) {
				return undefined;
			}

			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};

			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;

			return proxy;
		};

		jQuery.holdReady = function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		};
		jQuery.isArray = Array.isArray;
		jQuery.parseJSON = JSON.parse;
		jQuery.nodeName = nodeName;
		jQuery.isFunction = isFunction;
		jQuery.isWindow = isWindow;
		jQuery.camelCase = camelCase;
		jQuery.type = toType;

		jQuery.now = Date.now;

		jQuery.isNumeric = function( obj ) {

			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&

				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		};

		jQuery.trim = function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "$1" );
		};




		var

			// Map over jQuery in case of overwrite
			_jQuery = window.jQuery,

			// Map over the $ in case of overwrite
			_$ = window.$;

		jQuery.noConflict = function( deep ) {
			if ( window.$ === jQuery ) {
				window.$ = _$;
			}

			if ( deep && window.jQuery === jQuery ) {
				window.jQuery = _jQuery;
			}

			return jQuery;
		};

		// Expose jQuery and $ identifiers, even in AMD
		// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
		// and CommonJS for browser emulators (trac-13566)
		if ( typeof noGlobal === "undefined" ) {
			window.jQuery = window.$ = jQuery;
		}




		return jQuery;
		} ); 
	} (jquery));

	var jqueryExports = jquery.exports;
	var $ = /*@__PURE__*/getDefaultExportFromCjs(jqueryExports);

	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof_1 = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof_1 = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof(obj);
	}

	var _typeof_1 = _typeof;

	var _typeof$1 = /*@__PURE__*/getDefaultExportFromCjs(_typeof_1);

	var swiper_min = {exports: {}};

	(function (module, exports) {
	  !function (e, t) {
	    module.exports = t() ;
	  }(commonjsGlobal, function () {

	    function e(e, t) {
	      for (var _a = 0; _a < t.length; _a++) {
	        var _i = t[_a];
	        _i.enumerable = _i.enumerable || !1, _i.configurable = !0, 'value' in _i && (_i.writable = !0), Object.defineProperty(e, _i.key, _i);
	      }
	    }

	    function t() {
	      return (t = Object.assign || function (e) {
	        for (var _t = 1; _t < arguments.length; _t++) {
	          var _a2 = arguments[_t];

	          for (var _i2 in _a2) {
	            Object.prototype.hasOwnProperty.call(_a2, _i2) && (e[_i2] = _a2[_i2]);
	          }
	        }

	        return e;
	      }).apply(this, arguments);
	    }

	    function a(e) {
	      return null !== e && 'object' == _typeof$1(e) && 'constructor' in e && e.constructor === Object;
	    }

	    function i(e, t) {
	      void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach(function (s) {
	        void 0 === e[s] ? e[s] = t[s] : a(t[s]) && a(e[s]) && Object.keys(t[s]).length > 0 && i(e[s], t[s]);
	      });
	    }

	    var s = {
	      body: {},
	      addEventListener: function addEventListener() {},
	      removeEventListener: function removeEventListener() {},
	      activeElement: {
	        blur: function blur() {},
	        nodeName: ''
	      },
	      querySelector: function querySelector() {
	        return null;
	      },
	      querySelectorAll: function querySelectorAll() {
	        return [];
	      },
	      getElementById: function getElementById() {
	        return null;
	      },
	      createEvent: function createEvent() {
	        return {
	          initEvent: function initEvent() {}
	        };
	      },
	      createElement: function createElement() {
	        return {
	          children: [],
	          childNodes: [],
	          style: {},
	          setAttribute: function setAttribute() {},
	          getElementsByTagName: function getElementsByTagName() {
	            return [];
	          }
	        };
	      },
	      createElementNS: function createElementNS() {
	        return {};
	      },
	      importNode: function importNode() {
	        return null;
	      },
	      location: {
	        hash: '',
	        host: '',
	        hostname: '',
	        href: '',
	        origin: '',
	        pathname: '',
	        protocol: '',
	        search: ''
	      }
	    };

	    function r() {
	      var e = 'undefined' != typeof document ? document : {};
	      return i(e, s), e;
	    }

	    var n = {
	      document: s,
	      navigator: {
	        userAgent: ''
	      },
	      location: {
	        hash: '',
	        host: '',
	        hostname: '',
	        href: '',
	        origin: '',
	        pathname: '',
	        protocol: '',
	        search: ''
	      },
	      history: {
	        replaceState: function replaceState() {},
	        pushState: function pushState() {},
	        go: function go() {},
	        back: function back() {}
	      },
	      CustomEvent: function CustomEvent() {
	        return this;
	      },
	      addEventListener: function addEventListener() {},
	      removeEventListener: function removeEventListener() {},
	      getComputedStyle: function getComputedStyle() {
	        return {
	          getPropertyValue: function getPropertyValue() {
	            return '';
	          }
	        };
	      },
	      Image: function Image() {},
	      Date: function Date() {},
	      screen: {},
	      setTimeout: function setTimeout() {},
	      clearTimeout: function clearTimeout() {},
	      matchMedia: function matchMedia() {
	        return {};
	      },
	      requestAnimationFrame: function requestAnimationFrame(e) {
	        return 'undefined' == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
	      },
	      cancelAnimationFrame: function cancelAnimationFrame(e) {
	        'undefined' != typeof setTimeout && clearTimeout(e);
	      }
	    };

	    function l() {
	      var e = 'undefined' != typeof window ? window : {};
	      return i(e, n), e;
	    }

	    function o(e) {
	      return (o = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
	        return e.__proto__ || Object.getPrototypeOf(e);
	      })(e);
	    }

	    function d(e, t) {
	      return (d = Object.setPrototypeOf || function (e, t) {
	        return e.__proto__ = t, e;
	      })(e, t);
	    }

	    function p() {
	      if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
	      if (Reflect.construct.sham) return !1;
	      if ('function' == typeof Proxy) return !0;

	      try {
	        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
	      } catch (e) {
	        return !1;
	      }
	    }

	    function u(e, t, a) {
	      return (u = p() ? Reflect.construct : function (e, t, a) {
	        var i = [null];
	        i.push.apply(i, t);
	        var s = new (Function.bind.apply(e, i))();
	        return a && d(s, a.prototype), s;
	      }).apply(null, arguments);
	    }

	    function c(e) {
	      var t = 'function' == typeof Map ? new Map() : void 0;
	      return (c = function c(e) {
	        if (null === e || (a = e, -1 === Function.toString.call(a).indexOf('[native code]'))) return e;
	        var a;
	        if ('function' != typeof e) throw new TypeError('Super expression must either be null or a function');

	        if (void 0 !== t) {
	          if (t.has(e)) return t.get(e);
	          t.set(e, i);
	        }

	        function i() {
	          return u(e, arguments, o(this).constructor);
	        }

	        return i.prototype = Object.create(e.prototype, {
	          constructor: {
	            value: i,
	            enumerable: !1,
	            writable: !0,
	            configurable: !0
	          }
	        }), d(i, e);
	      })(e);
	    }

	    var h = function (e) {
	      var t, a;

	      function i(t) {
	        var a, i, s;
	        return a = e.call.apply(e, [this].concat(t)) || this, i = function (e) {
	          if (void 0 === e) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
	          return e;
	        }(a), s = i.__proto__, Object.defineProperty(i, '__proto__', {
	          get: function get() {
	            return s;
	          },
	          set: function set(e) {
	            s.__proto__ = e;
	          }
	        }), a;
	      }

	      return a = e, (t = i).prototype = Object.create(a.prototype), t.prototype.constructor = t, t.__proto__ = a, i;
	    }(c(Array));

	    function v(e) {
	      void 0 === e && (e = []);
	      var t = [];
	      return e.forEach(function (e) {
	        Array.isArray(e) ? t.push.apply(t, v(e)) : t.push(e);
	      }), t;
	    }

	    function f(e, t) {
	      return Array.prototype.filter.call(e, t);
	    }

	    function m(e, t) {
	      var a = l(),
	          i = r(),
	          s = [];
	      if (!t && e instanceof h) return e;
	      if (!e) return new h(s);

	      if ('string' == typeof e) {
	        var _n = e.trim();

	        if (_n.indexOf('<') >= 0 && _n.indexOf('>') >= 0) {
	          var _o = 'div';
	          0 === _n.indexOf('<li') && (_o = 'ul'), 0 === _n.indexOf('<tr') && (_o = 'tbody'), 0 !== _n.indexOf('<td') && 0 !== _n.indexOf('<th') || (_o = 'tr'), 0 === _n.indexOf('<tbody') && (_o = 'table'), 0 === _n.indexOf('<option') && (_o = 'select');

	          var _d = i.createElement(_o);

	          _d.innerHTML = _n;

	          for (var _p = 0; _p < _d.childNodes.length; _p += 1) {
	            s.push(_d.childNodes[_p]);
	          }
	        } else s = function (e, t) {
	          if ('string' != typeof e) return [e];

	          for (var a = [], i = t.querySelectorAll(e), s = 0; s < i.length; s += 1) {
	            a.push(i[s]);
	          }

	          return a;
	        }(e.trim(), t || i);
	      } else if (e.nodeType || e === a || e === i) s.push(e);else if (Array.isArray(e)) {
	        if (e instanceof h) return e;
	        s = e;
	      }

	      return new h(function (e) {
	        for (var t = [], a = 0; a < e.length; a += 1) {
	          -1 === t.indexOf(e[a]) && t.push(e[a]);
	        }

	        return t;
	      }(s));
	    }

	    m.fn = h.prototype;
	    var g,
	        b,
	        w,
	        y = {
	      addClass: function addClass() {
	        for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
	          t[a] = arguments[a];
	        }

	        var i = v(t.map(function (e) {
	          return e.split(' ');
	        }));
	        return this.forEach(function (e) {
	          var t;
	          (t = e.classList).add.apply(t, i);
	        }), this;
	      },
	      removeClass: function removeClass() {
	        for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
	          t[a] = arguments[a];
	        }

	        var i = v(t.map(function (e) {
	          return e.split(' ');
	        }));
	        return this.forEach(function (e) {
	          var t;
	          (t = e.classList).remove.apply(t, i);
	        }), this;
	      },
	      hasClass: function hasClass() {
	        for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
	          t[a] = arguments[a];
	        }

	        var i = v(t.map(function (e) {
	          return e.split(' ');
	        }));
	        return f(this, function (e) {
	          return i.filter(function (t) {
	            return e.classList.contains(t);
	          }).length > 0;
	        }).length > 0;
	      },
	      toggleClass: function toggleClass() {
	        for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
	          t[a] = arguments[a];
	        }

	        var i = v(t.map(function (e) {
	          return e.split(' ');
	        }));
	        this.forEach(function (e) {
	          i.forEach(function (t) {
	            e.classList.toggle(t);
	          });
	        });
	      },
	      attr: function attr(e, t) {
	        if (1 === arguments.length && 'string' == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;

	        for (var _a3 = 0; _a3 < this.length; _a3 += 1) {
	          if (2 === arguments.length) this[_a3].setAttribute(e, t);else for (var _i3 in e) {
	            this[_a3][_i3] = e[_i3], this[_a3].setAttribute(_i3, e[_i3]);
	          }
	        }

	        return this;
	      },
	      removeAttr: function removeAttr(e) {
	        for (var _t2 = 0; _t2 < this.length; _t2 += 1) {
	          this[_t2].removeAttribute(e);
	        }

	        return this;
	      },
	      transform: function transform(e) {
	        for (var _t3 = 0; _t3 < this.length; _t3 += 1) {
	          this[_t3].style.transform = e;
	        }

	        return this;
	      },
	      transition: function transition(e) {
	        for (var _t4 = 0; _t4 < this.length; _t4 += 1) {
	          this[_t4].style.transitionDuration = 'string' != typeof e ? e + 'ms' : e;
	        }

	        return this;
	      },
	      on: function on() {
	        for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
	          t[a] = arguments[a];
	        }

	        var i = t[0],
	            s = t[1],
	            r = t[2],
	            n = t[3];

	        function l(e) {
	          var t = e.target;

	          if (t) {
	            var _a4 = e.target.dom7EventData || [];

	            if (_a4.indexOf(e) < 0 && _a4.unshift(e), m(t).is(s)) r.apply(t, _a4);else for (var _i4 = m(t).parents(), _n2 = 0; _n2 < _i4.length; _n2 += 1) {
	              m(_i4[_n2]).is(s) && r.apply(_i4[_n2], _a4);
	            }
	          }
	        }

	        function o(e) {
	          var t = e && e.target && e.target.dom7EventData || [];
	          t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t);
	        }

	        'function' == typeof t[1] && (i = t[0], r = t[1], n = t[2], s = void 0), n || (n = !1);

	        for (var d, p = i.split(' '), u = 0; u < this.length; u += 1) {
	          var _c = this[u];
	          if (s) for (d = 0; d < p.length; d += 1) {
	            var _h = p[d];
	            _c.dom7LiveListeners || (_c.dom7LiveListeners = {}), _c.dom7LiveListeners[_h] || (_c.dom7LiveListeners[_h] = []), _c.dom7LiveListeners[_h].push({
	              listener: r,
	              proxyListener: l
	            }), _c.addEventListener(_h, l, n);
	          } else for (d = 0; d < p.length; d += 1) {
	            var _v = p[d];
	            _c.dom7Listeners || (_c.dom7Listeners = {}), _c.dom7Listeners[_v] || (_c.dom7Listeners[_v] = []), _c.dom7Listeners[_v].push({
	              listener: r,
	              proxyListener: o
	            }), _c.addEventListener(_v, o, n);
	          }
	        }

	        return this;
	      },
	      off: function off() {
	        for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
	          t[a] = arguments[a];
	        }

	        var i = t[0],
	            s = t[1],
	            r = t[2],
	            n = t[3];
	        'function' == typeof t[1] && (i = t[0], r = t[1], n = t[2], s = void 0), n || (n = !1);

	        for (var _l = i.split(' '), _o2 = 0; _o2 < _l.length; _o2 += 1) {
	          for (var _d2 = _l[_o2], _p2 = 0; _p2 < this.length; _p2 += 1) {
	            var _u = this[_p2],
	                _c2 = void 0;

	            if (!s && _u.dom7Listeners ? _c2 = _u.dom7Listeners[_d2] : s && _u.dom7LiveListeners && (_c2 = _u.dom7LiveListeners[_d2]), _c2 && _c2.length) for (var _h2 = _c2.length - 1; _h2 >= 0; _h2 -= 1) {
	              var _v2 = _c2[_h2];
	              r && _v2.listener === r || r && _v2.listener && _v2.listener.dom7proxy && _v2.listener.dom7proxy === r ? (_u.removeEventListener(_d2, _v2.proxyListener, n), _c2.splice(_h2, 1)) : r || (_u.removeEventListener(_d2, _v2.proxyListener, n), _c2.splice(_h2, 1));
	            }
	          }
	        }

	        return this;
	      },
	      trigger: function trigger() {
	        for (var e = l(), t = arguments.length, a = new Array(t), i = 0; i < t; i++) {
	          a[i] = arguments[i];
	        }

	        for (var _s = a[0].split(' '), _r = a[1], _n3 = 0; _n3 < _s.length; _n3 += 1) {
	          for (var _o3 = _s[_n3], _d3 = 0; _d3 < this.length; _d3 += 1) {
	            var _p3 = this[_d3];

	            if (e.CustomEvent) {
	              var _u2 = new e.CustomEvent(_o3, {
	                detail: _r,
	                bubbles: !0,
	                cancelable: !0
	              });

	              _p3.dom7EventData = a.filter(function (e, t) {
	                return t > 0;
	              }), _p3.dispatchEvent(_u2), _p3.dom7EventData = [], delete _p3.dom7EventData;
	            }
	          }
	        }

	        return this;
	      },
	      transitionEnd: function transitionEnd(e) {
	        var t = this;
	        return e && t.on('transitionend', function a(i) {
	          i.target === this && (e.call(this, i), t.off('transitionend', a));
	        }), this;
	      },
	      outerWidth: function outerWidth(e) {
	        if (this.length > 0) {
	          if (e) {
	            var _t5 = this.styles();

	            return this[0].offsetWidth + parseFloat(_t5.getPropertyValue('margin-right')) + parseFloat(_t5.getPropertyValue('margin-left'));
	          }

	          return this[0].offsetWidth;
	        }

	        return null;
	      },
	      outerHeight: function outerHeight(e) {
	        if (this.length > 0) {
	          if (e) {
	            var _t6 = this.styles();

	            return this[0].offsetHeight + parseFloat(_t6.getPropertyValue('margin-top')) + parseFloat(_t6.getPropertyValue('margin-bottom'));
	          }

	          return this[0].offsetHeight;
	        }

	        return null;
	      },
	      styles: function styles() {
	        var e = l();
	        return this[0] ? e.getComputedStyle(this[0], null) : {};
	      },
	      offset: function offset() {
	        if (this.length > 0) {
	          var _e = l(),
	              _t7 = r(),
	              _a5 = this[0],
	              _i5 = _a5.getBoundingClientRect(),
	              _s2 = _t7.body,
	              _n4 = _a5.clientTop || _s2.clientTop || 0,
	              _o4 = _a5.clientLeft || _s2.clientLeft || 0,
	              _d4 = _a5 === _e ? _e.scrollY : _a5.scrollTop,
	              _p4 = _a5 === _e ? _e.scrollX : _a5.scrollLeft;

	          return {
	            top: _i5.top + _d4 - _n4,
	            left: _i5.left + _p4 - _o4
	          };
	        }

	        return null;
	      },
	      css: function css(e, t) {
	        var a,
	            i = l();

	        if (1 === arguments.length) {
	          if ('string' != typeof e) {
	            for (a = 0; a < this.length; a += 1) {
	              for (var _s3 in e) {
	                this[a].style[_s3] = e[_s3];
	              }
	            }

	            return this;
	          }

	          if (this[0]) return i.getComputedStyle(this[0], null).getPropertyValue(e);
	        }

	        if (2 === arguments.length && 'string' == typeof e) {
	          for (a = 0; a < this.length; a += 1) {
	            this[a].style[e] = t;
	          }

	          return this;
	        }

	        return this;
	      },
	      each: function each(e) {
	        return e ? (this.forEach(function (t, a) {
	          e.apply(t, [t, a]);
	        }), this) : this;
	      },
	      html: function html(e) {
	        if (void 0 === e) return this[0] ? this[0].innerHTML : null;

	        for (var _t8 = 0; _t8 < this.length; _t8 += 1) {
	          this[_t8].innerHTML = e;
	        }

	        return this;
	      },
	      text: function text(e) {
	        if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;

	        for (var _t9 = 0; _t9 < this.length; _t9 += 1) {
	          this[_t9].textContent = e;
	        }

	        return this;
	      },
	      is: function is(e) {
	        var t,
	            a,
	            i = l(),
	            s = r(),
	            n = this[0];
	        if (!n || void 0 === e) return !1;

	        if ('string' == typeof e) {
	          if (n.matches) return n.matches(e);
	          if (n.webkitMatchesSelector) return n.webkitMatchesSelector(e);
	          if (n.msMatchesSelector) return n.msMatchesSelector(e);

	          for (t = m(e), a = 0; a < t.length; a += 1) {
	            if (t[a] === n) return !0;
	          }

	          return !1;
	        }

	        if (e === s) return n === s;
	        if (e === i) return n === i;

	        if (e.nodeType || e instanceof h) {
	          for (t = e.nodeType ? [e] : e, a = 0; a < t.length; a += 1) {
	            if (t[a] === n) return !0;
	          }

	          return !1;
	        }

	        return !1;
	      },
	      index: function index() {
	        var e,
	            t = this[0];

	        if (t) {
	          for (e = 0; null !== (t = t.previousSibling);) {
	            1 === t.nodeType && (e += 1);
	          }

	          return e;
	        }
	      },
	      eq: function eq(e) {
	        if (void 0 === e) return this;
	        var t = this.length;
	        if (e > t - 1) return m([]);

	        if (e < 0) {
	          var _a6 = t + e;

	          return m(_a6 < 0 ? [] : [this[_a6]]);
	        }

	        return m([this[e]]);
	      },
	      append: function append() {
	        for (var e, t = r(), a = 0; a < arguments.length; a += 1) {
	          e = a < 0 || arguments.length <= a ? void 0 : arguments[a];

	          for (var _i6 = 0; _i6 < this.length; _i6 += 1) {
	            if ('string' == typeof e) {
	              var _s4 = t.createElement('div');

	              for (_s4.innerHTML = e; _s4.firstChild;) {
	                this[_i6].appendChild(_s4.firstChild);
	              }
	            } else if (e instanceof h) for (var _n5 = 0; _n5 < e.length; _n5 += 1) {
	              this[_i6].appendChild(e[_n5]);
	            } else this[_i6].appendChild(e);
	          }
	        }

	        return this;
	      },
	      prepend: function prepend(e) {
	        var t,
	            a,
	            i = r();

	        for (t = 0; t < this.length; t += 1) {
	          if ('string' == typeof e) {
	            var _s5 = i.createElement('div');

	            for (_s5.innerHTML = e, a = _s5.childNodes.length - 1; a >= 0; a -= 1) {
	              this[t].insertBefore(_s5.childNodes[a], this[t].childNodes[0]);
	            }
	          } else if (e instanceof h) for (a = 0; a < e.length; a += 1) {
	            this[t].insertBefore(e[a], this[t].childNodes[0]);
	          } else this[t].insertBefore(e, this[t].childNodes[0]);
	        }

	        return this;
	      },
	      next: function next(e) {
	        return this.length > 0 ? e ? this[0].nextElementSibling && m(this[0].nextElementSibling).is(e) ? m([this[0].nextElementSibling]) : m([]) : this[0].nextElementSibling ? m([this[0].nextElementSibling]) : m([]) : m([]);
	      },
	      nextAll: function nextAll(e) {
	        var t = [],
	            a = this[0];
	        if (!a) return m([]);

	        for (; a.nextElementSibling;) {
	          var _i7 = a.nextElementSibling;
	          e ? m(_i7).is(e) && t.push(_i7) : t.push(_i7), a = _i7;
	        }

	        return m(t);
	      },
	      prev: function prev(e) {
	        if (this.length > 0) {
	          var _t10 = this[0];
	          return e ? _t10.previousElementSibling && m(_t10.previousElementSibling).is(e) ? m([_t10.previousElementSibling]) : m([]) : _t10.previousElementSibling ? m([_t10.previousElementSibling]) : m([]);
	        }

	        return m([]);
	      },
	      prevAll: function prevAll(e) {
	        var t = [],
	            a = this[0];
	        if (!a) return m([]);

	        for (; a.previousElementSibling;) {
	          var _i8 = a.previousElementSibling;
	          e ? m(_i8).is(e) && t.push(_i8) : t.push(_i8), a = _i8;
	        }

	        return m(t);
	      },
	      parent: function parent(e) {
	        for (var t = [], a = 0; a < this.length; a += 1) {
	          null !== this[a].parentNode && (e ? m(this[a].parentNode).is(e) && t.push(this[a].parentNode) : t.push(this[a].parentNode));
	        }

	        return m(t);
	      },
	      parents: function parents(e) {
	        for (var t = [], a = 0; a < this.length; a += 1) {
	          for (var _i9 = this[a].parentNode; _i9;) {
	            e ? m(_i9).is(e) && t.push(_i9) : t.push(_i9), _i9 = _i9.parentNode;
	          }
	        }

	        return m(t);
	      },
	      closest: function closest(e) {
	        var t = this;
	        return void 0 === e ? m([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
	      },
	      find: function find(e) {
	        for (var t = [], a = 0; a < this.length; a += 1) {
	          for (var _i10 = this[a].querySelectorAll(e), _s6 = 0; _s6 < _i10.length; _s6 += 1) {
	            t.push(_i10[_s6]);
	          }
	        }

	        return m(t);
	      },
	      children: function children(e) {
	        for (var t = [], a = 0; a < this.length; a += 1) {
	          for (var _i11 = this[a].children, _s7 = 0; _s7 < _i11.length; _s7 += 1) {
	            e && !m(_i11[_s7]).is(e) || t.push(_i11[_s7]);
	          }
	        }

	        return m(t);
	      },
	      filter: function filter(e) {
	        return m(f(this, e));
	      },
	      remove: function remove() {
	        for (var _e2 = 0; _e2 < this.length; _e2 += 1) {
	          this[_e2].parentNode && this[_e2].parentNode.removeChild(this[_e2]);
	        }

	        return this;
	      }
	    };

	    function E(e, t) {
	      return void 0 === t && (t = 0), setTimeout(e, t);
	    }

	    function x() {
	      return Date.now();
	    }

	    function T(e, t) {
	      void 0 === t && (t = 'x');

	      var a,
	          i,
	          s,
	          r = l(),
	          n = function (e) {
	        var t,
	            a = l();
	        return a.getComputedStyle && (t = a.getComputedStyle(e, null)), !t && e.currentStyle && (t = e.currentStyle), t || (t = e.style), t;
	      }(e);

	      return r.WebKitCSSMatrix ? ((i = n.transform || n.webkitTransform).split(',').length > 6 && (i = i.split(', ').map(function (e) {
	        return e.replace(',', '.');
	      }).join(', ')), s = new r.WebKitCSSMatrix('none' === i ? '' : i)) : a = (s = n.MozTransform || n.OTransform || n.MsTransform || n.msTransform || n.transform || n.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,')).toString().split(','), 'x' === t && (i = r.WebKitCSSMatrix ? s.m41 : 16 === a.length ? parseFloat(a[12]) : parseFloat(a[4])), 'y' === t && (i = r.WebKitCSSMatrix ? s.m42 : 16 === a.length ? parseFloat(a[13]) : parseFloat(a[5])), i || 0;
	    }

	    function C(e) {
	      return 'object' == _typeof$1(e) && null !== e && e.constructor && 'Object' === Object.prototype.toString.call(e).slice(8, -1);
	    }

	    function S(e) {
	      return 'undefined' != typeof window && void 0 !== window.HTMLElement ? e instanceof HTMLElement : e && (1 === e.nodeType || 11 === e.nodeType);
	    }

	    function M() {
	      for (var e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ['__proto__', 'constructor', 'prototype'], a = 1; a < arguments.length; a += 1) {
	        var _i12 = a < 0 || arguments.length <= a ? void 0 : arguments[a];

	        if (null != _i12 && !S(_i12)) for (var _s8 = Object.keys(Object(_i12)).filter(function (e) {
	          return t.indexOf(e) < 0;
	        }), _r2 = 0, _n6 = _s8.length; _r2 < _n6; _r2 += 1) {
	          var _l2 = _s8[_r2],
	              _o5 = Object.getOwnPropertyDescriptor(_i12, _l2);

	          void 0 !== _o5 && _o5.enumerable && (C(e[_l2]) && C(_i12[_l2]) ? _i12[_l2].__swiper__ ? e[_l2] = _i12[_l2] : M(e[_l2], _i12[_l2]) : !C(e[_l2]) && C(_i12[_l2]) ? (e[_l2] = {}, _i12[_l2].__swiper__ ? e[_l2] = _i12[_l2] : M(e[_l2], _i12[_l2])) : e[_l2] = _i12[_l2]);
	        }
	      }

	      return e;
	    }

	    function z(e, t) {
	      Object.keys(t).forEach(function (a) {
	        C(t[a]) && Object.keys(t[a]).forEach(function (i) {
	          'function' == typeof t[a][i] && (t[a][i] = t[a][i].bind(e));
	        }), e[a] = t[a];
	      });
	    }

	    function P(e) {
	      return void 0 === e && (e = ''), '.' + e.trim().replace(/([\.:!\/])/g, '\\$1').replace(/ /g, '.');
	    }

	    function k(e, t, a, i) {
	      var s = r();
	      return a && Object.keys(i).forEach(function (a) {
	        if (!t[a] && !0 === t.auto) {
	          var _r3 = s.createElement('div');

	          _r3.className = i[a], e.append(_r3), t[a] = _r3;
	        }
	      }), t;
	    }

	    function $() {
	      return g || (g = function () {
	        var e = l(),
	            t = r();
	        return {
	          touch: !!('ontouchstart' in e || e.DocumentTouch && t instanceof e.DocumentTouch),
	          pointerEvents: !!e.PointerEvent && 'maxTouchPoints' in e.navigator && e.navigator.maxTouchPoints >= 0,
	          observer: 'MutationObserver' in e || 'WebkitMutationObserver' in e,
	          passiveListener: function () {
	            var t = !1;

	            try {
	              var _a7 = Object.defineProperty({}, 'passive', {
	                get: function get() {
	                  t = !0;
	                }
	              });

	              e.addEventListener('testPassiveListener', null, _a7);
	            } catch (e) {}

	            return t;
	          }(),
	          gestures: 'ongesturestart' in e
	        };
	      }()), g;
	    }

	    function L(e) {
	      return void 0 === e && (e = {}), b || (b = function (e) {
	        var t = (void 0 === e ? {} : e).userAgent,
	            a = $(),
	            i = l(),
	            s = i.navigator.platform,
	            r = t || i.navigator.userAgent,
	            n = {
	          ios: !1,
	          android: !1
	        },
	            o = i.screen.width,
	            d = i.screen.height,
	            p = r.match(/(Android);?[\s\/]+([\d.]+)?/),
	            u = r.match(/(iPad).*OS\s([\d_]+)/),
	            c = r.match(/(iPod)(.*OS\s([\d_]+))?/),
	            h = !u && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
	            v = 'Win32' === s,
	            f = 'MacIntel' === s;
	        return !u && f && a.touch && ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'].indexOf(o + 'x' + d) >= 0 && ((u = r.match(/(Version)\/([\d.]+)/)) || (u = [0, 1, '13_0_0']), f = !1), p && !v && (n.os = 'android', n.android = !0), (u || h || c) && (n.os = 'ios', n.ios = !0), n;
	      }(e)), b;
	    }

	    function I() {
	      return w || (w = function () {
	        var e,
	            t = l();
	        return {
	          isEdge: !!t.navigator.userAgent.match(/Edge/g),
	          isSafari: (e = t.navigator.userAgent.toLowerCase(), e.indexOf('safari') >= 0 && e.indexOf('chrome') < 0 && e.indexOf('android') < 0),
	          isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)
	        };
	      }()), w;
	    }

	    Object.keys(y).forEach(function (e) {
	      Object.defineProperty(m.fn, e, {
	        value: y[e],
	        writable: !0
	      });
	    });
	    var O = {
	      name: 'resize',
	      create: function create() {
	        var e = this;
	        M(e, {
	          resize: {
	            observer: null,
	            createObserver: function createObserver() {
	              e && !e.destroyed && e.initialized && (e.resize.observer = new ResizeObserver(function (t) {
	                var a = e.width,
	                    i = e.height,
	                    s = a,
	                    r = i;
	                t.forEach(function (t) {
	                  var a = t.contentBoxSize,
	                      i = t.contentRect,
	                      n = t.target;
	                  n && n !== e.el || (s = i ? i.width : (a[0] || a).inlineSize, r = i ? i.height : (a[0] || a).blockSize);
	                }), s === a && r === i || e.resize.resizeHandler();
	              }), e.resize.observer.observe(e.el));
	            },
	            removeObserver: function removeObserver() {
	              e.resize.observer && e.resize.observer.unobserve && e.el && (e.resize.observer.unobserve(e.el), e.resize.observer = null);
	            },
	            resizeHandler: function resizeHandler() {
	              e && !e.destroyed && e.initialized && (e.emit('beforeResize'), e.emit('resize'));
	            },
	            orientationChangeHandler: function orientationChangeHandler() {
	              e && !e.destroyed && e.initialized && e.emit('orientationchange');
	            }
	          }
	        });
	      },
	      on: {
	        init: function init(e) {
	          var t = l();
	          e.params.resizeObserver && void 0 !== l().ResizeObserver ? e.resize.createObserver() : (t.addEventListener('resize', e.resize.resizeHandler), t.addEventListener('orientationchange', e.resize.orientationChangeHandler));
	        },
	        destroy: function destroy(e) {
	          var t = l();
	          e.resize.removeObserver(), t.removeEventListener('resize', e.resize.resizeHandler), t.removeEventListener('orientationchange', e.resize.orientationChangeHandler);
	        }
	      }
	    },
	        A = {
	      attach: function attach(e, t) {
	        void 0 === t && (t = {});
	        var a = l(),
	            i = this,
	            s = new (a.MutationObserver || a.WebkitMutationObserver)(function (e) {
	          if (1 !== e.length) {
	            var _t11 = function _t11() {
	              i.emit('observerUpdate', e[0]);
	            };

	            a.requestAnimationFrame ? a.requestAnimationFrame(_t11) : a.setTimeout(_t11, 0);
	          } else i.emit('observerUpdate', e[0]);
	        });
	        s.observe(e, {
	          attributes: void 0 === t.attributes || t.attributes,
	          childList: void 0 === t.childList || t.childList,
	          characterData: void 0 === t.characterData || t.characterData
	        }), i.observer.observers.push(s);
	      },
	      init: function init() {
	        var e = this;

	        if (e.support.observer && e.params.observer) {
	          if (e.params.observeParents) for (var _t12 = e.$el.parents(), _a8 = 0; _a8 < _t12.length; _a8 += 1) {
	            e.observer.attach(_t12[_a8]);
	          }
	          e.observer.attach(e.$el[0], {
	            childList: e.params.observeSlideChildren
	          }), e.observer.attach(e.$wrapperEl[0], {
	            attributes: !1
	          });
	        }
	      },
	      destroy: function destroy() {
	        this.observer.observers.forEach(function (e) {
	          e.disconnect();
	        }), this.observer.observers = [];
	      }
	    },
	        D = {
	      name: 'observer',
	      params: {
	        observer: !1,
	        observeParents: !1,
	        observeSlideChildren: !1
	      },
	      create: function create() {
	        z(this, {
	          observer: t({}, A, {
	            observers: []
	          })
	        });
	      },
	      on: {
	        init: function init(e) {
	          e.observer.init();
	        },
	        destroy: function destroy(e) {
	          e.observer.destroy();
	        }
	      }
	    };

	    function N(e) {
	      var t = this,
	          a = r(),
	          i = l(),
	          s = t.touchEventsData,
	          n = t.params,
	          o = t.touches;

	      if (t.enabled && (!t.animating || !n.preventInteractionOnTransition)) {
	        var _d5 = e;
	        _d5.originalEvent && (_d5 = _d5.originalEvent);

	        var _p5 = m(_d5.target);

	        if (('wrapper' !== n.touchEventsTarget || _p5.closest(t.wrapperEl).length) && (s.isTouchEvent = 'touchstart' === _d5.type, (s.isTouchEvent || !('which' in _d5) || 3 !== _d5.which) && !(!s.isTouchEvent && 'button' in _d5 && _d5.button > 0 || s.isTouched && s.isMoved))) {
	          !!n.noSwipingClass && '' !== n.noSwipingClass && _d5.target && _d5.target.shadowRoot && e.path && e.path[0] && (_p5 = m(e.path[0]));

	          var _u3 = n.noSwipingSelector ? n.noSwipingSelector : '.' + n.noSwipingClass,
	              _c3 = !(!_d5.target || !_d5.target.shadowRoot);

	          if (n.noSwiping && (_c3 ? function (e, t) {
	            return void 0 === t && (t = this), function t(a) {
	              return a && a !== r() && a !== l() ? (a.assignedSlot && (a = a.assignedSlot), a.closest(e) || t(a.getRootNode().host)) : null;
	            }(t);
	          }(_u3, _d5.target) : _p5.closest(_u3)[0])) t.allowClick = !0;else if (!n.swipeHandler || _p5.closest(n.swipeHandler)[0]) {
	            o.currentX = 'touchstart' === _d5.type ? _d5.targetTouches[0].pageX : _d5.pageX, o.currentY = 'touchstart' === _d5.type ? _d5.targetTouches[0].pageY : _d5.pageY;

	            var _h3 = o.currentX,
	                _v3 = o.currentY,
	                _f = n.edgeSwipeDetection || n.iOSEdgeSwipeDetection,
	                _g = n.edgeSwipeThreshold || n.iOSEdgeSwipeThreshold;

	            if (_f && (_h3 <= _g || _h3 >= i.innerWidth - _g)) {
	              if ('prevent' !== _f) return;
	              e.preventDefault();
	            }

	            if (M(s, {
	              isTouched: !0,
	              isMoved: !1,
	              allowTouchCallbacks: !0,
	              isScrolling: void 0,
	              startMoving: void 0
	            }), o.startX = _h3, o.startY = _v3, s.touchStartTime = x(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, n.threshold > 0 && (s.allowThresholdMove = !1), 'touchstart' !== _d5.type) {
	              var _b = !0;

	              _p5.is(s.focusableElements) && (_b = !1), a.activeElement && m(a.activeElement).is(s.focusableElements) && a.activeElement !== _p5[0] && a.activeElement.blur();

	              var _w = _b && t.allowTouchMove && n.touchStartPreventDefault;

	              !n.touchStartForcePreventDefault && !_w || _p5[0].isContentEditable || _d5.preventDefault();
	            }

	            t.emit('touchStart', _d5);
	          }
	        }
	      }
	    }

	    function G(e) {
	      var t = r(),
	          a = this,
	          i = a.touchEventsData,
	          s = a.params,
	          n = a.touches,
	          l = a.rtlTranslate;

	      if (a.enabled) {
	        var _o6 = e;

	        if (_o6.originalEvent && (_o6 = _o6.originalEvent), i.isTouched) {
	          if (!i.isTouchEvent || 'touchmove' === _o6.type) {
	            var _d6 = 'touchmove' === _o6.type && _o6.targetTouches && (_o6.targetTouches[0] || _o6.changedTouches[0]),
	                _p6 = 'touchmove' === _o6.type ? _d6.pageX : _o6.pageX,
	                _u4 = 'touchmove' === _o6.type ? _d6.pageY : _o6.pageY;

	            if (_o6.preventedByNestedSwiper) return n.startX = _p6, void (n.startY = _u4);
	            if (!a.allowTouchMove) return a.allowClick = !1, void (i.isTouched && (M(n, {
	              startX: _p6,
	              startY: _u4,
	              currentX: _p6,
	              currentY: _u4
	            }), i.touchStartTime = x()));
	            if (i.isTouchEvent && s.touchReleaseOnEdges && !s.loop) if (a.isVertical()) {
	              if (_u4 < n.startY && a.translate <= a.maxTranslate() || _u4 > n.startY && a.translate >= a.minTranslate()) return i.isTouched = !1, void (i.isMoved = !1);
	            } else if (_p6 < n.startX && a.translate <= a.maxTranslate() || _p6 > n.startX && a.translate >= a.minTranslate()) return;
	            if (i.isTouchEvent && t.activeElement && _o6.target === t.activeElement && m(_o6.target).is(i.focusableElements)) return i.isMoved = !0, void (a.allowClick = !1);

	            if (i.allowTouchCallbacks && a.emit('touchMove', _o6), !(_o6.targetTouches && _o6.targetTouches.length > 1)) {
	              n.currentX = _p6, n.currentY = _u4;

	              var _c4 = n.currentX - n.startX,
	                  _h4 = n.currentY - n.startY;

	              if (!(a.params.threshold && Math.sqrt(Math.pow(_c4, 2) + Math.pow(_h4, 2)) < a.params.threshold)) {
	                var _v4;

	                if (void 0 === i.isScrolling) a.isHorizontal() && n.currentY === n.startY || a.isVertical() && n.currentX === n.startX ? i.isScrolling = !1 : _c4 * _c4 + _h4 * _h4 >= 25 && (_v4 = 180 * Math.atan2(Math.abs(_h4), Math.abs(_c4)) / Math.PI, i.isScrolling = a.isHorizontal() ? _v4 > s.touchAngle : 90 - _v4 > s.touchAngle);
	                if (i.isScrolling && a.emit('touchMoveOpposite', _o6), void 0 === i.startMoving && (n.currentX === n.startX && n.currentY === n.startY || (i.startMoving = !0)), i.isScrolling) i.isTouched = !1;else if (i.startMoving) {
	                  a.allowClick = !1, !s.cssMode && _o6.cancelable && _o6.preventDefault(), s.touchMoveStopPropagation && !s.nested && _o6.stopPropagation(), i.isMoved || (s.loop && a.loopFix(), i.startTranslate = a.getTranslate(), a.setTransition(0), a.animating && a.$wrapperEl.trigger('webkitTransitionEnd transitionend'), i.allowMomentumBounce = !1, !s.grabCursor || !0 !== a.allowSlideNext && !0 !== a.allowSlidePrev || a.setGrabCursor(!0), a.emit('sliderFirstMove', _o6)), a.emit('sliderMove', _o6), i.isMoved = !0;

	                  var _f2 = a.isHorizontal() ? _c4 : _h4;

	                  n.diff = _f2, _f2 *= s.touchRatio, l && (_f2 = -_f2), a.swipeDirection = _f2 > 0 ? 'prev' : 'next', i.currentTranslate = _f2 + i.startTranslate;

	                  var _g2 = !0,
	                      _b2 = s.resistanceRatio;

	                  if (s.touchReleaseOnEdges && (_b2 = 0), _f2 > 0 && i.currentTranslate > a.minTranslate() ? (_g2 = !1, s.resistance && (i.currentTranslate = a.minTranslate() - 1 + Math.pow(-a.minTranslate() + i.startTranslate + _f2, _b2))) : _f2 < 0 && i.currentTranslate < a.maxTranslate() && (_g2 = !1, s.resistance && (i.currentTranslate = a.maxTranslate() + 1 - Math.pow(a.maxTranslate() - i.startTranslate - _f2, _b2))), _g2 && (_o6.preventedByNestedSwiper = !0), !a.allowSlideNext && 'next' === a.swipeDirection && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !a.allowSlidePrev && 'prev' === a.swipeDirection && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), a.allowSlidePrev || a.allowSlideNext || (i.currentTranslate = i.startTranslate), s.threshold > 0) {
	                    if (!(Math.abs(_f2) > s.threshold || i.allowThresholdMove)) return void (i.currentTranslate = i.startTranslate);
	                    if (!i.allowThresholdMove) return i.allowThresholdMove = !0, n.startX = n.currentX, n.startY = n.currentY, i.currentTranslate = i.startTranslate, void (n.diff = a.isHorizontal() ? n.currentX - n.startX : n.currentY - n.startY);
	                  }

	                  s.followFinger && !s.cssMode && ((s.freeMode || s.watchSlidesProgress || s.watchSlidesVisibility) && (a.updateActiveIndex(), a.updateSlidesClasses()), s.freeMode && (0 === i.velocities.length && i.velocities.push({
	                    position: n[a.isHorizontal() ? 'startX' : 'startY'],
	                    time: i.touchStartTime
	                  }), i.velocities.push({
	                    position: n[a.isHorizontal() ? 'currentX' : 'currentY'],
	                    time: x()
	                  })), a.updateProgress(i.currentTranslate), a.setTranslate(i.currentTranslate));
	                }
	              }
	            }
	          }
	        } else i.startMoving && i.isScrolling && a.emit('touchMoveOpposite', _o6);
	      }
	    }

	    function B(e) {
	      var t = this,
	          a = t.touchEventsData,
	          i = t.params,
	          s = t.touches,
	          r = t.rtlTranslate,
	          n = t.$wrapperEl,
	          l = t.slidesGrid,
	          o = t.snapGrid;

	      if (t.enabled) {
	        var _d7 = e;
	        if (_d7.originalEvent && (_d7 = _d7.originalEvent), a.allowTouchCallbacks && t.emit('touchEnd', _d7), a.allowTouchCallbacks = !1, !a.isTouched) return a.isMoved && i.grabCursor && t.setGrabCursor(!1), a.isMoved = !1, void (a.startMoving = !1);
	        i.grabCursor && a.isMoved && a.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);

	        var _p7,
	            _u5 = x(),
	            _c5 = _u5 - a.touchStartTime;

	        if (t.allowClick && (t.updateClickedSlide(_d7), t.emit('tap click', _d7), _c5 < 300 && _u5 - a.lastClickTime < 300 && t.emit('doubleTap doubleClick', _d7)), a.lastClickTime = x(), E(function () {
	          t.destroyed || (t.allowClick = !0);
	        }), !a.isTouched || !a.isMoved || !t.swipeDirection || 0 === s.diff || a.currentTranslate === a.startTranslate) return a.isTouched = !1, a.isMoved = !1, void (a.startMoving = !1);
	        if (a.isTouched = !1, a.isMoved = !1, a.startMoving = !1, _p7 = i.followFinger ? r ? t.translate : -t.translate : -a.currentTranslate, !i.cssMode) if (i.freeMode) {
	          if (_p7 < -t.minTranslate()) return void t.slideTo(t.activeIndex);
	          if (_p7 > -t.maxTranslate()) return void (t.slides.length < o.length ? t.slideTo(o.length - 1) : t.slideTo(t.slides.length - 1));

	          if (i.freeModeMomentum) {
	            if (a.velocities.length > 1) {
	              var _h5 = a.velocities.pop(),
	                  _v5 = a.velocities.pop(),
	                  _f3 = _h5.position - _v5.position,
	                  _m = _h5.time - _v5.time;

	              t.velocity = _f3 / _m, t.velocity /= 2, Math.abs(t.velocity) < i.freeModeMinimumVelocity && (t.velocity = 0), (_m > 150 || x() - _h5.time > 300) && (t.velocity = 0);
	            } else t.velocity = 0;

	            t.velocity *= i.freeModeMomentumVelocityRatio, a.velocities.length = 0;

	            var _g3 = 1e3 * i.freeModeMomentumRatio,
	                _b3 = t.velocity * _g3,
	                _w2 = t.translate + _b3;

	            r && (_w2 = -_w2);

	            var _y,
	                _T,
	                _C = !1,
	                _S = 20 * Math.abs(t.velocity) * i.freeModeMomentumBounceRatio;

	            if (_w2 < t.maxTranslate()) i.freeModeMomentumBounce ? (_w2 + t.maxTranslate() < -_S && (_w2 = t.maxTranslate() - _S), _y = t.maxTranslate(), _C = !0, a.allowMomentumBounce = !0) : _w2 = t.maxTranslate(), i.loop && i.centeredSlides && (_T = !0);else if (_w2 > t.minTranslate()) i.freeModeMomentumBounce ? (_w2 - t.minTranslate() > _S && (_w2 = t.minTranslate() + _S), _y = t.minTranslate(), _C = !0, a.allowMomentumBounce = !0) : _w2 = t.minTranslate(), i.loop && i.centeredSlides && (_T = !0);else if (i.freeModeSticky) {
	              for (var M, z = 0; z < o.length; z += 1) {
	                if (o[z] > -_w2) {
	                  M = z;
	                  break;
	                }
	              }

	              _w2 = -(_w2 = Math.abs(o[M] - _w2) < Math.abs(o[M - 1] - _w2) || 'next' === t.swipeDirection ? o[M] : o[M - 1]);
	            }

	            if (_T && t.once('transitionEnd', function () {
	              t.loopFix();
	            }), 0 !== t.velocity) {
	              if (_g3 = r ? Math.abs((-_w2 - t.translate) / t.velocity) : Math.abs((_w2 - t.translate) / t.velocity), i.freeModeSticky) {
	                var _P = Math.abs((r ? -_w2 : _w2) - t.translate),
	                    _k = t.slidesSizesGrid[t.activeIndex];

	                _g3 = _P < _k ? i.speed : _P < 2 * _k ? 1.5 * i.speed : 2.5 * i.speed;
	              }
	            } else if (i.freeModeSticky) return void t.slideToClosest();

	            i.freeModeMomentumBounce && _C ? (t.updateProgress(_y), t.setTransition(_g3), t.setTranslate(_w2), t.transitionStart(!0, t.swipeDirection), t.animating = !0, n.transitionEnd(function () {
	              t && !t.destroyed && a.allowMomentumBounce && (t.emit('momentumBounce'), t.setTransition(i.speed), setTimeout(function () {
	                t.setTranslate(_y), n.transitionEnd(function () {
	                  t && !t.destroyed && t.transitionEnd();
	                });
	              }, 0));
	            })) : t.velocity ? (t.updateProgress(_w2), t.setTransition(_g3), t.setTranslate(_w2), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, n.transitionEnd(function () {
	              t && !t.destroyed && t.transitionEnd();
	            }))) : (t.emit('_freeModeNoMomentumRelease'), t.updateProgress(_w2)), t.updateActiveIndex(), t.updateSlidesClasses();
	          } else {
	            if (i.freeModeSticky) return void t.slideToClosest();
	            i.freeMode && t.emit('_freeModeNoMomentumRelease');
	          }

	          (!i.freeModeMomentum || _c5 >= i.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
	        } else {
	          for (var $ = 0, L = t.slidesSizesGrid[0], I = 0; I < l.length; I += I < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
	            var _O = I < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;

	            void 0 !== l[I + _O] ? _p7 >= l[I] && _p7 < l[I + _O] && ($ = I, L = l[I + _O] - l[I]) : _p7 >= l[I] && ($ = I, L = l[l.length - 1] - l[l.length - 2]);
	          }

	          var _A = (_p7 - l[$]) / L,
	              _D = $ < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;

	          if (_c5 > i.longSwipesMs) {
	            if (!i.longSwipes) return void t.slideTo(t.activeIndex);
	            'next' === t.swipeDirection && (_A >= i.longSwipesRatio ? t.slideTo($ + _D) : t.slideTo($)), 'prev' === t.swipeDirection && (_A > 1 - i.longSwipesRatio ? t.slideTo($ + _D) : t.slideTo($));
	          } else {
	            if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
	            t.navigation && (_d7.target === t.navigation.nextEl || _d7.target === t.navigation.prevEl) ? _d7.target === t.navigation.nextEl ? t.slideTo($ + _D) : t.slideTo($) : ('next' === t.swipeDirection && t.slideTo($ + _D), 'prev' === t.swipeDirection && t.slideTo($));
	          }
	        }
	      }
	    }

	    function H() {
	      var e = this,
	          t = e.params,
	          a = e.el;

	      if (!a || 0 !== a.offsetWidth) {
	        t.breakpoints && e.setBreakpoint();
	        var _i13 = e.allowSlideNext,
	            _s9 = e.allowSlidePrev,
	            _r4 = e.snapGrid;
	        e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses(), ('auto' === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(), e.allowSlidePrev = _s9, e.allowSlideNext = _i13, e.params.watchOverflow && _r4 !== e.snapGrid && e.checkOverflow();
	      }
	    }

	    function R(e) {
	      var t = this;
	      t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
	    }

	    function X() {
	      var e = this,
	          t = e.wrapperEl,
	          a = e.rtlTranslate;

	      if (e.enabled) {
	        e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = a ? t.scrollWidth - t.offsetWidth - t.scrollLeft : -t.scrollLeft : e.translate = -t.scrollTop, -0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();

	        var _i14 = e.maxTranslate() - e.minTranslate();

	        (0 === _i14 ? 0 : (e.translate - e.minTranslate()) / _i14) !== e.progress && e.updateProgress(a ? -e.translate : e.translate), e.emit('setTranslate', e.translate, !1);
	      }
	    }

	    var Y = !1;

	    function V() {}

	    var W = {
	      init: !0,
	      direction: 'horizontal',
	      touchEventsTarget: 'container',
	      initialSlide: 0,
	      speed: 300,
	      cssMode: !1,
	      updateOnWindowResize: !0,
	      resizeObserver: !1,
	      nested: !1,
	      createElements: !1,
	      enabled: !0,
	      focusableElements: 'input, select, option, textarea, button, video, label',
	      width: null,
	      height: null,
	      preventInteractionOnTransition: !1,
	      userAgent: null,
	      url: null,
	      edgeSwipeDetection: !1,
	      edgeSwipeThreshold: 20,
	      freeMode: !1,
	      freeModeMomentum: !0,
	      freeModeMomentumRatio: 1,
	      freeModeMomentumBounce: !0,
	      freeModeMomentumBounceRatio: 1,
	      freeModeMomentumVelocityRatio: 1,
	      freeModeSticky: !1,
	      freeModeMinimumVelocity: .02,
	      autoHeight: !1,
	      setWrapperSize: !1,
	      virtualTranslate: !1,
	      effect: 'slide',
	      breakpoints: void 0,
	      breakpointsBase: 'window',
	      spaceBetween: 0,
	      slidesPerView: 1,
	      slidesPerColumn: 1,
	      slidesPerColumnFill: 'column',
	      slidesPerGroup: 1,
	      slidesPerGroupSkip: 0,
	      centeredSlides: !1,
	      centeredSlidesBounds: !1,
	      slidesOffsetBefore: 0,
	      slidesOffsetAfter: 0,
	      normalizeSlideIndex: !0,
	      centerInsufficientSlides: !1,
	      watchOverflow: !1,
	      roundLengths: !1,
	      touchRatio: 1,
	      touchAngle: 45,
	      simulateTouch: !0,
	      shortSwipes: !0,
	      longSwipes: !0,
	      longSwipesRatio: .5,
	      longSwipesMs: 300,
	      followFinger: !0,
	      allowTouchMove: !0,
	      threshold: 0,
	      touchMoveStopPropagation: !1,
	      touchStartPreventDefault: !0,
	      touchStartForcePreventDefault: !1,
	      touchReleaseOnEdges: !1,
	      uniqueNavElements: !0,
	      resistance: !0,
	      resistanceRatio: .85,
	      watchSlidesProgress: !1,
	      watchSlidesVisibility: !1,
	      grabCursor: !1,
	      preventClicks: !0,
	      preventClicksPropagation: !0,
	      slideToClickedSlide: !1,
	      preloadImages: !0,
	      updateOnImagesReady: !0,
	      loop: !1,
	      loopAdditionalSlides: 0,
	      loopedSlides: null,
	      loopFillGroupWithBlank: !1,
	      loopPreventsSlide: !0,
	      allowSlidePrev: !0,
	      allowSlideNext: !0,
	      swipeHandler: null,
	      noSwiping: !0,
	      noSwipingClass: 'swiper-no-swiping',
	      noSwipingSelector: null,
	      passiveListeners: !0,
	      containerModifierClass: 'swiper-container-',
	      slideClass: 'swiper-slide',
	      slideBlankClass: 'swiper-slide-invisible-blank',
	      slideActiveClass: 'swiper-slide-active',
	      slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	      slideVisibleClass: 'swiper-slide-visible',
	      slideDuplicateClass: 'swiper-slide-duplicate',
	      slideNextClass: 'swiper-slide-next',
	      slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	      slidePrevClass: 'swiper-slide-prev',
	      slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	      wrapperClass: 'swiper-wrapper',
	      runCallbacksOnInit: !0,
	      _emitClasses: !1
	    },
	        F = {
	      modular: {
	        useParams: function useParams(e) {
	          var t = this;
	          t.modules && Object.keys(t.modules).forEach(function (a) {
	            var i = t.modules[a];
	            i.params && M(e, i.params);
	          });
	        },
	        useModules: function useModules(e) {
	          void 0 === e && (e = {});
	          var t = this;
	          t.modules && Object.keys(t.modules).forEach(function (a) {
	            var i = t.modules[a],
	                s = e[a] || {};
	            i.on && t.on && Object.keys(i.on).forEach(function (e) {
	              t.on(e, i.on[e]);
	            }), i.create && i.create.bind(t)(s);
	          });
	        }
	      },
	      eventsEmitter: {
	        on: function on(e, t, a) {
	          var i = this;
	          if ('function' != typeof t) return i;
	          var s = a ? 'unshift' : 'push';
	          return e.split(' ').forEach(function (e) {
	            i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][s](t);
	          }), i;
	        },
	        once: function once(e, t, a) {
	          var i = this;
	          if ('function' != typeof t) return i;

	          function s() {
	            i.off(e, s), s.__emitterProxy && delete s.__emitterProxy;

	            for (var a = arguments.length, r = new Array(a), n = 0; n < a; n++) {
	              r[n] = arguments[n];
	            }

	            t.apply(i, r);
	          }

	          return s.__emitterProxy = t, i.on(e, s, a);
	        },
	        onAny: function onAny(e, t) {
	          var a = this;
	          if ('function' != typeof e) return a;
	          var i = t ? 'unshift' : 'push';
	          return a.eventsAnyListeners.indexOf(e) < 0 && a.eventsAnyListeners[i](e), a;
	        },
	        offAny: function offAny(e) {
	          var t = this;
	          if (!t.eventsAnyListeners) return t;
	          var a = t.eventsAnyListeners.indexOf(e);
	          return a >= 0 && t.eventsAnyListeners.splice(a, 1), t;
	        },
	        off: function off(e, t) {
	          var a = this;
	          return a.eventsListeners ? (e.split(' ').forEach(function (e) {
	            void 0 === t ? a.eventsListeners[e] = [] : a.eventsListeners[e] && a.eventsListeners[e].forEach(function (i, s) {
	              (i === t || i.__emitterProxy && i.__emitterProxy === t) && a.eventsListeners[e].splice(s, 1);
	            });
	          }), a) : a;
	        },
	        emit: function emit() {
	          var e,
	              t,
	              a,
	              i = this;
	          if (!i.eventsListeners) return i;

	          for (var s = arguments.length, r = new Array(s), n = 0; n < s; n++) {
	            r[n] = arguments[n];
	          }

	          'string' == typeof r[0] || Array.isArray(r[0]) ? (e = r[0], t = r.slice(1, r.length), a = i) : (e = r[0].events, t = r[0].data, a = r[0].context || i), t.unshift(a);
	          var l = Array.isArray(e) ? e : e.split(' ');
	          return l.forEach(function (e) {
	            i.eventsAnyListeners && i.eventsAnyListeners.length && i.eventsAnyListeners.forEach(function (i) {
	              i.apply(a, [e].concat(t));
	            }), i.eventsListeners && i.eventsListeners[e] && i.eventsListeners[e].forEach(function (e) {
	              e.apply(a, t);
	            });
	          }), i;
	        }
	      },
	      update: {
	        updateSize: function updateSize() {
	          var e,
	              t,
	              a = this,
	              i = a.$el;
	          e = void 0 !== a.params.width && null !== a.params.width ? a.params.width : i[0].clientWidth, t = void 0 !== a.params.height && null !== a.params.height ? a.params.height : i[0].clientHeight, 0 === e && a.isHorizontal() || 0 === t && a.isVertical() || (e = e - parseInt(i.css('padding-left') || 0, 10) - parseInt(i.css('padding-right') || 0, 10), t = t - parseInt(i.css('padding-top') || 0, 10) - parseInt(i.css('padding-bottom') || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(t) && (t = 0), M(a, {
	            width: e,
	            height: t,
	            size: a.isHorizontal() ? e : t
	          }));
	        },
	        updateSlides: function updateSlides() {
	          var e = this;

	          function t(t) {
	            return e.isHorizontal() ? t : {
	              width: 'height',
	              'margin-top': 'margin-left',
	              'margin-bottom ': 'margin-right',
	              'margin-left': 'margin-top',
	              'margin-right': 'margin-bottom',
	              'padding-left': 'padding-top',
	              'padding-right': 'padding-bottom',
	              marginRight: 'marginBottom'
	            }[t];
	          }

	          function a(e, a) {
	            return parseFloat(e.getPropertyValue(t(a)) || 0);
	          }

	          var i = e.params,
	              s = e.$wrapperEl,
	              r = e.size,
	              n = e.rtlTranslate,
	              l = e.wrongRTL,
	              o = e.virtual && i.virtual.enabled,
	              d = o ? e.virtual.slides.length : e.slides.length,
	              p = s.children('.' + e.params.slideClass),
	              u = o ? e.virtual.slides.length : p.length,
	              c = [],
	              h = [],
	              v = [],
	              f = i.slidesOffsetBefore;
	          'function' == typeof f && (f = i.slidesOffsetBefore.call(e));
	          var m = i.slidesOffsetAfter;
	          'function' == typeof m && (m = i.slidesOffsetAfter.call(e));
	          var g = e.snapGrid.length,
	              b = e.slidesGrid.length,
	              w = i.spaceBetween,
	              y = -f,
	              E = 0,
	              x = 0;

	          if (void 0 !== r) {
	            var _T2, _C2;

	            'string' == typeof w && w.indexOf('%') >= 0 && (w = parseFloat(w.replace('%', '')) / 100 * r), e.virtualSize = -w, n ? p.css({
	              marginLeft: '',
	              marginBottom: '',
	              marginTop: ''
	            }) : p.css({
	              marginRight: '',
	              marginBottom: '',
	              marginTop: ''
	            }), i.slidesPerColumn > 1 && (_T2 = Math.floor(u / i.slidesPerColumn) === u / e.params.slidesPerColumn ? u : Math.ceil(u / i.slidesPerColumn) * i.slidesPerColumn, 'auto' !== i.slidesPerView && 'row' === i.slidesPerColumnFill && (_T2 = Math.max(_T2, i.slidesPerView * i.slidesPerColumn)));

	            for (var S, z, P, k = i.slidesPerColumn, $ = _T2 / k, L = Math.floor(u / i.slidesPerColumn), I = 0; I < u; I += 1) {
	              _C2 = 0;

	              var _O2 = p.eq(I);

	              if (i.slidesPerColumn > 1) {
	                var _A2 = void 0,
	                    _D2 = void 0,
	                    _N = void 0;

	                if ('row' === i.slidesPerColumnFill && i.slidesPerGroup > 1) {
	                  var _G = Math.floor(I / (i.slidesPerGroup * i.slidesPerColumn)),
	                      _B = I - i.slidesPerColumn * i.slidesPerGroup * _G,
	                      _H = 0 === _G ? i.slidesPerGroup : Math.min(Math.ceil((u - _G * k * i.slidesPerGroup) / k), i.slidesPerGroup);

	                  _A2 = (_D2 = _B - (_N = Math.floor(_B / _H)) * _H + _G * i.slidesPerGroup) + _N * _T2 / k, _O2.css({
	                    '-webkit-box-ordinal-group': _A2,
	                    '-moz-box-ordinal-group': _A2,
	                    '-ms-flex-order': _A2,
	                    '-webkit-order': _A2,
	                    order: _A2
	                  });
	                } else 'column' === i.slidesPerColumnFill ? (_N = I - (_D2 = Math.floor(I / k)) * k, (_D2 > L || _D2 === L && _N === k - 1) && (_N += 1) >= k && (_N = 0, _D2 += 1)) : _D2 = I - (_N = Math.floor(I / $)) * $;

	                _O2.css(t('margin-top'), 0 !== _N ? i.spaceBetween && i.spaceBetween + 'px' : '');
	              }

	              if ('none' !== _O2.css('display')) {
	                if ('auto' === i.slidesPerView) {
	                  var _R = getComputedStyle(_O2[0]),
	                      _X = _O2[0].style.transform,
	                      _Y = _O2[0].style.webkitTransform;

	                  if (_X && (_O2[0].style.transform = 'none'), _Y && (_O2[0].style.webkitTransform = 'none'), i.roundLengths) _C2 = e.isHorizontal() ? _O2.outerWidth(!0) : _O2.outerHeight(!0);else {
	                    var _V = a(_R, 'width'),
	                        _W = a(_R, 'padding-left'),
	                        _F = a(_R, 'padding-right'),
	                        _2 = a(_R, 'margin-left'),
	                        _q = a(_R, 'margin-right'),
	                        _j = _R.getPropertyValue('box-sizing');

	                    if (_j && 'border-box' === _j) _C2 = _V + _2 + _q;else {
	                      var _U = _O2[0],
	                          _K = _U.clientWidth;
	                      _C2 = _V + _W + _F + _2 + _q + (_U.offsetWidth - _K);
	                    }
	                  }
	                  _X && (_O2[0].style.transform = _X), _Y && (_O2[0].style.webkitTransform = _Y), i.roundLengths && (_C2 = Math.floor(_C2));
	                } else _C2 = (r - (i.slidesPerView - 1) * w) / i.slidesPerView, i.roundLengths && (_C2 = Math.floor(_C2)), p[I] && (p[I].style[t('width')] = _C2 + 'px');

	                p[I] && (p[I].swiperSlideSize = _C2), v.push(_C2), i.centeredSlides ? (y = y + _C2 / 2 + E / 2 + w, 0 === E && 0 !== I && (y = y - r / 2 - w), 0 === I && (y = y - r / 2 - w), Math.abs(y) < .001 && (y = 0), i.roundLengths && (y = Math.floor(y)), x % i.slidesPerGroup == 0 && c.push(y), h.push(y)) : (i.roundLengths && (y = Math.floor(y)), (x - Math.min(e.params.slidesPerGroupSkip, x)) % e.params.slidesPerGroup == 0 && c.push(y), h.push(y), y = y + _C2 + w), e.virtualSize += _C2 + w, E = _C2, x += 1;
	              }
	            }

	            if (e.virtualSize = Math.max(e.virtualSize, r) + m, n && l && ('slide' === i.effect || 'coverflow' === i.effect) && s.css({
	              width: e.virtualSize + i.spaceBetween + 'px'
	            }), i.setWrapperSize) s.css(((z = {})[t('width')] = e.virtualSize + i.spaceBetween + 'px', z));
	            if (i.slidesPerColumn > 1) if (e.virtualSize = (_C2 + i.spaceBetween) * _T2, e.virtualSize = Math.ceil(e.virtualSize / i.slidesPerColumn) - i.spaceBetween, s.css(((P = {})[t('width')] = e.virtualSize + i.spaceBetween + 'px', P)), i.centeredSlides) {
	              S = [];

	              for (var _Z = 0; _Z < c.length; _Z += 1) {
	                var _J = c[_Z];
	                i.roundLengths && (_J = Math.floor(_J)), c[_Z] < e.virtualSize + c[0] && S.push(_J);
	              }

	              c = S;
	            }

	            if (!i.centeredSlides) {
	              S = [];

	              for (var _Q = 0; _Q < c.length; _Q += 1) {
	                var _ee = c[_Q];
	                i.roundLengths && (_ee = Math.floor(_ee)), c[_Q] <= e.virtualSize - r && S.push(_ee);
	              }

	              c = S, Math.floor(e.virtualSize - r) - Math.floor(c[c.length - 1]) > 1 && c.push(e.virtualSize - r);
	            }

	            if (0 === c.length && (c = [0]), 0 !== i.spaceBetween) {
	              var _te,
	                  _ae = e.isHorizontal() && n ? 'marginLeft' : t('marginRight');

	              p.filter(function (e, t) {
	                return !i.cssMode || t !== p.length - 1;
	              }).css(((_te = {})[_ae] = w + 'px', _te));
	            }

	            if (i.centeredSlides && i.centeredSlidesBounds) {
	              var _ie = 0;
	              v.forEach(function (e) {
	                _ie += e + (i.spaceBetween ? i.spaceBetween : 0);
	              });

	              var _se = (_ie -= i.spaceBetween) - r;

	              c = c.map(function (e) {
	                return e < 0 ? -f : e > _se ? _se + m : e;
	              });
	            }

	            if (i.centerInsufficientSlides) {
	              var _re = 0;

	              if (v.forEach(function (e) {
	                _re += e + (i.spaceBetween ? i.spaceBetween : 0);
	              }), (_re -= i.spaceBetween) < r) {
	                var _ne = (r - _re) / 2;

	                c.forEach(function (e, t) {
	                  c[t] = e - _ne;
	                }), h.forEach(function (e, t) {
	                  h[t] = e + _ne;
	                });
	              }
	            }

	            M(e, {
	              slides: p,
	              snapGrid: c,
	              slidesGrid: h,
	              slidesSizesGrid: v
	            }), u !== d && e.emit('slidesLengthChange'), c.length !== g && (e.params.watchOverflow && e.checkOverflow(), e.emit('snapGridLengthChange')), h.length !== b && e.emit('slidesGridLengthChange'), (i.watchSlidesProgress || i.watchSlidesVisibility) && e.updateSlidesOffset();
	          }
	        },
	        updateAutoHeight: function updateAutoHeight(e) {
	          var t,
	              a = this,
	              i = [],
	              s = a.virtual && a.params.virtual.enabled,
	              r = 0;
	          'number' == typeof e ? a.setTransition(e) : !0 === e && a.setTransition(a.params.speed);

	          var n = function n(e) {
	            return s ? a.slides.filter(function (t) {
	              return parseInt(t.getAttribute('data-swiper-slide-index'), 10) === e;
	            })[0] : a.slides.eq(e)[0];
	          };

	          if ('auto' !== a.params.slidesPerView && a.params.slidesPerView > 1) {
	            if (a.params.centeredSlides) a.visibleSlides.each(function (e) {
	              i.push(e);
	            });else for (t = 0; t < Math.ceil(a.params.slidesPerView); t += 1) {
	              var _l3 = a.activeIndex + t;

	              if (_l3 > a.slides.length && !s) break;
	              i.push(n(_l3));
	            }
	          } else i.push(n(a.activeIndex));

	          for (t = 0; t < i.length; t += 1) {
	            if (void 0 !== i[t]) {
	              var _o7 = i[t].offsetHeight;
	              r = _o7 > r ? _o7 : r;
	            }
	          }

	          r && a.$wrapperEl.css('height', r + 'px');
	        },
	        updateSlidesOffset: function updateSlidesOffset() {
	          for (var _e3 = this.slides, _t13 = 0; _t13 < _e3.length; _t13 += 1) {
	            _e3[_t13].swiperSlideOffset = this.isHorizontal() ? _e3[_t13].offsetLeft : _e3[_t13].offsetTop;
	          }
	        },
	        updateSlidesProgress: function updateSlidesProgress(e) {
	          void 0 === e && (e = this && this.translate || 0);
	          var t = this,
	              a = t.params,
	              i = t.slides,
	              s = t.rtlTranslate;

	          if (0 !== i.length) {
	            void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();

	            var _r5 = -e;

	            s && (_r5 = e), i.removeClass(a.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];

	            for (var _n7 = 0; _n7 < i.length; _n7 += 1) {
	              var _l4 = i[_n7],
	                  _o8 = (_r5 + (a.centeredSlides ? t.minTranslate() : 0) - _l4.swiperSlideOffset) / (_l4.swiperSlideSize + a.spaceBetween);

	              if (a.watchSlidesVisibility || a.centeredSlides && a.autoHeight) {
	                var _d8 = -(_r5 - _l4.swiperSlideOffset),
	                    _p8 = _d8 + t.slidesSizesGrid[_n7];

	                (_d8 >= 0 && _d8 < t.size - 1 || _p8 > 1 && _p8 <= t.size || _d8 <= 0 && _p8 >= t.size) && (t.visibleSlides.push(_l4), t.visibleSlidesIndexes.push(_n7), i.eq(_n7).addClass(a.slideVisibleClass));
	              }

	              _l4.progress = s ? -_o8 : _o8;
	            }

	            t.visibleSlides = m(t.visibleSlides);
	          }
	        },
	        updateProgress: function updateProgress(e) {
	          var t = this;

	          if (void 0 === e) {
	            var _a9 = t.rtlTranslate ? -1 : 1;

	            e = t && t.translate && t.translate * _a9 || 0;
	          }

	          var i = t.params,
	              s = t.maxTranslate() - t.minTranslate(),
	              r = t.progress,
	              n = t.isBeginning,
	              l = t.isEnd,
	              o = n,
	              d = l;
	          0 === s ? (r = 0, n = !0, l = !0) : (n = (r = (e - t.minTranslate()) / s) <= 0, l = r >= 1), M(t, {
	            progress: r,
	            isBeginning: n,
	            isEnd: l
	          }), (i.watchSlidesProgress || i.watchSlidesVisibility || i.centeredSlides && i.autoHeight) && t.updateSlidesProgress(e), n && !o && t.emit('reachBeginning toEdge'), l && !d && t.emit('reachEnd toEdge'), (o && !n || d && !l) && t.emit('fromEdge'), t.emit('progress', r);
	        },
	        updateSlidesClasses: function updateSlidesClasses() {
	          var e,
	              t = this,
	              a = t.slides,
	              i = t.params,
	              s = t.$wrapperEl,
	              r = t.activeIndex,
	              n = t.realIndex,
	              l = t.virtual && i.virtual.enabled;
	          a.removeClass(i.slideActiveClass + ' ' + i.slideNextClass + ' ' + i.slidePrevClass + ' ' + i.slideDuplicateActiveClass + ' ' + i.slideDuplicateNextClass + ' ' + i.slideDuplicatePrevClass), (e = l ? t.$wrapperEl.find('.' + i.slideClass + '[data-swiper-slide-index="' + r + '"]') : a.eq(r)).addClass(i.slideActiveClass), i.loop && (e.hasClass(i.slideDuplicateClass) ? s.children('.' + i.slideClass + ':not(.' + i.slideDuplicateClass + ')[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass) : s.children('.' + i.slideClass + '.' + i.slideDuplicateClass + '[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass));
	          var o = e.nextAll('.' + i.slideClass).eq(0).addClass(i.slideNextClass);
	          i.loop && 0 === o.length && (o = a.eq(0)).addClass(i.slideNextClass);
	          var d = e.prevAll('.' + i.slideClass).eq(0).addClass(i.slidePrevClass);
	          i.loop && 0 === d.length && (d = a.eq(-1)).addClass(i.slidePrevClass), i.loop && (o.hasClass(i.slideDuplicateClass) ? s.children('.' + i.slideClass + ':not(.' + i.slideDuplicateClass + ')[data-swiper-slide-index="' + o.attr('data-swiper-slide-index') + '"]').addClass(i.slideDuplicateNextClass) : s.children('.' + i.slideClass + '.' + i.slideDuplicateClass + '[data-swiper-slide-index="' + o.attr('data-swiper-slide-index') + '"]').addClass(i.slideDuplicateNextClass), d.hasClass(i.slideDuplicateClass) ? s.children('.' + i.slideClass + ':not(.' + i.slideDuplicateClass + ')[data-swiper-slide-index="' + d.attr('data-swiper-slide-index') + '"]').addClass(i.slideDuplicatePrevClass) : s.children('.' + i.slideClass + '.' + i.slideDuplicateClass + '[data-swiper-slide-index="' + d.attr('data-swiper-slide-index') + '"]').addClass(i.slideDuplicatePrevClass)), t.emitSlidesClasses();
	        },
	        updateActiveIndex: function updateActiveIndex(e) {
	          var t,
	              a = this,
	              i = a.rtlTranslate ? a.translate : -a.translate,
	              s = a.slidesGrid,
	              r = a.snapGrid,
	              n = a.params,
	              l = a.activeIndex,
	              o = a.realIndex,
	              d = a.snapIndex,
	              p = e;

	          if (void 0 === p) {
	            for (var _u6 = 0; _u6 < s.length; _u6 += 1) {
	              void 0 !== s[_u6 + 1] ? i >= s[_u6] && i < s[_u6 + 1] - (s[_u6 + 1] - s[_u6]) / 2 ? p = _u6 : i >= s[_u6] && i < s[_u6 + 1] && (p = _u6 + 1) : i >= s[_u6] && (p = _u6);
	            }

	            n.normalizeSlideIndex && (p < 0 || void 0 === p) && (p = 0);
	          }

	          if (r.indexOf(i) >= 0) t = r.indexOf(i);else {
	            var _c6 = Math.min(n.slidesPerGroupSkip, p);

	            t = _c6 + Math.floor((p - _c6) / n.slidesPerGroup);
	          }

	          if (t >= r.length && (t = r.length - 1), p !== l) {
	            var _h6 = parseInt(a.slides.eq(p).attr('data-swiper-slide-index') || p, 10);

	            M(a, {
	              snapIndex: t,
	              realIndex: _h6,
	              previousIndex: l,
	              activeIndex: p
	            }), a.emit('activeIndexChange'), a.emit('snapIndexChange'), o !== _h6 && a.emit('realIndexChange'), (a.initialized || a.params.runCallbacksOnInit) && a.emit('slideChange');
	          } else t !== d && (a.snapIndex = t, a.emit('snapIndexChange'));
	        },
	        updateClickedSlide: function updateClickedSlide(e) {
	          var t,
	              a = this,
	              i = a.params,
	              s = m(e.target).closest('.' + i.slideClass)[0],
	              r = !1;
	          if (s) for (var _n8 = 0; _n8 < a.slides.length; _n8 += 1) {
	            if (a.slides[_n8] === s) {
	              r = !0, t = _n8;
	              break;
	            }
	          }
	          if (!s || !r) return a.clickedSlide = void 0, void (a.clickedIndex = void 0);
	          a.clickedSlide = s, a.virtual && a.params.virtual.enabled ? a.clickedIndex = parseInt(m(s).attr('data-swiper-slide-index'), 10) : a.clickedIndex = t, i.slideToClickedSlide && void 0 !== a.clickedIndex && a.clickedIndex !== a.activeIndex && a.slideToClickedSlide();
	        }
	      },
	      translate: {
	        getTranslate: function getTranslate(e) {
	          void 0 === e && (e = this.isHorizontal() ? 'x' : 'y');
	          var t = this,
	              a = t.params,
	              i = t.rtlTranslate,
	              s = t.translate,
	              r = t.$wrapperEl;
	          if (a.virtualTranslate) return i ? -s : s;
	          if (a.cssMode) return s;
	          var n = T(r[0], e);
	          return i && (n = -n), n || 0;
	        },
	        setTranslate: function setTranslate(e, t) {
	          var a = this,
	              i = a.rtlTranslate,
	              s = a.params,
	              r = a.$wrapperEl,
	              n = a.wrapperEl,
	              l = a.progress,
	              o = 0,
	              d = 0;
	          a.isHorizontal() ? o = i ? -e : e : d = e, s.roundLengths && (o = Math.floor(o), d = Math.floor(d)), s.cssMode ? n[a.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = a.isHorizontal() ? -o : -d : s.virtualTranslate || r.transform('translate3d(' + o + 'px, ' + d + 'px, 0px)'), a.previousTranslate = a.translate, a.translate = a.isHorizontal() ? o : d;
	          var p = a.maxTranslate() - a.minTranslate();
	          (0 === p ? 0 : (e - a.minTranslate()) / p) !== l && a.updateProgress(e), a.emit('setTranslate', a.translate, t);
	        },
	        minTranslate: function minTranslate() {
	          return -this.snapGrid[0];
	        },
	        maxTranslate: function maxTranslate() {
	          return -this.snapGrid[this.snapGrid.length - 1];
	        },
	        translateTo: function translateTo(e, t, a, i, s) {
	          void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0), void 0 === i && (i = !0);
	          var r = this,
	              n = r.params,
	              l = r.wrapperEl;
	          if (r.animating && n.preventInteractionOnTransition) return !1;
	          var o,
	              d = r.minTranslate(),
	              p = r.maxTranslate();

	          if (o = i && e > d ? d : i && e < p ? p : e, r.updateProgress(o), n.cssMode) {
	            var _u7,
	                _c7 = r.isHorizontal();

	            if (0 === t) l[_c7 ? 'scrollLeft' : 'scrollTop'] = -o;else if (l.scrollTo) l.scrollTo(((_u7 = {})[_c7 ? 'left' : 'top'] = -o, _u7.behavior = 'smooth', _u7));else l[_c7 ? 'scrollLeft' : 'scrollTop'] = -o;
	            return !0;
	          }

	          return 0 === t ? (r.setTransition(0), r.setTranslate(o), a && (r.emit('beforeTransitionStart', t, s), r.emit('transitionEnd'))) : (r.setTransition(t), r.setTranslate(o), a && (r.emit('beforeTransitionStart', t, s), r.emit('transitionStart')), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function (e) {
	            r && !r.destroyed && e.target === this && (r.$wrapperEl[0].removeEventListener('transitionend', r.onTranslateToWrapperTransitionEnd), r.$wrapperEl[0].removeEventListener('webkitTransitionEnd', r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, a && r.emit('transitionEnd'));
	          }), r.$wrapperEl[0].addEventListener('transitionend', r.onTranslateToWrapperTransitionEnd), r.$wrapperEl[0].addEventListener('webkitTransitionEnd', r.onTranslateToWrapperTransitionEnd))), !0;
	        }
	      },
	      transition: {
	        setTransition: function setTransition(e, t) {
	          var a = this;
	          a.params.cssMode || a.$wrapperEl.transition(e), a.emit('setTransition', e, t);
	        },
	        transitionStart: function transitionStart(e, t) {
	          void 0 === e && (e = !0);
	          var a = this,
	              i = a.activeIndex,
	              s = a.params,
	              r = a.previousIndex;

	          if (!s.cssMode) {
	            s.autoHeight && a.updateAutoHeight();
	            var _n9 = t;

	            if (_n9 || (_n9 = i > r ? 'next' : i < r ? 'prev' : 'reset'), a.emit('transitionStart'), e && i !== r) {
	              if ('reset' === _n9) return void a.emit('slideResetTransitionStart');
	              a.emit('slideChangeTransitionStart'), 'next' === _n9 ? a.emit('slideNextTransitionStart') : a.emit('slidePrevTransitionStart');
	            }
	          }
	        },
	        transitionEnd: function transitionEnd(e, t) {
	          void 0 === e && (e = !0);
	          var a = this,
	              i = a.activeIndex,
	              s = a.previousIndex,
	              r = a.params;

	          if (a.animating = !1, !r.cssMode) {
	            a.setTransition(0);
	            var _n10 = t;

	            if (_n10 || (_n10 = i > s ? 'next' : i < s ? 'prev' : 'reset'), a.emit('transitionEnd'), e && i !== s) {
	              if ('reset' === _n10) return void a.emit('slideResetTransitionEnd');
	              a.emit('slideChangeTransitionEnd'), 'next' === _n10 ? a.emit('slideNextTransitionEnd') : a.emit('slidePrevTransitionEnd');
	            }
	          }
	        }
	      },
	      slide: {
	        slideTo: function slideTo(e, t, a, i, s) {
	          if (void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0), 'number' != typeof e && 'string' != typeof e) throw new Error('The \'index\' argument cannot have type other than \'number\' or \'string\'. [' + _typeof$1(e) + '] given.');

	          if ('string' == typeof e) {
	            var _r6 = parseInt(e, 10);

	            if (!isFinite(_r6)) throw new Error('The passed-in \'index\' (string) couldn\'t be converted to \'number\'. [' + e + '] given.');
	            e = _r6;
	          }

	          var n = this,
	              l = e;
	          l < 0 && (l = 0);
	          var o = n.params,
	              d = n.snapGrid,
	              p = n.slidesGrid,
	              u = n.previousIndex,
	              c = n.activeIndex,
	              h = n.rtlTranslate,
	              v = n.wrapperEl,
	              f = n.enabled;
	          if (n.animating && o.preventInteractionOnTransition || !f && !i && !s) return !1;
	          var m = Math.min(n.params.slidesPerGroupSkip, l),
	              g = m + Math.floor((l - m) / n.params.slidesPerGroup);
	          g >= d.length && (g = d.length - 1), (c || o.initialSlide || 0) === (u || 0) && a && n.emit('beforeSlideChangeStart');
	          var b,
	              w = -d[g];
	          if (n.updateProgress(w), o.normalizeSlideIndex) for (var _y2 = 0; _y2 < p.length; _y2 += 1) {
	            var _E = -Math.floor(100 * w),
	                _x = Math.floor(100 * p[_y2]),
	                _T3 = Math.floor(100 * p[_y2 + 1]);

	            void 0 !== p[_y2 + 1] ? _E >= _x && _E < _T3 - (_T3 - _x) / 2 ? l = _y2 : _E >= _x && _E < _T3 && (l = _y2 + 1) : _E >= _x && (l = _y2);
	          }

	          if (n.initialized && l !== c) {
	            if (!n.allowSlideNext && w < n.translate && w < n.minTranslate()) return !1;
	            if (!n.allowSlidePrev && w > n.translate && w > n.maxTranslate() && (c || 0) !== l) return !1;
	          }

	          if (b = l > c ? 'next' : l < c ? 'prev' : 'reset', h && -w === n.translate || !h && w === n.translate) return n.updateActiveIndex(l), o.autoHeight && n.updateAutoHeight(), n.updateSlidesClasses(), 'slide' !== o.effect && n.setTranslate(w), 'reset' !== b && (n.transitionStart(a, b), n.transitionEnd(a, b)), !1;

	          if (o.cssMode) {
	            var _C3,
	                _S2 = n.isHorizontal(),
	                _M = -w;

	            if (h && (_M = v.scrollWidth - v.offsetWidth - _M), 0 === t) v[_S2 ? 'scrollLeft' : 'scrollTop'] = _M;else if (v.scrollTo) v.scrollTo(((_C3 = {})[_S2 ? 'left' : 'top'] = _M, _C3.behavior = 'smooth', _C3));else v[_S2 ? 'scrollLeft' : 'scrollTop'] = _M;
	            return !0;
	          }

	          return 0 === t ? (n.setTransition(0), n.setTranslate(w), n.updateActiveIndex(l), n.updateSlidesClasses(), n.emit('beforeTransitionStart', t, i), n.transitionStart(a, b), n.transitionEnd(a, b)) : (n.setTransition(t), n.setTranslate(w), n.updateActiveIndex(l), n.updateSlidesClasses(), n.emit('beforeTransitionStart', t, i), n.transitionStart(a, b), n.animating || (n.animating = !0, n.onSlideToWrapperTransitionEnd || (n.onSlideToWrapperTransitionEnd = function (e) {
	            n && !n.destroyed && e.target === this && (n.$wrapperEl[0].removeEventListener('transitionend', n.onSlideToWrapperTransitionEnd), n.$wrapperEl[0].removeEventListener('webkitTransitionEnd', n.onSlideToWrapperTransitionEnd), n.onSlideToWrapperTransitionEnd = null, delete n.onSlideToWrapperTransitionEnd, n.transitionEnd(a, b));
	          }), n.$wrapperEl[0].addEventListener('transitionend', n.onSlideToWrapperTransitionEnd), n.$wrapperEl[0].addEventListener('webkitTransitionEnd', n.onSlideToWrapperTransitionEnd))), !0;
	        },
	        slideToLoop: function slideToLoop(e, t, a, i) {
	          void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0);
	          var s = this,
	              r = e;
	          return s.params.loop && (r += s.loopedSlides), s.slideTo(r, t, a, i);
	        },
	        slideNext: function slideNext(e, t, a) {
	          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
	          var i = this,
	              s = i.params,
	              r = i.animating;
	          if (!i.enabled) return i;
	          var n = i.activeIndex < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup;

	          if (s.loop) {
	            if (r && s.loopPreventsSlide) return !1;
	            i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft;
	          }

	          return i.slideTo(i.activeIndex + n, e, t, a);
	        },
	        slidePrev: function slidePrev(e, t, a) {
	          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
	          var i = this,
	              s = i.params,
	              r = i.animating,
	              n = i.snapGrid,
	              l = i.slidesGrid,
	              o = i.rtlTranslate;
	          if (!i.enabled) return i;

	          if (s.loop) {
	            if (r && s.loopPreventsSlide) return !1;
	            i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft;
	          }

	          function d(e) {
	            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
	          }

	          var p,
	              u = d(o ? i.translate : -i.translate),
	              c = n.map(function (e) {
	            return d(e);
	          }),
	              h = n[c.indexOf(u) - 1];
	          return void 0 === h && s.cssMode && n.forEach(function (e) {
	            !h && u >= e && (h = e);
	          }), void 0 !== h && (p = l.indexOf(h)) < 0 && (p = i.activeIndex - 1), i.slideTo(p, e, t, a);
	        },
	        slideReset: function slideReset(e, t, a) {
	          return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, a);
	        },
	        slideToClosest: function slideToClosest(e, t, a, i) {
	          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === i && (i = .5);
	          var s = this,
	              r = s.activeIndex,
	              n = Math.min(s.params.slidesPerGroupSkip, r),
	              l = n + Math.floor((r - n) / s.params.slidesPerGroup),
	              o = s.rtlTranslate ? s.translate : -s.translate;

	          if (o >= s.snapGrid[l]) {
	            var _d9 = s.snapGrid[l];
	            o - _d9 > (s.snapGrid[l + 1] - _d9) * i && (r += s.params.slidesPerGroup);
	          } else {
	            var _p9 = s.snapGrid[l - 1];
	            o - _p9 <= (s.snapGrid[l] - _p9) * i && (r -= s.params.slidesPerGroup);
	          }

	          return r = Math.max(r, 0), r = Math.min(r, s.slidesGrid.length - 1), s.slideTo(r, e, t, a);
	        },
	        slideToClickedSlide: function slideToClickedSlide() {
	          var e,
	              t = this,
	              a = t.params,
	              i = t.$wrapperEl,
	              s = 'auto' === a.slidesPerView ? t.slidesPerViewDynamic() : a.slidesPerView,
	              r = t.clickedIndex;

	          if (a.loop) {
	            if (t.animating) return;
	            e = parseInt(m(t.clickedSlide).attr('data-swiper-slide-index'), 10), a.centeredSlides ? r < t.loopedSlides - s / 2 || r > t.slides.length - t.loopedSlides + s / 2 ? (t.loopFix(), r = i.children('.' + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ')').eq(0).index(), E(function () {
	              t.slideTo(r);
	            })) : t.slideTo(r) : r > t.slides.length - s ? (t.loopFix(), r = i.children('.' + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ')').eq(0).index(), E(function () {
	              t.slideTo(r);
	            })) : t.slideTo(r);
	          } else t.slideTo(r);
	        }
	      },
	      loop: {
	        loopCreate: function loopCreate() {
	          var e = this,
	              t = r(),
	              a = e.params,
	              i = e.$wrapperEl;
	          i.children('.' + a.slideClass + '.' + a.slideDuplicateClass).remove();
	          var s = i.children('.' + a.slideClass);

	          if (a.loopFillGroupWithBlank) {
	            var _n11 = a.slidesPerGroup - s.length % a.slidesPerGroup;

	            if (_n11 !== a.slidesPerGroup) {
	              for (var _l5 = 0; _l5 < _n11; _l5 += 1) {
	                var _o9 = m(t.createElement('div')).addClass(a.slideClass + ' ' + a.slideBlankClass);

	                i.append(_o9);
	              }

	              s = i.children('.' + a.slideClass);
	            }
	          }

	          'auto' !== a.slidesPerView || a.loopedSlides || (a.loopedSlides = s.length), e.loopedSlides = Math.ceil(parseFloat(a.loopedSlides || a.slidesPerView, 10)), e.loopedSlides += a.loopAdditionalSlides, e.loopedSlides > s.length && (e.loopedSlides = s.length);
	          var d = [],
	              p = [];
	          s.each(function (t, a) {
	            var i = m(t);
	            a < e.loopedSlides && p.push(t), a < s.length && a >= s.length - e.loopedSlides && d.push(t), i.attr('data-swiper-slide-index', a);
	          });

	          for (var _u8 = 0; _u8 < p.length; _u8 += 1) {
	            i.append(m(p[_u8].cloneNode(!0)).addClass(a.slideDuplicateClass));
	          }

	          for (var _c8 = d.length - 1; _c8 >= 0; _c8 -= 1) {
	            i.prepend(m(d[_c8].cloneNode(!0)).addClass(a.slideDuplicateClass));
	          }
	        },
	        loopFix: function loopFix() {
	          var e = this;
	          e.emit('beforeLoopFix');
	          var t,
	              a = e.activeIndex,
	              i = e.slides,
	              s = e.loopedSlides,
	              r = e.allowSlidePrev,
	              n = e.allowSlideNext,
	              l = e.snapGrid,
	              o = e.rtlTranslate;
	          e.allowSlidePrev = !0, e.allowSlideNext = !0;
	          var d = -l[a] - e.getTranslate();
	          if (a < s) t = i.length - 3 * s + a, t += s, e.slideTo(t, 0, !1, !0) && 0 !== d && e.setTranslate((o ? -e.translate : e.translate) - d);else if (a >= i.length - s) {
	            t = -i.length + a + s, t += s, e.slideTo(t, 0, !1, !0) && 0 !== d && e.setTranslate((o ? -e.translate : e.translate) - d);
	          }
	          e.allowSlidePrev = r, e.allowSlideNext = n, e.emit('loopFix');
	        },
	        loopDestroy: function loopDestroy() {
	          var e = this,
	              t = e.$wrapperEl,
	              a = e.params,
	              i = e.slides;
	          t.children('.' + a.slideClass + '.' + a.slideDuplicateClass + ',.' + a.slideClass + '.' + a.slideBlankClass).remove(), i.removeAttr('data-swiper-slide-index');
	        }
	      },
	      grabCursor: {
	        setGrabCursor: function setGrabCursor(e) {
	          var t = this;

	          if (!(t.support.touch || !t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode)) {
	            var _a10 = t.el;
	            _a10.style.cursor = 'move', _a10.style.cursor = e ? '-webkit-grabbing' : '-webkit-grab', _a10.style.cursor = e ? '-moz-grabbin' : '-moz-grab', _a10.style.cursor = e ? 'grabbing' : 'grab';
	          }
	        },
	        unsetGrabCursor: function unsetGrabCursor() {
	          var e = this;
	          e.support.touch || e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.el.style.cursor = '');
	        }
	      },
	      manipulation: {
	        appendSlide: function appendSlide(e) {
	          var t = this,
	              a = t.$wrapperEl,
	              i = t.params;
	          if (i.loop && t.loopDestroy(), 'object' == _typeof$1(e) && 'length' in e) for (var _s10 = 0; _s10 < e.length; _s10 += 1) {
	            e[_s10] && a.append(e[_s10]);
	          } else a.append(e);
	          i.loop && t.loopCreate(), i.observer && t.support.observer || t.update();
	        },
	        prependSlide: function prependSlide(e) {
	          var t = this,
	              a = t.params,
	              i = t.$wrapperEl,
	              s = t.activeIndex;
	          a.loop && t.loopDestroy();
	          var r = s + 1;

	          if ('object' == _typeof$1(e) && 'length' in e) {
	            for (var _n12 = 0; _n12 < e.length; _n12 += 1) {
	              e[_n12] && i.prepend(e[_n12]);
	            }

	            r = s + e.length;
	          } else i.prepend(e);

	          a.loop && t.loopCreate(), a.observer && t.support.observer || t.update(), t.slideTo(r, 0, !1);
	        },
	        addSlide: function addSlide(e, t) {
	          var a = this,
	              i = a.$wrapperEl,
	              s = a.params,
	              r = a.activeIndex;
	          s.loop && (r -= a.loopedSlides, a.loopDestroy(), a.slides = i.children('.' + s.slideClass));
	          var n = a.slides.length;
	          if (e <= 0) a.prependSlide(t);else if (e >= n) a.appendSlide(t);else {
	            for (var l = r > e ? r + 1 : r, o = [], d = n - 1; d >= e; d -= 1) {
	              var _p10 = a.slides.eq(d);

	              _p10.remove(), o.unshift(_p10);
	            }

	            if ('object' == _typeof$1(t) && 'length' in t) {
	              for (var _u9 = 0; _u9 < t.length; _u9 += 1) {
	                t[_u9] && i.append(t[_u9]);
	              }

	              l = r > e ? r + t.length : r;
	            } else i.append(t);

	            for (var _c9 = 0; _c9 < o.length; _c9 += 1) {
	              i.append(o[_c9]);
	            }

	            s.loop && a.loopCreate(), s.observer && a.support.observer || a.update(), s.loop ? a.slideTo(l + a.loopedSlides, 0, !1) : a.slideTo(l, 0, !1);
	          }
	        },
	        removeSlide: function removeSlide(e) {
	          var t = this,
	              a = t.params,
	              i = t.$wrapperEl,
	              s = t.activeIndex;
	          a.loop && (s -= t.loopedSlides, t.loopDestroy(), t.slides = i.children('.' + a.slideClass));
	          var r,
	              n = s;

	          if ('object' == _typeof$1(e) && 'length' in e) {
	            for (var _l6 = 0; _l6 < e.length; _l6 += 1) {
	              r = e[_l6], t.slides[r] && t.slides.eq(r).remove(), r < n && (n -= 1);
	            }

	            n = Math.max(n, 0);
	          } else r = e, t.slides[r] && t.slides.eq(r).remove(), r < n && (n -= 1), n = Math.max(n, 0);

	          a.loop && t.loopCreate(), a.observer && t.support.observer || t.update(), a.loop ? t.slideTo(n + t.loopedSlides, 0, !1) : t.slideTo(n, 0, !1);
	        },
	        removeAllSlides: function removeAllSlides() {
	          for (var e = [], t = 0; t < this.slides.length; t += 1) {
	            e.push(t);
	          }

	          this.removeSlide(e);
	        }
	      },
	      events: {
	        attachEvents: function attachEvents() {
	          var e = this,
	              t = r(),
	              a = e.params,
	              i = e.touchEvents,
	              s = e.el,
	              n = e.wrapperEl,
	              l = e.device,
	              o = e.support;
	          e.onTouchStart = N.bind(e), e.onTouchMove = G.bind(e), e.onTouchEnd = B.bind(e), a.cssMode && (e.onScroll = X.bind(e)), e.onClick = R.bind(e);
	          var d = !!a.nested;
	          if (!o.touch && o.pointerEvents) s.addEventListener(i.start, e.onTouchStart, !1), t.addEventListener(i.move, e.onTouchMove, d), t.addEventListener(i.end, e.onTouchEnd, !1);else {
	            if (o.touch) {
	              var _p11 = !('touchstart' !== i.start || !o.passiveListener || !a.passiveListeners) && {
	                passive: !0,
	                capture: !1
	              };

	              s.addEventListener(i.start, e.onTouchStart, _p11), s.addEventListener(i.move, e.onTouchMove, o.passiveListener ? {
	                passive: !1,
	                capture: d
	              } : d), s.addEventListener(i.end, e.onTouchEnd, _p11), i.cancel && s.addEventListener(i.cancel, e.onTouchEnd, _p11), Y || (t.addEventListener('touchstart', V), Y = !0);
	            }

	            (a.simulateTouch && !l.ios && !l.android || a.simulateTouch && !o.touch && l.ios) && (s.addEventListener('mousedown', e.onTouchStart, !1), t.addEventListener('mousemove', e.onTouchMove, d), t.addEventListener('mouseup', e.onTouchEnd, !1));
	          }
	          (a.preventClicks || a.preventClicksPropagation) && s.addEventListener('click', e.onClick, !0), a.cssMode && n.addEventListener('scroll', e.onScroll), a.updateOnWindowResize ? e.on(l.ios || l.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', H, !0) : e.on('observerUpdate', H, !0);
	        },
	        detachEvents: function detachEvents() {
	          var e = this,
	              t = r(),
	              a = e.params,
	              i = e.touchEvents,
	              s = e.el,
	              n = e.wrapperEl,
	              l = e.device,
	              o = e.support,
	              d = !!a.nested;
	          if (!o.touch && o.pointerEvents) s.removeEventListener(i.start, e.onTouchStart, !1), t.removeEventListener(i.move, e.onTouchMove, d), t.removeEventListener(i.end, e.onTouchEnd, !1);else {
	            if (o.touch) {
	              var _p12 = !('onTouchStart' !== i.start || !o.passiveListener || !a.passiveListeners) && {
	                passive: !0,
	                capture: !1
	              };

	              s.removeEventListener(i.start, e.onTouchStart, _p12), s.removeEventListener(i.move, e.onTouchMove, d), s.removeEventListener(i.end, e.onTouchEnd, _p12), i.cancel && s.removeEventListener(i.cancel, e.onTouchEnd, _p12);
	            }

	            (a.simulateTouch && !l.ios && !l.android || a.simulateTouch && !o.touch && l.ios) && (s.removeEventListener('mousedown', e.onTouchStart, !1), t.removeEventListener('mousemove', e.onTouchMove, d), t.removeEventListener('mouseup', e.onTouchEnd, !1));
	          }
	          (a.preventClicks || a.preventClicksPropagation) && s.removeEventListener('click', e.onClick, !0), a.cssMode && n.removeEventListener('scroll', e.onScroll), e.off(l.ios || l.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', H);
	        }
	      },
	      breakpoints: {
	        setBreakpoint: function setBreakpoint() {
	          var e = this,
	              t = e.activeIndex,
	              a = e.initialized,
	              i = e.loopedSlides,
	              s = void 0 === i ? 0 : i,
	              r = e.params,
	              n = e.$el,
	              l = r.breakpoints;

	          if (l && (!l || 0 !== Object.keys(l).length)) {
	            var _o10 = e.getBreakpoint(l, e.params.breakpointsBase, e.el);

	            if (_o10 && e.currentBreakpoint !== _o10) {
	              var _d10 = _o10 in l ? l[_o10] : void 0;

	              _d10 && ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (e) {
	                var t = _d10[e];
	                void 0 !== t && (_d10[e] = 'slidesPerView' !== e || 'AUTO' !== t && 'auto' !== t ? 'slidesPerView' === e ? parseFloat(t) : parseInt(t, 10) : 'auto');
	              });

	              var _p13 = _d10 || e.originalParams,
	                  _u10 = r.slidesPerColumn > 1,
	                  _c10 = _p13.slidesPerColumn > 1,
	                  _h7 = r.enabled;

	              _u10 && !_c10 ? (n.removeClass(r.containerModifierClass + 'multirow ' + r.containerModifierClass + 'multirow-column'), e.emitContainerClasses()) : !_u10 && _c10 && (n.addClass(r.containerModifierClass + 'multirow'), (_p13.slidesPerColumnFill && 'column' === _p13.slidesPerColumnFill || !_p13.slidesPerColumnFill && 'column' === r.slidesPerColumnFill) && n.addClass(r.containerModifierClass + 'multirow-column'), e.emitContainerClasses());

	              var _v6 = _p13.direction && _p13.direction !== r.direction,
	                  _f4 = r.loop && (_p13.slidesPerView !== r.slidesPerView || _v6);

	              _v6 && a && e.changeDirection(), M(e.params, _p13);
	              var _m2 = e.params.enabled;
	              M(e, {
	                allowTouchMove: e.params.allowTouchMove,
	                allowSlideNext: e.params.allowSlideNext,
	                allowSlidePrev: e.params.allowSlidePrev
	              }), _h7 && !_m2 ? e.disable() : !_h7 && _m2 && e.enable(), e.currentBreakpoint = _o10, e.emit('_beforeBreakpoint', _p13), _f4 && a && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - s + e.loopedSlides, 0, !1)), e.emit('breakpoint', _p13);
	            }
	          }
	        },
	        getBreakpoint: function getBreakpoint(e, t, a) {
	          if (void 0 === t && (t = 'window'), e && ('container' !== t || a)) {
	            var _i15 = !1,
	                _s11 = l(),
	                _r7 = 'window' === t ? _s11.innerHeight : a.clientHeight,
	                _n13 = Object.keys(e).map(function (e) {
	              if ('string' == typeof e && 0 === e.indexOf('@')) {
	                var _t14 = parseFloat(e.substr(1));

	                return {
	                  value: _r7 * _t14,
	                  point: e
	                };
	              }

	              return {
	                value: e,
	                point: e
	              };
	            });

	            _n13.sort(function (e, t) {
	              return parseInt(e.value, 10) - parseInt(t.value, 10);
	            });

	            for (var _o11 = 0; _o11 < _n13.length; _o11 += 1) {
	              var _d11 = _n13[_o11],
	                  _p14 = _d11.point,
	                  _u11 = _d11.value;
	              'window' === t ? _s11.matchMedia('(min-width: ' + _u11 + 'px)').matches && (_i15 = _p14) : _u11 <= a.clientWidth && (_i15 = _p14);
	            }

	            return _i15 || 'max';
	          }
	        }
	      },
	      checkOverflow: {
	        checkOverflow: function checkOverflow() {
	          var e = this,
	              t = e.params,
	              a = e.isLocked,
	              i = e.slides.length > 0 && t.slidesOffsetBefore + t.spaceBetween * (e.slides.length - 1) + e.slides[0].offsetWidth * e.slides.length;
	          t.slidesOffsetBefore && t.slidesOffsetAfter && i ? e.isLocked = i <= e.size : e.isLocked = 1 === e.snapGrid.length, e.allowSlideNext = !e.isLocked, e.allowSlidePrev = !e.isLocked, a !== e.isLocked && e.emit(e.isLocked ? 'lock' : 'unlock'), a && a !== e.isLocked && (e.isEnd = !1, e.navigation && e.navigation.update());
	        }
	      },
	      classes: {
	        addClasses: function addClasses() {
	          var e,
	              t,
	              a,
	              i = this,
	              s = i.classNames,
	              r = i.params,
	              n = i.rtl,
	              l = i.$el,
	              o = i.device,
	              d = i.support,
	              p = (e = ['initialized', r.direction, {
	            'pointer-events': d.pointerEvents && !d.touch
	          }, {
	            'free-mode': r.freeMode
	          }, {
	            autoheight: r.autoHeight
	          }, {
	            rtl: n
	          }, {
	            multirow: r.slidesPerColumn > 1
	          }, {
	            'multirow-column': r.slidesPerColumn > 1 && 'column' === r.slidesPerColumnFill
	          }, {
	            android: o.android
	          }, {
	            ios: o.ios
	          }, {
	            'css-mode': r.cssMode
	          }], t = r.containerModifierClass, a = [], e.forEach(function (e) {
	            'object' == _typeof$1(e) ? Object.keys(e).forEach(function (i) {
	              e[i] && a.push(t + i);
	            }) : 'string' == typeof e && a.push(t + e);
	          }), a);
	          s.push.apply(s, p), l.addClass([].concat(s).join(' ')), i.emitContainerClasses();
	        },
	        removeClasses: function removeClasses() {
	          var e = this,
	              t = e.$el,
	              a = e.classNames;
	          t.removeClass(a.join(' ')), e.emitContainerClasses();
	        }
	      },
	      images: {
	        loadImage: function loadImage(e, t, a, i, s, r) {
	          var n,
	              o = l();

	          function d() {
	            r && r();
	          }

	          m(e).parent('picture')[0] || e.complete && s ? d() : t ? ((n = new o.Image()).onload = d, n.onerror = d, i && (n.sizes = i), a && (n.srcset = a), t && (n.src = t)) : d();
	        },
	        preloadImages: function preloadImages() {
	          var e = this;

	          function t() {
	            null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit('imagesReady')));
	          }

	          e.imagesToLoad = e.$el.find('img');

	          for (var _a11 = 0; _a11 < e.imagesToLoad.length; _a11 += 1) {
	            var _i16 = e.imagesToLoad[_a11];
	            e.loadImage(_i16, _i16.currentSrc || _i16.getAttribute('src'), _i16.srcset || _i16.getAttribute('srcset'), _i16.sizes || _i16.getAttribute('sizes'), !0, t);
	          }
	        }
	      }
	    },
	        _ = {},
	        q = function () {
	      function t() {
	        for (var e, a, i = arguments.length, s = new Array(i), r = 0; r < i; r++) {
	          s[r] = arguments[r];
	        }

	        if (1 === s.length && s[0].constructor && 'Object' === Object.prototype.toString.call(s[0]).slice(8, -1) ? a = s[0] : (e = s[0], a = s[1]), a || (a = {}), a = M({}, a), e && !a.el && (a.el = e), a.el && m(a.el).length > 1) {
	          var _n14 = [];
	          return m(a.el).each(function (e) {
	            var i = M({}, a, {
	              el: e
	            });

	            _n14.push(new t(i));
	          }), _n14;
	        }

	        var l = this;
	        l.__swiper__ = !0, l.support = $(), l.device = L({
	          userAgent: a.userAgent
	        }), l.browser = I(), l.eventsListeners = {}, l.eventsAnyListeners = [], void 0 === l.modules && (l.modules = {}), Object.keys(l.modules).forEach(function (e) {
	          var t = l.modules[e];

	          if (t.params) {
	            var _i17 = Object.keys(t.params)[0],
	                _s12 = t.params[_i17];
	            if ('object' != _typeof$1(_s12) || null === _s12) return;
	            if (['navigation', 'pagination', 'scrollbar'].indexOf(_i17) >= 0 && !0 === a[_i17] && (a[_i17] = {
	              auto: !0
	            }), !(_i17 in a) || !('enabled' in _s12)) return;
	            !0 === a[_i17] && (a[_i17] = {
	              enabled: !0
	            }), 'object' != _typeof$1(a[_i17]) || 'enabled' in a[_i17] || (a[_i17].enabled = !0), a[_i17] || (a[_i17] = {
	              enabled: !1
	            });
	          }
	        });
	        var o,
	            d,
	            p = M({}, W);
	        return l.useParams(p), l.params = M({}, p, _, a), l.originalParams = M({}, l.params), l.passedParams = M({}, a), l.params && l.params.on && Object.keys(l.params.on).forEach(function (e) {
	          l.on(e, l.params.on[e]);
	        }), l.params && l.params.onAny && l.onAny(l.params.onAny), l.$ = m, M(l, {
	          enabled: l.params.enabled,
	          el: e,
	          classNames: [],
	          slides: m(),
	          slidesGrid: [],
	          snapGrid: [],
	          slidesSizesGrid: [],
	          isHorizontal: function isHorizontal() {
	            return 'horizontal' === l.params.direction;
	          },
	          isVertical: function isVertical() {
	            return 'vertical' === l.params.direction;
	          },
	          activeIndex: 0,
	          realIndex: 0,
	          isBeginning: !0,
	          isEnd: !1,
	          translate: 0,
	          previousTranslate: 0,
	          progress: 0,
	          velocity: 0,
	          animating: !1,
	          allowSlideNext: l.params.allowSlideNext,
	          allowSlidePrev: l.params.allowSlidePrev,
	          touchEvents: (o = ['touchstart', 'touchmove', 'touchend', 'touchcancel'], d = ['mousedown', 'mousemove', 'mouseup'], l.support.pointerEvents && (d = ['pointerdown', 'pointermove', 'pointerup']), l.touchEventsTouch = {
	            start: o[0],
	            move: o[1],
	            end: o[2],
	            cancel: o[3]
	          }, l.touchEventsDesktop = {
	            start: d[0],
	            move: d[1],
	            end: d[2]
	          }, l.support.touch || !l.params.simulateTouch ? l.touchEventsTouch : l.touchEventsDesktop),
	          touchEventsData: {
	            isTouched: void 0,
	            isMoved: void 0,
	            allowTouchCallbacks: void 0,
	            touchStartTime: void 0,
	            isScrolling: void 0,
	            currentTranslate: void 0,
	            startTranslate: void 0,
	            allowThresholdMove: void 0,
	            focusableElements: l.params.focusableElements,
	            lastClickTime: x(),
	            clickTimeout: void 0,
	            velocities: [],
	            allowMomentumBounce: void 0,
	            isTouchEvent: void 0,
	            startMoving: void 0
	          },
	          allowClick: !0,
	          allowTouchMove: l.params.allowTouchMove,
	          touches: {
	            startX: 0,
	            startY: 0,
	            currentX: 0,
	            currentY: 0,
	            diff: 0
	          },
	          imagesToLoad: [],
	          imagesLoaded: 0
	        }), l.useModules(), l.emit('_swiper'), l.params.init && l.init(), l;
	      }

	      var a,
	          i,
	          s,
	          n = t.prototype;
	      return n.enable = function () {
	        var e = this;
	        e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit('enable'));
	      }, n.disable = function () {
	        var e = this;
	        e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit('disable'));
	      }, n.setProgress = function (e, t) {
	        var a = this;
	        e = Math.min(Math.max(e, 0), 1);
	        var i = a.minTranslate(),
	            s = (a.maxTranslate() - i) * e + i;
	        a.translateTo(s, void 0 === t ? 0 : t), a.updateActiveIndex(), a.updateSlidesClasses();
	      }, n.emitContainerClasses = function () {
	        var e = this;

	        if (e.params._emitClasses && e.el) {
	          var _t15 = e.el.className.split(' ').filter(function (t) {
	            return 0 === t.indexOf('swiper-container') || 0 === t.indexOf(e.params.containerModifierClass);
	          });

	          e.emit('_containerClasses', _t15.join(' '));
	        }
	      }, n.getSlideClasses = function (e) {
	        var t = this;
	        return e.className.split(' ').filter(function (e) {
	          return 0 === e.indexOf('swiper-slide') || 0 === e.indexOf(t.params.slideClass);
	        }).join(' ');
	      }, n.emitSlidesClasses = function () {
	        var e = this;

	        if (e.params._emitClasses && e.el) {
	          var _t16 = [];
	          e.slides.each(function (a) {
	            var i = e.getSlideClasses(a);
	            _t16.push({
	              slideEl: a,
	              classNames: i
	            }), e.emit('_slideClass', a, i);
	          }), e.emit('_slideClasses', _t16);
	        }
	      }, n.slidesPerViewDynamic = function () {
	        var e = this,
	            t = e.params,
	            a = e.slides,
	            i = e.slidesGrid,
	            s = e.size,
	            r = e.activeIndex,
	            n = 1;

	        if (t.centeredSlides) {
	          for (var l, o = a[r].swiperSlideSize, d = r + 1; d < a.length; d += 1) {
	            a[d] && !l && (n += 1, (o += a[d].swiperSlideSize) > s && (l = !0));
	          }

	          for (var _p15 = r - 1; _p15 >= 0; _p15 -= 1) {
	            a[_p15] && !l && (n += 1, (o += a[_p15].swiperSlideSize) > s && (l = !0));
	          }
	        } else for (var _u12 = r + 1; _u12 < a.length; _u12 += 1) {
	          i[_u12] - i[r] < s && (n += 1);
	        }

	        return n;
	      }, n.update = function () {
	        var e = this;

	        if (e && !e.destroyed) {
	          var _t17 = e.snapGrid,
	              _a12 = e.params;
	          _a12.breakpoints && e.setBreakpoint(), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.params.freeMode ? (i(), e.params.autoHeight && e.updateAutoHeight()) : (('auto' === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)) || i(), _a12.watchOverflow && _t17 !== e.snapGrid && e.checkOverflow(), e.emit('update');
	        }

	        function i() {
	          var t = e.rtlTranslate ? -1 * e.translate : e.translate,
	              a = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
	          e.setTranslate(a), e.updateActiveIndex(), e.updateSlidesClasses();
	        }
	      }, n.changeDirection = function (e, t) {
	        void 0 === t && (t = !0);
	        var a = this,
	            i = a.params.direction;
	        return e || (e = 'horizontal' === i ? 'vertical' : 'horizontal'), e === i || 'horizontal' !== e && 'vertical' !== e || (a.$el.removeClass('' + a.params.containerModifierClass + i).addClass('' + a.params.containerModifierClass + e), a.emitContainerClasses(), a.params.direction = e, a.slides.each(function (t) {
	          'vertical' === e ? t.style.width = '' : t.style.height = '';
	        }), a.emit('changeDirection'), t && a.update()), a;
	      }, n.mount = function (e) {
	        var t = this;
	        if (t.mounted) return !0;
	        var a = m(e || t.params.el);
	        if (!(e = a[0])) return !1;
	        e.swiper = t;

	        var i = function i() {
	          return '.' + (t.params.wrapperClass || '').trim().split(' ').join('.');
	        },
	            s = function () {
	          if (e && e.shadowRoot && e.shadowRoot.querySelector) {
	            var _t18 = m(e.shadowRoot.querySelector(i()));

	            return _t18.children = function (e) {
	              return a.children(e);
	            }, _t18;
	          }

	          return a.children(i());
	        }();

	        if (0 === s.length && t.params.createElements) {
	          var _n15 = r().createElement('div');

	          s = m(_n15), _n15.className = t.params.wrapperClass, a.append(_n15), a.children('.' + t.params.slideClass).each(function (e) {
	            s.append(e);
	          });
	        }

	        return M(t, {
	          $el: a,
	          el: e,
	          $wrapperEl: s,
	          wrapperEl: s[0],
	          mounted: !0,
	          rtl: 'rtl' === e.dir.toLowerCase() || 'rtl' === a.css('direction'),
	          rtlTranslate: 'horizontal' === t.params.direction && ('rtl' === e.dir.toLowerCase() || 'rtl' === a.css('direction')),
	          wrongRTL: '-webkit-box' === s.css('display')
	        }), !0;
	      }, n.init = function (e) {
	        var t = this;
	        return t.initialized || !1 === t.mount(e) || (t.emit('beforeInit'), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.params.loop && t.loopCreate(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.preloadImages && t.preloadImages(), t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.attachEvents(), t.initialized = !0, t.emit('init'), t.emit('afterInit')), t;
	      }, n.destroy = function (e, t) {
	        void 0 === e && (e = !0), void 0 === t && (t = !0);
	        var a,
	            i = this,
	            s = i.params,
	            r = i.$el,
	            n = i.$wrapperEl,
	            l = i.slides;
	        return void 0 === i.params || i.destroyed || (i.emit('beforeDestroy'), i.initialized = !1, i.detachEvents(), s.loop && i.loopDestroy(), t && (i.removeClasses(), r.removeAttr('style'), n.removeAttr('style'), l && l.length && l.removeClass([s.slideVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index')), i.emit('destroy'), Object.keys(i.eventsListeners).forEach(function (e) {
	          i.off(e);
	        }), !1 !== e && (i.$el[0].swiper = null, a = i, Object.keys(a).forEach(function (e) {
	          try {
	            a[e] = null;
	          } catch (e) {}

	          try {
	            delete a[e];
	          } catch (e) {}
	        })), i.destroyed = !0), null;
	      }, t.extendDefaults = function (e) {
	        M(_, e);
	      }, t.installModule = function (e) {
	        t.prototype.modules || (t.prototype.modules = {});
	        var a = e.name || Object.keys(t.prototype.modules).length + '_' + x();
	        t.prototype.modules[a] = e;
	      }, t.use = function (e) {
	        return Array.isArray(e) ? (e.forEach(function (e) {
	          return t.installModule(e);
	        }), t) : (t.installModule(e), t);
	      }, a = t, s = [{
	        key: 'extendedDefaults',
	        get: function get() {
	          return _;
	        }
	      }, {
	        key: 'defaults',
	        get: function get() {
	          return W;
	        }
	      }], (i = null) && e(a.prototype, i), s && e(a, s), t;
	    }();

	    Object.keys(F).forEach(function (e) {
	      Object.keys(F[e]).forEach(function (t) {
	        q.prototype[t] = F[e][t];
	      });
	    }), q.use([O, D]);
	    var j = {
	      update: function update(e) {
	        var t = this,
	            a = t.params,
	            i = a.slidesPerView,
	            s = a.slidesPerGroup,
	            r = a.centeredSlides,
	            n = t.params.virtual,
	            l = n.addSlidesBefore,
	            o = n.addSlidesAfter,
	            d = t.virtual,
	            p = d.from,
	            u = d.to,
	            c = d.slides,
	            h = d.slidesGrid,
	            v = d.renderSlide,
	            f = d.offset;
	        t.updateActiveIndex();
	        var m,
	            g,
	            b,
	            w = t.activeIndex || 0;
	        m = t.rtlTranslate ? 'right' : t.isHorizontal() ? 'left' : 'top', r ? (g = Math.floor(i / 2) + s + o, b = Math.floor(i / 2) + s + l) : (g = i + (s - 1) + o, b = s + l);
	        var y = Math.max((w || 0) - b, 0),
	            E = Math.min((w || 0) + g, c.length - 1),
	            x = (t.slidesGrid[y] || 0) - (t.slidesGrid[0] || 0);

	        function T() {
	          t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.lazy && t.params.lazy.enabled && t.lazy.load();
	        }

	        if (M(t.virtual, {
	          from: y,
	          to: E,
	          offset: x,
	          slidesGrid: t.slidesGrid
	        }), p === y && u === E && !e) return t.slidesGrid !== h && x !== f && t.slides.css(m, x + 'px'), void t.updateProgress();
	        if (t.params.virtual.renderExternal) return t.params.virtual.renderExternal.call(t, {
	          offset: x,
	          from: y,
	          to: E,
	          slides: function () {
	            for (var e = [], t = y; t <= E; t += 1) {
	              e.push(c[t]);
	            }

	            return e;
	          }()
	        }), void (t.params.virtual.renderExternalUpdate && T());
	        var C = [],
	            S = [];
	        if (e) t.$wrapperEl.find('.' + t.params.slideClass).remove();else for (var _z = p; _z <= u; _z += 1) {
	          (_z < y || _z > E) && t.$wrapperEl.find('.' + t.params.slideClass + '[data-swiper-slide-index="' + _z + '"]').remove();
	        }

	        for (var _P2 = 0; _P2 < c.length; _P2 += 1) {
	          _P2 >= y && _P2 <= E && (void 0 === u || e ? S.push(_P2) : (_P2 > u && S.push(_P2), _P2 < p && C.push(_P2)));
	        }

	        S.forEach(function (e) {
	          t.$wrapperEl.append(v(c[e], e));
	        }), C.sort(function (e, t) {
	          return t - e;
	        }).forEach(function (e) {
	          t.$wrapperEl.prepend(v(c[e], e));
	        }), t.$wrapperEl.children('.swiper-slide').css(m, x + 'px'), T();
	      },
	      renderSlide: function renderSlide(e, t) {
	        var a = this,
	            i = a.params.virtual;
	        if (i.cache && a.virtual.cache[t]) return a.virtual.cache[t];
	        var s = i.renderSlide ? m(i.renderSlide.call(a, e, t)) : m('<div class="' + a.params.slideClass + '" data-swiper-slide-index="' + t + '">' + e + '</div>');
	        return s.attr('data-swiper-slide-index') || s.attr('data-swiper-slide-index', t), i.cache && (a.virtual.cache[t] = s), s;
	      },
	      appendSlide: function appendSlide(e) {
	        var t = this;
	        if ('object' == _typeof$1(e) && 'length' in e) for (var _a13 = 0; _a13 < e.length; _a13 += 1) {
	          e[_a13] && t.virtual.slides.push(e[_a13]);
	        } else t.virtual.slides.push(e);
	        t.virtual.update(!0);
	      },
	      prependSlide: function prependSlide(e) {
	        var t = this,
	            a = t.activeIndex,
	            i = a + 1,
	            s = 1;

	        if (Array.isArray(e)) {
	          for (var _r8 = 0; _r8 < e.length; _r8 += 1) {
	            e[_r8] && t.virtual.slides.unshift(e[_r8]);
	          }

	          i = a + e.length, s = e.length;
	        } else t.virtual.slides.unshift(e);

	        if (t.params.virtual.cache) {
	          var _n16 = t.virtual.cache,
	              _l7 = {};
	          Object.keys(_n16).forEach(function (e) {
	            var t = _n16[e],
	                a = t.attr('data-swiper-slide-index');
	            a && t.attr('data-swiper-slide-index', parseInt(a, 10) + 1), _l7[parseInt(e, 10) + s] = t;
	          }), t.virtual.cache = _l7;
	        }

	        t.virtual.update(!0), t.slideTo(i, 0);
	      },
	      removeSlide: function removeSlide(e) {
	        var t = this;

	        if (null != e) {
	          var _a14 = t.activeIndex;
	          if (Array.isArray(e)) for (var _i18 = e.length - 1; _i18 >= 0; _i18 -= 1) {
	            t.virtual.slides.splice(e[_i18], 1), t.params.virtual.cache && delete t.virtual.cache[e[_i18]], e[_i18] < _a14 && (_a14 -= 1), _a14 = Math.max(_a14, 0);
	          } else t.virtual.slides.splice(e, 1), t.params.virtual.cache && delete t.virtual.cache[e], e < _a14 && (_a14 -= 1), _a14 = Math.max(_a14, 0);
	          t.virtual.update(!0), t.slideTo(_a14, 0);
	        }
	      },
	      removeAllSlides: function removeAllSlides() {
	        var e = this;
	        e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), e.virtual.update(!0), e.slideTo(0, 0);
	      }
	    },
	        U = {
	      name: 'virtual',
	      params: {
	        virtual: {
	          enabled: !1,
	          slides: [],
	          cache: !0,
	          renderSlide: null,
	          renderExternal: null,
	          renderExternalUpdate: !0,
	          addSlidesBefore: 0,
	          addSlidesAfter: 0
	        }
	      },
	      create: function create() {
	        z(this, {
	          virtual: t({}, j, {
	            slides: this.params.virtual.slides,
	            cache: {}
	          })
	        });
	      },
	      on: {
	        beforeInit: function beforeInit(e) {
	          if (e.params.virtual.enabled) {
	            e.classNames.push(e.params.containerModifierClass + 'virtual');
	            var _t19 = {
	              watchSlidesProgress: !0
	            };
	            M(e.params, _t19), M(e.originalParams, _t19), e.params.initialSlide || e.virtual.update();
	          }
	        },
	        setTranslate: function setTranslate(e) {
	          e.params.virtual.enabled && e.virtual.update();
	        }
	      }
	    },
	        K = {
	      handle: function handle(e) {
	        var t = this;

	        if (t.enabled) {
	          var _a15 = l(),
	              _i19 = r(),
	              _s13 = t.rtlTranslate,
	              _n17 = e;

	          _n17.originalEvent && (_n17 = _n17.originalEvent);

	          var _o12 = _n17.keyCode || _n17.charCode,
	              _d12 = t.params.keyboard.pageUpDown,
	              _p16 = _d12 && 33 === _o12,
	              _u13 = _d12 && 34 === _o12,
	              _c11 = 37 === _o12,
	              _h8 = 39 === _o12,
	              _v7 = 38 === _o12,
	              _f5 = 40 === _o12;

	          if (!t.allowSlideNext && (t.isHorizontal() && _h8 || t.isVertical() && _f5 || _u13)) return !1;
	          if (!t.allowSlidePrev && (t.isHorizontal() && _c11 || t.isVertical() && _v7 || _p16)) return !1;

	          if (!(_n17.shiftKey || _n17.altKey || _n17.ctrlKey || _n17.metaKey || _i19.activeElement && _i19.activeElement.nodeName && ('input' === _i19.activeElement.nodeName.toLowerCase() || 'textarea' === _i19.activeElement.nodeName.toLowerCase()))) {
	            if (t.params.keyboard.onlyInViewport && (_p16 || _u13 || _c11 || _h8 || _v7 || _f5)) {
	              var _m3 = !1;

	              if (t.$el.parents('.' + t.params.slideClass).length > 0 && 0 === t.$el.parents('.' + t.params.slideActiveClass).length) return;

	              var _g4 = t.$el,
	                  _b4 = _g4[0].clientWidth,
	                  _w3 = _g4[0].clientHeight,
	                  _y3 = _a15.innerWidth,
	                  _E2 = _a15.innerHeight,
	                  _x2 = t.$el.offset();

	              _s13 && (_x2.left -= t.$el[0].scrollLeft);

	              for (var _T4 = [[_x2.left, _x2.top], [_x2.left + _b4, _x2.top], [_x2.left, _x2.top + _w3], [_x2.left + _b4, _x2.top + _w3]], _C4 = 0; _C4 < _T4.length; _C4 += 1) {
	                var _S3 = _T4[_C4];

	                if (_S3[0] >= 0 && _S3[0] <= _y3 && _S3[1] >= 0 && _S3[1] <= _E2) {
	                  if (0 === _S3[0] && 0 === _S3[1]) continue;
	                  _m3 = !0;
	                }
	              }

	              if (!_m3) return;
	            }

	            t.isHorizontal() ? ((_p16 || _u13 || _c11 || _h8) && (_n17.preventDefault ? _n17.preventDefault() : _n17.returnValue = !1), ((_u13 || _h8) && !_s13 || (_p16 || _c11) && _s13) && t.slideNext(), ((_p16 || _c11) && !_s13 || (_u13 || _h8) && _s13) && t.slidePrev()) : ((_p16 || _u13 || _v7 || _f5) && (_n17.preventDefault ? _n17.preventDefault() : _n17.returnValue = !1), (_u13 || _f5) && t.slideNext(), (_p16 || _v7) && t.slidePrev()), t.emit('keyPress', _o12);
	          }
	        }
	      },
	      enable: function enable() {
	        var e = this,
	            t = r();
	        e.keyboard.enabled || (m(t).on('keydown', e.keyboard.handle), e.keyboard.enabled = !0);
	      },
	      disable: function disable() {
	        var e = this,
	            t = r();
	        e.keyboard.enabled && (m(t).off('keydown', e.keyboard.handle), e.keyboard.enabled = !1);
	      }
	    },
	        Z = {
	      name: 'keyboard',
	      params: {
	        keyboard: {
	          enabled: !1,
	          onlyInViewport: !0,
	          pageUpDown: !0
	        }
	      },
	      create: function create() {
	        z(this, {
	          keyboard: t({
	            enabled: !1
	          }, K)
	        });
	      },
	      on: {
	        init: function init(e) {
	          e.params.keyboard.enabled && e.keyboard.enable();
	        },
	        destroy: function destroy(e) {
	          e.keyboard.enabled && e.keyboard.disable();
	        }
	      }
	    };
	    var J = {
	      lastScrollTime: x(),
	      lastEventBeforeSnap: void 0,
	      recentWheelEvents: [],
	      event: function event() {
	        return l().navigator.userAgent.indexOf('firefox') > -1 ? 'DOMMouseScroll' : function () {
	          var e = r(),
	              t = 'onwheel',
	              a = (t in e);

	          if (!a) {
	            var _i20 = e.createElement('div');

	            _i20.setAttribute(t, 'return;'), a = 'function' == typeof _i20.onwheel;
	          }

	          return !a && e.implementation && e.implementation.hasFeature && !0 !== e.implementation.hasFeature('', '') && (a = e.implementation.hasFeature('Events.wheel', '3.0')), a;
	        }() ? 'wheel' : 'mousewheel';
	      },
	      normalize: function normalize(e) {
	        var t = 0,
	            a = 0,
	            i = 0,
	            s = 0;
	        return 'detail' in e && (a = e.detail), 'wheelDelta' in e && (a = -e.wheelDelta / 120), 'wheelDeltaY' in e && (a = -e.wheelDeltaY / 120), 'wheelDeltaX' in e && (t = -e.wheelDeltaX / 120), 'axis' in e && e.axis === e.HORIZONTAL_AXIS && (t = a, a = 0), i = 10 * t, s = 10 * a, 'deltaY' in e && (s = e.deltaY), 'deltaX' in e && (i = e.deltaX), e.shiftKey && !i && (i = s, s = 0), (i || s) && e.deltaMode && (1 === e.deltaMode ? (i *= 40, s *= 40) : (i *= 800, s *= 800)), i && !t && (t = i < 1 ? -1 : 1), s && !a && (a = s < 1 ? -1 : 1), {
	          spinX: t,
	          spinY: a,
	          pixelX: i,
	          pixelY: s
	        };
	      },
	      handleMouseEnter: function handleMouseEnter() {
	        this.enabled && (this.mouseEntered = !0);
	      },
	      handleMouseLeave: function handleMouseLeave() {
	        this.enabled && (this.mouseEntered = !1);
	      },
	      handle: function handle(e) {
	        var t = e,
	            a = this;

	        if (a.enabled) {
	          var _i21 = a.params.mousewheel;
	          a.params.cssMode && t.preventDefault();
	          var _s14 = a.$el;
	          if ('container' !== a.params.mousewheel.eventsTarget && (_s14 = m(a.params.mousewheel.eventsTarget)), !a.mouseEntered && !_s14[0].contains(t.target) && !_i21.releaseOnEdges) return !0;
	          t.originalEvent && (t = t.originalEvent);

	          var _r9 = 0,
	              _n18 = a.rtlTranslate ? -1 : 1,
	              _l8 = J.normalize(t);

	          if (_i21.forceToAxis) {
	            if (a.isHorizontal()) {
	              if (!(Math.abs(_l8.pixelX) > Math.abs(_l8.pixelY))) return !0;
	              _r9 = -_l8.pixelX * _n18;
	            } else {
	              if (!(Math.abs(_l8.pixelY) > Math.abs(_l8.pixelX))) return !0;
	              _r9 = -_l8.pixelY;
	            }
	          } else _r9 = Math.abs(_l8.pixelX) > Math.abs(_l8.pixelY) ? -_l8.pixelX * _n18 : -_l8.pixelY;
	          if (0 === _r9) return !0;
	          _i21.invert && (_r9 = -_r9);

	          var _o13 = a.getTranslate() + _r9 * _i21.sensitivity;

	          if (_o13 >= a.minTranslate() && (_o13 = a.minTranslate()), _o13 <= a.maxTranslate() && (_o13 = a.maxTranslate()), (!!a.params.loop || !(_o13 === a.minTranslate() || _o13 === a.maxTranslate())) && a.params.nested && t.stopPropagation(), a.params.freeMode) {
	            var _d13 = {
	              time: x(),
	              delta: Math.abs(_r9),
	              direction: Math.sign(_r9)
	            },
	                _p17 = a.mousewheel.lastEventBeforeSnap,
	                _u14 = _p17 && _d13.time < _p17.time + 500 && _d13.delta <= _p17.delta && _d13.direction === _p17.direction;

	            if (!_u14) {
	              a.mousewheel.lastEventBeforeSnap = void 0, a.params.loop && a.loopFix();

	              var _c12 = a.getTranslate() + _r9 * _i21.sensitivity,
	                  _h9 = a.isBeginning,
	                  _v8 = a.isEnd;

	              if (_c12 >= a.minTranslate() && (_c12 = a.minTranslate()), _c12 <= a.maxTranslate() && (_c12 = a.maxTranslate()), a.setTransition(0), a.setTranslate(_c12), a.updateProgress(), a.updateActiveIndex(), a.updateSlidesClasses(), (!_h9 && a.isBeginning || !_v8 && a.isEnd) && a.updateSlidesClasses(), a.params.freeModeSticky) {
	                clearTimeout(a.mousewheel.timeout), a.mousewheel.timeout = void 0;
	                var _f6 = a.mousewheel.recentWheelEvents;
	                _f6.length >= 15 && _f6.shift();

	                var _g5 = _f6.length ? _f6[_f6.length - 1] : void 0,
	                    _b5 = _f6[0];

	                if (_f6.push(_d13), _g5 && (_d13.delta > _g5.delta || _d13.direction !== _g5.direction)) _f6.splice(0);else if (_f6.length >= 15 && _d13.time - _b5.time < 500 && _b5.delta - _d13.delta >= 1 && _d13.delta <= 6) {
	                  var _w4 = _r9 > 0 ? .8 : .2;

	                  a.mousewheel.lastEventBeforeSnap = _d13, _f6.splice(0), a.mousewheel.timeout = E(function () {
	                    a.slideToClosest(a.params.speed, !0, void 0, _w4);
	                  }, 0);
	                }
	                a.mousewheel.timeout || (a.mousewheel.timeout = E(function () {
	                  a.mousewheel.lastEventBeforeSnap = _d13, _f6.splice(0), a.slideToClosest(a.params.speed, !0, void 0, .5);
	                }, 500));
	              }

	              if (_u14 || a.emit('scroll', t), a.params.autoplay && a.params.autoplayDisableOnInteraction && a.autoplay.stop(), _c12 === a.minTranslate() || _c12 === a.maxTranslate()) return !0;
	            }
	          } else {
	            var _y4 = {
	              time: x(),
	              delta: Math.abs(_r9),
	              direction: Math.sign(_r9),
	              raw: e
	            },
	                _T5 = a.mousewheel.recentWheelEvents;
	            _T5.length >= 2 && _T5.shift();

	            var _C5 = _T5.length ? _T5[_T5.length - 1] : void 0;

	            if (_T5.push(_y4), _C5 ? (_y4.direction !== _C5.direction || _y4.delta > _C5.delta || _y4.time > _C5.time + 150) && a.mousewheel.animateSlider(_y4) : a.mousewheel.animateSlider(_y4), a.mousewheel.releaseScroll(_y4)) return !0;
	          }

	          return t.preventDefault ? t.preventDefault() : t.returnValue = !1, !1;
	        }
	      },
	      animateSlider: function animateSlider(e) {
	        var t = this,
	            a = l();
	        return !(this.params.mousewheel.thresholdDelta && e.delta < this.params.mousewheel.thresholdDelta) && !(this.params.mousewheel.thresholdTime && x() - t.mousewheel.lastScrollTime < this.params.mousewheel.thresholdTime) && (e.delta >= 6 && x() - t.mousewheel.lastScrollTime < 60 || (e.direction < 0 ? t.isEnd && !t.params.loop || t.animating || (t.slideNext(), t.emit('scroll', e.raw)) : t.isBeginning && !t.params.loop || t.animating || (t.slidePrev(), t.emit('scroll', e.raw)), t.mousewheel.lastScrollTime = new a.Date().getTime(), !1));
	      },
	      releaseScroll: function releaseScroll(e) {
	        var t = this,
	            a = t.params.mousewheel;

	        if (e.direction < 0) {
	          if (t.isEnd && !t.params.loop && a.releaseOnEdges) return !0;
	        } else if (t.isBeginning && !t.params.loop && a.releaseOnEdges) return !0;

	        return !1;
	      },
	      enable: function enable() {
	        var e = this,
	            t = J.event();
	        if (e.params.cssMode) return e.wrapperEl.removeEventListener(t, e.mousewheel.handle), !0;
	        if (!t) return !1;
	        if (e.mousewheel.enabled) return !1;
	        var a = e.$el;
	        return 'container' !== e.params.mousewheel.eventsTarget && (a = m(e.params.mousewheel.eventsTarget)), a.on('mouseenter', e.mousewheel.handleMouseEnter), a.on('mouseleave', e.mousewheel.handleMouseLeave), a.on(t, e.mousewheel.handle), e.mousewheel.enabled = !0, !0;
	      },
	      disable: function disable() {
	        var e = this,
	            t = J.event();
	        if (e.params.cssMode) return e.wrapperEl.addEventListener(t, e.mousewheel.handle), !0;
	        if (!t) return !1;
	        if (!e.mousewheel.enabled) return !1;
	        var a = e.$el;
	        return 'container' !== e.params.mousewheel.eventsTarget && (a = m(e.params.mousewheel.eventsTarget)), a.off(t, e.mousewheel.handle), e.mousewheel.enabled = !1, !0;
	      }
	    },
	        Q = {
	      toggleEl: function toggleEl(e, t) {
	        e[t ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass), e[0] && 'BUTTON' === e[0].tagName && (e[0].disabled = t);
	      },
	      update: function update() {
	        var e = this,
	            t = e.params.navigation,
	            a = e.navigation.toggleEl;

	        if (!e.params.loop) {
	          var _i22 = e.navigation,
	              _s15 = _i22.$nextEl,
	              _r10 = _i22.$prevEl;
	          _r10 && _r10.length > 0 && (e.isBeginning ? a(_r10, !0) : a(_r10, !1), e.params.watchOverflow && e.enabled && _r10[e.isLocked ? 'addClass' : 'removeClass'](t.lockClass)), _s15 && _s15.length > 0 && (e.isEnd ? a(_s15, !0) : a(_s15, !1), e.params.watchOverflow && e.enabled && _s15[e.isLocked ? 'addClass' : 'removeClass'](t.lockClass));
	        }
	      },
	      onPrevClick: function onPrevClick(e) {
	        var t = this;
	        e.preventDefault(), t.isBeginning && !t.params.loop || t.slidePrev();
	      },
	      onNextClick: function onNextClick(e) {
	        var t = this;
	        e.preventDefault(), t.isEnd && !t.params.loop || t.slideNext();
	      },
	      init: function init() {
	        var e,
	            t,
	            a = this,
	            i = a.params.navigation;
	        (a.params.navigation = k(a.$el, a.params.navigation, a.params.createElements, {
	          nextEl: 'swiper-button-next',
	          prevEl: 'swiper-button-prev'
	        }), i.nextEl || i.prevEl) && (i.nextEl && (e = m(i.nextEl), a.params.uniqueNavElements && 'string' == typeof i.nextEl && e.length > 1 && 1 === a.$el.find(i.nextEl).length && (e = a.$el.find(i.nextEl))), i.prevEl && (t = m(i.prevEl), a.params.uniqueNavElements && 'string' == typeof i.prevEl && t.length > 1 && 1 === a.$el.find(i.prevEl).length && (t = a.$el.find(i.prevEl))), e && e.length > 0 && e.on('click', a.navigation.onNextClick), t && t.length > 0 && t.on('click', a.navigation.onPrevClick), M(a.navigation, {
	          $nextEl: e,
	          nextEl: e && e[0],
	          $prevEl: t,
	          prevEl: t && t[0]
	        }), a.enabled || (e && e.addClass(i.lockClass), t && t.addClass(i.lockClass)));
	      },
	      destroy: function destroy() {
	        var e = this,
	            t = e.navigation,
	            a = t.$nextEl,
	            i = t.$prevEl;
	        a && a.length && (a.off('click', e.navigation.onNextClick), a.removeClass(e.params.navigation.disabledClass)), i && i.length && (i.off('click', e.navigation.onPrevClick), i.removeClass(e.params.navigation.disabledClass));
	      }
	    },
	        ee = {
	      update: function update() {
	        var e = this,
	            t = e.rtl,
	            a = e.params.pagination;

	        if (a.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
	          var _i23,
	              _s16 = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
	              _r11 = e.pagination.$el,
	              _n19 = e.params.loop ? Math.ceil((_s16 - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;

	          if (e.params.loop ? ((_i23 = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > _s16 - 1 - 2 * e.loopedSlides && (_i23 -= _s16 - 2 * e.loopedSlides), _i23 > _n19 - 1 && (_i23 -= _n19), _i23 < 0 && 'bullets' !== e.params.paginationType && (_i23 = _n19 + _i23)) : _i23 = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0, 'bullets' === a.type && e.pagination.bullets && e.pagination.bullets.length > 0) {
	            var _l9,
	                _o14,
	                _d14,
	                _p18 = e.pagination.bullets;

	            if (a.dynamicBullets && (e.pagination.bulletSize = _p18.eq(0)[e.isHorizontal() ? 'outerWidth' : 'outerHeight'](!0), _r11.css(e.isHorizontal() ? 'width' : 'height', e.pagination.bulletSize * (a.dynamicMainBullets + 4) + 'px'), a.dynamicMainBullets > 1 && void 0 !== e.previousIndex && (e.pagination.dynamicBulletIndex += _i23 - e.previousIndex, e.pagination.dynamicBulletIndex > a.dynamicMainBullets - 1 ? e.pagination.dynamicBulletIndex = a.dynamicMainBullets - 1 : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)), _l9 = _i23 - e.pagination.dynamicBulletIndex, _d14 = ((_o14 = _l9 + (Math.min(_p18.length, a.dynamicMainBullets) - 1)) + _l9) / 2), _p18.removeClass(a.bulletActiveClass + ' ' + a.bulletActiveClass + '-next ' + a.bulletActiveClass + '-next-next ' + a.bulletActiveClass + '-prev ' + a.bulletActiveClass + '-prev-prev ' + a.bulletActiveClass + '-main'), _r11.length > 1) _p18.each(function (e) {
	              var t = m(e),
	                  s = t.index();
	              s === _i23 && t.addClass(a.bulletActiveClass), a.dynamicBullets && (s >= _l9 && s <= _o14 && t.addClass(a.bulletActiveClass + '-main'), s === _l9 && t.prev().addClass(a.bulletActiveClass + '-prev').prev().addClass(a.bulletActiveClass + '-prev-prev'), s === _o14 && t.next().addClass(a.bulletActiveClass + '-next').next().addClass(a.bulletActiveClass + '-next-next'));
	            });else {
	              var _u15 = _p18.eq(_i23),
	                  _c13 = _u15.index();

	              if (_u15.addClass(a.bulletActiveClass), a.dynamicBullets) {
	                for (var h = _p18.eq(_l9), v = _p18.eq(_o14), f = _l9; f <= _o14; f += 1) {
	                  _p18.eq(f).addClass(a.bulletActiveClass + '-main');
	                }

	                if (e.params.loop) {
	                  if (_c13 >= _p18.length - a.dynamicMainBullets) {
	                    for (var _g6 = a.dynamicMainBullets; _g6 >= 0; _g6 -= 1) {
	                      _p18.eq(_p18.length - _g6).addClass(a.bulletActiveClass + '-main');
	                    }

	                    _p18.eq(_p18.length - a.dynamicMainBullets - 1).addClass(a.bulletActiveClass + '-prev');
	                  } else h.prev().addClass(a.bulletActiveClass + '-prev').prev().addClass(a.bulletActiveClass + '-prev-prev'), v.next().addClass(a.bulletActiveClass + '-next').next().addClass(a.bulletActiveClass + '-next-next');
	                } else h.prev().addClass(a.bulletActiveClass + '-prev').prev().addClass(a.bulletActiveClass + '-prev-prev'), v.next().addClass(a.bulletActiveClass + '-next').next().addClass(a.bulletActiveClass + '-next-next');
	              }
	            }

	            if (a.dynamicBullets) {
	              var _b6 = Math.min(_p18.length, a.dynamicMainBullets + 4),
	                  _w5 = (e.pagination.bulletSize * _b6 - e.pagination.bulletSize) / 2 - _d14 * e.pagination.bulletSize,
	                  _y5 = t ? 'right' : 'left';

	              _p18.css(e.isHorizontal() ? _y5 : 'top', _w5 + 'px');
	            }
	          }

	          if ('fraction' === a.type && (_r11.find(P(a.currentClass)).text(a.formatFractionCurrent(_i23 + 1)), _r11.find(P(a.totalClass)).text(a.formatFractionTotal(_n19))), 'progressbar' === a.type) {
	            var _E3;

	            _E3 = a.progressbarOpposite ? e.isHorizontal() ? 'vertical' : 'horizontal' : e.isHorizontal() ? 'horizontal' : 'vertical';

	            var _x3 = (_i23 + 1) / _n19,
	                _T6 = 1,
	                _C6 = 1;

	            'horizontal' === _E3 ? _T6 = _x3 : _C6 = _x3, _r11.find(P(a.progressbarFillClass)).transform('translate3d(0,0,0) scaleX(' + _T6 + ') scaleY(' + _C6 + ')').transition(e.params.speed);
	          }

	          'custom' === a.type && a.renderCustom ? (_r11.html(a.renderCustom(e, _i23 + 1, _n19)), e.emit('paginationRender', _r11[0])) : e.emit('paginationUpdate', _r11[0]), e.params.watchOverflow && e.enabled && _r11[e.isLocked ? 'addClass' : 'removeClass'](a.lockClass);
	        }
	      },
	      render: function render() {
	        var e = this,
	            t = e.params.pagination;

	        if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
	          var _a16 = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
	              _i24 = e.pagination.$el,
	              _s17 = '';

	          if ('bullets' === t.type) {
	            var _r12 = e.params.loop ? Math.ceil((_a16 - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;

	            e.params.freeMode && !e.params.loop && _r12 > _a16 && (_r12 = _a16);

	            for (var _n20 = 0; _n20 < _r12; _n20 += 1) {
	              t.renderBullet ? _s17 += t.renderBullet.call(e, _n20, t.bulletClass) : _s17 += '<' + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + '>';
	            }

	            _i24.html(_s17), e.pagination.bullets = _i24.find(P(t.bulletClass));
	          }

	          'fraction' === t.type && (_s17 = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>', _i24.html(_s17)), 'progressbar' === t.type && (_s17 = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>', _i24.html(_s17)), 'custom' !== t.type && e.emit('paginationRender', e.pagination.$el[0]);
	        }
	      },
	      init: function init() {
	        var e = this;
	        e.params.pagination = k(e.$el, e.params.pagination, e.params.createElements, {
	          el: 'swiper-pagination'
	        });
	        var t = e.params.pagination;

	        if (t.el) {
	          var _a17 = m(t.el);

	          0 !== _a17.length && (e.params.uniqueNavElements && 'string' == typeof t.el && _a17.length > 1 && (_a17 = e.$el.find(t.el)), 'bullets' === t.type && t.clickable && _a17.addClass(t.clickableClass), _a17.addClass(t.modifierClass + t.type), 'bullets' === t.type && t.dynamicBullets && (_a17.addClass('' + t.modifierClass + t.type + '-dynamic'), e.pagination.dynamicBulletIndex = 0, t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)), 'progressbar' === t.type && t.progressbarOpposite && _a17.addClass(t.progressbarOppositeClass), t.clickable && _a17.on('click', P(t.bulletClass), function (t) {
	            t.preventDefault();
	            var a = m(this).index() * e.params.slidesPerGroup;
	            e.params.loop && (a += e.loopedSlides), e.slideTo(a);
	          }), M(e.pagination, {
	            $el: _a17,
	            el: _a17[0]
	          }), e.enabled || _a17.addClass(t.lockClass));
	        }
	      },
	      destroy: function destroy() {
	        var e = this,
	            t = e.params.pagination;

	        if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
	          var _a18 = e.pagination.$el;
	          _a18.removeClass(t.hiddenClass), _a18.removeClass(t.modifierClass + t.type), e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && _a18.off('click', P(t.bulletClass));
	        }
	      }
	    },
	        te = {
	      setTranslate: function setTranslate() {
	        var e = this;

	        if (e.params.scrollbar.el && e.scrollbar.el) {
	          var _t20 = e.scrollbar,
	              _a19 = e.rtlTranslate,
	              _i25 = e.progress,
	              _s18 = _t20.dragSize,
	              _r13 = _t20.trackSize,
	              _n21 = _t20.$dragEl,
	              _l10 = _t20.$el,
	              _o15 = e.params.scrollbar,
	              _d15 = _s18,
	              _p19 = (_r13 - _s18) * _i25;

	          _a19 ? (_p19 = -_p19) > 0 ? (_d15 = _s18 - _p19, _p19 = 0) : -_p19 + _s18 > _r13 && (_d15 = _r13 + _p19) : _p19 < 0 ? (_d15 = _s18 + _p19, _p19 = 0) : _p19 + _s18 > _r13 && (_d15 = _r13 - _p19), e.isHorizontal() ? (_n21.transform('translate3d(' + _p19 + 'px, 0, 0)'), _n21[0].style.width = _d15 + 'px') : (_n21.transform('translate3d(0px, ' + _p19 + 'px, 0)'), _n21[0].style.height = _d15 + 'px'), _o15.hide && (clearTimeout(e.scrollbar.timeout), _l10[0].style.opacity = 1, e.scrollbar.timeout = setTimeout(function () {
	            _l10[0].style.opacity = 0, _l10.transition(400);
	          }, 1e3));
	        }
	      },
	      setTransition: function setTransition(e) {
	        var t = this;
	        t.params.scrollbar.el && t.scrollbar.el && t.scrollbar.$dragEl.transition(e);
	      },
	      updateSize: function updateSize() {
	        var e = this;

	        if (e.params.scrollbar.el && e.scrollbar.el) {
	          var _t21 = e.scrollbar,
	              _a20 = _t21.$dragEl,
	              _i26 = _t21.$el;
	          _a20[0].style.width = '', _a20[0].style.height = '';

	          var _s19,
	              _r14 = e.isHorizontal() ? _i26[0].offsetWidth : _i26[0].offsetHeight,
	              _n22 = e.size / e.virtualSize,
	              _l11 = _n22 * (_r14 / e.size);

	          _s19 = 'auto' === e.params.scrollbar.dragSize ? _r14 * _n22 : parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? _a20[0].style.width = _s19 + 'px' : _a20[0].style.height = _s19 + 'px', _i26[0].style.display = _n22 >= 1 ? 'none' : '', e.params.scrollbar.hide && (_i26[0].style.opacity = 0), M(_t21, {
	            trackSize: _r14,
	            divider: _n22,
	            moveDivider: _l11,
	            dragSize: _s19
	          }), e.params.watchOverflow && e.enabled && _t21.$el[e.isLocked ? 'addClass' : 'removeClass'](e.params.scrollbar.lockClass);
	        }
	      },
	      getPointerPosition: function getPointerPosition(e) {
	        return this.isHorizontal() ? 'touchstart' === e.type || 'touchmove' === e.type ? e.targetTouches[0].clientX : e.clientX : 'touchstart' === e.type || 'touchmove' === e.type ? e.targetTouches[0].clientY : e.clientY;
	      },
	      setDragPosition: function setDragPosition(e) {
	        var t,
	            a = this,
	            i = a.scrollbar,
	            s = a.rtlTranslate,
	            r = i.$el,
	            n = i.dragSize,
	            l = i.trackSize,
	            o = i.dragStartPos;
	        t = (i.getPointerPosition(e) - r.offset()[a.isHorizontal() ? 'left' : 'top'] - (null !== o ? o : n / 2)) / (l - n), t = Math.max(Math.min(t, 1), 0), s && (t = 1 - t);
	        var d = a.minTranslate() + (a.maxTranslate() - a.minTranslate()) * t;
	        a.updateProgress(d), a.setTranslate(d), a.updateActiveIndex(), a.updateSlidesClasses();
	      },
	      onDragStart: function onDragStart(e) {
	        var t = this,
	            a = t.params.scrollbar,
	            i = t.scrollbar,
	            s = t.$wrapperEl,
	            r = i.$el,
	            n = i.$dragEl;
	        t.scrollbar.isTouched = !0, t.scrollbar.dragStartPos = e.target === n[0] || e.target === n ? i.getPointerPosition(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? 'left' : 'top'] : null, e.preventDefault(), e.stopPropagation(), s.transition(100), n.transition(100), i.setDragPosition(e), clearTimeout(t.scrollbar.dragTimeout), r.transition(0), a.hide && r.css('opacity', 1), t.params.cssMode && t.$wrapperEl.css('scroll-snap-type', 'none'), t.emit('scrollbarDragStart', e);
	      },
	      onDragMove: function onDragMove(e) {
	        var t = this,
	            a = t.scrollbar,
	            i = t.$wrapperEl,
	            s = a.$el,
	            r = a.$dragEl;
	        t.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, a.setDragPosition(e), i.transition(0), s.transition(0), r.transition(0), t.emit('scrollbarDragMove', e));
	      },
	      onDragEnd: function onDragEnd(e) {
	        var t = this,
	            a = t.params.scrollbar,
	            i = t.scrollbar,
	            s = t.$wrapperEl,
	            r = i.$el;
	        t.scrollbar.isTouched && (t.scrollbar.isTouched = !1, t.params.cssMode && (t.$wrapperEl.css('scroll-snap-type', ''), s.transition('')), a.hide && (clearTimeout(t.scrollbar.dragTimeout), t.scrollbar.dragTimeout = E(function () {
	          r.css('opacity', 0), r.transition(400);
	        }, 1e3)), t.emit('scrollbarDragEnd', e), a.snapOnRelease && t.slideToClosest());
	      },
	      enableDraggable: function enableDraggable() {
	        var e = this;

	        if (e.params.scrollbar.el) {
	          var _t22 = r(),
	              _a21 = e.scrollbar,
	              _i27 = e.touchEventsTouch,
	              _s20 = e.touchEventsDesktop,
	              _n23 = e.params,
	              _l12 = e.support,
	              _o16 = _a21.$el[0],
	              _d16 = !(!_l12.passiveListener || !_n23.passiveListeners) && {
	            passive: !1,
	            capture: !1
	          },
	              _p20 = !(!_l12.passiveListener || !_n23.passiveListeners) && {
	            passive: !0,
	            capture: !1
	          };

	          _o16 && (_l12.touch ? (_o16.addEventListener(_i27.start, e.scrollbar.onDragStart, _d16), _o16.addEventListener(_i27.move, e.scrollbar.onDragMove, _d16), _o16.addEventListener(_i27.end, e.scrollbar.onDragEnd, _p20)) : (_o16.addEventListener(_s20.start, e.scrollbar.onDragStart, _d16), _t22.addEventListener(_s20.move, e.scrollbar.onDragMove, _d16), _t22.addEventListener(_s20.end, e.scrollbar.onDragEnd, _p20)));
	        }
	      },
	      disableDraggable: function disableDraggable() {
	        var e = this;

	        if (e.params.scrollbar.el) {
	          var _t23 = r(),
	              _a22 = e.scrollbar,
	              _i28 = e.touchEventsTouch,
	              _s21 = e.touchEventsDesktop,
	              _n24 = e.params,
	              _l13 = e.support,
	              _o17 = _a22.$el[0],
	              _d17 = !(!_l13.passiveListener || !_n24.passiveListeners) && {
	            passive: !1,
	            capture: !1
	          },
	              _p21 = !(!_l13.passiveListener || !_n24.passiveListeners) && {
	            passive: !0,
	            capture: !1
	          };

	          _o17 && (_l13.touch ? (_o17.removeEventListener(_i28.start, e.scrollbar.onDragStart, _d17), _o17.removeEventListener(_i28.move, e.scrollbar.onDragMove, _d17), _o17.removeEventListener(_i28.end, e.scrollbar.onDragEnd, _p21)) : (_o17.removeEventListener(_s21.start, e.scrollbar.onDragStart, _d17), _t23.removeEventListener(_s21.move, e.scrollbar.onDragMove, _d17), _t23.removeEventListener(_s21.end, e.scrollbar.onDragEnd, _p21)));
	        }
	      },
	      init: function init() {
	        var e = this,
	            t = e.scrollbar,
	            a = e.$el;
	        e.params.scrollbar = k(a, e.params.scrollbar, e.params.createElements, {
	          el: 'swiper-scrollbar'
	        });
	        var i = e.params.scrollbar;

	        if (i.el) {
	          var _s22 = m(i.el);

	          e.params.uniqueNavElements && 'string' == typeof i.el && _s22.length > 1 && 1 === a.find(i.el).length && (_s22 = a.find(i.el));

	          var _r15 = _s22.find('.' + e.params.scrollbar.dragClass);

	          0 === _r15.length && (_r15 = m('<div class="' + e.params.scrollbar.dragClass + '"></div>'), _s22.append(_r15)), M(t, {
	            $el: _s22,
	            el: _s22[0],
	            $dragEl: _r15,
	            dragEl: _r15[0]
	          }), i.draggable && t.enableDraggable(), _s22 && _s22[e.enabled ? 'removeClass' : 'addClass'](e.params.scrollbar.lockClass);
	        }
	      },
	      destroy: function destroy() {
	        this.scrollbar.disableDraggable();
	      }
	    },
	        ae = {
	      setTransform: function setTransform(e, t) {
	        var a = this.rtl,
	            i = m(e),
	            s = a ? -1 : 1,
	            r = i.attr('data-swiper-parallax') || '0',
	            n = i.attr('data-swiper-parallax-x'),
	            l = i.attr('data-swiper-parallax-y'),
	            o = i.attr('data-swiper-parallax-scale'),
	            d = i.attr('data-swiper-parallax-opacity');

	        if (n || l ? (n = n || '0', l = l || '0') : this.isHorizontal() ? (n = r, l = '0') : (l = r, n = '0'), n = n.indexOf('%') >= 0 ? parseInt(n, 10) * t * s + '%' : n * t * s + 'px', l = l.indexOf('%') >= 0 ? parseInt(l, 10) * t + '%' : l * t + 'px', null != d) {
	          var _p22 = d - (d - 1) * (1 - Math.abs(t));

	          i[0].style.opacity = _p22;
	        }

	        if (null == o) i.transform('translate3d(' + n + ', ' + l + ', 0px)');else {
	          var _u16 = o - (o - 1) * (1 - Math.abs(t));

	          i.transform('translate3d(' + n + ', ' + l + ', 0px) scale(' + _u16 + ')');
	        }
	      },
	      setTranslate: function setTranslate() {
	        var e = this,
	            t = e.$el,
	            a = e.slides,
	            i = e.progress,
	            s = e.snapGrid;
	        t.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (t) {
	          e.parallax.setTransform(t, i);
	        }), a.each(function (t, a) {
	          var r = t.progress;
	          e.params.slidesPerGroup > 1 && 'auto' !== e.params.slidesPerView && (r += Math.ceil(a / 2) - i * (s.length - 1)), r = Math.min(Math.max(r, -1), 1), m(t).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (t) {
	            e.parallax.setTransform(t, r);
	          });
	        });
	      },
	      setTransition: function setTransition(e) {
	        void 0 === e && (e = this.params.speed);
	        this.$el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (t) {
	          var a = m(t),
	              i = parseInt(a.attr('data-swiper-parallax-duration'), 10) || e;
	          0 === e && (i = 0), a.transition(i);
	        });
	      }
	    },
	        ie = {
	      getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
	        if (e.targetTouches.length < 2) return 1;
	        var t = e.targetTouches[0].pageX,
	            a = e.targetTouches[0].pageY,
	            i = e.targetTouches[1].pageX,
	            s = e.targetTouches[1].pageY;
	        return Math.sqrt(Math.pow(i - t, 2) + Math.pow(s - a, 2));
	      },
	      onGestureStart: function onGestureStart(e) {
	        var t = this,
	            a = t.support,
	            i = t.params.zoom,
	            s = t.zoom,
	            r = s.gesture;

	        if (s.fakeGestureTouched = !1, s.fakeGestureMoved = !1, !a.gestures) {
	          if ('touchstart' !== e.type || 'touchstart' === e.type && e.targetTouches.length < 2) return;
	          s.fakeGestureTouched = !0, r.scaleStart = ie.getDistanceBetweenTouches(e);
	        }

	        r.$slideEl && r.$slideEl.length || (r.$slideEl = m(e.target).closest('.' + t.params.slideClass), 0 === r.$slideEl.length && (r.$slideEl = t.slides.eq(t.activeIndex)), r.$imageEl = r.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target'), r.$imageWrapEl = r.$imageEl.parent('.' + i.containerClass), r.maxRatio = r.$imageWrapEl.attr('data-swiper-zoom') || i.maxRatio, 0 !== r.$imageWrapEl.length) ? (r.$imageEl && r.$imageEl.transition(0), t.zoom.isScaling = !0) : r.$imageEl = void 0;
	      },
	      onGestureChange: function onGestureChange(e) {
	        var t = this,
	            a = t.support,
	            i = t.params.zoom,
	            s = t.zoom,
	            r = s.gesture;

	        if (!a.gestures) {
	          if ('touchmove' !== e.type || 'touchmove' === e.type && e.targetTouches.length < 2) return;
	          s.fakeGestureMoved = !0, r.scaleMove = ie.getDistanceBetweenTouches(e);
	        }

	        r.$imageEl && 0 !== r.$imageEl.length ? (a.gestures ? s.scale = e.scale * s.currentScale : s.scale = r.scaleMove / r.scaleStart * s.currentScale, s.scale > r.maxRatio && (s.scale = r.maxRatio - 1 + Math.pow(s.scale - r.maxRatio + 1, .5)), s.scale < i.minRatio && (s.scale = i.minRatio + 1 - Math.pow(i.minRatio - s.scale + 1, .5)), r.$imageEl.transform('translate3d(0,0,0) scale(' + s.scale + ')')) : 'gesturechange' === e.type && s.onGestureStart(e);
	      },
	      onGestureEnd: function onGestureEnd(e) {
	        var t = this,
	            a = t.device,
	            i = t.support,
	            s = t.params.zoom,
	            r = t.zoom,
	            n = r.gesture;

	        if (!i.gestures) {
	          if (!r.fakeGestureTouched || !r.fakeGestureMoved) return;
	          if ('touchend' !== e.type || 'touchend' === e.type && e.changedTouches.length < 2 && !a.android) return;
	          r.fakeGestureTouched = !1, r.fakeGestureMoved = !1;
	        }

	        n.$imageEl && 0 !== n.$imageEl.length && (r.scale = Math.max(Math.min(r.scale, n.maxRatio), s.minRatio), n.$imageEl.transition(t.params.speed).transform('translate3d(0,0,0) scale(' + r.scale + ')'), r.currentScale = r.scale, r.isScaling = !1, 1 === r.scale && (n.$slideEl = void 0));
	      },
	      onTouchStart: function onTouchStart(e) {
	        var t = this.device,
	            a = this.zoom,
	            i = a.gesture,
	            s = a.image;
	        i.$imageEl && 0 !== i.$imageEl.length && (s.isTouched || (t.android && e.cancelable && e.preventDefault(), s.isTouched = !0, s.touchesStart.x = 'touchstart' === e.type ? e.targetTouches[0].pageX : e.pageX, s.touchesStart.y = 'touchstart' === e.type ? e.targetTouches[0].pageY : e.pageY));
	      },
	      onTouchMove: function onTouchMove(e) {
	        var t = this,
	            a = t.zoom,
	            i = a.gesture,
	            s = a.image,
	            r = a.velocity;

	        if (i.$imageEl && 0 !== i.$imageEl.length && (t.allowClick = !1, s.isTouched && i.$slideEl)) {
	          s.isMoved || (s.width = i.$imageEl[0].offsetWidth, s.height = i.$imageEl[0].offsetHeight, s.startX = T(i.$imageWrapEl[0], 'x') || 0, s.startY = T(i.$imageWrapEl[0], 'y') || 0, i.slideWidth = i.$slideEl[0].offsetWidth, i.slideHeight = i.$slideEl[0].offsetHeight, i.$imageWrapEl.transition(0));

	          var _n25 = s.width * a.scale,
	              _l14 = s.height * a.scale;

	          if (!(_n25 < i.slideWidth && _l14 < i.slideHeight)) {
	            if (s.minX = Math.min(i.slideWidth / 2 - _n25 / 2, 0), s.maxX = -s.minX, s.minY = Math.min(i.slideHeight / 2 - _l14 / 2, 0), s.maxY = -s.minY, s.touchesCurrent.x = 'touchmove' === e.type ? e.targetTouches[0].pageX : e.pageX, s.touchesCurrent.y = 'touchmove' === e.type ? e.targetTouches[0].pageY : e.pageY, !s.isMoved && !a.isScaling) {
	              if (t.isHorizontal() && (Math.floor(s.minX) === Math.floor(s.startX) && s.touchesCurrent.x < s.touchesStart.x || Math.floor(s.maxX) === Math.floor(s.startX) && s.touchesCurrent.x > s.touchesStart.x)) return void (s.isTouched = !1);
	              if (!t.isHorizontal() && (Math.floor(s.minY) === Math.floor(s.startY) && s.touchesCurrent.y < s.touchesStart.y || Math.floor(s.maxY) === Math.floor(s.startY) && s.touchesCurrent.y > s.touchesStart.y)) return void (s.isTouched = !1);
	            }

	            e.cancelable && e.preventDefault(), e.stopPropagation(), s.isMoved = !0, s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX, s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY, s.currentX < s.minX && (s.currentX = s.minX + 1 - Math.pow(s.minX - s.currentX + 1, .8)), s.currentX > s.maxX && (s.currentX = s.maxX - 1 + Math.pow(s.currentX - s.maxX + 1, .8)), s.currentY < s.minY && (s.currentY = s.minY + 1 - Math.pow(s.minY - s.currentY + 1, .8)), s.currentY > s.maxY && (s.currentY = s.maxY - 1 + Math.pow(s.currentY - s.maxY + 1, .8)), r.prevPositionX || (r.prevPositionX = s.touchesCurrent.x), r.prevPositionY || (r.prevPositionY = s.touchesCurrent.y), r.prevTime || (r.prevTime = Date.now()), r.x = (s.touchesCurrent.x - r.prevPositionX) / (Date.now() - r.prevTime) / 2, r.y = (s.touchesCurrent.y - r.prevPositionY) / (Date.now() - r.prevTime) / 2, Math.abs(s.touchesCurrent.x - r.prevPositionX) < 2 && (r.x = 0), Math.abs(s.touchesCurrent.y - r.prevPositionY) < 2 && (r.y = 0), r.prevPositionX = s.touchesCurrent.x, r.prevPositionY = s.touchesCurrent.y, r.prevTime = Date.now(), i.$imageWrapEl.transform('translate3d(' + s.currentX + 'px, ' + s.currentY + 'px,0)');
	          }
	        }
	      },
	      onTouchEnd: function onTouchEnd() {
	        var e = this.zoom,
	            t = e.gesture,
	            a = e.image,
	            i = e.velocity;

	        if (t.$imageEl && 0 !== t.$imageEl.length) {
	          if (!a.isTouched || !a.isMoved) return a.isTouched = !1, void (a.isMoved = !1);
	          a.isTouched = !1, a.isMoved = !1;

	          var _s23 = 300,
	              _r16 = 300,
	              _n26 = i.x * _s23,
	              _l15 = a.currentX + _n26,
	              _o18 = i.y * _r16,
	              _d18 = a.currentY + _o18;

	          0 !== i.x && (_s23 = Math.abs((_l15 - a.currentX) / i.x)), 0 !== i.y && (_r16 = Math.abs((_d18 - a.currentY) / i.y));

	          var _p23 = Math.max(_s23, _r16);

	          a.currentX = _l15, a.currentY = _d18;

	          var _u17 = a.width * e.scale,
	              _c14 = a.height * e.scale;

	          a.minX = Math.min(t.slideWidth / 2 - _u17 / 2, 0), a.maxX = -a.minX, a.minY = Math.min(t.slideHeight / 2 - _c14 / 2, 0), a.maxY = -a.minY, a.currentX = Math.max(Math.min(a.currentX, a.maxX), a.minX), a.currentY = Math.max(Math.min(a.currentY, a.maxY), a.minY), t.$imageWrapEl.transition(_p23).transform('translate3d(' + a.currentX + 'px, ' + a.currentY + 'px,0)');
	        }
	      },
	      onTransitionEnd: function onTransitionEnd() {
	        var e = this,
	            t = e.zoom,
	            a = t.gesture;
	        a.$slideEl && e.previousIndex !== e.activeIndex && (a.$imageEl && a.$imageEl.transform('translate3d(0,0,0) scale(1)'), a.$imageWrapEl && a.$imageWrapEl.transform('translate3d(0,0,0)'), t.scale = 1, t.currentScale = 1, a.$slideEl = void 0, a.$imageEl = void 0, a.$imageWrapEl = void 0);
	      },
	      toggle: function toggle(e) {
	        var t = this.zoom;
	        t.scale && 1 !== t.scale ? t.out() : t["in"](e);
	      },
	      "in": function _in(e) {
	        var t,
	            a,
	            i,
	            s,
	            r,
	            n,
	            o,
	            d,
	            p,
	            u,
	            c,
	            h,
	            v,
	            f,
	            g,
	            b,
	            w = this,
	            y = l(),
	            E = w.zoom,
	            x = w.params.zoom,
	            T = E.gesture,
	            C = E.image;
	        (T.$slideEl || (e && e.target && (T.$slideEl = m(e.target).closest('.' + w.params.slideClass)), T.$slideEl || (w.params.virtual && w.params.virtual.enabled && w.virtual ? T.$slideEl = w.$wrapperEl.children('.' + w.params.slideActiveClass) : T.$slideEl = w.slides.eq(w.activeIndex)), T.$imageEl = T.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target'), T.$imageWrapEl = T.$imageEl.parent('.' + x.containerClass)), T.$imageEl && 0 !== T.$imageEl.length && T.$imageWrapEl && 0 !== T.$imageWrapEl.length) && (T.$slideEl.addClass('' + x.zoomedSlideClass), void 0 === C.touchesStart.x && e ? (t = 'touchend' === e.type ? e.changedTouches[0].pageX : e.pageX, a = 'touchend' === e.type ? e.changedTouches[0].pageY : e.pageY) : (t = C.touchesStart.x, a = C.touchesStart.y), E.scale = T.$imageWrapEl.attr('data-swiper-zoom') || x.maxRatio, E.currentScale = T.$imageWrapEl.attr('data-swiper-zoom') || x.maxRatio, e ? (g = T.$slideEl[0].offsetWidth, b = T.$slideEl[0].offsetHeight, i = T.$slideEl.offset().left + y.scrollX + g / 2 - t, s = T.$slideEl.offset().top + y.scrollY + b / 2 - a, o = T.$imageEl[0].offsetWidth, d = T.$imageEl[0].offsetHeight, p = o * E.scale, u = d * E.scale, v = -(c = Math.min(g / 2 - p / 2, 0)), f = -(h = Math.min(b / 2 - u / 2, 0)), (r = i * E.scale) < c && (r = c), r > v && (r = v), (n = s * E.scale) < h && (n = h), n > f && (n = f)) : (r = 0, n = 0), T.$imageWrapEl.transition(300).transform('translate3d(' + r + 'px, ' + n + 'px,0)'), T.$imageEl.transition(300).transform('translate3d(0,0,0) scale(' + E.scale + ')'));
	      },
	      out: function out() {
	        var e = this,
	            t = e.zoom,
	            a = e.params.zoom,
	            i = t.gesture;
	        i.$slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? i.$slideEl = e.$wrapperEl.children('.' + e.params.slideActiveClass) : i.$slideEl = e.slides.eq(e.activeIndex), i.$imageEl = i.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target'), i.$imageWrapEl = i.$imageEl.parent('.' + a.containerClass)), i.$imageEl && 0 !== i.$imageEl.length && i.$imageWrapEl && 0 !== i.$imageWrapEl.length && (t.scale = 1, t.currentScale = 1, i.$imageWrapEl.transition(300).transform('translate3d(0,0,0)'), i.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)'), i.$slideEl.removeClass('' + a.zoomedSlideClass), i.$slideEl = void 0);
	      },
	      toggleGestures: function toggleGestures(e) {
	        var t = this,
	            a = t.zoom,
	            i = a.slideSelector,
	            s = a.passiveListener;
	        t.$wrapperEl[e]('gesturestart', i, a.onGestureStart, s), t.$wrapperEl[e]('gesturechange', i, a.onGestureChange, s), t.$wrapperEl[e]('gestureend', i, a.onGestureEnd, s);
	      },
	      enableGestures: function enableGestures() {
	        this.zoom.gesturesEnabled || (this.zoom.gesturesEnabled = !0, this.zoom.toggleGestures('on'));
	      },
	      disableGestures: function disableGestures() {
	        this.zoom.gesturesEnabled && (this.zoom.gesturesEnabled = !1, this.zoom.toggleGestures('off'));
	      },
	      enable: function enable() {
	        var e = this,
	            t = e.support,
	            a = e.zoom;

	        if (!a.enabled) {
	          a.enabled = !0;

	          var _i29 = !('touchstart' !== e.touchEvents.start || !t.passiveListener || !e.params.passiveListeners) && {
	            passive: !0,
	            capture: !1
	          },
	              _s24 = !t.passiveListener || {
	            passive: !1,
	            capture: !0
	          },
	              _r17 = '.' + e.params.slideClass;

	          e.zoom.passiveListener = _i29, e.zoom.slideSelector = _r17, t.gestures ? (e.$wrapperEl.on(e.touchEvents.start, e.zoom.enableGestures, _i29), e.$wrapperEl.on(e.touchEvents.end, e.zoom.disableGestures, _i29)) : 'touchstart' === e.touchEvents.start && (e.$wrapperEl.on(e.touchEvents.start, _r17, a.onGestureStart, _i29), e.$wrapperEl.on(e.touchEvents.move, _r17, a.onGestureChange, _s24), e.$wrapperEl.on(e.touchEvents.end, _r17, a.onGestureEnd, _i29), e.touchEvents.cancel && e.$wrapperEl.on(e.touchEvents.cancel, _r17, a.onGestureEnd, _i29)), e.$wrapperEl.on(e.touchEvents.move, '.' + e.params.zoom.containerClass, a.onTouchMove, _s24);
	        }
	      },
	      disable: function disable() {
	        var e = this,
	            t = e.zoom;

	        if (t.enabled) {
	          var _a23 = e.support;
	          e.zoom.enabled = !1;

	          var _i30 = !('touchstart' !== e.touchEvents.start || !_a23.passiveListener || !e.params.passiveListeners) && {
	            passive: !0,
	            capture: !1
	          },
	              _s25 = !_a23.passiveListener || {
	            passive: !1,
	            capture: !0
	          },
	              _r18 = '.' + e.params.slideClass;

	          _a23.gestures ? (e.$wrapperEl.off(e.touchEvents.start, e.zoom.enableGestures, _i30), e.$wrapperEl.off(e.touchEvents.end, e.zoom.disableGestures, _i30)) : 'touchstart' === e.touchEvents.start && (e.$wrapperEl.off(e.touchEvents.start, _r18, t.onGestureStart, _i30), e.$wrapperEl.off(e.touchEvents.move, _r18, t.onGestureChange, _s25), e.$wrapperEl.off(e.touchEvents.end, _r18, t.onGestureEnd, _i30), e.touchEvents.cancel && e.$wrapperEl.off(e.touchEvents.cancel, _r18, t.onGestureEnd, _i30)), e.$wrapperEl.off(e.touchEvents.move, '.' + e.params.zoom.containerClass, t.onTouchMove, _s25);
	        }
	      }
	    },
	        se = {
	      loadInSlide: function loadInSlide(e, t) {
	        void 0 === t && (t = !0);
	        var a = this,
	            i = a.params.lazy;

	        if (void 0 !== e && 0 !== a.slides.length) {
	          var _s26 = a.virtual && a.params.virtual.enabled ? a.$wrapperEl.children('.' + a.params.slideClass + '[data-swiper-slide-index="' + e + '"]') : a.slides.eq(e),
	              _r19 = _s26.find('.' + i.elementClass + ':not(.' + i.loadedClass + '):not(.' + i.loadingClass + ')');

	          !_s26.hasClass(i.elementClass) || _s26.hasClass(i.loadedClass) || _s26.hasClass(i.loadingClass) || _r19.push(_s26[0]), 0 !== _r19.length && _r19.each(function (e) {
	            var r = m(e);
	            r.addClass(i.loadingClass);
	            var n = r.attr('data-background'),
	                l = r.attr('data-src'),
	                o = r.attr('data-srcset'),
	                d = r.attr('data-sizes'),
	                p = r.parent('picture');
	            a.loadImage(r[0], l || n, o, d, !1, function () {
	              if (null != a && a && (!a || a.params) && !a.destroyed) {
	                if (n ? (r.css('background-image', 'url("' + n + '")'), r.removeAttr('data-background')) : (o && (r.attr('srcset', o), r.removeAttr('data-srcset')), d && (r.attr('sizes', d), r.removeAttr('data-sizes')), p.length && p.children('source').each(function (e) {
	                  var t = m(e);
	                  t.attr('data-srcset') && (t.attr('srcset', t.attr('data-srcset')), t.removeAttr('data-srcset'));
	                }), l && (r.attr('src', l), r.removeAttr('data-src'))), r.addClass(i.loadedClass).removeClass(i.loadingClass), _s26.find('.' + i.preloaderClass).remove(), a.params.loop && t) {
	                  var _e4 = _s26.attr('data-swiper-slide-index');

	                  if (_s26.hasClass(a.params.slideDuplicateClass)) {
	                    var _u18 = a.$wrapperEl.children('[data-swiper-slide-index="' + _e4 + '"]:not(.' + a.params.slideDuplicateClass + ')');

	                    a.lazy.loadInSlide(_u18.index(), !1);
	                  } else {
	                    var _c15 = a.$wrapperEl.children('.' + a.params.slideDuplicateClass + '[data-swiper-slide-index="' + _e4 + '"]');

	                    a.lazy.loadInSlide(_c15.index(), !1);
	                  }
	                }

	                a.emit('lazyImageReady', _s26[0], r[0]), a.params.autoHeight && a.updateAutoHeight();
	              }
	            }), a.emit('lazyImageLoad', _s26[0], r[0]);
	          });
	        }
	      },
	      load: function load() {
	        var e = this,
	            t = e.$wrapperEl,
	            a = e.params,
	            i = e.slides,
	            s = e.activeIndex,
	            r = e.virtual && a.virtual.enabled,
	            n = a.lazy,
	            l = a.slidesPerView;

	        function o(e) {
	          if (r) {
	            if (t.children('.' + a.slideClass + '[data-swiper-slide-index="' + e + '"]').length) return !0;
	          } else if (i[e]) return !0;

	          return !1;
	        }

	        function d(e) {
	          return r ? m(e).attr('data-swiper-slide-index') : m(e).index();
	        }

	        if ('auto' === l && (l = 0), e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0), e.params.watchSlidesVisibility) t.children('.' + a.slideVisibleClass).each(function (t) {
	          var a = r ? m(t).attr('data-swiper-slide-index') : m(t).index();
	          e.lazy.loadInSlide(a);
	        });else if (l > 1) for (var _p24 = s; _p24 < s + l; _p24 += 1) {
	          o(_p24) && e.lazy.loadInSlide(_p24);
	        } else e.lazy.loadInSlide(s);
	        if (n.loadPrevNext) if (l > 1 || n.loadPrevNextAmount && n.loadPrevNextAmount > 1) {
	          for (var u = n.loadPrevNextAmount, c = l, h = Math.min(s + c + Math.max(u, c), i.length), v = Math.max(s - Math.max(c, u), 0), f = s + l; f < h; f += 1) {
	            o(f) && e.lazy.loadInSlide(f);
	          }

	          for (var _g7 = v; _g7 < s; _g7 += 1) {
	            o(_g7) && e.lazy.loadInSlide(_g7);
	          }
	        } else {
	          var _b7 = t.children('.' + a.slideNextClass);

	          _b7.length > 0 && e.lazy.loadInSlide(d(_b7));

	          var _w6 = t.children('.' + a.slidePrevClass);

	          _w6.length > 0 && e.lazy.loadInSlide(d(_w6));
	        }
	      },
	      checkInViewOnLoad: function checkInViewOnLoad() {
	        var e = l(),
	            t = this;

	        if (t && !t.destroyed) {
	          var _a24 = t.params.lazy.scrollingElement ? m(t.params.lazy.scrollingElement) : m(e),
	              _i31 = _a24[0] === e,
	              _s27 = _i31 ? e.innerWidth : _a24[0].offsetWidth,
	              _r20 = _i31 ? e.innerHeight : _a24[0].offsetHeight,
	              _n27 = t.$el.offset(),
	              _o19 = !1;

	          t.rtlTranslate && (_n27.left -= t.$el[0].scrollLeft);

	          for (var _d19 = [[_n27.left, _n27.top], [_n27.left + t.width, _n27.top], [_n27.left, _n27.top + t.height], [_n27.left + t.width, _n27.top + t.height]], _p25 = 0; _p25 < _d19.length; _p25 += 1) {
	            var _u19 = _d19[_p25];

	            if (_u19[0] >= 0 && _u19[0] <= _s27 && _u19[1] >= 0 && _u19[1] <= _r20) {
	              if (0 === _u19[0] && 0 === _u19[1]) continue;
	              _o19 = !0;
	            }
	          }

	          var _c16 = !('touchstart' !== t.touchEvents.start || !t.support.passiveListener || !t.params.passiveListeners) && {
	            passive: !0,
	            capture: !1
	          };

	          _o19 ? (t.lazy.load(), _a24.off('scroll', t.lazy.checkInViewOnLoad, _c16)) : t.lazy.scrollHandlerAttached || (t.lazy.scrollHandlerAttached = !0, _a24.on('scroll', t.lazy.checkInViewOnLoad, _c16));
	        }
	      }
	    },
	        re = {
	      LinearSpline: function LinearSpline(e, t) {
	        var a,
	            i,
	            s,
	            r,
	            n,
	            l = function l(e, t) {
	          for (i = -1, a = e.length; a - i > 1;) {
	            e[s = a + i >> 1] <= t ? i = s : a = s;
	          }

	          return a;
	        };

	        return this.x = e, this.y = t, this.lastIndex = e.length - 1, this.interpolate = function (e) {
	          return e ? (n = l(this.x, e), r = n - 1, (e - this.x[r]) * (this.y[n] - this.y[r]) / (this.x[n] - this.x[r]) + this.y[r]) : 0;
	        }, this;
	      },
	      getInterpolateFunction: function getInterpolateFunction(e) {
	        var t = this;
	        t.controller.spline || (t.controller.spline = t.params.loop ? new re.LinearSpline(t.slidesGrid, e.slidesGrid) : new re.LinearSpline(t.snapGrid, e.snapGrid));
	      },
	      setTranslate: function setTranslate(e, t) {
	        var a,
	            i,
	            s = this,
	            r = s.controller.control,
	            n = s.constructor;

	        function l(e) {
	          var t = s.rtlTranslate ? -s.translate : s.translate;
	          'slide' === s.params.controller.by && (s.controller.getInterpolateFunction(e), i = -s.controller.spline.interpolate(-t)), i && 'container' !== s.params.controller.by || (a = (e.maxTranslate() - e.minTranslate()) / (s.maxTranslate() - s.minTranslate()), i = (t - s.minTranslate()) * a + e.minTranslate()), s.params.controller.inverse && (i = e.maxTranslate() - i), e.updateProgress(i), e.setTranslate(i, s), e.updateActiveIndex(), e.updateSlidesClasses();
	        }

	        if (Array.isArray(r)) for (var _o20 = 0; _o20 < r.length; _o20 += 1) {
	          r[_o20] !== t && r[_o20] instanceof n && l(r[_o20]);
	        } else r instanceof n && t !== r && l(r);
	      },
	      setTransition: function setTransition(e, t) {
	        var a,
	            i = this,
	            s = i.constructor,
	            r = i.controller.control;

	        function n(t) {
	          t.setTransition(e, i), 0 !== e && (t.transitionStart(), t.params.autoHeight && E(function () {
	            t.updateAutoHeight();
	          }), t.$wrapperEl.transitionEnd(function () {
	            r && (t.params.loop && 'slide' === i.params.controller.by && t.loopFix(), t.transitionEnd());
	          }));
	        }

	        if (Array.isArray(r)) for (a = 0; a < r.length; a += 1) {
	          r[a] !== t && r[a] instanceof s && n(r[a]);
	        } else r instanceof s && t !== r && n(r);
	      }
	    },
	        ne = {
	      getRandomNumber: function getRandomNumber(e) {
	        void 0 === e && (e = 16);
	        return 'x'.repeat(e).replace(/x/g, function () {
	          return Math.round(16 * Math.random()).toString(16);
	        });
	      },
	      makeElFocusable: function makeElFocusable(e) {
	        return e.attr('tabIndex', '0'), e;
	      },
	      makeElNotFocusable: function makeElNotFocusable(e) {
	        return e.attr('tabIndex', '-1'), e;
	      },
	      addElRole: function addElRole(e, t) {
	        return e.attr('role', t), e;
	      },
	      addElRoleDescription: function addElRoleDescription(e, t) {
	        return e.attr('aria-roledescription', t), e;
	      },
	      addElControls: function addElControls(e, t) {
	        return e.attr('aria-controls', t), e;
	      },
	      addElLabel: function addElLabel(e, t) {
	        return e.attr('aria-label', t), e;
	      },
	      addElId: function addElId(e, t) {
	        return e.attr('id', t), e;
	      },
	      addElLive: function addElLive(e, t) {
	        return e.attr('aria-live', t), e;
	      },
	      disableEl: function disableEl(e) {
	        return e.attr('aria-disabled', !0), e;
	      },
	      enableEl: function enableEl(e) {
	        return e.attr('aria-disabled', !1), e;
	      },
	      onEnterOrSpaceKey: function onEnterOrSpaceKey(e) {
	        if (13 === e.keyCode || 32 === e.keyCode) {
	          var _t24 = this,
	              _a25 = _t24.params.a11y,
	              _i32 = m(e.target);

	          _t24.navigation && _t24.navigation.$nextEl && _i32.is(_t24.navigation.$nextEl) && (_t24.isEnd && !_t24.params.loop || _t24.slideNext(), _t24.isEnd ? _t24.a11y.notify(_a25.lastSlideMessage) : _t24.a11y.notify(_a25.nextSlideMessage)), _t24.navigation && _t24.navigation.$prevEl && _i32.is(_t24.navigation.$prevEl) && (_t24.isBeginning && !_t24.params.loop || _t24.slidePrev(), _t24.isBeginning ? _t24.a11y.notify(_a25.firstSlideMessage) : _t24.a11y.notify(_a25.prevSlideMessage)), _t24.pagination && _i32.is(P(_t24.params.pagination.bulletClass)) && _i32[0].click();
	        }
	      },
	      notify: function notify(e) {
	        var t = this.a11y.liveRegion;
	        0 !== t.length && (t.html(''), t.html(e));
	      },
	      updateNavigation: function updateNavigation() {
	        var e = this;

	        if (!e.params.loop && e.navigation) {
	          var _t25 = e.navigation,
	              _a26 = _t25.$nextEl,
	              _i33 = _t25.$prevEl;
	          _i33 && _i33.length > 0 && (e.isBeginning ? (e.a11y.disableEl(_i33), e.a11y.makeElNotFocusable(_i33)) : (e.a11y.enableEl(_i33), e.a11y.makeElFocusable(_i33))), _a26 && _a26.length > 0 && (e.isEnd ? (e.a11y.disableEl(_a26), e.a11y.makeElNotFocusable(_a26)) : (e.a11y.enableEl(_a26), e.a11y.makeElFocusable(_a26)));
	        }
	      },
	      updatePagination: function updatePagination() {
	        var e = this,
	            t = e.params.a11y;
	        e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.bullets.each(function (a) {
	          var i = m(a);
	          e.a11y.makeElFocusable(i), e.params.pagination.renderBullet || (e.a11y.addElRole(i, 'button'), e.a11y.addElLabel(i, t.paginationBulletMessage.replace(/\{\{index\}\}/, i.index() + 1)));
	        });
	      },
	      init: function init() {
	        var e = this,
	            t = e.params.a11y;
	        e.$el.append(e.a11y.liveRegion);
	        var a = e.$el;
	        t.containerRoleDescriptionMessage && e.a11y.addElRoleDescription(a, t.containerRoleDescriptionMessage), t.containerMessage && e.a11y.addElLabel(a, t.containerMessage);
	        var i = e.$wrapperEl,
	            s = i.attr('id') || 'swiper-wrapper-' + e.a11y.getRandomNumber(16),
	            r = e.params.autoplay && e.params.autoplay.enabled ? 'off' : 'polite';
	        e.a11y.addElId(i, s), e.a11y.addElLive(i, r), t.itemRoleDescriptionMessage && e.a11y.addElRoleDescription(m(e.slides), t.itemRoleDescriptionMessage), e.a11y.addElRole(m(e.slides), t.slideRole);
	        var n,
	            l,
	            o = e.params.loop ? e.slides.filter(function (t) {
	          return !t.classList.contains(e.params.slideDuplicateClass);
	        }).length : e.slides.length;
	        e.slides.each(function (a, i) {
	          var s = m(a),
	              r = e.params.loop ? parseInt(s.attr('data-swiper-slide-index'), 10) : i,
	              n = t.slideLabelMessage.replace(/\{\{index\}\}/, r + 1).replace(/\{\{slidesLength\}\}/, o);
	          e.a11y.addElLabel(s, n);
	        }), e.navigation && e.navigation.$nextEl && (n = e.navigation.$nextEl), e.navigation && e.navigation.$prevEl && (l = e.navigation.$prevEl), n && n.length && (e.a11y.makeElFocusable(n), 'BUTTON' !== n[0].tagName && (e.a11y.addElRole(n, 'button'), n.on('keydown', e.a11y.onEnterOrSpaceKey)), e.a11y.addElLabel(n, t.nextSlideMessage), e.a11y.addElControls(n, s)), l && l.length && (e.a11y.makeElFocusable(l), 'BUTTON' !== l[0].tagName && (e.a11y.addElRole(l, 'button'), l.on('keydown', e.a11y.onEnterOrSpaceKey)), e.a11y.addElLabel(l, t.prevSlideMessage), e.a11y.addElControls(l, s)), e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.$el.on('keydown', P(e.params.pagination.bulletClass), e.a11y.onEnterOrSpaceKey);
	      },
	      destroy: function destroy() {
	        var e,
	            t,
	            a = this;
	        a.a11y.liveRegion && a.a11y.liveRegion.length > 0 && a.a11y.liveRegion.remove(), a.navigation && a.navigation.$nextEl && (e = a.navigation.$nextEl), a.navigation && a.navigation.$prevEl && (t = a.navigation.$prevEl), e && e.off('keydown', a.a11y.onEnterOrSpaceKey), t && t.off('keydown', a.a11y.onEnterOrSpaceKey), a.pagination && a.params.pagination.clickable && a.pagination.bullets && a.pagination.bullets.length && a.pagination.$el.off('keydown', P(a.params.pagination.bulletClass), a.a11y.onEnterOrSpaceKey);
	      }
	    },
	        le = {
	      init: function init() {
	        var e = this,
	            t = l();

	        if (e.params.history) {
	          if (!t.history || !t.history.pushState) return e.params.history.enabled = !1, void (e.params.hashNavigation.enabled = !0);
	          var _a27 = e.history;
	          _a27.initialized = !0, _a27.paths = le.getPathValues(e.params.url), (_a27.paths.key || _a27.paths.value) && (_a27.scrollToSlide(0, _a27.paths.value, e.params.runCallbacksOnInit), e.params.history.replaceState || t.addEventListener('popstate', e.history.setHistoryPopState));
	        }
	      },
	      destroy: function destroy() {
	        var e = l();
	        this.params.history.replaceState || e.removeEventListener('popstate', this.history.setHistoryPopState);
	      },
	      setHistoryPopState: function setHistoryPopState() {
	        var e = this;
	        e.history.paths = le.getPathValues(e.params.url), e.history.scrollToSlide(e.params.speed, e.history.paths.value, !1);
	      },
	      getPathValues: function getPathValues(e) {
	        var t = l(),
	            a = (e ? new URL(e) : t.location).pathname.slice(1).split('/').filter(function (e) {
	          return '' !== e;
	        }),
	            i = a.length;
	        return {
	          key: a[i - 2],
	          value: a[i - 1]
	        };
	      },
	      setHistory: function setHistory(e, t) {
	        var a = this,
	            i = l();

	        if (a.history.initialized && a.params.history.enabled) {
	          var _s28;

	          _s28 = a.params.url ? new URL(a.params.url) : i.location;

	          var _r21 = a.slides.eq(t),
	              _n28 = le.slugify(_r21.attr('data-history'));

	          if (a.params.history.root.length > 0) {
	            var _o21 = a.params.history.root;
	            '/' === _o21[_o21.length - 1] && (_o21 = _o21.slice(0, _o21.length - 1)), _n28 = _o21 + '/' + e + '/' + _n28;
	          } else _s28.pathname.includes(e) || (_n28 = e + '/' + _n28);

	          var _d20 = i.history.state;
	          _d20 && _d20.value === _n28 || (a.params.history.replaceState ? i.history.replaceState({
	            value: _n28
	          }, null, _n28) : i.history.pushState({
	            value: _n28
	          }, null, _n28));
	        }
	      },
	      slugify: function slugify(e) {
	        return e.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
	      },
	      scrollToSlide: function scrollToSlide(e, t, a) {
	        var i = this;
	        if (t) for (var _s29 = 0, _r22 = i.slides.length; _s29 < _r22; _s29 += 1) {
	          var _n29 = i.slides.eq(_s29);

	          if (le.slugify(_n29.attr('data-history')) === t && !_n29.hasClass(i.params.slideDuplicateClass)) {
	            var _l16 = _n29.index();

	            i.slideTo(_l16, e, a);
	          }
	        } else i.slideTo(0, e, a);
	      }
	    },
	        oe = {
	      onHashChange: function onHashChange() {
	        var e = this,
	            t = r();
	        e.emit('hashChange');
	        var a = t.location.hash.replace('#', '');

	        if (a !== e.slides.eq(e.activeIndex).attr('data-hash')) {
	          var _i34 = e.$wrapperEl.children('.' + e.params.slideClass + '[data-hash="' + a + '"]').index();

	          if (void 0 === _i34) return;
	          e.slideTo(_i34);
	        }
	      },
	      setHash: function setHash() {
	        var e = this,
	            t = l(),
	            a = r();
	        if (e.hashNavigation.initialized && e.params.hashNavigation.enabled) if (e.params.hashNavigation.replaceState && t.history && t.history.replaceState) t.history.replaceState(null, null, '#' + e.slides.eq(e.activeIndex).attr('data-hash') || ''), e.emit('hashSet');else {
	          var _i35 = e.slides.eq(e.activeIndex),
	              _s30 = _i35.attr('data-hash') || _i35.attr('data-history');

	          a.location.hash = _s30 || '', e.emit('hashSet');
	        }
	      },
	      init: function init() {
	        var e = this,
	            t = r(),
	            a = l();

	        if (!(!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled)) {
	          e.hashNavigation.initialized = !0;

	          var _i36 = t.location.hash.replace('#', '');

	          if (_i36) for (var _s31 = 0, _n30 = e.slides.length; _s31 < _n30; _s31 += 1) {
	            var _o22 = e.slides.eq(_s31);

	            if ((_o22.attr('data-hash') || _o22.attr('data-history')) === _i36 && !_o22.hasClass(e.params.slideDuplicateClass)) {
	              var _d21 = _o22.index();

	              e.slideTo(_d21, 0, e.params.runCallbacksOnInit, !0);
	            }
	          }
	          e.params.hashNavigation.watchState && m(a).on('hashchange', e.hashNavigation.onHashChange);
	        }
	      },
	      destroy: function destroy() {
	        var e = l();
	        this.params.hashNavigation.watchState && m(e).off('hashchange', this.hashNavigation.onHashChange);
	      }
	    },
	        de = {
	      run: function run() {
	        var e = this,
	            t = e.slides.eq(e.activeIndex),
	            a = e.params.autoplay.delay;
	        t.attr('data-swiper-autoplay') && (a = t.attr('data-swiper-autoplay') || e.params.autoplay.delay), clearTimeout(e.autoplay.timeout), e.autoplay.timeout = E(function () {
	          var t;
	          e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(), t = e.slidePrev(e.params.speed, !0, !0), e.emit('autoplay')) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (t = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), e.emit('autoplay')) : (t = e.slidePrev(e.params.speed, !0, !0), e.emit('autoplay')) : e.params.loop ? (e.loopFix(), t = e.slideNext(e.params.speed, !0, !0), e.emit('autoplay')) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (t = e.slideTo(0, e.params.speed, !0, !0), e.emit('autoplay')) : (t = e.slideNext(e.params.speed, !0, !0), e.emit('autoplay')), (e.params.cssMode && e.autoplay.running || !1 === t) && e.autoplay.run();
	        }, a);
	      },
	      start: function start() {
	        var e = this;
	        return void 0 === e.autoplay.timeout && !e.autoplay.running && (e.autoplay.running = !0, e.emit('autoplayStart'), e.autoplay.run(), !0);
	      },
	      stop: function stop() {
	        var e = this;
	        return !!e.autoplay.running && void 0 !== e.autoplay.timeout && (e.autoplay.timeout && (clearTimeout(e.autoplay.timeout), e.autoplay.timeout = void 0), e.autoplay.running = !1, e.emit('autoplayStop'), !0);
	      },
	      pause: function pause(e) {
	        var t = this;
	        t.autoplay.running && (t.autoplay.paused || (t.autoplay.timeout && clearTimeout(t.autoplay.timeout), t.autoplay.paused = !0, 0 !== e && t.params.autoplay.waitForTransition ? ['transitionend', 'webkitTransitionEnd'].forEach(function (e) {
	          t.$wrapperEl[0].addEventListener(e, t.autoplay.onTransitionEnd);
	        }) : (t.autoplay.paused = !1, t.autoplay.run())));
	      },
	      onVisibilityChange: function onVisibilityChange() {
	        var e = this,
	            t = r();
	        'hidden' === t.visibilityState && e.autoplay.running && e.autoplay.pause(), 'visible' === t.visibilityState && e.autoplay.paused && (e.autoplay.run(), e.autoplay.paused = !1);
	      },
	      onTransitionEnd: function onTransitionEnd(e) {
	        var t = this;
	        t && !t.destroyed && t.$wrapperEl && e.target === t.$wrapperEl[0] && (['transitionend', 'webkitTransitionEnd'].forEach(function (e) {
	          t.$wrapperEl[0].removeEventListener(e, t.autoplay.onTransitionEnd);
	        }), t.autoplay.paused = !1, t.autoplay.running ? t.autoplay.run() : t.autoplay.stop());
	      },
	      onMouseEnter: function onMouseEnter() {
	        var e = this;
	        e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause(), ['transitionend', 'webkitTransitionEnd'].forEach(function (t) {
	          e.$wrapperEl[0].removeEventListener(t, e.autoplay.onTransitionEnd);
	        });
	      },
	      onMouseLeave: function onMouseLeave() {
	        var e = this;
	        e.params.autoplay.disableOnInteraction || (e.autoplay.paused = !1, e.autoplay.run());
	      },
	      attachMouseEvents: function attachMouseEvents() {
	        var e = this;
	        e.params.autoplay.pauseOnMouseEnter && (e.$el.on('mouseenter', e.autoplay.onMouseEnter), e.$el.on('mouseleave', e.autoplay.onMouseLeave));
	      },
	      detachMouseEvents: function detachMouseEvents() {
	        var e = this;
	        e.$el.off('mouseenter', e.autoplay.onMouseEnter), e.$el.off('mouseleave', e.autoplay.onMouseLeave);
	      }
	    },
	        pe = {
	      setTranslate: function setTranslate() {
	        for (var _e5 = this, _t26 = _e5.slides, _a28 = 0; _a28 < _t26.length; _a28 += 1) {
	          var _i37 = _e5.slides.eq(_a28),
	              _s32 = -_i37[0].swiperSlideOffset;

	          _e5.params.virtualTranslate || (_s32 -= _e5.translate);
	          var _r23 = 0;
	          _e5.isHorizontal() || (_r23 = _s32, _s32 = 0);

	          var _n31 = _e5.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(_i37[0].progress), 0) : 1 + Math.min(Math.max(_i37[0].progress, -1), 0);

	          _i37.css({
	            opacity: _n31
	          }).transform('translate3d(' + _s32 + 'px, ' + _r23 + 'px, 0px)');
	        }
	      },
	      setTransition: function setTransition(e) {
	        var t = this,
	            a = t.slides,
	            i = t.$wrapperEl;

	        if (a.transition(e), t.params.virtualTranslate && 0 !== e) {
	          var _s33 = !1;

	          a.transitionEnd(function () {
	            if (!_s33 && t && !t.destroyed) {
	              _s33 = !0, t.animating = !1;

	              for (var _e6 = ['webkitTransitionEnd', 'transitionend'], _a29 = 0; _a29 < _e6.length; _a29 += 1) {
	                i.trigger(_e6[_a29]);
	              }
	            }
	          });
	        }
	      }
	    },
	        ue = {
	      setTranslate: function setTranslate() {
	        var e,
	            t = this,
	            a = t.$el,
	            i = t.$wrapperEl,
	            s = t.slides,
	            r = t.width,
	            n = t.height,
	            l = t.rtlTranslate,
	            o = t.size,
	            d = t.browser,
	            p = t.params.cubeEffect,
	            u = t.isHorizontal(),
	            c = t.virtual && t.params.virtual.enabled,
	            h = 0;
	        p.shadow && (u ? (0 === (e = i.find('.swiper-cube-shadow')).length && (e = m('<div class="swiper-cube-shadow"></div>'), i.append(e)), e.css({
	          height: r + 'px'
	        })) : 0 === (e = a.find('.swiper-cube-shadow')).length && (e = m('<div class="swiper-cube-shadow"></div>'), a.append(e)));

	        for (var _v9 = 0; _v9 < s.length; _v9 += 1) {
	          var _f7 = s.eq(_v9),
	              _g8 = _v9;

	          c && (_g8 = parseInt(_f7.attr('data-swiper-slide-index'), 10));

	          var _b8 = 90 * _g8,
	              _w7 = Math.floor(_b8 / 360);

	          l && (_b8 = -_b8, _w7 = Math.floor(-_b8 / 360));

	          var _y6 = Math.max(Math.min(_f7[0].progress, 1), -1),
	              _E4 = 0,
	              _x4 = 0,
	              _T7 = 0;

	          _g8 % 4 == 0 ? (_E4 = 4 * -_w7 * o, _T7 = 0) : (_g8 - 1) % 4 == 0 ? (_E4 = 0, _T7 = 4 * -_w7 * o) : (_g8 - 2) % 4 == 0 ? (_E4 = o + 4 * _w7 * o, _T7 = o) : (_g8 - 3) % 4 == 0 && (_E4 = -o, _T7 = 3 * o + 4 * o * _w7), l && (_E4 = -_E4), u || (_x4 = _E4, _E4 = 0);

	          var _C7 = 'rotateX(' + (u ? 0 : -_b8) + 'deg) rotateY(' + (u ? _b8 : 0) + 'deg) translate3d(' + _E4 + 'px, ' + _x4 + 'px, ' + _T7 + 'px)';

	          if (_y6 <= 1 && _y6 > -1 && (h = 90 * _g8 + 90 * _y6, l && (h = 90 * -_g8 - 90 * _y6)), _f7.transform(_C7), p.slideShadows) {
	            var _S4 = u ? _f7.find('.swiper-slide-shadow-left') : _f7.find('.swiper-slide-shadow-top'),
	                _M2 = u ? _f7.find('.swiper-slide-shadow-right') : _f7.find('.swiper-slide-shadow-bottom');

	            0 === _S4.length && (_S4 = m('<div class="swiper-slide-shadow-' + (u ? 'left' : 'top') + '"></div>'), _f7.append(_S4)), 0 === _M2.length && (_M2 = m('<div class="swiper-slide-shadow-' + (u ? 'right' : 'bottom') + '"></div>'), _f7.append(_M2)), _S4.length && (_S4[0].style.opacity = Math.max(-_y6, 0)), _M2.length && (_M2[0].style.opacity = Math.max(_y6, 0));
	          }
	        }

	        if (i.css({
	          '-webkit-transform-origin': '50% 50% -' + o / 2 + 'px',
	          '-moz-transform-origin': '50% 50% -' + o / 2 + 'px',
	          '-ms-transform-origin': '50% 50% -' + o / 2 + 'px',
	          'transform-origin': '50% 50% -' + o / 2 + 'px'
	        }), p.shadow) if (u) e.transform('translate3d(0px, ' + (r / 2 + p.shadowOffset) + 'px, ' + -r / 2 + 'px) rotateX(90deg) rotateZ(0deg) scale(' + p.shadowScale + ')');else {
	          var _z2 = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90),
	              _P3 = 1.5 - (Math.sin(2 * _z2 * Math.PI / 360) / 2 + Math.cos(2 * _z2 * Math.PI / 360) / 2),
	              _k2 = p.shadowScale,
	              _$ = p.shadowScale / _P3,
	              _L = p.shadowOffset;

	          e.transform('scale3d(' + _k2 + ', 1, ' + _$ + ') translate3d(0px, ' + (n / 2 + _L) + 'px, ' + -n / 2 / _$ + 'px) rotateX(-90deg)');
	        }
	        var I = d.isSafari || d.isWebView ? -o / 2 : 0;
	        i.transform('translate3d(0px,0,' + I + 'px) rotateX(' + (t.isHorizontal() ? 0 : h) + 'deg) rotateY(' + (t.isHorizontal() ? -h : 0) + 'deg)');
	      },
	      setTransition: function setTransition(e) {
	        var t = this,
	            a = t.$el;
	        t.slides.transition(e).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(e), t.params.cubeEffect.shadow && !t.isHorizontal() && a.find('.swiper-cube-shadow').transition(e);
	      }
	    },
	        ce = {
	      setTranslate: function setTranslate() {
	        for (var _e7 = this, _t27 = _e7.slides, _a30 = _e7.rtlTranslate, _i38 = 0; _i38 < _t27.length; _i38 += 1) {
	          var _s34 = _t27.eq(_i38),
	              _r24 = _s34[0].progress;

	          _e7.params.flipEffect.limitRotation && (_r24 = Math.max(Math.min(_s34[0].progress, 1), -1));

	          var _n32 = -180 * _r24,
	              _l17 = 0,
	              _o23 = -_s34[0].swiperSlideOffset,
	              _d22 = 0;

	          if (_e7.isHorizontal() ? _a30 && (_n32 = -_n32) : (_d22 = _o23, _o23 = 0, _l17 = -_n32, _n32 = 0), _s34[0].style.zIndex = -Math.abs(Math.round(_r24)) + _t27.length, _e7.params.flipEffect.slideShadows) {
	            var _p26 = _e7.isHorizontal() ? _s34.find('.swiper-slide-shadow-left') : _s34.find('.swiper-slide-shadow-top'),
	                _u20 = _e7.isHorizontal() ? _s34.find('.swiper-slide-shadow-right') : _s34.find('.swiper-slide-shadow-bottom');

	            0 === _p26.length && (_p26 = m('<div class="swiper-slide-shadow-' + (_e7.isHorizontal() ? 'left' : 'top') + '"></div>'), _s34.append(_p26)), 0 === _u20.length && (_u20 = m('<div class="swiper-slide-shadow-' + (_e7.isHorizontal() ? 'right' : 'bottom') + '"></div>'), _s34.append(_u20)), _p26.length && (_p26[0].style.opacity = Math.max(-_r24, 0)), _u20.length && (_u20[0].style.opacity = Math.max(_r24, 0));
	          }

	          _s34.transform('translate3d(' + _o23 + 'px, ' + _d22 + 'px, 0px) rotateX(' + _l17 + 'deg) rotateY(' + _n32 + 'deg)');
	        }
	      },
	      setTransition: function setTransition(e) {
	        var t = this,
	            a = t.slides,
	            i = t.activeIndex,
	            s = t.$wrapperEl;

	        if (a.transition(e).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(e), t.params.virtualTranslate && 0 !== e) {
	          var _r25 = !1;

	          a.eq(i).transitionEnd(function () {
	            if (!_r25 && t && !t.destroyed) {
	              _r25 = !0, t.animating = !1;

	              for (var _e8 = ['webkitTransitionEnd', 'transitionend'], _a31 = 0; _a31 < _e8.length; _a31 += 1) {
	                s.trigger(_e8[_a31]);
	              }
	            }
	          });
	        }
	      }
	    },
	        he = {
	      setTranslate: function setTranslate() {
	        for (var _e9 = this, _t28 = _e9.width, _a32 = _e9.height, _i39 = _e9.slides, _s35 = _e9.slidesSizesGrid, _r26 = _e9.params.coverflowEffect, _n33 = _e9.isHorizontal(), _l18 = _e9.translate, _o24 = _n33 ? _t28 / 2 - _l18 : _a32 / 2 - _l18, _d23 = _n33 ? _r26.rotate : -_r26.rotate, _p27 = _r26.depth, _u21 = 0, _c17 = _i39.length; _u21 < _c17; _u21 += 1) {
	          var _h10 = _i39.eq(_u21),
	              _v10 = _s35[_u21],
	              _f8 = (_o24 - _h10[0].swiperSlideOffset - _v10 / 2) / _v10 * _r26.modifier,
	              _g9 = _n33 ? _d23 * _f8 : 0,
	              _b9 = _n33 ? 0 : _d23 * _f8,
	              _w8 = -_p27 * Math.abs(_f8),
	              _y7 = _r26.stretch;

	          'string' == typeof _y7 && -1 !== _y7.indexOf('%') && (_y7 = parseFloat(_r26.stretch) / 100 * _v10);

	          var _E5 = _n33 ? 0 : _y7 * _f8,
	              _x5 = _n33 ? _y7 * _f8 : 0,
	              _T8 = 1 - (1 - _r26.scale) * Math.abs(_f8);

	          Math.abs(_x5) < .001 && (_x5 = 0), Math.abs(_E5) < .001 && (_E5 = 0), Math.abs(_w8) < .001 && (_w8 = 0), Math.abs(_g9) < .001 && (_g9 = 0), Math.abs(_b9) < .001 && (_b9 = 0), Math.abs(_T8) < .001 && (_T8 = 0);

	          var _C8 = 'translate3d(' + _x5 + 'px,' + _E5 + 'px,' + _w8 + 'px)  rotateX(' + _b9 + 'deg) rotateY(' + _g9 + 'deg) scale(' + _T8 + ')';

	          if (_h10.transform(_C8), _h10[0].style.zIndex = 1 - Math.abs(Math.round(_f8)), _r26.slideShadows) {
	            var _S5 = _n33 ? _h10.find('.swiper-slide-shadow-left') : _h10.find('.swiper-slide-shadow-top'),
	                _M3 = _n33 ? _h10.find('.swiper-slide-shadow-right') : _h10.find('.swiper-slide-shadow-bottom');

	            0 === _S5.length && (_S5 = m('<div class="swiper-slide-shadow-' + (_n33 ? 'left' : 'top') + '"></div>'), _h10.append(_S5)), 0 === _M3.length && (_M3 = m('<div class="swiper-slide-shadow-' + (_n33 ? 'right' : 'bottom') + '"></div>'), _h10.append(_M3)), _S5.length && (_S5[0].style.opacity = _f8 > 0 ? _f8 : 0), _M3.length && (_M3[0].style.opacity = -_f8 > 0 ? -_f8 : 0);
	          }
	        }
	      },
	      setTransition: function setTransition(e) {
	        this.slides.transition(e).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(e);
	      }
	    },
	        ve = {
	      init: function init() {
	        var e = this,
	            t = e.params.thumbs;
	        if (e.thumbs.initialized) return !1;
	        e.thumbs.initialized = !0;
	        var a = e.constructor;
	        return t.swiper instanceof a ? (e.thumbs.swiper = t.swiper, M(e.thumbs.swiper.originalParams, {
	          watchSlidesProgress: !0,
	          slideToClickedSlide: !1
	        }), M(e.thumbs.swiper.params, {
	          watchSlidesProgress: !0,
	          slideToClickedSlide: !1
	        })) : C(t.swiper) && (e.thumbs.swiper = new a(M({}, t.swiper, {
	          watchSlidesVisibility: !0,
	          watchSlidesProgress: !0,
	          slideToClickedSlide: !1
	        })), e.thumbs.swiperCreated = !0), e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on('tap', e.thumbs.onThumbClick), !0;
	      },
	      onThumbClick: function onThumbClick() {
	        var e = this,
	            t = e.thumbs.swiper;

	        if (t) {
	          var _a33 = t.clickedIndex,
	              _i40 = t.clickedSlide;

	          if (!(_i40 && m(_i40).hasClass(e.params.thumbs.slideThumbActiveClass) || null == _a33)) {
	            var _s36;

	            if (_s36 = t.params.loop ? parseInt(m(t.clickedSlide).attr('data-swiper-slide-index'), 10) : _a33, e.params.loop) {
	              var _r27 = e.activeIndex;
	              e.slides.eq(_r27).hasClass(e.params.slideDuplicateClass) && (e.loopFix(), e._clientLeft = e.$wrapperEl[0].clientLeft, _r27 = e.activeIndex);

	              var _n34 = e.slides.eq(_r27).prevAll('[data-swiper-slide-index="' + _s36 + '"]').eq(0).index(),
	                  _l19 = e.slides.eq(_r27).nextAll('[data-swiper-slide-index="' + _s36 + '"]').eq(0).index();

	              _s36 = void 0 === _n34 ? _l19 : void 0 === _l19 ? _n34 : _l19 - _r27 < _r27 - _n34 ? _l19 : _n34;
	            }

	            e.slideTo(_s36);
	          }
	        }
	      },
	      update: function update(e) {
	        var t = this,
	            a = t.thumbs.swiper;

	        if (a) {
	          var _i41 = 'auto' === a.params.slidesPerView ? a.slidesPerViewDynamic() : a.params.slidesPerView,
	              _s37 = t.params.thumbs.autoScrollOffset,
	              _r28 = _s37 && !a.params.loop;

	          if (t.realIndex !== a.realIndex || _r28) {
	            var _n35,
	                _l20,
	                _o25 = a.activeIndex;

	            if (a.params.loop) {
	              a.slides.eq(_o25).hasClass(a.params.slideDuplicateClass) && (a.loopFix(), a._clientLeft = a.$wrapperEl[0].clientLeft, _o25 = a.activeIndex);

	              var _d24 = a.slides.eq(_o25).prevAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index(),
	                  _p28 = a.slides.eq(_o25).nextAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index();

	              _n35 = void 0 === _d24 ? _p28 : void 0 === _p28 ? _d24 : _p28 - _o25 == _o25 - _d24 ? a.params.slidesPerGroup > 1 ? _p28 : _o25 : _p28 - _o25 < _o25 - _d24 ? _p28 : _d24, _l20 = t.activeIndex > t.previousIndex ? 'next' : 'prev';
	            } else _l20 = (_n35 = t.realIndex) > t.previousIndex ? 'next' : 'prev';

	            _r28 && (_n35 += 'next' === _l20 ? _s37 : -1 * _s37), a.visibleSlidesIndexes && a.visibleSlidesIndexes.indexOf(_n35) < 0 && (a.params.centeredSlides ? _n35 = _n35 > _o25 ? _n35 - Math.floor(_i41 / 2) + 1 : _n35 + Math.floor(_i41 / 2) - 1 : _n35 > _o25 && a.params.slidesPerGroup, a.slideTo(_n35, e ? 0 : void 0));
	          }

	          var _u22 = 1,
	              _c18 = t.params.thumbs.slideThumbActiveClass;
	          if (t.params.slidesPerView > 1 && !t.params.centeredSlides && (_u22 = t.params.slidesPerView), t.params.thumbs.multipleActiveThumbs || (_u22 = 1), _u22 = Math.floor(_u22), a.slides.removeClass(_c18), a.params.loop || a.params.virtual && a.params.virtual.enabled) for (var _h11 = 0; _h11 < _u22; _h11 += 1) {
	            a.$wrapperEl.children('[data-swiper-slide-index="' + (t.realIndex + _h11) + '"]').addClass(_c18);
	          } else for (var _v11 = 0; _v11 < _u22; _v11 += 1) {
	            a.slides.eq(t.realIndex + _v11).addClass(_c18);
	          }
	        }
	      }
	    },
	        fe = [U, Z, {
	      name: 'mousewheel',
	      params: {
	        mousewheel: {
	          enabled: !1,
	          releaseOnEdges: !1,
	          invert: !1,
	          forceToAxis: !1,
	          sensitivity: 1,
	          eventsTarget: 'container',
	          thresholdDelta: null,
	          thresholdTime: null
	        }
	      },
	      create: function create() {
	        z(this, {
	          mousewheel: {
	            enabled: !1,
	            lastScrollTime: x(),
	            lastEventBeforeSnap: void 0,
	            recentWheelEvents: [],
	            enable: J.enable,
	            disable: J.disable,
	            handle: J.handle,
	            handleMouseEnter: J.handleMouseEnter,
	            handleMouseLeave: J.handleMouseLeave,
	            animateSlider: J.animateSlider,
	            releaseScroll: J.releaseScroll
	          }
	        });
	      },
	      on: {
	        init: function init(e) {
	          !e.params.mousewheel.enabled && e.params.cssMode && e.mousewheel.disable(), e.params.mousewheel.enabled && e.mousewheel.enable();
	        },
	        destroy: function destroy(e) {
	          e.params.cssMode && e.mousewheel.enable(), e.mousewheel.enabled && e.mousewheel.disable();
	        }
	      }
	    }, {
	      name: 'navigation',
	      params: {
	        navigation: {
	          nextEl: null,
	          prevEl: null,
	          hideOnClick: !1,
	          disabledClass: 'swiper-button-disabled',
	          hiddenClass: 'swiper-button-hidden',
	          lockClass: 'swiper-button-lock'
	        }
	      },
	      create: function create() {
	        z(this, {
	          navigation: t({}, Q)
	        });
	      },
	      on: {
	        init: function init(e) {
	          e.navigation.init(), e.navigation.update();
	        },
	        toEdge: function toEdge(e) {
	          e.navigation.update();
	        },
	        fromEdge: function fromEdge(e) {
	          e.navigation.update();
	        },
	        destroy: function destroy(e) {
	          e.navigation.destroy();
	        },
	        'enable disable': function enableDisable(e) {
	          var t = e.navigation,
	              a = t.$nextEl,
	              i = t.$prevEl;
	          a && a[e.enabled ? 'removeClass' : 'addClass'](e.params.navigation.lockClass), i && i[e.enabled ? 'removeClass' : 'addClass'](e.params.navigation.lockClass);
	        },
	        click: function click(e, t) {
	          var a = e.navigation,
	              i = a.$nextEl,
	              s = a.$prevEl,
	              r = t.target;

	          if (e.params.navigation.hideOnClick && !m(r).is(s) && !m(r).is(i)) {
	            if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === r || e.pagination.el.contains(r))) return;

	            var _n36;

	            i ? _n36 = i.hasClass(e.params.navigation.hiddenClass) : s && (_n36 = s.hasClass(e.params.navigation.hiddenClass)), !0 === _n36 ? e.emit('navigationShow') : e.emit('navigationHide'), i && i.toggleClass(e.params.navigation.hiddenClass), s && s.toggleClass(e.params.navigation.hiddenClass);
	          }
	        }
	      }
	    }, {
	      name: 'pagination',
	      params: {
	        pagination: {
	          el: null,
	          bulletElement: 'span',
	          clickable: !1,
	          hideOnClick: !1,
	          renderBullet: null,
	          renderProgressbar: null,
	          renderFraction: null,
	          renderCustom: null,
	          progressbarOpposite: !1,
	          type: 'bullets',
	          dynamicBullets: !1,
	          dynamicMainBullets: 1,
	          formatFractionCurrent: function formatFractionCurrent(e) {
	            return e;
	          },
	          formatFractionTotal: function formatFractionTotal(e) {
	            return e;
	          },
	          bulletClass: 'swiper-pagination-bullet',
	          bulletActiveClass: 'swiper-pagination-bullet-active',
	          modifierClass: 'swiper-pagination-',
	          currentClass: 'swiper-pagination-current',
	          totalClass: 'swiper-pagination-total',
	          hiddenClass: 'swiper-pagination-hidden',
	          progressbarFillClass: 'swiper-pagination-progressbar-fill',
	          progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
	          clickableClass: 'swiper-pagination-clickable',
	          lockClass: 'swiper-pagination-lock'
	        }
	      },
	      create: function create() {
	        z(this, {
	          pagination: t({
	            dynamicBulletIndex: 0
	          }, ee)
	        });
	      },
	      on: {
	        init: function init(e) {
	          e.pagination.init(), e.pagination.render(), e.pagination.update();
	        },
	        activeIndexChange: function activeIndexChange(e) {
	          (e.params.loop || void 0 === e.snapIndex) && e.pagination.update();
	        },
	        snapIndexChange: function snapIndexChange(e) {
	          e.params.loop || e.pagination.update();
	        },
	        slidesLengthChange: function slidesLengthChange(e) {
	          e.params.loop && (e.pagination.render(), e.pagination.update());
	        },
	        snapGridLengthChange: function snapGridLengthChange(e) {
	          e.params.loop || (e.pagination.render(), e.pagination.update());
	        },
	        destroy: function destroy(e) {
	          e.pagination.destroy();
	        },
	        'enable disable': function enableDisable(e) {
	          var t = e.pagination.$el;
	          t && t[e.enabled ? 'removeClass' : 'addClass'](e.params.pagination.lockClass);
	        },
	        click: function click(e, t) {
	          var a = t.target;

	          if (e.params.pagination.el && e.params.pagination.hideOnClick && e.pagination.$el.length > 0 && !m(a).hasClass(e.params.pagination.bulletClass)) {
	            if (e.navigation && (e.navigation.nextEl && a === e.navigation.nextEl || e.navigation.prevEl && a === e.navigation.prevEl)) return;
	            !0 === e.pagination.$el.hasClass(e.params.pagination.hiddenClass) ? e.emit('paginationShow') : e.emit('paginationHide'), e.pagination.$el.toggleClass(e.params.pagination.hiddenClass);
	          }
	        }
	      }
	    }, {
	      name: 'scrollbar',
	      params: {
	        scrollbar: {
	          el: null,
	          dragSize: 'auto',
	          hide: !1,
	          draggable: !1,
	          snapOnRelease: !0,
	          lockClass: 'swiper-scrollbar-lock',
	          dragClass: 'swiper-scrollbar-drag'
	        }
	      },
	      create: function create() {
	        z(this, {
	          scrollbar: t({
	            isTouched: !1,
	            timeout: null,
	            dragTimeout: null
	          }, te)
	        });
	      },
	      on: {
	        init: function init(e) {
	          e.scrollbar.init(), e.scrollbar.updateSize(), e.scrollbar.setTranslate();
	        },
	        update: function update(e) {
	          e.scrollbar.updateSize();
	        },
	        resize: function resize(e) {
	          e.scrollbar.updateSize();
	        },
	        observerUpdate: function observerUpdate(e) {
	          e.scrollbar.updateSize();
	        },
	        setTranslate: function setTranslate(e) {
	          e.scrollbar.setTranslate();
	        },
	        setTransition: function setTransition(e, t) {
	          e.scrollbar.setTransition(t);
	        },
	        'enable disable': function enableDisable(e) {
	          var t = e.scrollbar.$el;
	          t && t[e.enabled ? 'removeClass' : 'addClass'](e.params.scrollbar.lockClass);
	        },
	        destroy: function destroy(e) {
	          e.scrollbar.destroy();
	        }
	      }
	    }, {
	      name: 'parallax',
	      params: {
	        parallax: {
	          enabled: !1
	        }
	      },
	      create: function create() {
	        z(this, {
	          parallax: t({}, ae)
	        });
	      },
	      on: {
	        beforeInit: function beforeInit(e) {
	          e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
	        },
	        init: function init(e) {
	          e.params.parallax.enabled && e.parallax.setTranslate();
	        },
	        setTranslate: function setTranslate(e) {
	          e.params.parallax.enabled && e.parallax.setTranslate();
	        },
	        setTransition: function setTransition(e, t) {
	          e.params.parallax.enabled && e.parallax.setTransition(t);
	        }
	      }
	    }, {
	      name: 'zoom',
	      params: {
	        zoom: {
	          enabled: !1,
	          maxRatio: 3,
	          minRatio: 1,
	          toggle: !0,
	          containerClass: 'swiper-zoom-container',
	          zoomedSlideClass: 'swiper-slide-zoomed'
	        }
	      },
	      create: function create() {
	        var e = this;
	        z(e, {
	          zoom: t({
	            enabled: !1,
	            scale: 1,
	            currentScale: 1,
	            isScaling: !1,
	            gesture: {
	              $slideEl: void 0,
	              slideWidth: void 0,
	              slideHeight: void 0,
	              $imageEl: void 0,
	              $imageWrapEl: void 0,
	              maxRatio: 3
	            },
	            image: {
	              isTouched: void 0,
	              isMoved: void 0,
	              currentX: void 0,
	              currentY: void 0,
	              minX: void 0,
	              minY: void 0,
	              maxX: void 0,
	              maxY: void 0,
	              width: void 0,
	              height: void 0,
	              startX: void 0,
	              startY: void 0,
	              touchesStart: {},
	              touchesCurrent: {}
	            },
	            velocity: {
	              x: void 0,
	              y: void 0,
	              prevPositionX: void 0,
	              prevPositionY: void 0,
	              prevTime: void 0
	            }
	          }, ie)
	        });
	        var a = 1;
	        Object.defineProperty(e.zoom, 'scale', {
	          get: function get() {
	            return a;
	          },
	          set: function set(t) {
	            if (a !== t) {
	              var _i42 = e.zoom.gesture.$imageEl ? e.zoom.gesture.$imageEl[0] : void 0,
	                  _s38 = e.zoom.gesture.$slideEl ? e.zoom.gesture.$slideEl[0] : void 0;

	              e.emit('zoomChange', t, _i42, _s38);
	            }

	            a = t;
	          }
	        });
	      },
	      on: {
	        init: function init(e) {
	          e.params.zoom.enabled && e.zoom.enable();
	        },
	        destroy: function destroy(e) {
	          e.zoom.disable();
	        },
	        touchStart: function touchStart(e, t) {
	          e.zoom.enabled && e.zoom.onTouchStart(t);
	        },
	        touchEnd: function touchEnd(e, t) {
	          e.zoom.enabled && e.zoom.onTouchEnd(t);
	        },
	        doubleTap: function doubleTap(e, t) {
	          !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && e.zoom.toggle(t);
	        },
	        transitionEnd: function transitionEnd(e) {
	          e.zoom.enabled && e.params.zoom.enabled && e.zoom.onTransitionEnd();
	        },
	        slideChange: function slideChange(e) {
	          e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && e.zoom.onTransitionEnd();
	        }
	      }
	    }, {
	      name: 'lazy',
	      params: {
	        lazy: {
	          checkInView: !1,
	          enabled: !1,
	          loadPrevNext: !1,
	          loadPrevNextAmount: 1,
	          loadOnTransitionStart: !1,
	          scrollingElement: '',
	          elementClass: 'swiper-lazy',
	          loadingClass: 'swiper-lazy-loading',
	          loadedClass: 'swiper-lazy-loaded',
	          preloaderClass: 'swiper-lazy-preloader'
	        }
	      },
	      create: function create() {
	        z(this, {
	          lazy: t({
	            initialImageLoaded: !1
	          }, se)
	        });
	      },
	      on: {
	        beforeInit: function beforeInit(e) {
	          e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1);
	        },
	        init: function init(e) {
	          e.params.lazy.enabled && !e.params.loop && 0 === e.params.initialSlide && (e.params.lazy.checkInView ? e.lazy.checkInViewOnLoad() : e.lazy.load());
	        },
	        scroll: function scroll(e) {
	          e.params.freeMode && !e.params.freeModeSticky && e.lazy.load();
	        },
	        'scrollbarDragMove resize _freeModeNoMomentumRelease': function scrollbarDragMoveResize_freeModeNoMomentumRelease(e) {
	          e.params.lazy.enabled && e.lazy.load();
	        },
	        transitionStart: function transitionStart(e) {
	          e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || !e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded) && e.lazy.load();
	        },
	        transitionEnd: function transitionEnd(e) {
	          e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && e.lazy.load();
	        },
	        slideChange: function slideChange(e) {
	          var t = e.params,
	              a = t.lazy,
	              i = t.cssMode,
	              s = t.watchSlidesVisibility,
	              r = t.watchSlidesProgress,
	              n = t.touchReleaseOnEdges,
	              l = t.resistanceRatio;
	          a.enabled && (i || (s || r) && (n || 0 === l)) && e.lazy.load();
	        }
	      }
	    }, {
	      name: 'controller',
	      params: {
	        controller: {
	          control: void 0,
	          inverse: !1,
	          by: 'slide'
	        }
	      },
	      create: function create() {
	        z(this, {
	          controller: t({
	            control: this.params.controller.control
	          }, re)
	        });
	      },
	      on: {
	        update: function update(e) {
	          e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
	        },
	        resize: function resize(e) {
	          e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
	        },
	        observerUpdate: function observerUpdate(e) {
	          e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
	        },
	        setTranslate: function setTranslate(e, t, a) {
	          e.controller.control && e.controller.setTranslate(t, a);
	        },
	        setTransition: function setTransition(e, t, a) {
	          e.controller.control && e.controller.setTransition(t, a);
	        }
	      }
	    }, {
	      name: 'a11y',
	      params: {
	        a11y: {
	          enabled: !0,
	          notificationClass: 'swiper-notification',
	          prevSlideMessage: 'Previous slide',
	          nextSlideMessage: 'Next slide',
	          firstSlideMessage: 'This is the first slide',
	          lastSlideMessage: 'This is the last slide',
	          paginationBulletMessage: 'Go to slide {{index}}',
	          slideLabelMessage: '{{index}} / {{slidesLength}}',
	          containerMessage: null,
	          containerRoleDescriptionMessage: null,
	          itemRoleDescriptionMessage: null,
	          slideRole: 'group'
	        }
	      },
	      create: function create() {
	        z(this, {
	          a11y: t({}, ne, {
	            liveRegion: m('<span class="' + this.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
	          })
	        });
	      },
	      on: {
	        afterInit: function afterInit(e) {
	          e.params.a11y.enabled && (e.a11y.init(), e.a11y.updateNavigation());
	        },
	        toEdge: function toEdge(e) {
	          e.params.a11y.enabled && e.a11y.updateNavigation();
	        },
	        fromEdge: function fromEdge(e) {
	          e.params.a11y.enabled && e.a11y.updateNavigation();
	        },
	        paginationUpdate: function paginationUpdate(e) {
	          e.params.a11y.enabled && e.a11y.updatePagination();
	        },
	        destroy: function destroy(e) {
	          e.params.a11y.enabled && e.a11y.destroy();
	        }
	      }
	    }, {
	      name: 'history',
	      params: {
	        history: {
	          enabled: !1,
	          root: '',
	          replaceState: !1,
	          key: 'slides'
	        }
	      },
	      create: function create() {
	        z(this, {
	          history: t({}, le)
	        });
	      },
	      on: {
	        init: function init(e) {
	          e.params.history.enabled && e.history.init();
	        },
	        destroy: function destroy(e) {
	          e.params.history.enabled && e.history.destroy();
	        },
	        'transitionEnd _freeModeNoMomentumRelease': function transitionEnd_freeModeNoMomentumRelease(e) {
	          e.history.initialized && e.history.setHistory(e.params.history.key, e.activeIndex);
	        },
	        slideChange: function slideChange(e) {
	          e.history.initialized && e.params.cssMode && e.history.setHistory(e.params.history.key, e.activeIndex);
	        }
	      }
	    }, {
	      name: 'hash-navigation',
	      params: {
	        hashNavigation: {
	          enabled: !1,
	          replaceState: !1,
	          watchState: !1
	        }
	      },
	      create: function create() {
	        z(this, {
	          hashNavigation: t({
	            initialized: !1
	          }, oe)
	        });
	      },
	      on: {
	        init: function init(e) {
	          e.params.hashNavigation.enabled && e.hashNavigation.init();
	        },
	        destroy: function destroy(e) {
	          e.params.hashNavigation.enabled && e.hashNavigation.destroy();
	        },
	        'transitionEnd _freeModeNoMomentumRelease': function transitionEnd_freeModeNoMomentumRelease(e) {
	          e.hashNavigation.initialized && e.hashNavigation.setHash();
	        },
	        slideChange: function slideChange(e) {
	          e.hashNavigation.initialized && e.params.cssMode && e.hashNavigation.setHash();
	        }
	      }
	    }, {
	      name: 'autoplay',
	      params: {
	        autoplay: {
	          enabled: !1,
	          delay: 3e3,
	          waitForTransition: !0,
	          disableOnInteraction: !0,
	          stopOnLastSlide: !1,
	          reverseDirection: !1,
	          pauseOnMouseEnter: !1
	        }
	      },
	      create: function create() {
	        z(this, {
	          autoplay: t({}, de, {
	            running: !1,
	            paused: !1
	          })
	        });
	      },
	      on: {
	        init: function init(e) {
	          e.params.autoplay.enabled && (e.autoplay.start(), r().addEventListener('visibilitychange', e.autoplay.onVisibilityChange), e.autoplay.attachMouseEvents());
	        },
	        beforeTransitionStart: function beforeTransitionStart(e, t, a) {
	          e.autoplay.running && (a || !e.params.autoplay.disableOnInteraction ? e.autoplay.pause(t) : e.autoplay.stop());
	        },
	        sliderFirstMove: function sliderFirstMove(e) {
	          e.autoplay.running && (e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause());
	        },
	        touchEnd: function touchEnd(e) {
	          e.params.cssMode && e.autoplay.paused && !e.params.autoplay.disableOnInteraction && e.autoplay.run();
	        },
	        destroy: function destroy(e) {
	          e.autoplay.detachMouseEvents(), e.autoplay.running && e.autoplay.stop(), r().removeEventListener('visibilitychange', e.autoplay.onVisibilityChange);
	        }
	      }
	    }, {
	      name: 'effect-fade',
	      params: {
	        fadeEffect: {
	          crossFade: !1
	        }
	      },
	      create: function create() {
	        z(this, {
	          fadeEffect: t({}, pe)
	        });
	      },
	      on: {
	        beforeInit: function beforeInit(e) {
	          if ('fade' === e.params.effect) {
	            e.classNames.push(e.params.containerModifierClass + 'fade');
	            var _t29 = {
	              slidesPerView: 1,
	              slidesPerColumn: 1,
	              slidesPerGroup: 1,
	              watchSlidesProgress: !0,
	              spaceBetween: 0,
	              virtualTranslate: !0
	            };
	            M(e.params, _t29), M(e.originalParams, _t29);
	          }
	        },
	        setTranslate: function setTranslate(e) {
	          'fade' === e.params.effect && e.fadeEffect.setTranslate();
	        },
	        setTransition: function setTransition(e, t) {
	          'fade' === e.params.effect && e.fadeEffect.setTransition(t);
	        }
	      }
	    }, {
	      name: 'effect-cube',
	      params: {
	        cubeEffect: {
	          slideShadows: !0,
	          shadow: !0,
	          shadowOffset: 20,
	          shadowScale: .94
	        }
	      },
	      create: function create() {
	        z(this, {
	          cubeEffect: t({}, ue)
	        });
	      },
	      on: {
	        beforeInit: function beforeInit(e) {
	          if ('cube' === e.params.effect) {
	            e.classNames.push(e.params.containerModifierClass + 'cube'), e.classNames.push(e.params.containerModifierClass + '3d');
	            var _t30 = {
	              slidesPerView: 1,
	              slidesPerColumn: 1,
	              slidesPerGroup: 1,
	              watchSlidesProgress: !0,
	              resistanceRatio: 0,
	              spaceBetween: 0,
	              centeredSlides: !1,
	              virtualTranslate: !0
	            };
	            M(e.params, _t30), M(e.originalParams, _t30);
	          }
	        },
	        setTranslate: function setTranslate(e) {
	          'cube' === e.params.effect && e.cubeEffect.setTranslate();
	        },
	        setTransition: function setTransition(e, t) {
	          'cube' === e.params.effect && e.cubeEffect.setTransition(t);
	        }
	      }
	    }, {
	      name: 'effect-flip',
	      params: {
	        flipEffect: {
	          slideShadows: !0,
	          limitRotation: !0
	        }
	      },
	      create: function create() {
	        z(this, {
	          flipEffect: t({}, ce)
	        });
	      },
	      on: {
	        beforeInit: function beforeInit(e) {
	          if ('flip' === e.params.effect) {
	            e.classNames.push(e.params.containerModifierClass + 'flip'), e.classNames.push(e.params.containerModifierClass + '3d');
	            var _t31 = {
	              slidesPerView: 1,
	              slidesPerColumn: 1,
	              slidesPerGroup: 1,
	              watchSlidesProgress: !0,
	              spaceBetween: 0,
	              virtualTranslate: !0
	            };
	            M(e.params, _t31), M(e.originalParams, _t31);
	          }
	        },
	        setTranslate: function setTranslate(e) {
	          'flip' === e.params.effect && e.flipEffect.setTranslate();
	        },
	        setTransition: function setTransition(e, t) {
	          'flip' === e.params.effect && e.flipEffect.setTransition(t);
	        }
	      }
	    }, {
	      name: 'effect-coverflow',
	      params: {
	        coverflowEffect: {
	          rotate: 50,
	          stretch: 0,
	          depth: 100,
	          scale: 1,
	          modifier: 1,
	          slideShadows: !0
	        }
	      },
	      create: function create() {
	        z(this, {
	          coverflowEffect: t({}, he)
	        });
	      },
	      on: {
	        beforeInit: function beforeInit(e) {
	          'coverflow' === e.params.effect && (e.classNames.push(e.params.containerModifierClass + 'coverflow'), e.classNames.push(e.params.containerModifierClass + '3d'), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
	        },
	        setTranslate: function setTranslate(e) {
	          'coverflow' === e.params.effect && e.coverflowEffect.setTranslate();
	        },
	        setTransition: function setTransition(e, t) {
	          'coverflow' === e.params.effect && e.coverflowEffect.setTransition(t);
	        }
	      }
	    }, {
	      name: 'thumbs',
	      params: {
	        thumbs: {
	          swiper: null,
	          multipleActiveThumbs: !0,
	          autoScrollOffset: 0,
	          slideThumbActiveClass: 'swiper-slide-thumb-active',
	          thumbsContainerClass: 'swiper-container-thumbs'
	        }
	      },
	      create: function create() {
	        z(this, {
	          thumbs: t({
	            swiper: null,
	            initialized: !1
	          }, ve)
	        });
	      },
	      on: {
	        beforeInit: function beforeInit(e) {
	          var t = e.params.thumbs;
	          t && t.swiper && (e.thumbs.init(), e.thumbs.update(!0));
	        },
	        slideChange: function slideChange(e) {
	          e.thumbs.swiper && e.thumbs.update();
	        },
	        update: function update(e) {
	          e.thumbs.swiper && e.thumbs.update();
	        },
	        resize: function resize(e) {
	          e.thumbs.swiper && e.thumbs.update();
	        },
	        observerUpdate: function observerUpdate(e) {
	          e.thumbs.swiper && e.thumbs.update();
	        },
	        setTransition: function setTransition(e, t) {
	          var a = e.thumbs.swiper;
	          a && a.setTransition(t);
	        },
	        beforeDestroy: function beforeDestroy(e) {
	          var t = e.thumbs.swiper;
	          t && e.thumbs.swiperCreated && t && t.destroy();
	        }
	      }
	    }];
	    return q.use(fe), q;
	  });
	})(swiper_min);

	var swiper_minExports = swiper_min.exports;
	var swiper = /*@__PURE__*/getDefaultExportFromCjs(swiper_minExports);

	window.$ = window.$ || $;
	window.jQuery = window.jQuery || $;
	window.Swiper = swiper;

})();
